window.solutionsData3 = {
    "nm": "Animation",
    "ddd": 0,
    "h": 732,
    "w": 764,
    "meta": {
        "g": "@lottiefiles/toolkit-js 0.76.0"
    },
    "layers": [
        {
            "ty": 0,
            "nm": "User chat",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "164",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "1",
            "ind": 1
        },
        {
            "ty": 0,
            "nm": "Popup",
            "sr": 1,
            "st": 25,
            "op": 18026,
            "ip": 25,
            "ln": "163",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "6",
            "ind": 2
        },
        {
            "ty": 0,
            "nm": "Text field",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "162",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "7",
            "ind": 3
        },
        {
            "ty": 0,
            "nm": "Window",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "161",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "10",
            "ind": 4
        }
    ],
    "v": "5.7.0",
    "fr": 30,
    "op": 258,
    "ip": 0,
    "fonts": {
        "list": [
            {
                "ascent": null,
                "fClass": "",
                "fFamily": "BDO Grotesk",
                "fStyle": "Bold",
                "fName": "BDOGrotesk-Bold",
                "fPath": "",
                "fWeight": "",
                "origin": 0
            },
            {
                "ascent": null,
                "fClass": "",
                "fFamily": "BDO Grotesk",
                "fStyle": "Regular",
                "fName": "BDOGrotesk-Regular",
                "fPath": "",
                "fWeight": "",
                "origin": 0
            }
        ]
    },
    "chars": [
        {
            "ch": "S",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 65.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.1666666666666667,
                                                1.6666666666666667
                                            ],
                                            [
                                                1.900000000000001,
                                                0.7333333333333295
                                            ],
                                            [
                                                2.2666666666666657,
                                                0
                                            ],
                                            [
                                                1.7999999999999996,
                                                -1.400000000000001
                                            ],
                                            [
                                                0,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -1.5,
                                                -1.1999999999999982
                                            ],
                                            [
                                                -2.7666666666666657,
                                                -0.7666666666666705
                                            ],
                                            [
                                                -3.599999999999999,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -2.700000000000003,
                                                -1.1000000000000039
                                            ],
                                            [
                                                -2,
                                                -1.6999999999999982
                                            ],
                                            [
                                                -1.033333333333336,
                                                -2.4666666666666637
                                            ],
                                            [
                                                0,
                                                -3.3333333333333335
                                            ],
                                            [
                                                2.2666666666666657,
                                                -3.366666666666666
                                            ],
                                            [
                                                4.300000000000002,
                                                -1.8666666666666665
                                            ],
                                            [
                                                6.13333333333333,
                                                0
                                            ],
                                            [
                                                4.300000000000002,
                                                1.9666666666666668
                                            ],
                                            [
                                                2.366666666666666,
                                                3.5666666666666664
                                            ],
                                            [
                                                0.19999999999999987,
                                                4.666666666666668
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.5666666666666678,
                                                -2.1
                                            ],
                                            [
                                                -4.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.200000000000003,
                                                1.3999999999999997
                                            ],
                                            [
                                                0,
                                                3
                                            ],
                                            [
                                                1.2999999999999972,
                                                1.1999999999999982
                                            ],
                                            [
                                                2,
                                                0.6333333333333329
                                            ],
                                            [
                                                2.3333333333333335,
                                                0.4666666666666662
                                            ],
                                            [
                                                3.2000000000000006,
                                                1.0333333333333314
                                            ],
                                            [
                                                2.4666666666666663,
                                                1.599999999999999
                                            ],
                                            [
                                                1.3666666666666665,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                3.7333333333333343
                                            ],
                                            [
                                                -2.233333333333333,
                                                3.2333333333333294
                                            ],
                                            [
                                                -4.033333333333334,
                                                1.7999999999999925
                                            ],
                                            [
                                                -5.399999999999999,
                                                0
                                            ],
                                            [
                                                -4.900000000000001,
                                                -3.933333333333328
                                            ],
                                            [
                                                -0.3333333333333333,
                                                -6.466666666666669
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.06666666666666761,
                                                -2.6666666666666665
                                            ],
                                            [
                                                -1.1666666666666667,
                                                -1.6666666666666667
                                            ],
                                            [
                                                -1.900000000000001,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -3.4666666666666663,
                                                0
                                            ],
                                            [
                                                -1.7999999999999996,
                                                1.3999999999999961
                                            ],
                                            [
                                                0,
                                                2.2666666666666706
                                            ],
                                            [
                                                1.5,
                                                1.1999999999999982
                                            ],
                                            [
                                                2.766666666666668,
                                                0.7666666666666657
                                            ],
                                            [
                                                3.199999999999998,
                                                0.7333333333333295
                                            ],
                                            [
                                                2.699999999999998,
                                                1.099999999999999
                                            ],
                                            [
                                                2,
                                                1.7000000000000028
                                            ],
                                            [
                                                1.0333333333333314,
                                                2.4666666666666686
                                            ],
                                            [
                                                0,
                                                4.466666666666666
                                            ],
                                            [
                                                -2.2666666666666657,
                                                3.366666666666667
                                            ],
                                            [
                                                -4.300000000000002,
                                                1.8666666666666665
                                            ],
                                            [
                                                -6,
                                                0
                                            ],
                                            [
                                                -4.3,
                                                -1.9666666666666668
                                            ],
                                            [
                                                -2.366666666666667,
                                                -3.5666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.13333333333333286,
                                                4.599999999999999
                                            ],
                                            [
                                                2.5666666666666678,
                                                2.1
                                            ],
                                            [
                                                3.7333333333333294,
                                                0
                                            ],
                                            [
                                                2.199999999999998,
                                                -1.3999999999999997
                                            ],
                                            [
                                                0,
                                                -2.266666666666668
                                            ],
                                            [
                                                -1.3000000000000018,
                                                -1.2000000000000004
                                            ],
                                            [
                                                -2,
                                                -0.6333333333333352
                                            ],
                                            [
                                                -3.599999999999999,
                                                -0.8666666666666671
                                            ],
                                            [
                                                -3.2000000000000006,
                                                -1.033333333333336
                                            ],
                                            [
                                                -2.4666666666666672,
                                                -1.599999999999999
                                            ],
                                            [
                                                -1.3666666666666665,
                                                -2.5333333333333363
                                            ],
                                            [
                                                0,
                                                -4.333333333333333
                                            ],
                                            [
                                                2.233333333333333,
                                                -3.233333333333339
                                            ],
                                            [
                                                4.033333333333334,
                                                -1.8000000000000018
                                            ],
                                            [
                                                8.666666666666666,
                                                0
                                            ],
                                            [
                                                4.900000000000001,
                                                3.933333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                60.6,
                                                -52.3
                                            ],
                                            [
                                                45.1,
                                                -50.2
                                            ],
                                            [
                                                43.25,
                                                -56.7
                                            ],
                                            [
                                                38.65,
                                                -60.3
                                            ],
                                            [
                                                32.4,
                                                -61.4
                                            ],
                                            [
                                                24.5,
                                                -59.3
                                            ],
                                            [
                                                21.8,
                                                -53.7
                                            ],
                                            [
                                                24.05,
                                                -48.5
                                            ],
                                            [
                                                30.45,
                                                -45.55
                                            ],
                                            [
                                                40,
                                                -43.3
                                            ],
                                            [
                                                48.85,
                                                -40.55
                                            ],
                                            [
                                                55.9,
                                                -36.35
                                            ],
                                            [
                                                60.45,
                                                -30.1
                                            ],
                                            [
                                                62,
                                                -21.4
                                            ],
                                            [
                                                58.6,
                                                -9.65
                                            ],
                                            [
                                                48.75,
                                                -1.8
                                            ],
                                            [
                                                33.1,
                                                1
                                            ],
                                            [
                                                17.65,
                                                -1.95
                                            ],
                                            [
                                                7.65,
                                                -10.25
                                            ],
                                            [
                                                3.8,
                                                -22.6
                                            ],
                                            [
                                                19.2,
                                                -24.7
                                            ],
                                            [
                                                23.25,
                                                -14.65
                                            ],
                                            [
                                                33.2,
                                                -11.5
                                            ],
                                            [
                                                42.1,
                                                -13.6
                                            ],
                                            [
                                                45.4,
                                                -20.2
                                            ],
                                            [
                                                43.45,
                                                -25.4
                                            ],
                                            [
                                                38.5,
                                                -28.15
                                            ],
                                            [
                                                32,
                                                -29.8
                                            ],
                                            [
                                                21.8,
                                                -32.65
                                            ],
                                            [
                                                13.3,
                                                -36.6
                                            ],
                                            [
                                                7.55,
                                                -42.8
                                            ],
                                            [
                                                5.5,
                                                -52.2
                                            ],
                                            [
                                                8.85,
                                                -63.55
                                            ],
                                            [
                                                18.25,
                                                -71.1
                                            ],
                                            [
                                                32.4,
                                                -73.8
                                            ],
                                            [
                                                52.75,
                                                -67.9
                                            ],
                                            [
                                                60.6,
                                                -52.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "u",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 63.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.5666666666666664,
                                                3.533333333333333
                                            ],
                                            [
                                                0,
                                                6.466666666666668
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.599999999999999,
                                                -1.6333333333333329
                                            ],
                                            [
                                                -2.9333333333333322,
                                                0
                                            ],
                                            [
                                                -1.6333333333333353,
                                                0.8999999999999998
                                            ],
                                            [
                                                -1,
                                                1.6333333333333329
                                            ],
                                            [
                                                -0.13333333333333522,
                                                2.133333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.8333333333333335,
                                                -1.4333333333333333
                                            ],
                                            [
                                                3.4666666666666663,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.2,
                                                0
                                            ],
                                            [
                                                -3.5666666666666664,
                                                -3.533333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.2000000000000006
                                            ],
                                            [
                                                1.6000000000000014,
                                                1.6333333333333329
                                            ],
                                            [
                                                2.133333333333333,
                                                0
                                            ],
                                            [
                                                1.6333333333333304,
                                                -0.8999999999999998
                                            ],
                                            [
                                                1,
                                                -1.6333333333333353
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.9333333333333325,
                                                3
                                            ],
                                            [
                                                -2.8333333333333357,
                                                1.4333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                26,
                                                1
                                            ],
                                            [
                                                11.35,
                                                -4.3
                                            ],
                                            [
                                                6,
                                                -19.3
                                            ],
                                            [
                                                6,
                                                -57.6
                                            ],
                                            [
                                                21.5,
                                                -57.6
                                            ],
                                            [
                                                21.5,
                                                -22.2
                                            ],
                                            [
                                                23.9,
                                                -14.95
                                            ],
                                            [
                                                30.7,
                                                -12.5
                                            ],
                                            [
                                                36.35,
                                                -13.85
                                            ],
                                            [
                                                40.3,
                                                -17.65
                                            ],
                                            [
                                                42,
                                                -23.3
                                            ],
                                            [
                                                42,
                                                -57.6
                                            ],
                                            [
                                                57.5,
                                                -57.6
                                            ],
                                            [
                                                57.5,
                                                0
                                            ],
                                            [
                                                43.2,
                                                0
                                            ],
                                            [
                                                42.6,
                                                -7.8
                                            ],
                                            [
                                                35.45,
                                                -1.15
                                            ],
                                            [
                                                26,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "m",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 97.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.7999999999999994,
                                                1.4333333333333371
                                            ],
                                            [
                                                -3.133333333333335,
                                                0
                                            ],
                                            [
                                                -3.0666666666666678,
                                                -1.7666666666666657
                                            ],
                                            [
                                                -1.599999999999999,
                                                -3.5333333333333314
                                            ],
                                            [
                                                -3.133333333333335,
                                                1.8666666666666647
                                            ],
                                            [
                                                -3.933333333333337,
                                                0
                                            ],
                                            [
                                                -3.3666666666666742,
                                                -3.599999999999999
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3999999999999961,
                                                1.7666666666666657
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                1.6000000000000039,
                                                -0.8666666666666648
                                            ],
                                            [
                                                0.9333333333333323,
                                                -1.6999999999999982
                                            ],
                                            [
                                                0,
                                                -2.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3666666666666696,
                                                1.900000000000001
                                            ],
                                            [
                                                3.133333333333335,
                                                0
                                            ],
                                            [
                                                1.599999999999999,
                                                -0.9666666666666686
                                            ],
                                            [
                                                0.8666666666666671,
                                                -1.7000000000000028
                                            ],
                                            [
                                                0,
                                                -2.2666666666666657
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2,
                                                -3.1333333333333306
                                            ],
                                            [
                                                2.7999999999999994,
                                                -1.4333333333333325
                                            ],
                                            [
                                                3.799999999999997,
                                                0
                                            ],
                                            [
                                                3.0666666666666678,
                                                1.7666666666666704
                                            ],
                                            [
                                                1.6666666666666667,
                                                -3.3333333333333335
                                            ],
                                            [
                                                3.1333333333333306,
                                                -1.8666666666666696
                                            ],
                                            [
                                                6.266666666666661,
                                                0
                                            ],
                                            [
                                                3.366666666666665,
                                                3.6000000000000036
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.133333333333335
                                            ],
                                            [
                                                -1.3999999999999961,
                                                -1.7666666666666657
                                            ],
                                            [
                                                -2.133333333333335,
                                                0
                                            ],
                                            [
                                                -1.599999999999999,
                                                0.8666666666666695
                                            ],
                                            [
                                                -0.9333333333333323,
                                                1.7000000000000028
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.066666666666663
                                            ],
                                            [
                                                -1.3666666666666647,
                                                -1.900000000000001
                                            ],
                                            [
                                                -2.199999999999998,
                                                0
                                            ],
                                            [
                                                -1.6000000000000014,
                                                0.9666666666666638
                                            ],
                                            [
                                                -0.8666666666666648,
                                                1.6999999999999982
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.6,
                                                0
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                6,
                                                -57.6
                                            ],
                                            [
                                                19.9,
                                                -57.6
                                            ],
                                            [
                                                21,
                                                -49.6
                                            ],
                                            [
                                                28.2,
                                                -56.45
                                            ],
                                            [
                                                37.1,
                                                -58.6
                                            ],
                                            [
                                                47.4,
                                                -55.95
                                            ],
                                            [
                                                54.4,
                                                -48
                                            ],
                                            [
                                                61.6,
                                                -55.8
                                            ],
                                            [
                                                72.2,
                                                -58.6
                                            ],
                                            [
                                                86.65,
                                                -53.2
                                            ],
                                            [
                                                91.7,
                                                -39
                                            ],
                                            [
                                                91.7,
                                                0
                                            ],
                                            [
                                                76.1,
                                                0
                                            ],
                                            [
                                                76.1,
                                                -35
                                            ],
                                            [
                                                74,
                                                -42.35
                                            ],
                                            [
                                                67.4,
                                                -45
                                            ],
                                            [
                                                61.8,
                                                -43.7
                                            ],
                                            [
                                                58,
                                                -39.85
                                            ],
                                            [
                                                56.6,
                                                -33.4
                                            ],
                                            [
                                                56.6,
                                                0
                                            ],
                                            [
                                                41.1,
                                                0
                                            ],
                                            [
                                                41.1,
                                                -34.7
                                            ],
                                            [
                                                39.05,
                                                -42.15
                                            ],
                                            [
                                                32.3,
                                                -45
                                            ],
                                            [
                                                26.6,
                                                -43.55
                                            ],
                                            [
                                                22.9,
                                                -39.55
                                            ],
                                            [
                                                21.6,
                                                -33.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "a",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 61.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.4333333333333322,
                                                3
                                            ],
                                            [
                                                0,
                                                4.933333333333334
                                            ],
                                            [
                                                -1.4333333333333333,
                                                2.400000000000001
                                            ],
                                            [
                                                -2.6333333333333333,
                                                1.4666666666666661
                                            ],
                                            [
                                                -3.6,
                                                0.5999999999999991
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.8333333333333334,
                                                0.9333333333333323
                                            ],
                                            [
                                                0,
                                                1.599999999999999
                                            ],
                                            [
                                                1.4333333333333371,
                                                1.0666666666666675
                                            ],
                                            [
                                                3.066666666666665,
                                                0
                                            ],
                                            [
                                                1.8333333333333333,
                                                -1.4666666666666686
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.6000000000000005,
                                                3.3333333333333335
                                            ],
                                            [
                                                -7.600000000000001,
                                                0
                                            ],
                                            [
                                                -3.5666666666666678,
                                                -1.5
                                            ],
                                            [
                                                -1.6999999999999982,
                                                -2.7333333333333343
                                            ],
                                            [
                                                0,
                                                -3.866666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7000000000000028,
                                                -0.5333333333333338
                                            ],
                                            [
                                                -0.8666666666666695,
                                                0
                                            ],
                                            [
                                                -0.26666666666667044,
                                                0.033333333333333805
                                            ],
                                            [
                                                -0.1999999999999981,
                                                0.06666666666666643
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4333333333333325,
                                                -0.20000000000000004
                                            ],
                                            [
                                                1.1999999999999982,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                1.3333333333333333
                                            ],
                                            [
                                                0.40000000000000097,
                                                2.733333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.2666666666666706,
                                                -1.6666666666666667
                                            ],
                                            [
                                                4.266666666666666,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.866666666666667,
                                                0
                                            ],
                                            [
                                                -3.4333333333333336,
                                                -3
                                            ],
                                            [
                                                0,
                                                -3.4
                                            ],
                                            [
                                                1.4333333333333336,
                                                -2.3999999999999986
                                            ],
                                            [
                                                2.633333333333333,
                                                -1.4666666666666686
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.133333333333335,
                                                -0.40000000000000097
                                            ],
                                            [
                                                0.8333333333333334,
                                                -0.9333333333333323
                                            ],
                                            [
                                                0,
                                                -2
                                            ],
                                            [
                                                -1.4333333333333325,
                                                -1.0666666666666675
                                            ],
                                            [
                                                -3.400000000000001,
                                                0
                                            ],
                                            [
                                                -1.8333333333333333,
                                                1.466666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.06666666666666643,
                                                -5.933333333333333
                                            ],
                                            [
                                                4.599999999999999,
                                                -3.3333333333333335
                                            ],
                                            [
                                                5.599999999999999,
                                                0
                                            ],
                                            [
                                                3.5666666666666678,
                                                1.5
                                            ],
                                            [
                                                1.6999999999999982,
                                                2.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                1.6666666666666667
                                            ],
                                            [
                                                0.6999999999999981,
                                                0.5333333333333338
                                            ],
                                            [
                                                0.3999999999999962,
                                                0
                                            ],
                                            [
                                                0.2666666666666657,
                                                -0.033333333333333805
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9333333333333323,
                                                0.4666666666666666
                                            ],
                                            [
                                                -1.4333333333333371,
                                                0.19999999999999996
                                            ],
                                            [
                                                -3.199999999999998,
                                                0
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -1.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7333333333333296,
                                                3
                                            ],
                                            [
                                                -3.2666666666666657,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                22.5,
                                                1
                                            ],
                                            [
                                                8.55,
                                                -3.5
                                            ],
                                            [
                                                3.4,
                                                -15.4
                                            ],
                                            [
                                                5.55,
                                                -24.1
                                            ],
                                            [
                                                11.65,
                                                -29.9
                                            ],
                                            [
                                                21,
                                                -33
                                            ],
                                            [
                                                33.5,
                                                -35.1
                                            ],
                                            [
                                                37.95,
                                                -37.1
                                            ],
                                            [
                                                39.2,
                                                -40.9
                                            ],
                                            [
                                                37.05,
                                                -45.5
                                            ],
                                            [
                                                30.3,
                                                -47.1
                                            ],
                                            [
                                                22.45,
                                                -44.9
                                            ],
                                            [
                                                19.7,
                                                -38.1
                                            ],
                                            [
                                                5.5,
                                                -39.7
                                            ],
                                            [
                                                12.3,
                                                -53.6
                                            ],
                                            [
                                                30.6,
                                                -58.6
                                            ],
                                            [
                                                44.35,
                                                -56.35
                                            ],
                                            [
                                                52.25,
                                                -50
                                            ],
                                            [
                                                54.8,
                                                -40.1
                                            ],
                                            [
                                                54.8,
                                                -15.3
                                            ],
                                            [
                                                55.85,
                                                -12
                                            ],
                                            [
                                                58.2,
                                                -11.2
                                            ],
                                            [
                                                59.2,
                                                -11.25
                                            ],
                                            [
                                                59.9,
                                                -11.4
                                            ],
                                            [
                                                60.5,
                                                -11.4
                                            ],
                                            [
                                                60.5,
                                                -0.6
                                            ],
                                            [
                                                56.95,
                                                0.4
                                            ],
                                            [
                                                53,
                                                0.7
                                            ],
                                            [
                                                45.1,
                                                -1.3
                                            ],
                                            [
                                                41.4,
                                                -7.4
                                            ],
                                            [
                                                41.3,
                                                -8.5
                                            ],
                                            [
                                                33.8,
                                                -1.5
                                            ],
                                            [
                                                22.5,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.1666666666666665,
                                                1.5333333333333339
                                            ],
                                            [
                                                -0.5333333333333362,
                                                2.733333333333332
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.099999999999999,
                                                -0.3333333333333333
                                            ],
                                            [
                                                1.599999999999999,
                                                -0.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.0333333333333339,
                                                -1.2666666666666657
                                            ],
                                            [
                                                0,
                                                -1.5333333333333339
                                            ],
                                            [
                                                -1.4666666666666661,
                                                -1.1333333333333329
                                            ],
                                            [
                                                -2.5333333333333337,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.333333333333331,
                                                0
                                            ],
                                            [
                                                2.1666666666666665,
                                                -1.5333333333333339
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.8000000000000019,
                                                0.4666666666666662
                                            ],
                                            [
                                                -1.099999999999999,
                                                0.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.6666666666666665,
                                                0.46666666666666856
                                            ],
                                            [
                                                -1.0333333333333314,
                                                1.2666666666666657
                                            ],
                                            [
                                                0,
                                                2.133333333333334
                                            ],
                                            [
                                                1.4666666666666661,
                                                1.133333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27.3,
                                                -10.2
                                            ],
                                            [
                                                35.55,
                                                -12.5
                                            ],
                                            [
                                                39.6,
                                                -18.9
                                            ],
                                            [
                                                39.6,
                                                -27.7
                                            ],
                                            [
                                                40.6,
                                                -27.2
                                            ],
                                            [
                                                37.75,
                                                -26
                                            ],
                                            [
                                                33.7,
                                                -25
                                            ],
                                            [
                                                26.2,
                                                -23.6
                                            ],
                                            [
                                                20.65,
                                                -21
                                            ],
                                            [
                                                19.1,
                                                -16.8
                                            ],
                                            [
                                                21.3,
                                                -11.9
                                            ],
                                            [
                                                27.3,
                                                -10.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "r",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 41.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.233333333333332,
                                                1.6333333333333353
                                            ],
                                            [
                                                -3.0666666666666678,
                                                0
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -0.46666666666666384
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.8000000000000019,
                                                0.09999999999999905
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                2.2333333333333343,
                                                -1.7666666666666657
                                            ],
                                            [
                                                0.5333333333333314,
                                                -3.133333333333335
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6000000000000014,
                                                -3.4666666666666637
                                            ],
                                            [
                                                2.2333333333333343,
                                                -1.6333333333333304
                                            ],
                                            [
                                                1.9333333333333325,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.46666666666666384,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.8000000000000019,
                                                -0.09999999999999905
                                            ],
                                            [
                                                -3.4666666666666637,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                1.7666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.6,
                                                0
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                6,
                                                -57.6
                                            ],
                                            [
                                                20.2,
                                                -57.6
                                            ],
                                            [
                                                20.9,
                                                -48.2
                                            ],
                                            [
                                                26.65,
                                                -55.85
                                            ],
                                            [
                                                34.6,
                                                -58.3
                                            ],
                                            [
                                                39.5,
                                                -57.6
                                            ],
                                            [
                                                39.5,
                                                -43.2
                                            ],
                                            [
                                                38.9,
                                                -43.2
                                            ],
                                            [
                                                37,
                                                -43.65
                                            ],
                                            [
                                                34.3,
                                                -43.8
                                            ],
                                            [
                                                25.75,
                                                -41.15
                                            ],
                                            [
                                                21.6,
                                                -33.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "i",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 27.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.5,
                                                0
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                6,
                                                -57.6
                                            ],
                                            [
                                                21.5,
                                                -57.6
                                            ],
                                            [
                                                21.5,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23.3,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -79.4
                                            ],
                                            [
                                                23.3,
                                                -79.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "s",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 56.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.133333333333334,
                                                3.3666666666666667
                                            ],
                                            [
                                                0.5333333333333332,
                                                5.800000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.8666666666666671,
                                                -1.8333333333333333
                                            ],
                                            [
                                                -3.4666666666666686,
                                                0
                                            ],
                                            [
                                                -1.5666666666666675,
                                                1.1000000000000003
                                            ],
                                            [
                                                0,
                                                2.133333333333333
                                            ],
                                            [
                                                0.6999999999999981,
                                                0.8666666666666648
                                            ],
                                            [
                                                1.3333333333333333,
                                                0.5
                                            ],
                                            [
                                                1.8666666666666647,
                                                0.40000000000000097
                                            ],
                                            [
                                                2.2000000000000006,
                                                0.46666666666666856
                                            ],
                                            [
                                                2.6666666666666665,
                                                1.2666666666666682
                                            ],
                                            [
                                                1.4999999999999993,
                                                2.133333333333333
                                            ],
                                            [
                                                0,
                                                3.3333333333333335
                                            ],
                                            [
                                                -1.9666666666666668,
                                                2.6666666666666665
                                            ],
                                            [
                                                -3.6,
                                                1.466666666666664
                                            ],
                                            [
                                                -4.800000000000002,
                                                0
                                            ],
                                            [
                                                -3.400000000000001,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -1.8999999999999961,
                                                -2.5333333333333314
                                            ],
                                            [
                                                -0.2666666666666657,
                                                -3.400000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6666666666666667,
                                                1.4666666666666686
                                            ],
                                            [
                                                3.000000000000002,
                                                0
                                            ],
                                            [
                                                1.400000000000001,
                                                -1.0666666666666629
                                            ],
                                            [
                                                0,
                                                -1.6666666666666667
                                            ],
                                            [
                                                -1.1333333333333329,
                                                -0.8666666666666695
                                            ],
                                            [
                                                -2.2000000000000006,
                                                -0.5666666666666677
                                            ],
                                            [
                                                -3.199999999999998,
                                                -0.6666666666666666
                                            ],
                                            [
                                                -2.2666666666666657,
                                                -0.7666666666666657
                                            ],
                                            [
                                                -1.7000000000000028,
                                                -1.2999999999999996
                                            ],
                                            [
                                                -1,
                                                -2
                                            ],
                                            [
                                                0,
                                                -3
                                            ],
                                            [
                                                4.266666666666666,
                                                -3.3666666666666667
                                            ],
                                            [
                                                8.4,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -7.8,
                                                0
                                            ],
                                            [
                                                -4.133333333333333,
                                                -3.3666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.06666666666666525,
                                                3.133333333333333
                                            ],
                                            [
                                                1.8666666666666647,
                                                1.8333333333333333
                                            ],
                                            [
                                                2.799999999999997,
                                                0
                                            ],
                                            [
                                                1.5666666666666675,
                                                -1.1000000000000003
                                            ],
                                            [
                                                0,
                                                -1.400000000000001
                                            ],
                                            [
                                                -0.7000000000000028,
                                                -0.8666666666666671
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -0.5
                                            ],
                                            [
                                                -1.8666666666666671,
                                                -0.3999999999999986
                                            ],
                                            [
                                                -3.5333333333333337,
                                                -0.8666666666666648
                                            ],
                                            [
                                                -2.6666666666666665,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -1.5,
                                                -2.133333333333335
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                1.9666666666666661,
                                                -2.6666666666666665
                                            ],
                                            [
                                                3.599999999999999,
                                                -1.4666666666666686
                                            ],
                                            [
                                                4.933333333333333,
                                                0
                                            ],
                                            [
                                                3.400000000000001,
                                                1.4333333333333371
                                            ],
                                            [
                                                1.900000000000001,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.06666666666666288,
                                                -2.866666666666665
                                            ],
                                            [
                                                -1.6666666666666667,
                                                -1.466666666666664
                                            ],
                                            [
                                                -2.599999999999999,
                                                0
                                            ],
                                            [
                                                -1.3999999999999986,
                                                1.0666666666666675
                                            ],
                                            [
                                                0,
                                                1.599999999999999
                                            ],
                                            [
                                                1.1333333333333329,
                                                0.8666666666666648
                                            ],
                                            [
                                                2.2000000000000006,
                                                0.5666666666666677
                                            ],
                                            [
                                                2.400000000000001,
                                                0.5333333333333314
                                            ],
                                            [
                                                2.2666666666666657,
                                                0.766666666666668
                                            ],
                                            [
                                                1.6999999999999982,
                                                1.3000000000000018
                                            ],
                                            [
                                                1,
                                                2
                                            ],
                                            [
                                                0,
                                                5.533333333333332
                                            ],
                                            [
                                                -4.266666666666666,
                                                3.3666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                28,
                                                1
                                            ],
                                            [
                                                10.1,
                                                -4.05
                                            ],
                                            [
                                                3.1,
                                                -17.8
                                            ],
                                            [
                                                17.9,
                                                -19.7
                                            ],
                                            [
                                                20.6,
                                                -12.25
                                            ],
                                            [
                                                28.6,
                                                -9.5
                                            ],
                                            [
                                                35.15,
                                                -11.15
                                            ],
                                            [
                                                37.5,
                                                -16
                                            ],
                                            [
                                                36.45,
                                                -19.4
                                            ],
                                            [
                                                33.4,
                                                -21.45
                                            ],
                                            [
                                                28.6,
                                                -22.8
                                            ],
                                            [
                                                22.5,
                                                -24.1
                                            ],
                                            [
                                                13.2,
                                                -27.3
                                            ],
                                            [
                                                6.95,
                                                -32.4
                                            ],
                                            [
                                                4.7,
                                                -40.6
                                            ],
                                            [
                                                7.65,
                                                -50.2
                                            ],
                                            [
                                                16,
                                                -56.4
                                            ],
                                            [
                                                28.6,
                                                -58.6
                                            ],
                                            [
                                                41.1,
                                                -56.45
                                            ],
                                            [
                                                49.05,
                                                -50.5
                                            ],
                                            [
                                                52.3,
                                                -41.6
                                            ],
                                            [
                                                37.8,
                                                -39.6
                                            ],
                                            [
                                                35.2,
                                                -46.1
                                            ],
                                            [
                                                28.2,
                                                -48.3
                                            ],
                                            [
                                                22.2,
                                                -46.7
                                            ],
                                            [
                                                20.1,
                                                -42.6
                                            ],
                                            [
                                                21.8,
                                                -38.9
                                            ],
                                            [
                                                26.8,
                                                -36.75
                                            ],
                                            [
                                                34.9,
                                                -34.9
                                            ],
                                            [
                                                41.9,
                                                -32.95
                                            ],
                                            [
                                                47.85,
                                                -29.85
                                            ],
                                            [
                                                51.9,
                                                -24.9
                                            ],
                                            [
                                                53.4,
                                                -17.4
                                            ],
                                            [
                                                47,
                                                -4.05
                                            ],
                                            [
                                                28,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "e",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 62.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.366666666666667,
                                                2.3333333333333335
                                            ],
                                            [
                                                2.5,
                                                4.3999999999999995
                                            ],
                                            [
                                                0,
                                                6.266666666666668
                                            ],
                                            [
                                                -2.3666666666666667,
                                                4.466666666666664
                                            ],
                                            [
                                                -4.266666666666666,
                                                2.5
                                            ],
                                            [
                                                -5.866666666666667,
                                                0
                                            ],
                                            [
                                                -4.266666666666666,
                                                -2.6666666666666665
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -5.066666666666667
                                            ],
                                            [
                                                0.6666666666666666,
                                                -7.333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2,
                                                2.9666666666666686
                                            ],
                                            [
                                                4.266666666666668,
                                                0
                                            ],
                                            [
                                                2.300000000000002,
                                                -2.9666666666666637
                                            ],
                                            [
                                                0,
                                                -5.933333333333333
                                            ],
                                            [
                                                -2.4666666666666663,
                                                -2.833333333333332
                                            ],
                                            [
                                                -4.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                1.5
                                            ],
                                            [
                                                -0.5333333333333314,
                                                2.6666666666666656
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.400000000000001,
                                                -2.5333333333333337
                                            ],
                                            [
                                                3.6666666666666665,
                                                -1.4333333333333333
                                            ],
                                            [
                                                4.533333333333331,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.666666666666667,
                                                0
                                            ],
                                            [
                                                -4.366666666666666,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2.5000000000000004,
                                                -4.3999999999999995
                                            ],
                                            [
                                                0,
                                                -6.066666666666667
                                            ],
                                            [
                                                2.3666666666666667,
                                                -4.466666666666669
                                            ],
                                            [
                                                4.266666666666668,
                                                -2.5
                                            ],
                                            [
                                                5.933333333333333,
                                                0
                                            ],
                                            [
                                                4.266666666666666,
                                                2.6666666666666665
                                            ],
                                            [
                                                2.0666666666666678,
                                                5.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.8666666666666695,
                                                -5.2
                                            ],
                                            [
                                                -2,
                                                -2.9666666666666637
                                            ],
                                            [
                                                -4.133333333333333,
                                                0
                                            ],
                                            [
                                                -2.2999999999999994,
                                                2.9666666666666686
                                            ],
                                            [
                                                0,
                                                6.466666666666669
                                            ],
                                            [
                                                2.4666666666666686,
                                                2.8333333333333335
                                            ],
                                            [
                                                3.3999999999999964,
                                                0
                                            ],
                                            [
                                                2.2333333333333343,
                                                -1.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.8000000000000019,
                                                3.4
                                            ],
                                            [
                                                -2.400000000000001,
                                                2.533333333333333
                                            ],
                                            [
                                                -3.6666666666666665,
                                                1.4333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.5,
                                                1
                                            ],
                                            [
                                                17.45,
                                                -2.5
                                            ],
                                            [
                                                7.15,
                                                -12.6
                                            ],
                                            [
                                                3.4,
                                                -28.6
                                            ],
                                            [
                                                6.95,
                                                -44.4
                                            ],
                                            [
                                                16.9,
                                                -54.85
                                            ],
                                            [
                                                32.1,
                                                -58.6
                                            ],
                                            [
                                                47.4,
                                                -54.6
                                            ],
                                            [
                                                56.9,
                                                -43
                                            ],
                                            [
                                                59,
                                                -24.4
                                            ],
                                            [
                                                15.9,
                                                -24.4
                                            ],
                                            [
                                                15.9,
                                                -34.6
                                            ],
                                            [
                                                47.6,
                                                -34.6
                                            ],
                                            [
                                                42.9,
                                                -30.2
                                            ],
                                            [
                                                41.2,
                                                -42.45
                                            ],
                                            [
                                                31.8,
                                                -46.9
                                            ],
                                            [
                                                22.15,
                                                -42.45
                                            ],
                                            [
                                                18.7,
                                                -29.1
                                            ],
                                            [
                                                22.4,
                                                -15.15
                                            ],
                                            [
                                                32.7,
                                                -10.9
                                            ],
                                            [
                                                41.15,
                                                -13.15
                                            ],
                                            [
                                                45.3,
                                                -19.4
                                            ],
                                            [
                                                58.7,
                                                -16
                                            ],
                                            [
                                                53.9,
                                                -7.1
                                            ],
                                            [
                                                44.8,
                                                -1.15
                                            ],
                                            [
                                                32.5,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": " ",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 20.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": []
                    }
                ]
            }
        },
        {
            "ch": "t",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 37.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.233333333333332,
                                                2.2333333333333334
                                            ],
                                            [
                                                0,
                                                4.333333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333338,
                                                -0.7666666666666669
                                            ],
                                            [
                                                -1.8666666666666647,
                                                0
                                            ],
                                            [
                                                -0.8666666666666648,
                                                0.2333333333333331
                                            ],
                                            [
                                                -0.5333333333333314,
                                                0.20000000000000048
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9999999999999976,
                                                -0.3333333333333333
                                            ],
                                            [
                                                1.8666666666666671,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -4.733333333333334,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                -2.233333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2.133333333333333
                                            ],
                                            [
                                                0.5333333333333338,
                                                0.7666666666666669
                                            ],
                                            [
                                                1.0666666666666675,
                                                0
                                            ],
                                            [
                                                0.8666666666666695,
                                                -0.2333333333333331
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.400000000000001,
                                                0.5333333333333333
                                            ],
                                            [
                                                -2,
                                                0.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23.5,
                                                0.9
                                            ],
                                            [
                                                13.05,
                                                -2.45
                                            ],
                                            [
                                                9.7,
                                                -12.3
                                            ],
                                            [
                                                9.7,
                                                -72.5
                                            ],
                                            [
                                                25,
                                                -73.5
                                            ],
                                            [
                                                25,
                                                -17.5
                                            ],
                                            [
                                                25.8,
                                                -13.15
                                            ],
                                            [
                                                29.4,
                                                -12
                                            ],
                                            [
                                                32.3,
                                                -12.35
                                            ],
                                            [
                                                34.4,
                                                -13
                                            ],
                                            [
                                                34.4,
                                                -0.9
                                            ],
                                            [
                                                29.3,
                                                0.4
                                            ],
                                            [
                                                23.5,
                                                0.9
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                -47
                                            ],
                                            [
                                                2.3,
                                                -46.4
                                            ],
                                            [
                                                2.3,
                                                -57.6
                                            ],
                                            [
                                                17.4,
                                                -57
                                            ],
                                            [
                                                17.4,
                                                -47
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                34.5,
                                                -57.6
                                            ],
                                            [
                                                34.5,
                                                -46.4
                                            ],
                                            [
                                                17.4,
                                                -47
                                            ],
                                            [
                                                17.4,
                                                -57
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "h",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 63.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.7000000000000006,
                                                1.2333333333333343
                                            ],
                                            [
                                                -3.6666666666666665,
                                                0
                                            ],
                                            [
                                                -3.5,
                                                -3.3333333333333335
                                            ],
                                            [
                                                0,
                                                -6.466666666666669
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6333333333333304,
                                                1.5
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                1.6666666666666667,
                                                -0.8666666666666695
                                            ],
                                            [
                                                1.0333333333333314,
                                                -1.6666666666666667
                                            ],
                                            [
                                                0.13333333333333286,
                                                -2.2666666666666657
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.133333333333333,
                                                -2.799999999999997
                                            ],
                                            [
                                                2.699999999999998,
                                                -1.2333333333333343
                                            ],
                                            [
                                                5.933333333333333,
                                                0
                                            ],
                                            [
                                                3.5,
                                                3.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -2.800000000000002
                                            ],
                                            [
                                                -1.6333333333333353,
                                                -1.5
                                            ],
                                            [
                                                -2,
                                                0
                                            ],
                                            [
                                                -1.6666666666666667,
                                                0.8666666666666648
                                            ],
                                            [
                                                -1.0333333333333339,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.6,
                                                0
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                6,
                                                -79
                                            ],
                                            [
                                                21.6,
                                                -79
                                            ],
                                            [
                                                21.6,
                                                -50.7
                                            ],
                                            [
                                                28.85,
                                                -56.75
                                            ],
                                            [
                                                38.4,
                                                -58.6
                                            ],
                                            [
                                                52.55,
                                                -53.6
                                            ],
                                            [
                                                57.8,
                                                -38.9
                                            ],
                                            [
                                                57.8,
                                                0
                                            ],
                                            [
                                                42.3,
                                                0
                                            ],
                                            [
                                                42.3,
                                                -36.4
                                            ],
                                            [
                                                39.85,
                                                -42.85
                                            ],
                                            [
                                                32.9,
                                                -45.1
                                            ],
                                            [
                                                27.4,
                                                -43.8
                                            ],
                                            [
                                                23.35,
                                                -40
                                            ],
                                            [
                                                21.6,
                                                -34.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "c",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 61.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.333333333333333,
                                                2.5
                                            ],
                                            [
                                                2.3666666666666667,
                                                4.466666666666666
                                            ],
                                            [
                                                0,
                                                5.9333333333333345
                                            ],
                                            [
                                                -2.4,
                                                4.433333333333337
                                            ],
                                            [
                                                -4.333333333333335,
                                                2.5
                                            ],
                                            [
                                                -5.799999999999997,
                                                0
                                            ],
                                            [
                                                -4.533333333333331,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -6.13333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                1.5666666666666629
                                            ],
                                            [
                                                3.2666666666666657,
                                                0
                                            ],
                                            [
                                                2.366666666666667,
                                                -2.9666666666666637
                                            ],
                                            [
                                                0,
                                                -5.466666666666666
                                            ],
                                            [
                                                -2.366666666666667,
                                                -3
                                            ],
                                            [
                                                -4.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.1000000000000036,
                                                1.8666666666666671
                                            ],
                                            [
                                                -0.1999999999999981,
                                                3.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.300000000000002,
                                                -3.2000000000000006
                                            ],
                                            [
                                                3.8666666666666694,
                                                -1.7333333333333334
                                            ],
                                            [
                                                4.933333333333333,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.800000000000002,
                                                0
                                            ],
                                            [
                                                -4.333333333333333,
                                                -2.5
                                            ],
                                            [
                                                -2.3666666666666667,
                                                -4.466666666666666
                                            ],
                                            [
                                                0,
                                                -5.999999999999997
                                            ],
                                            [
                                                2.4,
                                                -4.433333333333333
                                            ],
                                            [
                                                4.333333333333333,
                                                -2.5
                                            ],
                                            [
                                                7.600000000000004,
                                                0
                                            ],
                                            [
                                                4.533333333333331,
                                                3.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.3333333333333333,
                                                -3.3333333333333335
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -1.5666666666666675
                                            ],
                                            [
                                                -4.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.366666666666667,
                                                2.9666666666666686
                                            ],
                                            [
                                                0,
                                                5.400000000000001
                                            ],
                                            [
                                                2.366666666666667,
                                                3
                                            ],
                                            [
                                                3.4666666666666637,
                                                0
                                            ],
                                            [
                                                2.099999999999999,
                                                -1.8666666666666671
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.40000000000000097,
                                                4.266666666666666
                                            ],
                                            [
                                                -2.299999999999997,
                                                3.1999999999999997
                                            ],
                                            [
                                                -3.866666666666665,
                                                1.7333333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.2,
                                                1
                                            ],
                                            [
                                                17,
                                                -2.75
                                            ],
                                            [
                                                6.95,
                                                -13.2
                                            ],
                                            [
                                                3.4,
                                                -28.8
                                            ],
                                            [
                                                7,
                                                -44.45
                                            ],
                                            [
                                                17.1,
                                                -54.85
                                            ],
                                            [
                                                32.3,
                                                -58.6
                                            ],
                                            [
                                                50.5,
                                                -53
                                            ],
                                            [
                                                58.3,
                                                -38.2
                                            ],
                                            [
                                                43.7,
                                                -36.2
                                            ],
                                            [
                                                40.1,
                                                -43.55
                                            ],
                                            [
                                                32.1,
                                                -45.9
                                            ],
                                            [
                                                22.45,
                                                -41.45
                                            ],
                                            [
                                                18.9,
                                                -28.8
                                            ],
                                            [
                                                22.45,
                                                -16.2
                                            ],
                                            [
                                                32.1,
                                                -11.7
                                            ],
                                            [
                                                40.45,
                                                -14.5
                                            ],
                                            [
                                                43.9,
                                                -22.3
                                            ],
                                            [
                                                58.7,
                                                -20.2
                                            ],
                                            [
                                                54.65,
                                                -9
                                            ],
                                            [
                                                45.4,
                                                -1.6
                                            ],
                                            [
                                                32.2,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "o",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 64.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.333333333333333,
                                                2.5
                                            ],
                                            [
                                                2.3666666666666667,
                                                4.433333333333334
                                            ],
                                            [
                                                0,
                                                5.933333333333333
                                            ],
                                            [
                                                -2.4,
                                                4.466666666666664
                                            ],
                                            [
                                                -4.333333333333335,
                                                2.5
                                            ],
                                            [
                                                -5.799999999999997,
                                                0
                                            ],
                                            [
                                                -4.300000000000002,
                                                -2.5
                                            ],
                                            [
                                                -2.3666666666666694,
                                                -4.466666666666669
                                            ],
                                            [
                                                0,
                                                -5.9333333333333345
                                            ],
                                            [
                                                2.366666666666665,
                                                -4.466666666666668
                                            ],
                                            [
                                                4.299999999999997,
                                                -2.466666666666667
                                            ],
                                            [
                                                5.800000000000002,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.8666666666666645,
                                                0
                                            ],
                                            [
                                                -4.333333333333333,
                                                -2.5
                                            ],
                                            [
                                                -2.3666666666666667,
                                                -4.433333333333334
                                            ],
                                            [
                                                0,
                                                -6.000000000000003
                                            ],
                                            [
                                                2.4,
                                                -4.466666666666669
                                            ],
                                            [
                                                4.333333333333333,
                                                -2.5
                                            ],
                                            [
                                                5.800000000000002,
                                                0
                                            ],
                                            [
                                                4.299999999999997,
                                                2.5
                                            ],
                                            [
                                                2.366666666666665,
                                                4.466666666666664
                                            ],
                                            [
                                                0,
                                                6
                                            ],
                                            [
                                                -2.3666666666666694,
                                                4.466666666666666
                                            ],
                                            [
                                                -4.300000000000002,
                                                2.466666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.3,
                                                1
                                            ],
                                            [
                                                17,
                                                -2.75
                                            ],
                                            [
                                                6.95,
                                                -13.15
                                            ],
                                            [
                                                3.4,
                                                -28.7
                                            ],
                                            [
                                                7,
                                                -44.4
                                            ],
                                            [
                                                17.1,
                                                -54.85
                                            ],
                                            [
                                                32.3,
                                                -58.6
                                            ],
                                            [
                                                47.45,
                                                -54.85
                                            ],
                                            [
                                                57.45,
                                                -44.4
                                            ],
                                            [
                                                61,
                                                -28.8
                                            ],
                                            [
                                                57.45,
                                                -13.1
                                            ],
                                            [
                                                47.45,
                                                -2.7
                                            ],
                                            [
                                                32.3,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.366666666666665,
                                                3.0000000000000013
                                            ],
                                            [
                                                0,
                                                5.466666666666666
                                            ],
                                            [
                                                2.3666666666666694,
                                                2.9666666666666637
                                            ],
                                            [
                                                4.1333333333333355,
                                                0
                                            ],
                                            [
                                                2.366666666666665,
                                                -3.0333333333333314
                                            ],
                                            [
                                                0,
                                                -5.399999999999999
                                            ],
                                            [
                                                -2.366666666666667,
                                                -2.9666666666666663
                                            ],
                                            [
                                                -4.200000000000003,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4.199999999999998,
                                                0
                                            ],
                                            [
                                                2.3666666666666694,
                                                -3
                                            ],
                                            [
                                                0,
                                                -5.533333333333334
                                            ],
                                            [
                                                -2.366666666666665,
                                                -2.9666666666666686
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ],
                                            [
                                                -2.366666666666667,
                                                3.0333333333333363
                                            ],
                                            [
                                                0,
                                                5.533333333333334
                                            ],
                                            [
                                                2.366666666666665,
                                                2.9666666666666672
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.2,
                                                -11.6
                                            ],
                                            [
                                                42.05,
                                                -16.1
                                            ],
                                            [
                                                45.6,
                                                -28.8
                                            ],
                                            [
                                                42.05,
                                                -41.55
                                            ],
                                            [
                                                32.3,
                                                -46
                                            ],
                                            [
                                                22.35,
                                                -41.45
                                            ],
                                            [
                                                18.8,
                                                -28.8
                                            ],
                                            [
                                                22.35,
                                                -16.05
                                            ],
                                            [
                                                32.2,
                                                -11.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "n",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 63.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.7999999999999994,
                                                1.400000000000001
                                            ],
                                            [
                                                -3.866666666666665,
                                                0
                                            ],
                                            [
                                                -3.5,
                                                -3.3666666666666694
                                            ],
                                            [
                                                0,
                                                -6.466666666666669
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6333333333333304,
                                                1.5
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                1.6666666666666667,
                                                -0.8666666666666648
                                            ],
                                            [
                                                1.0333333333333314,
                                                -1.6666666666666667
                                            ],
                                            [
                                                0.13333333333333286,
                                                -2.2666666666666657
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.2000000000000006,
                                                -3.0666666666666678
                                            ],
                                            [
                                                2.800000000000002,
                                                -1.400000000000001
                                            ],
                                            [
                                                5.933333333333333,
                                                0
                                            ],
                                            [
                                                3.5,
                                                3.366666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -2.800000000000002
                                            ],
                                            [
                                                -1.6333333333333353,
                                                -1.5
                                            ],
                                            [
                                                -2,
                                                0
                                            ],
                                            [
                                                -1.6666666666666667,
                                                0.8666666666666695
                                            ],
                                            [
                                                -1.0333333333333339,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.6,
                                                0
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                6,
                                                -57.6
                                            ],
                                            [
                                                20.3,
                                                -57.6
                                            ],
                                            [
                                                20.9,
                                                -49.8
                                            ],
                                            [
                                                28.4,
                                                -56.5
                                            ],
                                            [
                                                38.4,
                                                -58.6
                                            ],
                                            [
                                                52.55,
                                                -53.55
                                            ],
                                            [
                                                57.8,
                                                -38.8
                                            ],
                                            [
                                                57.8,
                                                0
                                            ],
                                            [
                                                42.3,
                                                0
                                            ],
                                            [
                                                42.3,
                                                -36.3
                                            ],
                                            [
                                                39.85,
                                                -42.75
                                            ],
                                            [
                                                32.9,
                                                -45
                                            ],
                                            [
                                                27.4,
                                                -43.7
                                            ],
                                            [
                                                23.35,
                                                -39.9
                                            ],
                                            [
                                                21.6,
                                                -34
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "f",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 37.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.0333333333333328,
                                                2.6666666666666665
                                            ],
                                            [
                                                -5.933333333333333,
                                                0
                                            ],
                                            [
                                                -1.1333333333333353,
                                                0.1999999999999981
                                            ],
                                            [
                                                -0.8000000000000019,
                                                0.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.5999999999999991,
                                                1.9666666666666686
                                            ],
                                            [
                                                0.7333333333333343,
                                                0
                                            ],
                                            [
                                                1.1999999999999982,
                                                -1.1333333333333353
                                            ],
                                            [
                                                0,
                                                3.133333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -4.533333333333331
                                            ],
                                            [
                                                3.0333333333333337,
                                                -2.6666666666666665
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                1.1333333333333304,
                                                -0.1999999999999981
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.13333333333333522,
                                                3.2666666666666706
                                            ],
                                            [
                                                -0.5999999999999991,
                                                -1.9666666666666686
                                            ],
                                            [
                                                -2.4666666666666686,
                                                8.800000000000002
                                            ],
                                            [
                                                -1.2000000000000004,
                                                1.1333333333333353
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                24.3,
                                                -1
                                            ],
                                            [
                                                9.9,
                                                -1
                                            ],
                                            [
                                                9.9,
                                                -68.2
                                            ],
                                            [
                                                14.45,
                                                -79
                                            ],
                                            [
                                                27.9,
                                                -83
                                            ],
                                            [
                                                31.1,
                                                -83.3
                                            ],
                                            [
                                                34,
                                                -84.1
                                            ],
                                            [
                                                34,
                                                -75.4
                                            ],
                                            [
                                                34.7,
                                                -75.4
                                            ],
                                            [
                                                33.6,
                                                -73.45
                                            ],
                                            [
                                                31.6,
                                                -76.4
                                            ],
                                            [
                                                26.1,
                                                -61.5
                                            ],
                                            [
                                                24.3,
                                                -64.5
                                            ],
                                            [
                                                24.3,
                                                -1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19.6,
                                                -48.2
                                            ],
                                            [
                                                6,
                                                -48.2
                                            ],
                                            [
                                                6,
                                                -55.6
                                            ],
                                            [
                                                19.6,
                                                -55.6
                                            ],
                                            [
                                                19.6,
                                                -48.2
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                36.8,
                                                -48.6
                                            ],
                                            [
                                                20.1,
                                                -48.6
                                            ],
                                            [
                                                20.1,
                                                -56.6
                                            ],
                                            [
                                                36.8,
                                                -56.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "\u0003",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 0
        },
        {
            "ch": ":",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 31.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23,
                                                -36.7
                                            ],
                                            [
                                                8.4,
                                                -36.7
                                            ],
                                            [
                                                8.4,
                                                -51.7
                                            ],
                                            [
                                                23,
                                                -51.7
                                            ],
                                            [
                                                23,
                                                -36.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23,
                                                0
                                            ],
                                            [
                                                8.4,
                                                0
                                            ],
                                            [
                                                8.4,
                                                -14.9
                                            ],
                                            [
                                                23,
                                                -14.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "[",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 35.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.4,
                                                13.9
                                            ],
                                            [
                                                7.2,
                                                13.9
                                            ],
                                            [
                                                7.2,
                                                -79
                                            ],
                                            [
                                                32.4,
                                                -79
                                            ],
                                            [
                                                32.4,
                                                -67.6
                                            ],
                                            [
                                                21,
                                                -67.6
                                            ],
                                            [
                                                21,
                                                2.8
                                            ],
                                            [
                                                32.4,
                                                2.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "N",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 79.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                22.8,
                                                0
                                            ],
                                            [
                                                7.2,
                                                0
                                            ],
                                            [
                                                7.2,
                                                -72.9
                                            ],
                                            [
                                                26.4,
                                                -72.9
                                            ],
                                            [
                                                58.7,
                                                -21.4
                                            ],
                                            [
                                                57.2,
                                                -21.4
                                            ],
                                            [
                                                57.2,
                                                -72.9
                                            ],
                                            [
                                                72.6,
                                                -72.9
                                            ],
                                            [
                                                72.6,
                                                0
                                            ],
                                            [
                                                54.6,
                                                0
                                            ],
                                            [
                                                21.4,
                                                -52
                                            ],
                                            [
                                                22.8,
                                                -52
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "A",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 76.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.5999999999999991,
                                                1.8666666666666647
                                            ],
                                            [
                                                0.7333333333333343,
                                                2.5333333333333363
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.6333333333333352,
                                                -1.8666666666666647
                                            ],
                                            [
                                                0.6666666666666666,
                                                -1.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5999999999999991,
                                                -1.7333333333333343
                                            ],
                                            [
                                                -0.5999999999999991,
                                                -1.8666666666666647
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                2.5333333333333363
                                            ],
                                            [
                                                -0.6333333333333352,
                                                1.8666666666666647
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                0
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                29.2,
                                                -72.9
                                            ],
                                            [
                                                47.2,
                                                -72.9
                                            ],
                                            [
                                                75.4,
                                                0
                                            ],
                                            [
                                                58.6,
                                                0
                                            ],
                                            [
                                                41.3,
                                                -47.6
                                            ],
                                            [
                                                39.5,
                                                -53
                                            ],
                                            [
                                                37.5,
                                                -59.6
                                            ],
                                            [
                                                38.7,
                                                -59.6
                                            ],
                                            [
                                                36.75,
                                                -53
                                            ],
                                            [
                                                34.8,
                                                -47.6
                                            ],
                                            [
                                                17.3,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                54.6,
                                                -15.1
                                            ],
                                            [
                                                21.4,
                                                -15.1
                                            ],
                                            [
                                                26.2,
                                                -28.1
                                            ],
                                            [
                                                49.8,
                                                -28.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "M",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 94.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                22.3,
                                                0
                                            ],
                                            [
                                                7.2,
                                                0
                                            ],
                                            [
                                                7.2,
                                                -72.9
                                            ],
                                            [
                                                31.8,
                                                -72.9
                                            ],
                                            [
                                                48.1,
                                                -23.2
                                            ],
                                            [
                                                46.6,
                                                -23.2
                                            ],
                                            [
                                                63,
                                                -72.9
                                            ],
                                            [
                                                87.4,
                                                -72.9
                                            ],
                                            [
                                                87.4,
                                                0
                                            ],
                                            [
                                                72.2,
                                                0
                                            ],
                                            [
                                                72.5,
                                                -62.3
                                            ],
                                            [
                                                74,
                                                -62.3
                                            ],
                                            [
                                                53.3,
                                                0
                                            ],
                                            [
                                                41,
                                                0
                                            ],
                                            [
                                                20.5,
                                                -62.2
                                            ],
                                            [
                                                22.3,
                                                -62.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "E",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 66.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                62.9,
                                                0
                                            ],
                                            [
                                                7.2,
                                                0
                                            ],
                                            [
                                                7.2,
                                                -72.9
                                            ],
                                            [
                                                59.9,
                                                -72.9
                                            ],
                                            [
                                                59.9,
                                                -59.7
                                            ],
                                            [
                                                23,
                                                -59.7
                                            ],
                                            [
                                                23,
                                                -13.4
                                            ],
                                            [
                                                62.9,
                                                -13.4
                                            ],
                                            [
                                                62.9,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                55.5,
                                                -30.6
                                            ],
                                            [
                                                21.4,
                                                -30.6
                                            ],
                                            [
                                                21.4,
                                                -43.6
                                            ],
                                            [
                                                55.5,
                                                -43.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "]",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 35.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27.9,
                                                13.9
                                            ],
                                            [
                                                2.7,
                                                13.9
                                            ],
                                            [
                                                2.7,
                                                2.8
                                            ],
                                            [
                                                14.1,
                                                2.8
                                            ],
                                            [
                                                14.1,
                                                -67.6
                                            ],
                                            [
                                                2.7,
                                                -67.6
                                            ],
                                            [
                                                2.7,
                                                -79
                                            ],
                                            [
                                                27.9,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ",",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 25,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333331,
                                                0.8666666666666666
                                            ],
                                            [
                                                0,
                                                1.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.133333333333333,
                                                -1.8666666666666671
                                            ],
                                            [
                                                3.866666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.1333333333333333,
                                                0
                                            ],
                                            [
                                                0.7333333333333331,
                                                -0.8666666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.733333333333333
                                            ],
                                            [
                                                -2.133333333333334,
                                                1.8666666666666671
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                7.6,
                                                16.1
                                            ],
                                            [
                                                4.4,
                                                16.1
                                            ],
                                            [
                                                4.4,
                                                8.5
                                            ],
                                            [
                                                6.8,
                                                8.5
                                            ],
                                            [
                                                11.1,
                                                7.2
                                            ],
                                            [
                                                12.2,
                                                3.4
                                            ],
                                            [
                                                12.2,
                                                0
                                            ],
                                            [
                                                5.2,
                                                0
                                            ],
                                            [
                                                5.2,
                                                -14.9
                                            ],
                                            [
                                                19.8,
                                                -14.9
                                            ],
                                            [
                                                19.8,
                                                4.9
                                            ],
                                            [
                                                16.6,
                                                13.3
                                            ],
                                            [
                                                7.6,
                                                16.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "I",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 30.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23,
                                                -72.9
                                            ],
                                            [
                                                23,
                                                0
                                            ],
                                            [
                                                7.2,
                                                0
                                            ],
                                            [
                                                7.2,
                                                -72.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "L",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 60.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                60.1,
                                                0
                                            ],
                                            [
                                                7.2,
                                                0
                                            ],
                                            [
                                                7.2,
                                                -72.9
                                            ],
                                            [
                                                23,
                                                -72.9
                                            ],
                                            [
                                                23,
                                                -11.8
                                            ],
                                            [
                                                21.3,
                                                -13.4
                                            ],
                                            [
                                                60.1,
                                                -13.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "C",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 75.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.1333333333333355,
                                                2.8666666666666667
                                            ],
                                            [
                                                2.7666666666666657,
                                                5.6000000000000005
                                            ],
                                            [
                                                0,
                                                8.066666666666668
                                            ],
                                            [
                                                -2.6333333333333333,
                                                5.566666666666667
                                            ],
                                            [
                                                -5.133333333333333,
                                                3.0333333333333314
                                            ],
                                            [
                                                -7.466666666666666,
                                                0
                                            ],
                                            [
                                                -4.6333333333333355,
                                                -2.1666666666666665
                                            ],
                                            [
                                                -2.7666666666666706,
                                                -3.866666666666665
                                            ],
                                            [
                                                -0.6000000000000038,
                                                -5.26666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.866666666666665,
                                                2.4333333333333322
                                            ],
                                            [
                                                4.733333333333334,
                                                0
                                            ],
                                            [
                                                2.700000000000003,
                                                -1.7333333333333343
                                            ],
                                            [
                                                1.3666666666666671,
                                                -3.4333333333333322
                                            ],
                                            [
                                                0,
                                                -5.1333333333333355
                                            ],
                                            [
                                                -3,
                                                -4.099999999999999
                                            ],
                                            [
                                                -5.8666666666666645,
                                                0
                                            ],
                                            [
                                                -2.9333333333333322,
                                                2.4333333333333336
                                            ],
                                            [
                                                -0.6666666666666666,
                                                4.600000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.933333333333337,
                                                -3.9666666666666672
                                            ],
                                            [
                                                4.766666666666666,
                                                -2.066666666666667
                                            ],
                                            [
                                                6.066666666666663,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -7.066666666666667,
                                                0
                                            ],
                                            [
                                                -5.133333333333333,
                                                -2.8666666666666667
                                            ],
                                            [
                                                -2.766666666666667,
                                                -5.599999999999999
                                            ],
                                            [
                                                0,
                                                -7.666666666666667
                                            ],
                                            [
                                                2.633333333333334,
                                                -5.566666666666667
                                            ],
                                            [
                                                5.133333333333333,
                                                -3.0333333333333314
                                            ],
                                            [
                                                6.333333333333333,
                                                0
                                            ],
                                            [
                                                4.63333333333333,
                                                2.1666666666666665
                                            ],
                                            [
                                                2.766666666666661,
                                                3.866666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -4.533333333333331
                                            ],
                                            [
                                                -2.8666666666666694,
                                                -2.433333333333337
                                            ],
                                            [
                                                -3.7333333333333294,
                                                0
                                            ],
                                            [
                                                -2.699999999999998,
                                                1.7333333333333343
                                            ],
                                            [
                                                -1.3666666666666671,
                                                3.4333333333333322
                                            ],
                                            [
                                                0,
                                                7.400000000000001
                                            ],
                                            [
                                                3,
                                                4.1000000000000005
                                            ],
                                            [
                                                4.86666666666667,
                                                0
                                            ],
                                            [
                                                2.9333333333333322,
                                                -2.4333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5999999999999943,
                                                5.599999999999999
                                            ],
                                            [
                                                -2.9333333333333322,
                                                3.966666666666667
                                            ],
                                            [
                                                -4.76666666666667,
                                                2.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                38.2,
                                                1
                                            ],
                                            [
                                                19.9,
                                                -3.3
                                            ],
                                            [
                                                8.05,
                                                -16
                                            ],
                                            [
                                                3.9,
                                                -36.5
                                            ],
                                            [
                                                7.85,
                                                -56.35
                                            ],
                                            [
                                                19.5,
                                                -69.25
                                            ],
                                            [
                                                38.4,
                                                -73.8
                                            ],
                                            [
                                                54.85,
                                                -70.55
                                            ],
                                            [
                                                65.95,
                                                -61.5
                                            ],
                                            [
                                                71,
                                                -47.8
                                            ],
                                            [
                                                55.1,
                                                -45.6
                                            ],
                                            [
                                                49.7,
                                                -56.05
                                            ],
                                            [
                                                38.3,
                                                -59.7
                                            ],
                                            [
                                                28.65,
                                                -57.1
                                            ],
                                            [
                                                22.55,
                                                -49.35
                                            ],
                                            [
                                                20.5,
                                                -36.5
                                            ],
                                            [
                                                25,
                                                -19.25
                                            ],
                                            [
                                                38.3,
                                                -13.1
                                            ],
                                            [
                                                50,
                                                -16.75
                                            ],
                                            [
                                                55.4,
                                                -27.3
                                            ],
                                            [
                                                71.3,
                                                -25.5
                                            ],
                                            [
                                                66,
                                                -11.15
                                            ],
                                            [
                                                54.45,
                                                -2.1
                                            ],
                                            [
                                                38.2,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "R",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 73.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.566666666666663,
                                                -1.6000000000000039
                                            ],
                                            [
                                                -1.9333333333333325,
                                                -2.9666666666666637
                                            ],
                                            [
                                                0,
                                                -4.200000000000003
                                            ],
                                            [
                                                2.566666666666672,
                                                -3.2333333333333343
                                            ],
                                            [
                                                4.599999999999999,
                                                -0.8666666666666695
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.900000000000001,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -0.6000000000000038,
                                                -1.8666666666666671
                                            ],
                                            [
                                                0,
                                                -2.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7999999999999972,
                                                1.3666666666666671
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.8666666666666647,
                                                1.6999999999999982
                                            ],
                                            [
                                                0,
                                                2.933333333333337
                                            ],
                                            [
                                                1.966666666666664,
                                                1.5666666666666675
                                            ],
                                            [
                                                3.199999999999998,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.86666666666667,
                                                0
                                            ],
                                            [
                                                3.5666666666666678,
                                                1.6000000000000039
                                            ],
                                            [
                                                1.9333333333333371,
                                                2.9666666666666637
                                            ],
                                            [
                                                0,
                                                4.666666666666667
                                            ],
                                            [
                                                -2.566666666666663,
                                                3.2333333333333294
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4,
                                                0.5333333333333362
                                            ],
                                            [
                                                1.8999999999999961,
                                                1.2666666666666657
                                            ],
                                            [
                                                0.5999999999999943,
                                                1.8666666666666671
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -2.4666666666666663
                                            ],
                                            [
                                                -0.8000000000000019,
                                                -1.3666666666666647
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.5333333333333363,
                                                0
                                            ],
                                            [
                                                1.8666666666666647,
                                                -1.6999999999999982
                                            ],
                                            [
                                                0,
                                                -3.1333333333333306
                                            ],
                                            [
                                                -1.9666666666666686,
                                                -1.5666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23,
                                                0
                                            ],
                                            [
                                                7.2,
                                                0
                                            ],
                                            [
                                                7.2,
                                                -72.9
                                            ],
                                            [
                                                44.9,
                                                -72.9
                                            ],
                                            [
                                                57.55,
                                                -70.5
                                            ],
                                            [
                                                65.8,
                                                -63.65
                                            ],
                                            [
                                                68.7,
                                                -52.9
                                            ],
                                            [
                                                64.85,
                                                -41.05
                                            ],
                                            [
                                                54.1,
                                                -34.9
                                            ],
                                            [
                                                54.1,
                                                -36.1
                                            ],
                                            [
                                                62.95,
                                                -33.4
                                            ],
                                            [
                                                66.7,
                                                -28.7
                                            ],
                                            [
                                                67.6,
                                                -21.9
                                            ],
                                            [
                                                67.6,
                                                0
                                            ],
                                            [
                                                51.8,
                                                0
                                            ],
                                            [
                                                51.8,
                                                -20.1
                                            ],
                                            [
                                                50.6,
                                                -25.85
                                            ],
                                            [
                                                44.9,
                                                -27.9
                                            ],
                                            [
                                                21.4,
                                                -27.9
                                            ],
                                            [
                                                21.4,
                                                -40.7
                                            ],
                                            [
                                                41.4,
                                                -40.7
                                            ],
                                            [
                                                49.5,
                                                -43.25
                                            ],
                                            [
                                                52.3,
                                                -50.2
                                            ],
                                            [
                                                49.35,
                                                -57.25
                                            ],
                                            [
                                                41.6,
                                                -59.6
                                            ],
                                            [
                                                20.8,
                                                -59.6
                                            ],
                                            [
                                                23,
                                                -61.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "D",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 76.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -5.099999999999999,
                                                -2.9000000000000057
                                            ],
                                            [
                                                -2.800000000000002,
                                                -5.433333333333337
                                            ],
                                            [
                                                0,
                                                -7.666666666666667
                                            ],
                                            [
                                                2.633333333333335,
                                                -5.466666666666666
                                            ],
                                            [
                                                5.099999999999999,
                                                -3.033333333333333
                                            ],
                                            [
                                                7.26666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                6.933333333333337,
                                                0
                                            ],
                                            [
                                                5.099999999999999,
                                                2.8999999999999964
                                            ],
                                            [
                                                2.800000000000002,
                                                5.433333333333333
                                            ],
                                            [
                                                0,
                                                7.266666666666666
                                            ],
                                            [
                                                -2.633333333333335,
                                                5.466666666666668
                                            ],
                                            [
                                                -5.099999999999999,
                                                3.033333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                38.3,
                                                0
                                            ],
                                            [
                                                7.2,
                                                0
                                            ],
                                            [
                                                7.2,
                                                -72.9
                                            ],
                                            [
                                                38.3,
                                                -72.9
                                            ],
                                            [
                                                56.35,
                                                -68.55
                                            ],
                                            [
                                                68.2,
                                                -56.05
                                            ],
                                            [
                                                72.4,
                                                -36.4
                                            ],
                                            [
                                                68.45,
                                                -17.3
                                            ],
                                            [
                                                56.85,
                                                -4.55
                                            ],
                                            [
                                                38.3,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.7666666666666657,
                                                1.7000000000000004
                                            ],
                                            [
                                                -1.5,
                                                3.4333333333333322
                                            ],
                                            [
                                                0,
                                                5.200000000000003
                                            ],
                                            [
                                                1.3666666666666647,
                                                3.400000000000001
                                            ],
                                            [
                                                2.7333333333333294,
                                                1.8666666666666696
                                            ],
                                            [
                                                4.200000000000003,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.8666666666666694,
                                                0
                                            ],
                                            [
                                                2.7666666666666657,
                                                -1.7000000000000004
                                            ],
                                            [
                                                1.5,
                                                -3.4333333333333322
                                            ],
                                            [
                                                0,
                                                -4.599999999999999
                                            ],
                                            [
                                                -1.3666666666666696,
                                                -3.3999999999999964
                                            ],
                                            [
                                                -2.7333333333333343,
                                                -1.8666666666666647
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23,
                                                -61.8
                                            ],
                                            [
                                                23,
                                                -11.1
                                            ],
                                            [
                                                20.6,
                                                -13.5
                                            ],
                                            [
                                                37.3,
                                                -13.5
                                            ],
                                            [
                                                47.25,
                                                -16.05
                                            ],
                                            [
                                                53.65,
                                                -23.75
                                            ],
                                            [
                                                55.9,
                                                -36.7
                                            ],
                                            [
                                                53.85,
                                                -48.7
                                            ],
                                            [
                                                47.7,
                                                -56.6
                                            ],
                                            [
                                                37.3,
                                                -59.4
                                            ],
                                            [
                                                20.6,
                                                -59.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "p",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 66.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.2666666666666657,
                                                1.8666666666666696
                                            ],
                                            [
                                                -4,
                                                1.0666666666666675
                                            ],
                                            [
                                                -3.5,
                                                -1.8666666666666696
                                            ],
                                            [
                                                -1.966666666666664,
                                                -4.166666666666667
                                            ],
                                            [
                                                0,
                                                -5.733333333333334
                                            ],
                                            [
                                                1.9666666666666686,
                                                -4.099999999999999
                                            ],
                                            [
                                                3.6666666666666665,
                                                -2.233333333333334
                                            ],
                                            [
                                                4.86666666666667,
                                                0.7333333333333331
                                            ],
                                            [
                                                3.233333333333332,
                                                0.2666666666666669
                                            ],
                                            [
                                                1.9333333333333347,
                                                4.933333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7333333333333343,
                                                -3.3333333333333335
                                            ],
                                            [
                                                3.2666666666666657,
                                                -1.8666666666666647
                                            ],
                                            [
                                                4.800000000000002,
                                                0
                                            ],
                                            [
                                                3.5,
                                                1.8666666666666647
                                            ],
                                            [
                                                1.9666666666666686,
                                                4.166666666666667
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                -1.966666666666664,
                                                4.1000000000000005
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.233333333333333
                                            ],
                                            [
                                                -4,
                                                0
                                            ],
                                            [
                                                -3.233333333333332,
                                                -0.26666666666666633
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                20.2,
                                                15.9
                                            ],
                                            [
                                                6,
                                                15.9
                                            ],
                                            [
                                                6,
                                                -55.6
                                            ],
                                            [
                                                15.4,
                                                -55.6
                                            ],
                                            [
                                                21,
                                                -44.4
                                            ],
                                            [
                                                28.5,
                                                -52.2
                                            ],
                                            [
                                                39.4,
                                                -56.6
                                            ],
                                            [
                                                51.85,
                                                -53.8
                                            ],
                                            [
                                                60.05,
                                                -44.75
                                            ],
                                            [
                                                63,
                                                -29.9
                                            ],
                                            [
                                                60.05,
                                                -15.05
                                            ],
                                            [
                                                51.6,
                                                -5.55
                                            ],
                                            [
                                                38.8,
                                                -3.3
                                            ],
                                            [
                                                27.95,
                                                -3.7
                                            ],
                                            [
                                                20.2,
                                                -11.5
                                            ],
                                            [
                                                20.2,
                                                15.9
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.5,
                                                0.16666666666666666
                                            ],
                                            [
                                                -2.766666666666668,
                                                -1.2333333333333332
                                            ],
                                            [
                                                -3.3999999999999964,
                                                0
                                            ],
                                            [
                                                -2.799999999999997,
                                                3.5666666666666678
                                            ],
                                            [
                                                0,
                                                6.9333333333333345
                                            ],
                                            [
                                                2.7666666666666657,
                                                3.6333333333333306
                                            ],
                                            [
                                                5.066666666666667,
                                                0
                                            ],
                                            [
                                                2.500000000000002,
                                                -1.5666666666666675
                                            ],
                                            [
                                                1.3666666666666671,
                                                -2.699999999999998
                                            ],
                                            [
                                                0,
                                                -3.6666666666666665
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.13333333333333522,
                                                3.6
                                            ],
                                            [
                                                1.5,
                                                -0.16666666666666666
                                            ],
                                            [
                                                2.766666666666668,
                                                1.2333333333333343
                                            ],
                                            [
                                                5.200000000000003,
                                                0
                                            ],
                                            [
                                                2.800000000000002,
                                                -3.566666666666665
                                            ],
                                            [
                                                0,
                                                -6.533333333333334
                                            ],
                                            [
                                                -2.7666666666666657,
                                                -3.633333333333335
                                            ],
                                            [
                                                -3.2666666666666657,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                1.5666666666666675
                                            ],
                                            [
                                                -1.3666666666666647,
                                                2.699999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.6,
                                                -32.7
                                            ],
                                            [
                                                20.1,
                                                -17.8
                                            ],
                                            [
                                                22.15,
                                                -12.65
                                            ],
                                            [
                                                28.55,
                                                -11.05
                                            ],
                                            [
                                                37.8,
                                                -9.2
                                            ],
                                            [
                                                49.8,
                                                -14.55
                                            ],
                                            [
                                                54,
                                                -30.3
                                            ],
                                            [
                                                49.85,
                                                -45.55
                                            ],
                                            [
                                                38.1,
                                                -51
                                            ],
                                            [
                                                29.45,
                                                -48.65
                                            ],
                                            [
                                                23.65,
                                                -42.25
                                            ],
                                            [
                                                21.6,
                                                -32.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "l",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 27.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.6,
                                                0
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                6,
                                                -79
                                            ],
                                            [
                                                21.6,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "d",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 66.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.0333333333333337,
                                                4.5
                                            ],
                                            [
                                                -3.733333333333333,
                                                2.4666666666666637
                                            ],
                                            [
                                                -5,
                                                0
                                            ],
                                            [
                                                -2.900000000000001,
                                                -1.4666666666666686
                                            ],
                                            [
                                                -1.6666666666666667,
                                                -2.933333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.1666666666666665,
                                                -1.6333333333333335
                                            ],
                                            [
                                                3.933333333333335,
                                                0
                                            ],
                                            [
                                                3.633333333333334,
                                                2.4
                                            ],
                                            [
                                                2,
                                                4.433333333333333
                                            ],
                                            [
                                                0,
                                                6
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                -6.1333333333333355
                                            ],
                                            [
                                                2.033333333333333,
                                                -4.5
                                            ],
                                            [
                                                3.733333333333333,
                                                -2.4666666666666686
                                            ],
                                            [
                                                3.7999999999999994,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                1.466666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.466666666666664,
                                                3
                                            ],
                                            [
                                                -3.1666666666666665,
                                                1.6333333333333335
                                            ],
                                            [
                                                -5,
                                                0
                                            ],
                                            [
                                                -3.633333333333333,
                                                -2.4
                                            ],
                                            [
                                                -2.0000000000000004,
                                                -4.433333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                3.4,
                                                -28.5
                                            ],
                                            [
                                                6.45,
                                                -44.45
                                            ],
                                            [
                                                15.1,
                                                -54.9
                                            ],
                                            [
                                                28.2,
                                                -58.6
                                            ],
                                            [
                                                38.25,
                                                -56.4
                                            ],
                                            [
                                                45.1,
                                                -49.8
                                            ],
                                            [
                                                45.1,
                                                -79
                                            ],
                                            [
                                                60.6,
                                                -79
                                            ],
                                            [
                                                60.6,
                                                0
                                            ],
                                            [
                                                46.3,
                                                0
                                            ],
                                            [
                                                45.4,
                                                -8.4
                                            ],
                                            [
                                                38.45,
                                                -1.45
                                            ],
                                            [
                                                27.8,
                                                1
                                            ],
                                            [
                                                14.85,
                                                -2.6
                                            ],
                                            [
                                                6.4,
                                                -12.85
                                            ],
                                            [
                                                3.4,
                                                -28.5
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.2000000000000006,
                                                -2.8999999999999986
                                            ],
                                            [
                                                -4.1333333333333355,
                                                0
                                            ],
                                            [
                                                -1.9333333333333325,
                                                1.2000000000000004
                                            ],
                                            [
                                                -1.0333333333333314,
                                                2.233333333333332
                                            ],
                                            [
                                                0,
                                                3.2000000000000006
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.033333333333336,
                                                2.300000000000002
                                            ],
                                            [
                                                1.900000000000001,
                                                1.2000000000000028
                                            ],
                                            [
                                                2.799999999999997,
                                                0
                                            ],
                                            [
                                                2.199999999999998,
                                                -2.9666666666666637
                                            ],
                                            [
                                                0,
                                                -5.599999999999999
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                5.466666666666669
                                            ],
                                            [
                                                2.199999999999998,
                                                2.900000000000001
                                            ],
                                            [
                                                2.7333333333333343,
                                                0
                                            ],
                                            [
                                                1.9333333333333325,
                                                -1.2000000000000004
                                            ],
                                            [
                                                1.033333333333336,
                                                -2.2333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.2666666666666657
                                            ],
                                            [
                                                -1.0333333333333314,
                                                -2.299999999999997
                                            ],
                                            [
                                                -1.900000000000001,
                                                -1.1999999999999982
                                            ],
                                            [
                                                -4.1333333333333355,
                                                0
                                            ],
                                            [
                                                -2.2000000000000006,
                                                2.9666666666666686
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19.3,
                                                -28.6
                                            ],
                                            [
                                                22.6,
                                                -16.05
                                            ],
                                            [
                                                32.1,
                                                -11.7
                                            ],
                                            [
                                                39.1,
                                                -13.5
                                            ],
                                            [
                                                43.55,
                                                -18.65
                                            ],
                                            [
                                                45.1,
                                                -26.8
                                            ],
                                            [
                                                45.1,
                                                -30.5
                                            ],
                                            [
                                                43.55,
                                                -38.85
                                            ],
                                            [
                                                39.15,
                                                -44.1
                                            ],
                                            [
                                                32.1,
                                                -45.9
                                            ],
                                            [
                                                22.6,
                                                -41.45
                                            ],
                                            [
                                                19.3,
                                                -28.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "b",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 66.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.900000000000001,
                                                1.4333333333333371
                                            ],
                                            [
                                                -3.6666666666666665,
                                                0
                                            ],
                                            [
                                                -3.699999999999998,
                                                -2.4666666666666686
                                            ],
                                            [
                                                -2.0333333333333314,
                                                -4.5
                                            ],
                                            [
                                                0,
                                                -6.1333333333333355
                                            ],
                                            [
                                                2,
                                                -4.433333333333334
                                            ],
                                            [
                                                3.633333333333335,
                                                -2.4
                                            ],
                                            [
                                                5,
                                                0
                                            ],
                                            [
                                                3.2000000000000006,
                                                1.6333333333333335
                                            ],
                                            [
                                                1.4666666666666661,
                                                3
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7333333333333318,
                                                -3
                                            ],
                                            [
                                                2.8999999999999986,
                                                -1.4333333333333325
                                            ],
                                            [
                                                5.066666666666667,
                                                0
                                            ],
                                            [
                                                3.700000000000003,
                                                2.4666666666666637
                                            ],
                                            [
                                                2.0333333333333363,
                                                4.5
                                            ],
                                            [
                                                0,
                                                6
                                            ],
                                            [
                                                -2,
                                                4.433333333333333
                                            ],
                                            [
                                                -3.633333333333335,
                                                2.4
                                            ],
                                            [
                                                -3.866666666666665,
                                                0
                                            ],
                                            [
                                                -3.2000000000000006,
                                                -1.6333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                20.3,
                                                0
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                6,
                                                -79
                                            ],
                                            [
                                                21.6,
                                                -79
                                            ],
                                            [
                                                21.6,
                                                -49.8
                                            ],
                                            [
                                                28.55,
                                                -56.45
                                            ],
                                            [
                                                38.4,
                                                -58.6
                                            ],
                                            [
                                                51.55,
                                                -54.9
                                            ],
                                            [
                                                60.15,
                                                -44.45
                                            ],
                                            [
                                                63.2,
                                                -28.5
                                            ],
                                            [
                                                60.2,
                                                -12.85
                                            ],
                                            [
                                                51.75,
                                                -2.6
                                            ],
                                            [
                                                38.8,
                                                1
                                            ],
                                            [
                                                28.2,
                                                -1.45
                                            ],
                                            [
                                                21.2,
                                                -8.4
                                            ],
                                            [
                                                20.3,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.0333333333333314,
                                                -2.233333333333332
                                            ],
                                            [
                                                -1.9333333333333347,
                                                -1.1666666666666667
                                            ],
                                            [
                                                -2.6666666666666665,
                                                0
                                            ],
                                            [
                                                -2.2333333333333294,
                                                2.933333333333335
                                            ],
                                            [
                                                0,
                                                5.400000000000001
                                            ],
                                            [
                                                2.2333333333333343,
                                                2.9666666666666686
                                            ],
                                            [
                                                4.1333333333333355,
                                                0
                                            ],
                                            [
                                                1.9333333333333325,
                                                -1.1999999999999982
                                            ],
                                            [
                                                1,
                                                -2.299999999999997
                                            ],
                                            [
                                                0,
                                                -3.2666666666666657
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.133333333333335
                                            ],
                                            [
                                                1.0333333333333339,
                                                2.2333333333333343
                                            ],
                                            [
                                                1.9333333333333325,
                                                1.1666666666666667
                                            ],
                                            [
                                                4.1333333333333355,
                                                0
                                            ],
                                            [
                                                2.2333333333333343,
                                                -2.9333333333333322
                                            ],
                                            [
                                                0,
                                                -5.599999999999999
                                            ],
                                            [
                                                -2.2333333333333294,
                                                -2.9666666666666637
                                            ],
                                            [
                                                -2.7333333333333343,
                                                0
                                            ],
                                            [
                                                -1.9333333333333325,
                                                1.2000000000000028
                                            ],
                                            [
                                                -1,
                                                2.300000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.6,
                                                -30.5
                                            ],
                                            [
                                                21.6,
                                                -26.6
                                            ],
                                            [
                                                23.15,
                                                -18.55
                                            ],
                                            [
                                                27.6,
                                                -13.45
                                            ],
                                            [
                                                34.5,
                                                -11.7
                                            ],
                                            [
                                                44.05,
                                                -16.1
                                            ],
                                            [
                                                47.4,
                                                -28.6
                                            ],
                                            [
                                                44.05,
                                                -41.45
                                            ],
                                            [
                                                34.5,
                                                -45.9
                                            ],
                                            [
                                                27.5,
                                                -44.1
                                            ],
                                            [
                                                23.1,
                                                -38.85
                                            ],
                                            [
                                                21.6,
                                                -30.5
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "y",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 58.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3666666666666671,
                                                0.20000000000000048
                                            ],
                                            [
                                                0.8000000000000007,
                                                0.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -0.10000000000000024
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0
                                            ],
                                            [
                                                -1.400000000000001,
                                                0.7999999999999998
                                            ],
                                            [
                                                -0.7333333333333343,
                                                2.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -2.1666666666666643
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -2.4666666666666663
                                            ],
                                            [
                                                -0.6000000000000014,
                                                -2.7999999999999994
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5999999999999991,
                                                2.266666666666668
                                            ],
                                            [
                                                -0.6333333333333352,
                                                2.0666666666666678
                                            ],
                                            [
                                                -0.6666666666666666,
                                                2.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7666666666666657,
                                                -2.1
                                            ],
                                            [
                                                2.5,
                                                -0.9333333333333348
                                            ],
                                            [
                                                3.4666666666666663,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1.3333333333333333,
                                                0
                                            ],
                                            [
                                                -1.366666666666666,
                                                -0.20000000000000048
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.39999999999999974,
                                                0.19999999999999987
                                            ],
                                            [
                                                0.6666666666666666,
                                                0.09999999999999964
                                            ],
                                            [
                                                2.266666666666667,
                                                0
                                            ],
                                            [
                                                1.3999999999999986,
                                                -0.7999999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.5333333333333314,
                                                1.6666666666666667
                                            ],
                                            [
                                                0.6666666666666666,
                                                2.1666666666666665
                                            ],
                                            [
                                                0.6666666666666666,
                                                2.4666666666666686
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.6666666666666666,
                                                -2.7999999999999994
                                            ],
                                            [
                                                0.5999999999999991,
                                                -2.2666666666666657
                                            ],
                                            [
                                                0.6333333333333352,
                                                -2.066666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.2666666666666657,
                                                3.5333333333333337
                                            ],
                                            [
                                                -1.7666666666666682,
                                                2.099999999999999
                                            ],
                                            [
                                                -2.5,
                                                0.9333333333333323
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                15.5,
                                                17.5
                                            ],
                                            [
                                                11.45,
                                                17.2
                                            ],
                                            [
                                                8.2,
                                                16.4
                                            ],
                                            [
                                                8.2,
                                                4.5
                                            ],
                                            [
                                                9,
                                                4.5
                                            ],
                                            [
                                                10.6,
                                                4.95
                                            ],
                                            [
                                                12.6,
                                                5.1
                                            ],
                                            [
                                                18.1,
                                                3.9
                                            ],
                                            [
                                                21.3,
                                                -0.4
                                            ],
                                            [
                                                22.3,
                                                -3.1
                                            ],
                                            [
                                                0.8,
                                                -57.6
                                            ],
                                            [
                                                17.7,
                                                -57.6
                                            ],
                                            [
                                                24.6,
                                                -35.8
                                            ],
                                            [
                                                26.4,
                                                -30.05
                                            ],
                                            [
                                                28.4,
                                                -23.1
                                            ],
                                            [
                                                30.3,
                                                -15.2
                                            ],
                                            [
                                                29.5,
                                                -15.2
                                            ],
                                            [
                                                31.4,
                                                -22.8
                                            ],
                                            [
                                                33.25,
                                                -29.3
                                            ],
                                            [
                                                35.2,
                                                -35.8
                                            ],
                                            [
                                                42.3,
                                                -57.6
                                            ],
                                            [
                                                57.6,
                                                -57.6
                                            ],
                                            [
                                                35.4,
                                                3.1
                                            ],
                                            [
                                                30.85,
                                                11.55
                                            ],
                                            [
                                                24.45,
                                                16.1
                                            ],
                                            [
                                                15.5,
                                                17.5
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "1",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 44.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.866666666666667,
                                                2.700000000000003
                                            ],
                                            [
                                                -0.8666666666666648,
                                                4.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.466666666666666,
                                                0
                                            ],
                                            [
                                                2.866666666666667,
                                                -2.700000000000003
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                34.8,
                                                0
                                            ],
                                            [
                                                19.3,
                                                0
                                            ],
                                            [
                                                19.3,
                                                -46.9
                                            ],
                                            [
                                                3.4,
                                                -46.9
                                            ],
                                            [
                                                3.4,
                                                -57.8
                                            ],
                                            [
                                                5.3,
                                                -57.8
                                            ],
                                            [
                                                17.8,
                                                -61.85
                                            ],
                                            [
                                                23.4,
                                                -72.9
                                            ],
                                            [
                                                34.8,
                                                -72.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "4",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 68,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                54.9,
                                                0
                                            ],
                                            [
                                                39.4,
                                                0
                                            ],
                                            [
                                                39.4,
                                                -14.2
                                            ],
                                            [
                                                3.9,
                                                -14.2
                                            ],
                                            [
                                                3.9,
                                                -25.8
                                            ],
                                            [
                                                40,
                                                -72.9
                                            ],
                                            [
                                                54.9,
                                                -72.9
                                            ],
                                            [
                                                54.9,
                                                -26.7
                                            ],
                                            [
                                                66.1,
                                                -26.7
                                            ],
                                            [
                                                66.1,
                                                -14.2
                                            ],
                                            [
                                                54.9,
                                                -14.2
                                            ],
                                            [
                                                54.9,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                39.4,
                                                -52.7
                                            ],
                                            [
                                                19.8,
                                                -26.7
                                            ],
                                            [
                                                39.4,
                                                -26.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "g",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 64.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.2,
                                                2.9666666666666663
                                            ],
                                            [
                                                0.6000000000000002,
                                                4.800000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9000000000000009,
                                                -1.1666666666666667
                                            ],
                                            [
                                                -1.5,
                                                -0.4666666666666668
                                            ],
                                            [
                                                -1.8666666666666671,
                                                0
                                            ],
                                            [
                                                -2.099999999999999,
                                                1.7000000000000004
                                            ],
                                            [
                                                0,
                                                3.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.800000000000002,
                                                -1.3
                                            ],
                                            [
                                                3.5333333333333363,
                                                0
                                            ],
                                            [
                                                3.5333333333333337,
                                                2.2000000000000006
                                            ],
                                            [
                                                1.933333333333333,
                                                4.000000000000001
                                            ],
                                            [
                                                0,
                                                5.399999999999999
                                            ],
                                            [
                                                -1.9000000000000001,
                                                4
                                            ],
                                            [
                                                -3.4333333333333336,
                                                2.2333333333333343
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.0666666666666678,
                                                -1.5666666666666675
                                            ],
                                            [
                                                -1.3999999999999961,
                                                -2.866666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.966666666666664,
                                                -3.3333333333333335
                                            ],
                                            [
                                                4.166666666666667,
                                                -1.8666666666666671
                                            ],
                                            [
                                                6.666666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -7.133333333333333,
                                                0
                                            ],
                                            [
                                                -4.2,
                                                -2.9666666666666663
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.20000000000000048,
                                                2
                                            ],
                                            [
                                                0.8999999999999986,
                                                1.1666666666666667
                                            ],
                                            [
                                                1.5,
                                                0.4666666666666668
                                            ],
                                            [
                                                3.7333333333333343,
                                                0
                                            ],
                                            [
                                                2.099999999999999,
                                                -1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.5333333333333314,
                                                2.733333333333333
                                            ],
                                            [
                                                -2.799999999999997,
                                                1.3
                                            ],
                                            [
                                                -4.733333333333332,
                                                0
                                            ],
                                            [
                                                -3.5333333333333337,
                                                -2.1999999999999993
                                            ],
                                            [
                                                -1.9333333333333333,
                                                -4
                                            ],
                                            [
                                                0,
                                                -5.399999999999999
                                            ],
                                            [
                                                1.8999999999999997,
                                                -4
                                            ],
                                            [
                                                3.4333333333333322,
                                                -2.2333333333333343
                                            ],
                                            [
                                                3.7333333333333343,
                                                0
                                            ],
                                            [
                                                3.0666666666666678,
                                                1.5666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.333333333333333
                                            ],
                                            [
                                                -1.9666666666666686,
                                                3.3333333333333335
                                            ],
                                            [
                                                -4.166666666666667,
                                                1.866666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30,
                                                17.7
                                            ],
                                            [
                                                13,
                                                13.25
                                            ],
                                            [
                                                5.8,
                                                1.6
                                            ],
                                            [
                                                20.7,
                                                -1
                                            ],
                                            [
                                                22.35,
                                                3.75
                                            ],
                                            [
                                                25.95,
                                                6.2
                                            ],
                                            [
                                                31,
                                                6.9
                                            ],
                                            [
                                                39.75,
                                                4.35
                                            ],
                                            [
                                                42.9,
                                                -3.7
                                            ],
                                            [
                                                42.9,
                                                -13
                                            ],
                                            [
                                                36.4,
                                                -6.95
                                            ],
                                            [
                                                26.9,
                                                -5
                                            ],
                                            [
                                                14.5,
                                                -8.3
                                            ],
                                            [
                                                6.3,
                                                -17.6
                                            ],
                                            [
                                                3.4,
                                                -31.7
                                            ],
                                            [
                                                6.25,
                                                -45.8
                                            ],
                                            [
                                                14.25,
                                                -55.15
                                            ],
                                            [
                                                26.4,
                                                -58.5
                                            ],
                                            [
                                                36.6,
                                                -56.15
                                            ],
                                            [
                                                43.3,
                                                -49.5
                                            ],
                                            [
                                                44,
                                                -57.6
                                            ],
                                            [
                                                58.4,
                                                -57.6
                                            ],
                                            [
                                                58.4,
                                                -4.4
                                            ],
                                            [
                                                55.45,
                                                7.1
                                            ],
                                            [
                                                46.25,
                                                14.9
                                            ],
                                            [
                                                30,
                                                17.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7666666666666657,
                                                1.1333333333333329
                                            ],
                                            [
                                                -0.9666666666666686,
                                                2.0666666666666678
                                            ],
                                            [
                                                0,
                                                2.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.9666666666666638,
                                                2.0333333333333314
                                            ],
                                            [
                                                1.8000000000000018,
                                                1.0666666666666675
                                            ],
                                            [
                                                2.4666666666666686,
                                                0
                                            ],
                                            [
                                                2.0333333333333337,
                                                -2.633333333333335
                                            ],
                                            [
                                                0,
                                                -4.666666666666667
                                            ],
                                            [
                                                -2.0333333333333337,
                                                -2.7000000000000006
                                            ],
                                            [
                                                -3.7999999999999994,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                2.4666666666666686,
                                                0
                                            ],
                                            [
                                                1.7666666666666657,
                                                -1.1333333333333329
                                            ],
                                            [
                                                0.9666666666666638,
                                                -2.066666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -2.800000000000002
                                            ],
                                            [
                                                -0.9666666666666686,
                                                -2.0333333333333314
                                            ],
                                            [
                                                -1.7999999999999972,
                                                -1.0666666666666675
                                            ],
                                            [
                                                -3.733333333333332,
                                                0
                                            ],
                                            [
                                                -2.0333333333333337,
                                                2.6333333333333306
                                            ],
                                            [
                                                0,
                                                4.600000000000001
                                            ],
                                            [
                                                2.0333333333333337,
                                                2.699999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31,
                                                -16.6
                                            ],
                                            [
                                                37.35,
                                                -18.3
                                            ],
                                            [
                                                41.45,
                                                -23.1
                                            ],
                                            [
                                                42.9,
                                                -30.3
                                            ],
                                            [
                                                42.9,
                                                -33
                                            ],
                                            [
                                                41.45,
                                                -40.25
                                            ],
                                            [
                                                37.3,
                                                -44.9
                                            ],
                                            [
                                                30.9,
                                                -46.5
                                            ],
                                            [
                                                22.25,
                                                -42.55
                                            ],
                                            [
                                                19.2,
                                                -31.6
                                            ],
                                            [
                                                22.25,
                                                -20.65
                                            ],
                                            [
                                                31,
                                                -16.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ".",
            "fFamily": "BDO Grotesk",
            "size": 14,
            "style": "Bold",
            "w": 25,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19.8,
                                                0
                                            ],
                                            [
                                                5.2,
                                                0
                                            ],
                                            [
                                                5.2,
                                                -14.9
                                            ],
                                            [
                                                19.8,
                                                -14.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "S",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 64.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.400000000000001,
                                                2.099999999999999
                                            ],
                                            [
                                                2.4333333333333322,
                                                1.1000000000000039
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.5,
                                                -1.966666666666664
                                            ],
                                            [
                                                0,
                                                -3.133333333333335
                                            ],
                                            [
                                                -1.5333333333333339,
                                                -1.5333333333333314
                                            ],
                                            [
                                                -2.8999999999999986,
                                                -0.9666666666666638
                                            ],
                                            [
                                                -3.999999999999998,
                                                -0.8666666666666648
                                            ],
                                            [
                                                -2.800000000000002,
                                                -0.9333333333333323
                                            ],
                                            [
                                                -2.2333333333333294,
                                                -1.5333333333333314
                                            ],
                                            [
                                                -1.3000000000000018,
                                                -2.4666666666666663
                                            ],
                                            [
                                                0,
                                                -3.599999999999999
                                            ],
                                            [
                                                2.1666666666666665,
                                                -3.233333333333333
                                            ],
                                            [
                                                4.13333333333333,
                                                -1.8
                                            ],
                                            [
                                                5.933333333333333,
                                                0
                                            ],
                                            [
                                                4.166666666666667,
                                                2
                                            ],
                                            [
                                                2.266666666666667,
                                                3.6
                                            ],
                                            [
                                                0.13333333333333344,
                                                4.733333333333332
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.233333333333333,
                                                -2.7999999999999994
                                            ],
                                            [
                                                -5.466666666666664,
                                                0
                                            ],
                                            [
                                                -3,
                                                1.8666666666666665
                                            ],
                                            [
                                                0,
                                                4.3999999999999995
                                            ],
                                            [
                                                1.6000000000000039,
                                                1.5666666666666675
                                            ],
                                            [
                                                2.599999999999999,
                                                0.8333333333333334
                                            ],
                                            [
                                                3.133333333333335,
                                                0.6666666666666666
                                            ],
                                            [
                                                3.1666666666666665,
                                                1.1999999999999982
                                            ],
                                            [
                                                2.1,
                                                1.6333333333333304
                                            ],
                                            [
                                                1.0333333333333325,
                                                2.2666666666666657
                                            ],
                                            [
                                                0,
                                                3
                                            ],
                                            [
                                                -2.1,
                                                3
                                            ],
                                            [
                                                -3.833333333333332,
                                                1.6999999999999982
                                            ],
                                            [
                                                -5.066666666666667,
                                                0
                                            ],
                                            [
                                                -4.733333333333334,
                                                -3.9666666666666686
                                            ],
                                            [
                                                -0.2666666666666657,
                                                -6.599999999999999
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.13333333333333522,
                                                -3.0666666666666678
                                            ],
                                            [
                                                -1.400000000000001,
                                                -2.099999999999999
                                            ],
                                            [
                                                -2.4333333333333322,
                                                -1.0999999999999943
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                1.966666666666664
                                            ],
                                            [
                                                0,
                                                2.6666666666666665
                                            ],
                                            [
                                                1.5333333333333339,
                                                1.533333333333336
                                            ],
                                            [
                                                2.900000000000001,
                                                0.9666666666666686
                                            ],
                                            [
                                                3,
                                                0.6000000000000038
                                            ],
                                            [
                                                2.800000000000002,
                                                0.9333333333333323
                                            ],
                                            [
                                                2.2333333333333343,
                                                1.533333333333336
                                            ],
                                            [
                                                1.2999999999999972,
                                                2.4666666666666663
                                            ],
                                            [
                                                0,
                                                4.333333333333335
                                            ],
                                            [
                                                -2.1666666666666665,
                                                3.233333333333333
                                            ],
                                            [
                                                -4.1333333333333355,
                                                1.8
                                            ],
                                            [
                                                -5.8,
                                                0
                                            ],
                                            [
                                                -4.166666666666667,
                                                -2
                                            ],
                                            [
                                                -2.266666666666667,
                                                -3.6
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.20000000000000048,
                                                5.266666666666668
                                            ],
                                            [
                                                3.2333333333333343,
                                                2.8000000000000003
                                            ],
                                            [
                                                4.933333333333337,
                                                0
                                            ],
                                            [
                                                3,
                                                -1.8666666666666671
                                            ],
                                            [
                                                0,
                                                -2.9333333333333322
                                            ],
                                            [
                                                -1.599999999999999,
                                                -1.5666666666666675
                                            ],
                                            [
                                                -2.599999999999999,
                                                -0.8333333333333334
                                            ],
                                            [
                                                -4.266666666666666,
                                                -0.9333333333333323
                                            ],
                                            [
                                                -3.1666666666666665,
                                                -1.2000000000000028
                                            ],
                                            [
                                                -2.1,
                                                -1.6333333333333353
                                            ],
                                            [
                                                -1.0333333333333339,
                                                -2.2666666666666657
                                            ],
                                            [
                                                0,
                                                -4
                                            ],
                                            [
                                                2.1,
                                                -3
                                            ],
                                            [
                                                3.8333333333333335,
                                                -1.7000000000000075
                                            ],
                                            [
                                                8.333333333333334,
                                                0
                                            ],
                                            [
                                                4.733333333333334,
                                                3.9666666666666686
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                59.1,
                                                -52.1
                                            ],
                                            [
                                                48.7,
                                                -50.9
                                            ],
                                            [
                                                46.4,
                                                -58.65
                                            ],
                                            [
                                                40.65,
                                                -63.45
                                            ],
                                            [
                                                32,
                                                -65.1
                                            ],
                                            [
                                                21.25,
                                                -62.15
                                            ],
                                            [
                                                17.5,
                                                -54.5
                                            ],
                                            [
                                                19.8,
                                                -48.2
                                            ],
                                            [
                                                26.45,
                                                -44.45
                                            ],
                                            [
                                                36.8,
                                                -41.7
                                            ],
                                            [
                                                45.5,
                                                -39.4
                                            ],
                                            [
                                                53.05,
                                                -35.7
                                            ],
                                            [
                                                58.35,
                                                -29.7
                                            ],
                                            [
                                                60.3,
                                                -20.6
                                            ],
                                            [
                                                57.05,
                                                -9.25
                                            ],
                                            [
                                                47.6,
                                                -1.7
                                            ],
                                            [
                                                32.5,
                                                1
                                            ],
                                            [
                                                17.55,
                                                -2
                                            ],
                                            [
                                                7.9,
                                                -10.4
                                            ],
                                            [
                                                4.3,
                                                -22.9
                                            ],
                                            [
                                                14.6,
                                                -24.1
                                            ],
                                            [
                                                19.75,
                                                -12
                                            ],
                                            [
                                                32.8,
                                                -7.8
                                            ],
                                            [
                                                44.7,
                                                -10.6
                                            ],
                                            [
                                                49.2,
                                                -20
                                            ],
                                            [
                                                46.8,
                                                -26.75
                                            ],
                                            [
                                                40.5,
                                                -30.35
                                            ],
                                            [
                                                31.9,
                                                -32.6
                                            ],
                                            [
                                                20.75,
                                                -35.8
                                            ],
                                            [
                                                12.85,
                                                -40.05
                                            ],
                                            [
                                                8.15,
                                                -45.9
                                            ],
                                            [
                                                6.6,
                                                -53.8
                                            ],
                                            [
                                                9.75,
                                                -64.3
                                            ],
                                            [
                                                18.65,
                                                -71.35
                                            ],
                                            [
                                                32,
                                                -73.9
                                            ],
                                            [
                                                51.6,
                                                -67.95
                                            ],
                                            [
                                                59.1,
                                                -52.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "u",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 61.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.400000000000001,
                                                3.5
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.133333333333335,
                                                -1.8999999999999997
                                            ],
                                            [
                                                -3.5333333333333337,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                1.2000000000000004
                                            ],
                                            [
                                                -1.2333333333333343,
                                                2.099999999999999
                                            ],
                                            [
                                                0,
                                                2.7999999999999994
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.1000000000000036,
                                                -1.7
                                            ],
                                            [
                                                3.599999999999999,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.466666666666666,
                                                0
                                            ],
                                            [
                                                -3.4,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.4666666666666672
                                            ],
                                            [
                                                2.133333333333333,
                                                1.900000000000001
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                2.2333333333333294,
                                                -1.2000000000000004
                                            ],
                                            [
                                                1.2333333333333343,
                                                -2.1000000000000014
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7333333333333296,
                                                2.9333333333333336
                                            ],
                                            [
                                                -3.099999999999999,
                                                1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27,
                                                1
                                            ],
                                            [
                                                12.2,
                                                -4.25
                                            ],
                                            [
                                                7.1,
                                                -18.2
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -19.1
                                            ],
                                            [
                                                20.6,
                                                -11.05
                                            ],
                                            [
                                                29.1,
                                                -8.2
                                            ],
                                            [
                                                36.95,
                                                -10
                                            ],
                                            [
                                                42.15,
                                                -14.95
                                            ],
                                            [
                                                44,
                                                -22.3
                                            ],
                                            [
                                                44,
                                                -56.3
                                            ],
                                            [
                                                54.3,
                                                -56.3
                                            ],
                                            [
                                                54.3,
                                                0
                                            ],
                                            [
                                                44.8,
                                                0
                                            ],
                                            [
                                                44.3,
                                                -8.5
                                            ],
                                            [
                                                37.05,
                                                -1.55
                                            ],
                                            [
                                                27,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "m",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 95.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3,
                                                1.6333333333333353
                                            ],
                                            [
                                                -3.4666666666666686,
                                                0
                                            ],
                                            [
                                                -3,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -1.400000000000001,
                                                -3.800000000000002
                                            ],
                                            [
                                                -3.299999999999997,
                                                1.9666666666666686
                                            ],
                                            [
                                                -3.933333333333337,
                                                0
                                            ],
                                            [
                                                -3.199999999999998,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                -5.799999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8000000000000018,
                                                2.0333333333333314
                                            ],
                                            [
                                                3.4666666666666686,
                                                0
                                            ],
                                            [
                                                2.199999999999998,
                                                -1.2666666666666657
                                            ],
                                            [
                                                1.2333333333333296,
                                                -2.366666666666665
                                            ],
                                            [
                                                0,
                                                -3.2666666666666706
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7333333333333343,
                                                2.3333333333333335
                                            ],
                                            [
                                                3.7333333333333343,
                                                0
                                            ],
                                            [
                                                2.133333333333333,
                                                -1.3333333333333333
                                            ],
                                            [
                                                1.2000000000000004,
                                                -2.300000000000002
                                            ],
                                            [
                                                0,
                                                -2.933333333333337
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666647,
                                                -3.400000000000001
                                            ],
                                            [
                                                3,
                                                -1.6333333333333304
                                            ],
                                            [
                                                3.866666666666665,
                                                0
                                            ],
                                            [
                                                3,
                                                1.9333333333333325
                                            ],
                                            [
                                                1.7333333333333343,
                                                -3.7333333333333343
                                            ],
                                            [
                                                3.300000000000002,
                                                -1.966666666666664
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                3.199999999999998,
                                                3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -1.8000000000000018,
                                                -2.0333333333333363
                                            ],
                                            [
                                                -2.799999999999997,
                                                0
                                            ],
                                            [
                                                -2.200000000000003,
                                                1.2666666666666704
                                            ],
                                            [
                                                -1.2333333333333343,
                                                2.366666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -1.7333333333333296,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2.800000000000002,
                                                0
                                            ],
                                            [
                                                -2.133333333333333,
                                                1.3333333333333333
                                            ],
                                            [
                                                -1.2000000000000004,
                                                2.299999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.4,
                                                -56.3
                                            ],
                                            [
                                                17.1,
                                                -47.3
                                            ],
                                            [
                                                24.4,
                                                -54.85
                                            ],
                                            [
                                                34.1,
                                                -57.3
                                            ],
                                            [
                                                44.4,
                                                -54.4
                                            ],
                                            [
                                                51,
                                                -45.8
                                            ],
                                            [
                                                58.55,
                                                -54.35
                                            ],
                                            [
                                                69.4,
                                                -57.3
                                            ],
                                            [
                                                83.2,
                                                -52.05
                                            ],
                                            [
                                                88,
                                                -38.1
                                            ],
                                            [
                                                88,
                                                0
                                            ],
                                            [
                                                77.7,
                                                0
                                            ],
                                            [
                                                77.7,
                                                -36.4
                                            ],
                                            [
                                                75,
                                                -45.05
                                            ],
                                            [
                                                67.1,
                                                -48.1
                                            ],
                                            [
                                                59.6,
                                                -46.2
                                            ],
                                            [
                                                54.45,
                                                -40.75
                                            ],
                                            [
                                                52.6,
                                                -32.3
                                            ],
                                            [
                                                52.6,
                                                0
                                            ],
                                            [
                                                42.4,
                                                0
                                            ],
                                            [
                                                42.4,
                                                -35.5
                                            ],
                                            [
                                                39.8,
                                                -44.6
                                            ],
                                            [
                                                31.6,
                                                -48.1
                                            ],
                                            [
                                                24.2,
                                                -46.1
                                            ],
                                            [
                                                19.2,
                                                -40.65
                                            ],
                                            [
                                                17.4,
                                                -32.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "a",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 58,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.233333333333333,
                                                2.9
                                            ],
                                            [
                                                0,
                                                4.666666666666666
                                            ],
                                            [
                                                -1.7,
                                                2.3333333333333335
                                            ],
                                            [
                                                -2.733333333333333,
                                                1.2999999999999996
                                            ],
                                            [
                                                -3.2000000000000006,
                                                0.6000000000000014
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9333333333333323,
                                                1.099999999999999
                                            ],
                                            [
                                                0,
                                                1.8000000000000018
                                            ],
                                            [
                                                1.6666666666666667,
                                                1.5666666666666675
                                            ],
                                            [
                                                4.399999999999999,
                                                0
                                            ],
                                            [
                                                2.5333333333333314,
                                                -1.6666666666666667
                                            ],
                                            [
                                                -0.06666666666666643,
                                                -3.4666666666666637
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.3,
                                                2.9666666666666686
                                            ],
                                            [
                                                -7,
                                                0
                                            ],
                                            [
                                                -3.2333333333333343,
                                                -1.2333333333333296
                                            ],
                                            [
                                                -1.6999999999999982,
                                                -2.5333333333333363
                                            ],
                                            [
                                                0,
                                                -3.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -0.6000000000000002
                                            ],
                                            [
                                                -0.8666666666666695,
                                                0
                                            ],
                                            [
                                                -0.2666666666666657,
                                                0.033333333333333805
                                            ],
                                            [
                                                -0.06666666666666288,
                                                0.06666666666666643
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.099999999999999,
                                                -0.1333333333333333
                                            ],
                                            [
                                                0.5333333333333362,
                                                0
                                            ],
                                            [
                                                1.7666666666666657,
                                                1.4000000000000001
                                            ],
                                            [
                                                0,
                                                2.866666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.6666666666666665,
                                                -1.9333333333333333
                                            ],
                                            [
                                                4.600000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.866666666666666,
                                                0
                                            ],
                                            [
                                                -3.233333333333334,
                                                -2.9
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                1.7000000000000004,
                                                -2.3333333333333335
                                            ],
                                            [
                                                2.733333333333333,
                                                -1.2999999999999996
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3,
                                                -0.5333333333333362
                                            ],
                                            [
                                                0.9333333333333323,
                                                -1.099999999999999
                                            ],
                                            [
                                                0,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -1.6666666666666667,
                                                -1.5666666666666629
                                            ],
                                            [
                                                -4.266666666666668,
                                                0
                                            ],
                                            [
                                                -2.5333333333333337,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.13333333333333344,
                                                -5.533333333333331
                                            ],
                                            [
                                                4.300000000000001,
                                                -2.9666666666666637
                                            ],
                                            [
                                                4.666666666666664,
                                                0
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.2333333333333343
                                            ],
                                            [
                                                1.7000000000000028,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2
                                            ],
                                            [
                                                0.7333333333333295,
                                                0.6000000000000002
                                            ],
                                            [
                                                0.5333333333333314,
                                                0
                                            ],
                                            [
                                                0.26666666666667044,
                                                -0.033333333333333215
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0.26666666666666666
                                            ],
                                            [
                                                -1.099999999999999,
                                                0.1333333333333334
                                            ],
                                            [
                                                -2.866666666666665,
                                                0
                                            ],
                                            [
                                                -1.7666666666666657,
                                                -1.3999999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.400000000000001,
                                                3.1333333333333333
                                            ],
                                            [
                                                -3.6666666666666665,
                                                1.9333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                22.7,
                                                1
                                            ],
                                            [
                                                9.05,
                                                -3.35
                                            ],
                                            [
                                                4.2,
                                                -14.7
                                            ],
                                            [
                                                6.75,
                                                -23.8
                                            ],
                                            [
                                                13.4,
                                                -29.25
                                            ],
                                            [
                                                22.3,
                                                -32.1
                                            ],
                                            [
                                                34.1,
                                                -34.3
                                            ],
                                            [
                                                40,
                                                -36.75
                                            ],
                                            [
                                                41.4,
                                                -41.1
                                            ],
                                            [
                                                38.9,
                                                -46.95
                                            ],
                                            [
                                                29.8,
                                                -49.3
                                            ],
                                            [
                                                19.6,
                                                -46.8
                                            ],
                                            [
                                                15.9,
                                                -39.1
                                            ],
                                            [
                                                6.2,
                                                -40.1
                                            ],
                                            [
                                                12.85,
                                                -52.85
                                            ],
                                            [
                                                29.8,
                                                -57.3
                                            ],
                                            [
                                                41.65,
                                                -55.45
                                            ],
                                            [
                                                49.05,
                                                -49.8
                                            ],
                                            [
                                                51.6,
                                                -40.3
                                            ],
                                            [
                                                51.6,
                                                -11.9
                                            ],
                                            [
                                                52.7,
                                                -8
                                            ],
                                            [
                                                55.1,
                                                -7.1
                                            ],
                                            [
                                                56.3,
                                                -7.15
                                            ],
                                            [
                                                56.8,
                                                -7.3
                                            ],
                                            [
                                                57.4,
                                                -7.3
                                            ],
                                            [
                                                57.4,
                                                0
                                            ],
                                            [
                                                54.75,
                                                0.6
                                            ],
                                            [
                                                52.3,
                                                0.8
                                            ],
                                            [
                                                45.35,
                                                -1.3
                                            ],
                                            [
                                                42.7,
                                                -7.7
                                            ],
                                            [
                                                42.7,
                                                -9.5
                                            ],
                                            [
                                                35.1,
                                                -1.9
                                            ],
                                            [
                                                22.7,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8999999999999986,
                                                1.7
                                            ],
                                            [
                                                -1,
                                                3.066666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4333333333333325,
                                                -0.3999999999999986
                                            ],
                                            [
                                                2.599999999999999,
                                                -0.5333333333333338
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3666666666666671,
                                                -1.6666666666666667
                                            ],
                                            [
                                                0,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2,
                                                -1.3333333333333333
                                            ],
                                            [
                                                -3.0666666666666678,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -1.7000000000000004
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0.6666666666666666
                                            ],
                                            [
                                                -1.4333333333333371,
                                                0.40000000000000097
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.2,
                                                0.8666666666666671
                                            ],
                                            [
                                                -1.3666666666666671,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                2.866666666666667
                                            ],
                                            [
                                                2,
                                                1.3333333333333328
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                25.3,
                                                -7.2
                                            ],
                                            [
                                                35.65,
                                                -9.75
                                            ],
                                            [
                                                41.5,
                                                -16.9
                                            ],
                                            [
                                                41.5,
                                                -29.8
                                            ],
                                            [
                                                42.6,
                                                -29.4
                                            ],
                                            [
                                                39.45,
                                                -27.8
                                            ],
                                            [
                                                33.4,
                                                -26.4
                                            ],
                                            [
                                                25.1,
                                                -24.7
                                            ],
                                            [
                                                16.75,
                                                -20.9
                                            ],
                                            [
                                                14.7,
                                                -15.5
                                            ],
                                            [
                                                17.7,
                                                -9.2
                                            ],
                                            [
                                                25.3,
                                                -7.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "r",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 35.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.2999999999999994,
                                                1.533333333333336
                                            ],
                                            [
                                                -3,
                                                0
                                            ],
                                            [
                                                -1,
                                                -0.40000000000000097
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7000000000000028,
                                                0.09999999999999905
                                            ],
                                            [
                                                0.6666666666666666,
                                                0
                                            ],
                                            [
                                                2.2999999999999994,
                                                -2.3333333333333335
                                            ],
                                            [
                                                0.3333333333333333,
                                                -3.933333333333337
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4666666666666686,
                                                -2.866666666666665
                                            ],
                                            [
                                                2.2999999999999994,
                                                -1.5333333333333314
                                            ],
                                            [
                                                2.0666666666666678,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333314,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.6999999999999981,
                                                -0.1000000000000038
                                            ],
                                            [
                                                -3.7999999999999994,
                                                0
                                            ],
                                            [
                                                -2.300000000000002,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.3,
                                                -56.3
                                            ],
                                            [
                                                16.9,
                                                -48
                                            ],
                                            [
                                                22.55,
                                                -54.6
                                            ],
                                            [
                                                30.5,
                                                -56.9
                                            ],
                                            [
                                                35.1,
                                                -56.3
                                            ],
                                            [
                                                35.1,
                                                -46.6
                                            ],
                                            [
                                                34.4,
                                                -46.6
                                            ],
                                            [
                                                32.55,
                                                -47.05
                                            ],
                                            [
                                                30.5,
                                                -47.2
                                            ],
                                            [
                                                21.35,
                                                -43.7
                                            ],
                                            [
                                                17.4,
                                                -34.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "i",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 24.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -78.6
                                            ],
                                            [
                                                17,
                                                -78.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "s",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 54.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.266666666666668,
                                                3.266666666666667
                                            ],
                                            [
                                                0.19999999999999987,
                                                5.733333333333332
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.5333333333333337,
                                                -2.2000000000000006
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                1.3
                                            ],
                                            [
                                                0,
                                                3.0666666666666664
                                            ],
                                            [
                                                0.8666666666666695,
                                                1.0666666666666675
                                            ],
                                            [
                                                1.5666666666666675,
                                                0.6333333333333329
                                            ],
                                            [
                                                2.066666666666665,
                                                0.3999999999999986
                                            ],
                                            [
                                                2.3999999999999986,
                                                0.5333333333333338
                                            ],
                                            [
                                                2.4666666666666663,
                                                1.400000000000001
                                            ],
                                            [
                                                1.2,
                                                2.099999999999999
                                            ],
                                            [
                                                0,
                                                2.8666666666666694
                                            ],
                                            [
                                                -1.7333333333333332,
                                                2.400000000000001
                                            ],
                                            [
                                                -3.2000000000000006,
                                                1.3333333333333333
                                            ],
                                            [
                                                -4.333333333333333,
                                                0
                                            ],
                                            [
                                                -3.2666666666666657,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -1.900000000000001,
                                                -2.5333333333333314
                                            ],
                                            [
                                                -0.1999999999999981,
                                                -3.866666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                2
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                1.8333333333333333,
                                                -1.4333333333333371
                                            ],
                                            [
                                                0,
                                                -2.2666666666666657
                                            ],
                                            [
                                                -1.099999999999999,
                                                -1.1666666666666667
                                            ],
                                            [
                                                -2.3333333333333335,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -3.6666666666666665,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -2.2666666666666706,
                                                -0.7666666666666657
                                            ],
                                            [
                                                -1.5666666666666675,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -0.8333333333333334,
                                                -1.8999999999999986
                                            ],
                                            [
                                                0,
                                                -2.7999999999999994
                                            ],
                                            [
                                                3.7666666666666657,
                                                -3.033333333333333
                                            ],
                                            [
                                                7.866666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -7.0666666666666655,
                                                0
                                            ],
                                            [
                                                -4.266666666666667,
                                                -3.266666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.4666666666666663
                                            ],
                                            [
                                                2.5333333333333337,
                                                2.1999999999999997
                                            ],
                                            [
                                                3.6666666666666665,
                                                0
                                            ],
                                            [
                                                2.2333333333333343,
                                                -1.2999999999999996
                                            ],
                                            [
                                                0,
                                                -1.8666666666666671
                                            ],
                                            [
                                                -0.8666666666666648,
                                                -1.0666666666666653
                                            ],
                                            [
                                                -1.5666666666666675,
                                                -0.6333333333333352
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -0.40000000000000097
                                            ],
                                            [
                                                -3.800000000000002,
                                                -0.8666666666666648
                                            ],
                                            [
                                                -2.4666666666666663,
                                                -1.400000000000001
                                            ],
                                            [
                                                -1.2,
                                                -2.099999999999999
                                            ],
                                            [
                                                0,
                                                -3.2666666666666657
                                            ],
                                            [
                                                1.7333333333333332,
                                                -2.3999999999999964
                                            ],
                                            [
                                                3.1999999999999993,
                                                -1.3333333333333333
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.2666666666666657,
                                                1.2666666666666657
                                            ],
                                            [
                                                1.900000000000001,
                                                2.5333333333333363
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.2666666666666706
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -2
                                            ],
                                            [
                                                -3.3999999999999986,
                                                0
                                            ],
                                            [
                                                -1.8333333333333333,
                                                1.4333333333333325
                                            ],
                                            [
                                                0,
                                                1.9333333333333325
                                            ],
                                            [
                                                1.1000000000000014,
                                                1.1666666666666667
                                            ],
                                            [
                                                2.3333333333333335,
                                                0.7333333333333343
                                            ],
                                            [
                                                2.799999999999997,
                                                0.5333333333333314
                                            ],
                                            [
                                                2.2666666666666657,
                                                0.766666666666668
                                            ],
                                            [
                                                1.5666666666666629,
                                                1.2666666666666682
                                            ],
                                            [
                                                0.8333333333333334,
                                                1.900000000000001
                                            ],
                                            [
                                                0,
                                                4.933333333333334
                                            ],
                                            [
                                                -3.7666666666666657,
                                                3.033333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27.2,
                                                1
                                            ],
                                            [
                                                10.2,
                                                -3.9
                                            ],
                                            [
                                                3.5,
                                                -17.4
                                            ],
                                            [
                                                13.5,
                                                -18.5
                                            ],
                                            [
                                                17.3,
                                                -10
                                            ],
                                            [
                                                27.5,
                                                -6.7
                                            ],
                                            [
                                                36.35,
                                                -8.65
                                            ],
                                            [
                                                39.7,
                                                -15.2
                                            ],
                                            [
                                                38.4,
                                                -19.6
                                            ],
                                            [
                                                34.75,
                                                -22.15
                                            ],
                                            [
                                                29.3,
                                                -23.7
                                            ],
                                            [
                                                22.6,
                                                -25.1
                                            ],
                                            [
                                                13.2,
                                                -28.5
                                            ],
                                            [
                                                7.7,
                                                -33.75
                                            ],
                                            [
                                                5.9,
                                                -41.2
                                            ],
                                            [
                                                8.5,
                                                -49.7
                                            ],
                                            [
                                                15.9,
                                                -55.3
                                            ],
                                            [
                                                27.2,
                                                -57.3
                                            ],
                                            [
                                                38.6,
                                                -55.4
                                            ],
                                            [
                                                46.35,
                                                -49.7
                                            ],
                                            [
                                                49.5,
                                                -40.1
                                            ],
                                            [
                                                39.6,
                                                -38.8
                                            ],
                                            [
                                                36.5,
                                                -46.7
                                            ],
                                            [
                                                26.9,
                                                -49.7
                                            ],
                                            [
                                                19.05,
                                                -47.55
                                            ],
                                            [
                                                16.3,
                                                -42
                                            ],
                                            [
                                                17.95,
                                                -37.35
                                            ],
                                            [
                                                23.1,
                                                -34.5
                                            ],
                                            [
                                                32.1,
                                                -32.3
                                            ],
                                            [
                                                39.7,
                                                -30.35
                                            ],
                                            [
                                                45.45,
                                                -27.3
                                            ],
                                            [
                                                49.05,
                                                -22.55
                                            ],
                                            [
                                                50.3,
                                                -15.5
                                            ],
                                            [
                                                44.65,
                                                -3.55
                                            ],
                                            [
                                                27.2,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "e",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 58.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.033333333333331,
                                                2.3000000000000003
                                            ],
                                            [
                                                2.233333333333334,
                                                4.333333333333333
                                            ],
                                            [
                                                0,
                                                6.1333333333333355
                                            ],
                                            [
                                                -2.1,
                                                4.36666666666667
                                            ],
                                            [
                                                -3.9333333333333336,
                                                2.4333333333333322
                                            ],
                                            [
                                                -5.600000000000001,
                                                0
                                            ],
                                            [
                                                -3.900000000000001,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2,
                                                -4.699999999999998
                                            ],
                                            [
                                                0.46666666666666384,
                                                -7.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.5666666666666678,
                                                3.599999999999999
                                            ],
                                            [
                                                5.333333333333333,
                                                0
                                            ],
                                            [
                                                3.066666666666665,
                                                -3.2666666666666706
                                            ],
                                            [
                                                0,
                                                -7.399999999999999
                                            ],
                                            [
                                                -2.933333333333335,
                                                -3.4333333333333336
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.5333333333333363,
                                                1.8666666666666671
                                            ],
                                            [
                                                -0.5999999999999991,
                                                3.3333333333333344
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.1333333333333306,
                                                -2.5333333333333337
                                            ],
                                            [
                                                3.3333333333333335,
                                                -1.4333333333333333
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4.033333333333334,
                                                -2.3000000000000003
                                            ],
                                            [
                                                -2.233333333333334,
                                                -4.333333333333332
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                2.1,
                                                -4.3666666666666645
                                            ],
                                            [
                                                3.9333333333333322,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.333333333333333,
                                                0
                                            ],
                                            [
                                                3.8999999999999964,
                                                2.3333333333333335
                                            ],
                                            [
                                                2,
                                                4.699999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.8666666666666695,
                                                -5.8
                                            ],
                                            [
                                                -2.5666666666666678,
                                                -3.6000000000000036
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.0666666666666678,
                                                3.2666666666666657
                                            ],
                                            [
                                                0,
                                                7
                                            ],
                                            [
                                                2.9333333333333322,
                                                3.4333333333333336
                                            ],
                                            [
                                                4.13333333333333,
                                                0
                                            ],
                                            [
                                                2.5333333333333314,
                                                -1.866666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                3.4
                                            ],
                                            [
                                                -2.133333333333335,
                                                2.533333333333333
                                            ],
                                            [
                                                -3.3333333333333335,
                                                1.4333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31,
                                                1
                                            ],
                                            [
                                                16.85,
                                                -2.45
                                            ],
                                            [
                                                7.45,
                                                -12.4
                                            ],
                                            [
                                                4.1,
                                                -28.1
                                            ],
                                            [
                                                7.25,
                                                -43.45
                                            ],
                                            [
                                                16.3,
                                                -53.65
                                            ],
                                            [
                                                30.6,
                                                -57.3
                                            ],
                                            [
                                                44.45,
                                                -53.8
                                            ],
                                            [
                                                53.3,
                                                -43.25
                                            ],
                                            [
                                                55.6,
                                                -25.6
                                            ],
                                            [
                                                13,
                                                -25.6
                                            ],
                                            [
                                                13,
                                                -33.3
                                            ],
                                            [
                                                49.5,
                                                -33.3
                                            ],
                                            [
                                                44.8,
                                                -29.7
                                            ],
                                            [
                                                42.25,
                                                -43.8
                                            ],
                                            [
                                                30.4,
                                                -49.2
                                            ],
                                            [
                                                18.8,
                                                -44.3
                                            ],
                                            [
                                                14.2,
                                                -28.3
                                            ],
                                            [
                                                18.6,
                                                -12.65
                                            ],
                                            [
                                                31.1,
                                                -7.5
                                            ],
                                            [
                                                41.1,
                                                -10.3
                                            ],
                                            [
                                                45.8,
                                                -18.1
                                            ],
                                            [
                                                54.9,
                                                -16
                                            ],
                                            [
                                                50.7,
                                                -7.1
                                            ],
                                            [
                                                42.5,
                                                -1.15
                                            ],
                                            [
                                                31,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": " ",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 24,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": []
                    }
                ]
            }
        },
        {
            "ch": "t",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 31.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9666666666666661,
                                                1.6333333333333335
                                            ],
                                            [
                                                0,
                                                3.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333329,
                                                -0.6666666666666666
                                            ],
                                            [
                                                -1.8666666666666671,
                                                0
                                            ],
                                            [
                                                -0.7000000000000005,
                                                0.06666666666666643
                                            ],
                                            [
                                                -0.5333333333333314,
                                                0.13333333333333405
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2666666666666657,
                                                -0.13333333333333333
                                            ],
                                            [
                                                1.0666666666666653,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -3.7333333333333343,
                                                0
                                            ],
                                            [
                                                -1.9666666666666661,
                                                -1.6333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2.0666666666666664
                                            ],
                                            [
                                                0.6333333333333329,
                                                0.6666666666666666
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                0.7000000000000005,
                                                -0.06666666666666643
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.4666666666666661,
                                                0.26666666666666666
                                            ],
                                            [
                                                -1.2666666666666682,
                                                0.1333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.3,
                                                0.7
                                            ],
                                            [
                                                12.75,
                                                -1.75
                                            ],
                                            [
                                                9.8,
                                                -8.8
                                            ],
                                            [
                                                9.8,
                                                -72
                                            ],
                                            [
                                                19.8,
                                                -73
                                            ],
                                            [
                                                19.8,
                                                -13
                                            ],
                                            [
                                                20.75,
                                                -8.9
                                            ],
                                            [
                                                24.5,
                                                -7.9
                                            ],
                                            [
                                                27.05,
                                                -8
                                            ],
                                            [
                                                28.9,
                                                -8.3
                                            ],
                                            [
                                                28.9,
                                                -0.1
                                            ],
                                            [
                                                24.8,
                                                0.5
                                            ],
                                            [
                                                21.3,
                                                0.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14.8,
                                                -48.3
                                            ],
                                            [
                                                2.3,
                                                -48.3
                                            ],
                                            [
                                                2.3,
                                                -56.3
                                            ],
                                            [
                                                14.8,
                                                -56.3
                                            ],
                                            [
                                                14.8,
                                                -48.3
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                28.9,
                                                -56.3
                                            ],
                                            [
                                                28.9,
                                                -48.3
                                            ],
                                            [
                                                14.8,
                                                -48.3
                                            ],
                                            [
                                                14.8,
                                                -56.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "h",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.9666666666666686,
                                                1.466666666666664
                                            ],
                                            [
                                                -3.7999999999999994,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -3.2333333333333343
                                            ],
                                            [
                                                0,
                                                -6.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2,
                                                2.0666666666666678
                                            ],
                                            [
                                                4.066666666666667,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.3666666666666671,
                                                -2.199999999999998
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -3.133333333333335
                                            ],
                                            [
                                                2.9666666666666663,
                                                -1.4666666666666686
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                3.6333333333333306,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.5333333333333363
                                            ],
                                            [
                                                -2,
                                                -2.066666666666663
                                            ],
                                            [
                                                -2.7333333333333343,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                1.1666666666666667
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.4,
                                                -79
                                            ],
                                            [
                                                17.4,
                                                -48.4
                                            ],
                                            [
                                                25.35,
                                                -55.3
                                            ],
                                            [
                                                35.5,
                                                -57.5
                                            ],
                                            [
                                                49.45,
                                                -52.65
                                            ],
                                            [
                                                54.9,
                                                -37.8
                                            ],
                                            [
                                                54.9,
                                                0
                                            ],
                                            [
                                                44.7,
                                                0
                                            ],
                                            [
                                                44.7,
                                                -36.8
                                            ],
                                            [
                                                41.7,
                                                -45.2
                                            ],
                                            [
                                                32.6,
                                                -48.3
                                            ],
                                            [
                                                25,
                                                -46.55
                                            ],
                                            [
                                                19.45,
                                                -41.5
                                            ],
                                            [
                                                17.4,
                                                -33.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "c",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 58.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4,
                                                2.433333333333333
                                            ],
                                            [
                                                2.1999999999999993,
                                                4.366666666666666
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                -2.233333333333334,
                                                4.3666666666666645
                                            ],
                                            [
                                                -4.033333333333334,
                                                2.400000000000001
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4.166666666666667,
                                                -3.566666666666663
                                            ],
                                            [
                                                -0.7333333333333295,
                                                -5.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.5333333333333363,
                                                1.9333333333333325
                                            ],
                                            [
                                                3.933333333333335,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.5666666666666678
                                            ],
                                            [
                                                0,
                                                -6.333333333333336
                                            ],
                                            [
                                                -2.866666666666666,
                                                -3.6
                                            ],
                                            [
                                                -5,
                                                0
                                            ],
                                            [
                                                -2.5333333333333314,
                                                2
                                            ],
                                            [
                                                -0.3999999999999962,
                                                3.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.1666666666666665,
                                                -2.866666666666666
                                            ],
                                            [
                                                3.400000000000001,
                                                -1.5
                                            ],
                                            [
                                                4.333333333333331,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4,
                                                -2.4333333333333336
                                            ],
                                            [
                                                -2.2000000000000006,
                                                -4.366666666666667
                                            ],
                                            [
                                                0,
                                                -5.866666666666667
                                            ],
                                            [
                                                2.233333333333334,
                                                -4.36666666666667
                                            ],
                                            [
                                                4.033333333333331,
                                                -2.3999999999999964
                                            ],
                                            [
                                                6.800000000000002,
                                                0
                                            ],
                                            [
                                                4.166666666666667,
                                                3.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.3999999999999962,
                                                -3.9333333333333322
                                            ],
                                            [
                                                -2.5333333333333314,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -2.9,
                                                3.566666666666663
                                            ],
                                            [
                                                0,
                                                6.266666666666666
                                            ],
                                            [
                                                2.866666666666667,
                                                3.6
                                            ],
                                            [
                                                3.933333333333335,
                                                0
                                            ],
                                            [
                                                2.5333333333333363,
                                                -2
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333314,
                                                4.066666666666667
                                            ],
                                            [
                                                -2.1666666666666665,
                                                2.866666666666667
                                            ],
                                            [
                                                -3.400000000000001,
                                                1.5
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.8,
                                                0.9
                                            ],
                                            [
                                                16.7,
                                                -2.75
                                            ],
                                            [
                                                7.4,
                                                -12.95
                                            ],
                                            [
                                                4.1,
                                                -28.2
                                            ],
                                            [
                                                7.45,
                                                -43.55
                                            ],
                                            [
                                                16.85,
                                                -53.7
                                            ],
                                            [
                                                31,
                                                -57.3
                                            ],
                                            [
                                                47.45,
                                                -51.95
                                            ],
                                            [
                                                54.8,
                                                -37.9
                                            ],
                                            [
                                                44.8,
                                                -36.7
                                            ],
                                            [
                                                40.4,
                                                -45.5
                                            ],
                                            [
                                                30.7,
                                                -48.4
                                            ],
                                            [
                                                18.95,
                                                -43.05
                                            ],
                                            [
                                                14.6,
                                                -28.2
                                            ],
                                            [
                                                18.9,
                                                -13.4
                                            ],
                                            [
                                                30.7,
                                                -8
                                            ],
                                            [
                                                40.4,
                                                -11
                                            ],
                                            [
                                                44.8,
                                                -19.5
                                            ],
                                            [
                                                54.8,
                                                -18.3
                                            ],
                                            [
                                                50.75,
                                                -7.9
                                            ],
                                            [
                                                42.4,
                                                -1.35
                                            ],
                                            [
                                                30.8,
                                                0.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "o",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 61.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.033333333333334,
                                                2.433333333333333
                                            ],
                                            [
                                                2.1999999999999993,
                                                4.333333333333334
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                -2.233333333333334,
                                                4.36666666666667
                                            ],
                                            [
                                                -4.033333333333334,
                                                2.4333333333333322
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4,
                                                -2.4333333333333322
                                            ],
                                            [
                                                -2.199999999999998,
                                                -4.3666666666666645
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                2.200000000000003,
                                                -4.366666666666667
                                            ],
                                            [
                                                4,
                                                -2.4
                                            ],
                                            [
                                                5.400000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.466666666666666,
                                                0
                                            ],
                                            [
                                                -4.033333333333334,
                                                -2.433333333333333
                                            ],
                                            [
                                                -2.2000000000000006,
                                                -4.333333333333333
                                            ],
                                            [
                                                0,
                                                -5.933333333333333
                                            ],
                                            [
                                                2.233333333333334,
                                                -4.3666666666666645
                                            ],
                                            [
                                                4.033333333333331,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.400000000000001,
                                                0
                                            ],
                                            [
                                                4,
                                                2.4333333333333322
                                            ],
                                            [
                                                2.200000000000003,
                                                4.36666666666667
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ],
                                            [
                                                -2.199999999999998,
                                                4.366666666666666
                                            ],
                                            [
                                                -4,
                                                2.4
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31,
                                                1
                                            ],
                                            [
                                                16.75,
                                                -2.65
                                            ],
                                            [
                                                7.4,
                                                -12.8
                                            ],
                                            [
                                                4.1,
                                                -28
                                            ],
                                            [
                                                7.45,
                                                -43.45
                                            ],
                                            [
                                                16.85,
                                                -53.65
                                            ],
                                            [
                                                31,
                                                -57.3
                                            ],
                                            [
                                                45.1,
                                                -53.65
                                            ],
                                            [
                                                54.4,
                                                -43.45
                                            ],
                                            [
                                                57.7,
                                                -28.1
                                            ],
                                            [
                                                54.4,
                                                -12.75
                                            ],
                                            [
                                                45.1,
                                                -2.6
                                            ],
                                            [
                                                31,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8999999999999964,
                                                3.5999999999999996
                                            ],
                                            [
                                                0,
                                                6.399999999999999
                                            ],
                                            [
                                                2.900000000000001,
                                                3.5333333333333363
                                            ],
                                            [
                                                5.1333333333333355,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.633333333333335
                                            ],
                                            [
                                                0,
                                                -6.333333333333333
                                            ],
                                            [
                                                -2.9,
                                                -3.5666666666666664
                                            ],
                                            [
                                                -5.199999999999998,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                5.200000000000003,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.6000000000000014
                                            ],
                                            [
                                                0,
                                                -6.466666666666666
                                            ],
                                            [
                                                -2.8999999999999964,
                                                -3.5333333333333314
                                            ],
                                            [
                                                -5.266666666666666,
                                                0
                                            ],
                                            [
                                                -2.9,
                                                3.6333333333333306
                                            ],
                                            [
                                                0,
                                                6.400000000000001
                                            ],
                                            [
                                                2.900000000000001,
                                                3.566666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.9,
                                                -7.8
                                            ],
                                            [
                                                43.05,
                                                -13.2
                                            ],
                                            [
                                                47.4,
                                                -28.2
                                            ],
                                            [
                                                43.05,
                                                -43.2
                                            ],
                                            [
                                                31,
                                                -48.5
                                            ],
                                            [
                                                18.75,
                                                -43.05
                                            ],
                                            [
                                                14.4,
                                                -28.1
                                            ],
                                            [
                                                18.75,
                                                -13.15
                                            ],
                                            [
                                                30.9,
                                                -7.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "n",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3,
                                                1.5333333333333314
                                            ],
                                            [
                                                -3.866666666666667,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -3.2333333333333294
                                            ],
                                            [
                                                0,
                                                -6.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2,
                                                2.0666666666666678
                                            ],
                                            [
                                                4.066666666666667,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.3666666666666671,
                                                -2.200000000000003
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3999999999999986,
                                                -3.2666666666666706
                                            ],
                                            [
                                                3,
                                                -1.5333333333333314
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                3.6333333333333306,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.5333333333333314
                                            ],
                                            [
                                                -2,
                                                -2.0666666666666678
                                            ],
                                            [
                                                -2.7333333333333343,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                1.1666666666666667
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.5,
                                                -56.3
                                            ],
                                            [
                                                17.1,
                                                -47.8
                                            ],
                                            [
                                                25.2,
                                                -55
                                            ],
                                            [
                                                35.5,
                                                -57.3
                                            ],
                                            [
                                                49.45,
                                                -52.45
                                            ],
                                            [
                                                54.9,
                                                -37.6
                                            ],
                                            [
                                                54.9,
                                                0
                                            ],
                                            [
                                                44.7,
                                                0
                                            ],
                                            [
                                                44.7,
                                                -36.6
                                            ],
                                            [
                                                41.7,
                                                -45
                                            ],
                                            [
                                                32.6,
                                                -48.1
                                            ],
                                            [
                                                25,
                                                -46.35
                                            ],
                                            [
                                                19.45,
                                                -41.3
                                            ],
                                            [
                                                17.4,
                                                -33.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "f",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 32.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.6999999999999993,
                                                2.6666666666666665
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -1,
                                                -0.1000000000000038
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -0.1999999999999981
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.6000000000000014,
                                                0.1000000000000038
                                            ],
                                            [
                                                0.7333333333333343,
                                                0
                                            ],
                                            [
                                                1.2666666666666682,
                                                -1.0999999999999943
                                            ],
                                            [
                                                0,
                                                -2.9333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -4.533333333333331
                                            ],
                                            [
                                                2.7000000000000006,
                                                -2.6666666666666665
                                            ],
                                            [
                                                0.9333333333333323,
                                                0
                                            ],
                                            [
                                                1,
                                                0.09999999999999432
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.3999999999999986,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.5999999999999991,
                                                -0.09999999999999432
                                            ],
                                            [
                                                -2.3999999999999986,
                                                0
                                            ],
                                            [
                                                -1.2666666666666657,
                                                1.1000000000000039
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19,
                                                0
                                            ],
                                            [
                                                8.9,
                                                0
                                            ],
                                            [
                                                8.9,
                                                -64.7
                                            ],
                                            [
                                                12.95,
                                                -75.5
                                            ],
                                            [
                                                25.1,
                                                -79.5
                                            ],
                                            [
                                                28,
                                                -79.35
                                            ],
                                            [
                                                30.5,
                                                -78.9
                                            ],
                                            [
                                                30.5,
                                                -70.2
                                            ],
                                            [
                                                29.9,
                                                -70.2
                                            ],
                                            [
                                                28.4,
                                                -70.65
                                            ],
                                            [
                                                26.4,
                                                -70.8
                                            ],
                                            [
                                                20.9,
                                                -69.15
                                            ],
                                            [
                                                19,
                                                -63.1
                                            ],
                                            [
                                                19,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14,
                                                -48.3
                                            ],
                                            [
                                                0.7,
                                                -48.3
                                            ],
                                            [
                                                0.7,
                                                -56.3
                                            ],
                                            [
                                                14,
                                                -56.3
                                            ],
                                            [
                                                14,
                                                -48.3
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.7,
                                                -48.3
                                            ],
                                            [
                                                14,
                                                -48.3
                                            ],
                                            [
                                                14,
                                                -56.3
                                            ],
                                            [
                                                30.7,
                                                -56.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "\u0003",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 0
        },
        {
            "ch": "\r",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 0
        },
        {
            "ch": "l",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 24.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.3,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ".",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 21.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                16.1,
                                                0
                                            ],
                                            [
                                                5.6,
                                                0
                                            ],
                                            [
                                                5.6,
                                                -11.4
                                            ],
                                            [
                                                16.1,
                                                -11.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "@",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 98.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                1.4666666666666668
                                            ],
                                            [
                                                0.46666666666666856,
                                                3.5333333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.633333333333335,
                                                -1.7666666666666668
                                            ],
                                            [
                                                3.5333333333333363,
                                                0
                                            ],
                                            [
                                                2.633333333333333,
                                                3.233333333333333
                                            ],
                                            [
                                                0.06666666666666761,
                                                5
                                            ],
                                            [
                                                -1.0333333333333339,
                                                3.400000000000001
                                            ],
                                            [
                                                -1.9333333333333325,
                                                2.6333333333333306
                                            ],
                                            [
                                                -2.7666666666666657,
                                                1.5333333333333314
                                            ],
                                            [
                                                -3.4666666666666637,
                                                0
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -1.5666666666666675
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -2.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9333333333333277,
                                                -1.8999999999999997
                                            ],
                                            [
                                                -2.933333333333337,
                                                0
                                            ],
                                            [
                                                -1.7333333333333296,
                                                0.7999999999999995
                                            ],
                                            [
                                                -1.4666666666666686,
                                                1.7999999999999996
                                            ],
                                            [
                                                -0.8999999999999962,
                                                2.866666666666665
                                            ],
                                            [
                                                0,
                                                4.133333333333333
                                            ],
                                            [
                                                1.7666666666666704,
                                                4.13333333333333
                                            ],
                                            [
                                                3.233333333333339,
                                                3.099999999999999
                                            ],
                                            [
                                                4.5,
                                                1.7000000000000028
                                            ],
                                            [
                                                5.533333333333336,
                                                0
                                            ],
                                            [
                                                4.833333333333333,
                                                -2.133333333333335
                                            ],
                                            [
                                                3.599999999999999,
                                                -3.8333333333333335
                                            ],
                                            [
                                                2.0333333333333337,
                                                -5.099999999999999
                                            ],
                                            [
                                                0,
                                                -5.933333333333333
                                            ],
                                            [
                                                -3.233333333333333,
                                                -5.866666666666667
                                            ],
                                            [
                                                -5.666666666666667,
                                                -3.1999999999999997
                                            ],
                                            [
                                                -7.266666666666666,
                                                0
                                            ],
                                            [
                                                -4.566666666666667,
                                                1.7000000000000004
                                            ],
                                            [
                                                -3,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.099999999999994,
                                                -1.900000000000001
                                            ],
                                            [
                                                6.666666666666667,
                                                0
                                            ],
                                            [
                                                5.3666666666666645,
                                                2.133333333333333
                                            ],
                                            [
                                                3.900000000000001,
                                                3.966666666666667
                                            ],
                                            [
                                                2.1666666666666665,
                                                5.5
                                            ],
                                            [
                                                0,
                                                6.666666666666667
                                            ],
                                            [
                                                -2.4000000000000004,
                                                5.766666666666666
                                            ],
                                            [
                                                -4.266666666666666,
                                                4.266666666666666
                                            ],
                                            [
                                                -5.699999999999998,
                                                2.366666666666665
                                            ],
                                            [
                                                -6.599999999999999,
                                                0
                                            ],
                                            [
                                                -5.266666666666666,
                                                -1.8666666666666742
                                            ],
                                            [
                                                -3.866666666666665,
                                                -3.4666666666666637
                                            ],
                                            [
                                                -2.1000000000000036,
                                                -4.799999999999997
                                            ],
                                            [
                                                0,
                                                -5.800000000000002
                                            ],
                                            [
                                                1.4333333333333276,
                                                -3.7000000000000006
                                            ],
                                            [
                                                2.300000000000002,
                                                -2.266666666666667
                                            ],
                                            [
                                                2.699999999999998,
                                                -1.0000000000000007
                                            ],
                                            [
                                                2.5333333333333314,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -3.2666666666666706,
                                                0
                                            ],
                                            [
                                                -2.4333333333333322,
                                                -1.4666666666666661
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.6666666666666667,
                                                3.133333333333333
                                            ],
                                            [
                                                -2.6333333333333306,
                                                1.7666666666666668
                                            ],
                                            [
                                                -4.8666666666666645,
                                                0
                                            ],
                                            [
                                                -2.633333333333333,
                                                -3.233333333333333
                                            ],
                                            [
                                                0,
                                                -3.7999999999999994
                                            ],
                                            [
                                                1.0333333333333339,
                                                -3.400000000000001
                                            ],
                                            [
                                                1.9333333333333325,
                                                -2.633333333333335
                                            ],
                                            [
                                                2.7666666666666706,
                                                -1.533333333333336
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                1.5666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5999999999999943,
                                                2.9333333333333322
                                            ],
                                            [
                                                0.9333333333333371,
                                                1.8999999999999997
                                            ],
                                            [
                                                1.6666666666666667,
                                                0
                                            ],
                                            [
                                                1.7333333333333296,
                                                -0.7999999999999995
                                            ],
                                            [
                                                1.4666666666666686,
                                                -1.8000000000000018
                                            ],
                                            [
                                                0.9000000000000057,
                                                -2.866666666666667
                                            ],
                                            [
                                                0,
                                                -4.86666666666667
                                            ],
                                            [
                                                -1.766666666666661,
                                                -4.1333333333333355
                                            ],
                                            [
                                                -3.2333333333333294,
                                                -3.099999999999999
                                            ],
                                            [
                                                -4.5,
                                                -1.6999999999999982
                                            ],
                                            [
                                                -5.666666666666667,
                                                0
                                            ],
                                            [
                                                -4.833333333333333,
                                                2.1333333333333306
                                            ],
                                            [
                                                -3.599999999999999,
                                                3.8333333333333335
                                            ],
                                            [
                                                -2.0333333333333337,
                                                5.100000000000004
                                            ],
                                            [
                                                0,
                                                7.999999999999999
                                            ],
                                            [
                                                3.233333333333333,
                                                5.866666666666667
                                            ],
                                            [
                                                5.666666666666669,
                                                3.2000000000000006
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                4.566666666666663,
                                                -1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.9333333333333322
                                            ],
                                            [
                                                -5.100000000000004,
                                                1.8999999999999986
                                            ],
                                            [
                                                -6.400000000000001,
                                                0
                                            ],
                                            [
                                                -5.366666666666667,
                                                -2.133333333333333
                                            ],
                                            [
                                                -3.9,
                                                -3.966666666666667
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -5.499999999999999
                                            ],
                                            [
                                                0,
                                                -6.86666666666667
                                            ],
                                            [
                                                2.4000000000000004,
                                                -5.766666666666666
                                            ],
                                            [
                                                4.266666666666668,
                                                -4.266666666666666
                                            ],
                                            [
                                                5.700000000000003,
                                                -2.3666666666666742
                                            ],
                                            [
                                                6.333333333333333,
                                                0
                                            ],
                                            [
                                                5.26666666666667,
                                                1.8666666666666647
                                            ],
                                            [
                                                3.866666666666665,
                                                3.4666666666666686
                                            ],
                                            [
                                                2.0999999999999943,
                                                4.800000000000002
                                            ],
                                            [
                                                0,
                                                5.399999999999999
                                            ],
                                            [
                                                -1.4333333333333371,
                                                3.6999999999999993
                                            ],
                                            [
                                                -2.300000000000002,
                                                2.2666666666666657
                                            ],
                                            [
                                                -2.699999999999998,
                                                1
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                71.2,
                                                -5.8
                                            ],
                                            [
                                                62.65,
                                                -8
                                            ],
                                            [
                                                58.3,
                                                -15.5
                                            ],
                                            [
                                                58,
                                                -15.5
                                            ],
                                            [
                                                51.55,
                                                -8.15
                                            ],
                                            [
                                                42.3,
                                                -5.5
                                            ],
                                            [
                                                31.05,
                                                -10.35
                                            ],
                                            [
                                                27,
                                                -22.7
                                            ],
                                            [
                                                28.55,
                                                -33.5
                                            ],
                                            [
                                                33,
                                                -42.55
                                            ],
                                            [
                                                40.05,
                                                -48.8
                                            ],
                                            [
                                                49.4,
                                                -51.1
                                            ],
                                            [
                                                57.5,
                                                -48.75
                                            ],
                                            [
                                                61.6,
                                                -43
                                            ],
                                            [
                                                61.9,
                                                -43
                                            ],
                                            [
                                                63.1,
                                                -49.5
                                            ],
                                            [
                                                72.2,
                                                -49.5
                                            ],
                                            [
                                                66.6,
                                                -21.9
                                            ],
                                            [
                                                67.1,
                                                -14.65
                                            ],
                                            [
                                                72.9,
                                                -11.8
                                            ],
                                            [
                                                78,
                                                -13
                                            ],
                                            [
                                                82.8,
                                                -16.9
                                            ],
                                            [
                                                86.35,
                                                -23.9
                                            ],
                                            [
                                                87.7,
                                                -34.4
                                            ],
                                            [
                                                85.05,
                                                -47.9
                                            ],
                                            [
                                                77.55,
                                                -58.75
                                            ],
                                            [
                                                65.95,
                                                -65.95
                                            ],
                                            [
                                                50.9,
                                                -68.5
                                            ],
                                            [
                                                35.15,
                                                -65.3
                                            ],
                                            [
                                                22.5,
                                                -56.35
                                            ],
                                            [
                                                14.05,
                                                -42.95
                                            ],
                                            [
                                                11,
                                                -26.4
                                            ],
                                            [
                                                15.85,
                                                -5.6
                                            ],
                                            [
                                                29.2,
                                                8
                                            ],
                                            [
                                                48.6,
                                                12.8
                                            ],
                                            [
                                                63.95,
                                                10.25
                                            ],
                                            [
                                                75.3,
                                                4.2
                                            ],
                                            [
                                                78.8,
                                                8.3
                                            ],
                                            [
                                                65.65,
                                                15.55
                                            ],
                                            [
                                                48,
                                                18.4
                                            ],
                                            [
                                                30.35,
                                                15.2
                                            ],
                                            [
                                                16.45,
                                                6.05
                                            ],
                                            [
                                                7.35,
                                                -8.15
                                            ],
                                            [
                                                4.1,
                                                -26.4
                                            ],
                                            [
                                                7.7,
                                                -45.35
                                            ],
                                            [
                                                17.7,
                                                -60.4
                                            ],
                                            [
                                                32.65,
                                                -70.35
                                            ],
                                            [
                                                51.1,
                                                -73.9
                                            ],
                                            [
                                                68.5,
                                                -71.1
                                            ],
                                            [
                                                82.2,
                                                -63.1
                                            ],
                                            [
                                                91.15,
                                                -50.7
                                            ],
                                            [
                                                94.3,
                                                -34.8
                                            ],
                                            [
                                                92.15,
                                                -21.15
                                            ],
                                            [
                                                86.55,
                                                -12.2
                                            ],
                                            [
                                                79.05,
                                                -7.3
                                            ],
                                            [
                                                71.2,
                                                -5.8
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.4333333333333322,
                                                2.6666666666666665
                                            ],
                                            [
                                                -0.7999999999999972,
                                                4.133333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.3666666666666695,
                                                2.133333333333335
                                            ],
                                            [
                                                1.3333333333333333,
                                                1.4333333333333371
                                            ],
                                            [
                                                2.5333333333333363,
                                                0
                                            ],
                                            [
                                                1.7666666666666704,
                                                -1.2666666666666657
                                            ],
                                            [
                                                1.1333333333333304,
                                                -2.099999999999999
                                            ],
                                            [
                                                0.5666666666666677,
                                                -2.4333333333333322
                                            ],
                                            [
                                                0,
                                                -2.3999999999999986
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -1.8999999999999986
                                            ],
                                            [
                                                -2.8666666666666694,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.199999999999998,
                                                0
                                            ],
                                            [
                                                2.433333333333337,
                                                -2.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.46666666666666856,
                                                -2.2666666666666657
                                            ],
                                            [
                                                -0.36666666666666475,
                                                -2.1333333333333306
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -2.3999999999999964,
                                                0
                                            ],
                                            [
                                                -1.7666666666666657,
                                                1.2666666666666704
                                            ],
                                            [
                                                -1.1333333333333353,
                                                2.099999999999999
                                            ],
                                            [
                                                -0.5666666666666677,
                                                2.433333333333335
                                            ],
                                            [
                                                0,
                                                3.133333333333335
                                            ],
                                            [
                                                1.3333333333333333,
                                                1.900000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                45.1,
                                                -12.7
                                            ],
                                            [
                                                53.55,
                                                -16.7
                                            ],
                                            [
                                                58.4,
                                                -26.9
                                            ],
                                            [
                                                59,
                                                -30
                                            ],
                                            [
                                                59.15,
                                                -36.6
                                            ],
                                            [
                                                56.6,
                                                -41.95
                                            ],
                                            [
                                                50.8,
                                                -44.1
                                            ],
                                            [
                                                44.55,
                                                -42.2
                                            ],
                                            [
                                                40.2,
                                                -37.15
                                            ],
                                            [
                                                37.65,
                                                -30.35
                                            ],
                                            [
                                                36.8,
                                                -23.1
                                            ],
                                            [
                                                38.8,
                                                -15.55
                                            ],
                                            [
                                                45.1,
                                                -12.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "b",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 64.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.1666666666666665,
                                                1.6666666666666667
                                            ],
                                            [
                                                -4.0666666666666655,
                                                0
                                            ],
                                            [
                                                -3.6666666666666665,
                                                -2.3999999999999964
                                            ],
                                            [
                                                -2,
                                                -4.433333333333333
                                            ],
                                            [
                                                0,
                                                -5.999999999999997
                                            ],
                                            [
                                                1.9666666666666686,
                                                -4.3
                                            ],
                                            [
                                                3.599999999999999,
                                                -2.3666666666666667
                                            ],
                                            [
                                                5,
                                                0
                                            ],
                                            [
                                                3.3333333333333335,
                                                1.9000000000000001
                                            ],
                                            [
                                                1.6000000000000014,
                                                3.266666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9333333333333325,
                                                -3.3999999999999964
                                            ],
                                            [
                                                3.1666666666666665,
                                                -1.6666666666666667
                                            ],
                                            [
                                                4.933333333333337,
                                                0
                                            ],
                                            [
                                                3.6666666666666665,
                                                2.400000000000001
                                            ],
                                            [
                                                2,
                                                4.433333333333337
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ],
                                            [
                                                -1.9666666666666686,
                                                4.300000000000001
                                            ],
                                            [
                                                -3.599999999999999,
                                                2.3666666666666667
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ],
                                            [
                                                -3.3333333333333335,
                                                -1.9000000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                16.5,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.3,
                                                -79
                                            ],
                                            [
                                                17.3,
                                                -47.2
                                            ],
                                            [
                                                24.95,
                                                -54.8
                                            ],
                                            [
                                                35.8,
                                                -57.3
                                            ],
                                            [
                                                48.7,
                                                -53.7
                                            ],
                                            [
                                                57.2,
                                                -43.45
                                            ],
                                            [
                                                60.2,
                                                -27.8
                                            ],
                                            [
                                                57.25,
                                                -12.55
                                            ],
                                            [
                                                48.9,
                                                -2.55
                                            ],
                                            [
                                                36,
                                                1
                                            ],
                                            [
                                                24.6,
                                                -1.85
                                            ],
                                            [
                                                17.2,
                                                -9.6
                                            ],
                                            [
                                                16.5,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.3999999999999986,
                                                -2.4999999999999987
                                            ],
                                            [
                                                -2.4666666666666663,
                                                -1.3666666666666671
                                            ],
                                            [
                                                -3.2666666666666657,
                                                0
                                            ],
                                            [
                                                -2.7666666666666657,
                                                3.5000000000000004
                                            ],
                                            [
                                                0,
                                                6.333333333333333
                                            ],
                                            [
                                                2.7666666666666706,
                                                3.599999999999999
                                            ],
                                            [
                                                5.13333333333333,
                                                0
                                            ],
                                            [
                                                2.4666666666666663,
                                                -1.4333333333333325
                                            ],
                                            [
                                                1.3333333333333333,
                                                -2.633333333333335
                                            ],
                                            [
                                                0,
                                                -3.599999999999999
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.266666666666668
                                            ],
                                            [
                                                1.400000000000001,
                                                2.5
                                            ],
                                            [
                                                2.4666666666666663,
                                                1.3666666666666665
                                            ],
                                            [
                                                5.066666666666667,
                                                0
                                            ],
                                            [
                                                2.7666666666666706,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                -6.600000000000001
                                            ],
                                            [
                                                -2.7666666666666657,
                                                -3.599999999999999
                                            ],
                                            [
                                                -3.3333333333333357,
                                                0
                                            ],
                                            [
                                                -2.4666666666666663,
                                                1.4333333333333325
                                            ],
                                            [
                                                -1.3333333333333333,
                                                2.633333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                -30.9
                                            ],
                                            [
                                                17.3,
                                                -24.3
                                            ],
                                            [
                                                19.4,
                                                -15.65
                                            ],
                                            [
                                                25.2,
                                                -9.85
                                            ],
                                            [
                                                33.8,
                                                -7.8
                                            ],
                                            [
                                                45.55,
                                                -13.05
                                            ],
                                            [
                                                49.7,
                                                -27.8
                                            ],
                                            [
                                                45.55,
                                                -43.1
                                            ],
                                            [
                                                33.7,
                                                -48.5
                                            ],
                                            [
                                                25,
                                                -46.35
                                            ],
                                            [
                                                19.3,
                                                -40.25
                                            ],
                                            [
                                                17.3,
                                                -30.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "k",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 56.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                57.1,
                                                0
                                            ],
                                            [
                                                44.9,
                                                0
                                            ],
                                            [
                                                26.1,
                                                -28.9
                                            ],
                                            [
                                                16.2,
                                                -19.6
                                            ],
                                            [
                                                16.3,
                                                -31.1
                                            ],
                                            [
                                                42.1,
                                                -56.3
                                            ],
                                            [
                                                55,
                                                -56.3
                                            ],
                                            [
                                                32.2,
                                                -34.7
                                            ],
                                            [
                                                32.2,
                                                -37.2
                                            ],
                                            [
                                                57.1,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.4,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ",",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 21.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6000000000000002,
                                                0.8333333333333327
                                            ],
                                            [
                                                0,
                                                1.2666666666666668
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7333333333333343,
                                                -1.4666666666666661
                                            ],
                                            [
                                                2.8000000000000003,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7333333333333332,
                                                0
                                            ],
                                            [
                                                0.6000000000000002,
                                                -0.8333333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.1333333333333333
                                            ],
                                            [
                                                -1.7333333333333332,
                                                1.4666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                6.7,
                                                13.8
                                            ],
                                            [
                                                4.7,
                                                13.8
                                            ],
                                            [
                                                4.7,
                                                8.2
                                            ],
                                            [
                                                6.4,
                                                8.2
                                            ],
                                            [
                                                9.9,
                                                6.95
                                            ],
                                            [
                                                10.8,
                                                3.8
                                            ],
                                            [
                                                10.8,
                                                0
                                            ],
                                            [
                                                5.6,
                                                0
                                            ],
                                            [
                                                5.6,
                                                -11.4
                                            ],
                                            [
                                                16.1,
                                                -11.4
                                            ],
                                            [
                                                16.1,
                                                4.7
                                            ],
                                            [
                                                13.5,
                                                11.6
                                            ],
                                            [
                                                6.7,
                                                13.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "d",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 64.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2,
                                                4.433333333333337
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.400000000000001
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.133333333333335,
                                                -1.7333333333333296
                                            ],
                                            [
                                                -1.8000000000000018,
                                                -3.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.300000000000002,
                                                -1.9000000000000001
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.633333333333334,
                                                2.3666666666666667
                                            ],
                                            [
                                                1.9333333333333336,
                                                4.300000000000001
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                -5.999999999999997
                                            ],
                                            [
                                                2,
                                                -4.433333333333333
                                            ],
                                            [
                                                3.666666666666668,
                                                -2.3999999999999964
                                            ],
                                            [
                                                4.266666666666666,
                                                0
                                            ],
                                            [
                                                3.1333333333333306,
                                                1.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.599999999999999,
                                                3.266666666666666
                                            ],
                                            [
                                                -3.299999999999997,
                                                1.9000000000000001
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.633333333333333,
                                                -2.3666666666666667
                                            ],
                                            [
                                                -1.9333333333333336,
                                                -4.3
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                4.1,
                                                -27.8
                                            ],
                                            [
                                                7.1,
                                                -43.45
                                            ],
                                            [
                                                15.6,
                                                -53.7
                                            ],
                                            [
                                                28.5,
                                                -57.3
                                            ],
                                            [
                                                39.6,
                                                -54.7
                                            ],
                                            [
                                                47,
                                                -47.2
                                            ],
                                            [
                                                47,
                                                -79
                                            ],
                                            [
                                                57.2,
                                                -79
                                            ],
                                            [
                                                57.2,
                                                0
                                            ],
                                            [
                                                47.7,
                                                0
                                            ],
                                            [
                                                47,
                                                -9.6
                                            ],
                                            [
                                                39.65,
                                                -1.85
                                            ],
                                            [
                                                28.2,
                                                1
                                            ],
                                            [
                                                15.35,
                                                -2.55
                                            ],
                                            [
                                                7,
                                                -12.55
                                            ],
                                            [
                                                4.1,
                                                -27.8
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.733333333333333,
                                                -3.4666666666666663
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                1.433333333333333
                                            ],
                                            [
                                                -1.3666666666666696,
                                                2.5666666666666664
                                            ],
                                            [
                                                0,
                                                3.3999999999999986
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                2.633333333333335
                                            ],
                                            [
                                                2.4666666666666686,
                                                1.4333333333333325
                                            ],
                                            [
                                                3.400000000000001,
                                                0
                                            ],
                                            [
                                                2.7666666666666657,
                                                -3.599999999999999
                                            ],
                                            [
                                                0,
                                                -6.600000000000001
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                6.400000000000001
                                            ],
                                            [
                                                2.7333333333333343,
                                                3.466666666666667
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.5,
                                                -1.4333333333333336
                                            ],
                                            [
                                                1.3666666666666647,
                                                -2.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.599999999999999
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2.633333333333335
                                            ],
                                            [
                                                -2.4666666666666637,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -5.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.766666666666667,
                                                3.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14.6,
                                                -27.8
                                            ],
                                            [
                                                18.7,
                                                -13
                                            ],
                                            [
                                                30.4,
                                                -7.8
                                            ],
                                            [
                                                39.15,
                                                -9.95
                                            ],
                                            [
                                                44.95,
                                                -15.95
                                            ],
                                            [
                                                47,
                                                -24.9
                                            ],
                                            [
                                                47,
                                                -30.9
                                            ],
                                            [
                                                45,
                                                -40.25
                                            ],
                                            [
                                                39.3,
                                                -46.35
                                            ],
                                            [
                                                30.5,
                                                -48.5
                                            ],
                                            [
                                                18.75,
                                                -43.1
                                            ],
                                            [
                                                14.6,
                                                -27.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "g",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.9,
                                                2.866666666666667
                                            ],
                                            [
                                                0.5333333333333332,
                                                4.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.2333333333333343,
                                                -1.4666666666666668
                                            ],
                                            [
                                                -2,
                                                -0.6333333333333329
                                            ],
                                            [
                                                -2.3333333333333335,
                                                0
                                            ],
                                            [
                                                -2.800000000000002,
                                                2.1666666666666674
                                            ],
                                            [
                                                0,
                                                4.933333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3,
                                                -1.366666666666666
                                            ],
                                            [
                                                3.999999999999998,
                                                0
                                            ],
                                            [
                                                3.5,
                                                2.133333333333334
                                            ],
                                            [
                                                1.866666666666666,
                                                3.8333333333333335
                                            ],
                                            [
                                                0,
                                                5.133333333333333
                                            ],
                                            [
                                                -1.8333333333333333,
                                                3.933333333333337
                                            ],
                                            [
                                                -3.4,
                                                2.2333333333333343
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.2333333333333343,
                                                -1.8333333333333333
                                            ],
                                            [
                                                -1.466666666666664,
                                                -3.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666647,
                                                -3.3000000000000003
                                            ],
                                            [
                                                3.8333333333333335,
                                                -1.8333333333333333
                                            ],
                                            [
                                                5.8666666666666645,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.600000000000001,
                                                0
                                            ],
                                            [
                                                -3.9,
                                                -2.866666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.2666666666666657,
                                                2.466666666666667
                                            ],
                                            [
                                                1.2333333333333343,
                                                1.4666666666666668
                                            ],
                                            [
                                                2,
                                                0.6333333333333341
                                            ],
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.799999999999997,
                                                -2.1666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7333333333333343,
                                                3.0666666666666678
                                            ],
                                            [
                                                -3,
                                                1.3666666666666671
                                            ],
                                            [
                                                -4.733333333333334,
                                                0
                                            ],
                                            [
                                                -3.5,
                                                -2.133333333333333
                                            ],
                                            [
                                                -1.8666666666666671,
                                                -3.8333333333333335
                                            ],
                                            [
                                                0,
                                                -5.0666666666666655
                                            ],
                                            [
                                                1.8333333333333333,
                                                -3.9333333333333322
                                            ],
                                            [
                                                3.400000000000001,
                                                -2.2333333333333294
                                            ],
                                            [
                                                4.133333333333333,
                                                0
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.8333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.333333333333333
                                            ],
                                            [
                                                -1.8666666666666696,
                                                3.2999999999999994
                                            ],
                                            [
                                                -3.8333333333333335,
                                                1.8333333333333346
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.1,
                                                17.6
                                            ],
                                            [
                                                13.35,
                                                13.3
                                            ],
                                            [
                                                6.7,
                                                2
                                            ],
                                            [
                                                16,
                                                -0.2
                                            ],
                                            [
                                                18.25,
                                                5.7
                                            ],
                                            [
                                                23.1,
                                                8.85
                                            ],
                                            [
                                                29.6,
                                                9.8
                                            ],
                                            [
                                                40.7,
                                                6.55
                                            ],
                                            [
                                                44.9,
                                                -4.1
                                            ],
                                            [
                                                44.9,
                                                -14.3
                                            ],
                                            [
                                                37.8,
                                                -7.65
                                            ],
                                            [
                                                27.3,
                                                -5.6
                                            ],
                                            [
                                                14.95,
                                                -8.8
                                            ],
                                            [
                                                6.9,
                                                -17.75
                                            ],
                                            [
                                                4.1,
                                                -31.2
                                            ],
                                            [
                                                6.85,
                                                -44.7
                                            ],
                                            [
                                                14.7,
                                                -53.95
                                            ],
                                            [
                                                26.8,
                                                -57.3
                                            ],
                                            [
                                                37.85,
                                                -54.55
                                            ],
                                            [
                                                44.9,
                                                -47
                                            ],
                                            [
                                                45.5,
                                                -56.3
                                            ],
                                            [
                                                55,
                                                -56.3
                                            ],
                                            [
                                                55,
                                                -4.3
                                            ],
                                            [
                                                52.2,
                                                7.15
                                            ],
                                            [
                                                43.65,
                                                14.85
                                            ],
                                            [
                                                29.1,
                                                17.6
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.299999999999997,
                                                1.4333333333333336
                                            ],
                                            [
                                                -1.3000000000000018,
                                                2.433333333333335
                                            ],
                                            [
                                                0,
                                                3.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                2.3333333333333335
                                            ],
                                            [
                                                2.3333333333333335,
                                                1.3666666666666647
                                            ],
                                            [
                                                3.133333333333333,
                                                0
                                            ],
                                            [
                                                2.5333333333333337,
                                                -3.2333333333333294
                                            ],
                                            [
                                                0,
                                                -5.333333333333333
                                            ],
                                            [
                                                -2.5333333333333328,
                                                -3.366666666666667
                                            ],
                                            [
                                                -4.866666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.0666666666666678,
                                                0
                                            ],
                                            [
                                                2.300000000000002,
                                                -1.4333333333333325
                                            ],
                                            [
                                                1.2999999999999972,
                                                -2.4333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2.3333333333333335,
                                                -1.3666666666666647
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -2.5333333333333328,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                5.266666666666668
                                            ],
                                            [
                                                2.5333333333333337,
                                                3.366666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.5,
                                                -13.1
                                            ],
                                            [
                                                37.55,
                                                -15.25
                                            ],
                                            [
                                                42.95,
                                                -21.05
                                            ],
                                            [
                                                44.9,
                                                -29.3
                                            ],
                                            [
                                                44.9,
                                                -33.1
                                            ],
                                            [
                                                42.9,
                                                -41.2
                                            ],
                                            [
                                                37.4,
                                                -46.75
                                            ],
                                            [
                                                29.2,
                                                -48.8
                                            ],
                                            [
                                                18.4,
                                                -43.95
                                            ],
                                            [
                                                14.6,
                                                -31.1
                                            ],
                                            [
                                                18.4,
                                                -18.15
                                            ],
                                            [
                                                29.5,
                                                -13.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "4",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 65.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                51.7,
                                                0
                                            ],
                                            [
                                                41.5,
                                                0
                                            ],
                                            [
                                                41.5,
                                                -15.7
                                            ],
                                            [
                                                4.7,
                                                -15.7
                                            ],
                                            [
                                                4.7,
                                                -24.5
                                            ],
                                            [
                                                41.1,
                                                -72.9
                                            ],
                                            [
                                                51.7,
                                                -72.9
                                            ],
                                            [
                                                51.7,
                                                -24.7
                                            ],
                                            [
                                                62.9,
                                                -24.7
                                            ],
                                            [
                                                62.9,
                                                -15.7
                                            ],
                                            [
                                                51.7,
                                                -15.7
                                            ],
                                            [
                                                51.7,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                41.5,
                                                -59.4
                                            ],
                                            [
                                                15.8,
                                                -24.7
                                            ],
                                            [
                                                41.5,
                                                -24.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "1",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 43.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.1666666666666665,
                                                2.9333333333333322
                                            ],
                                            [
                                                -0.7333333333333343,
                                                4.733333333333339
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5,
                                                0
                                            ],
                                            [
                                                3.1666666666666665,
                                                -2.9333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.3,
                                                0
                                            ],
                                            [
                                                21.1,
                                                0
                                            ],
                                            [
                                                21.1,
                                                -49.5
                                            ],
                                            [
                                                3.5,
                                                -49.5
                                            ],
                                            [
                                                3.5,
                                                -57
                                            ],
                                            [
                                                5.5,
                                                -57
                                            ],
                                            [
                                                17.75,
                                                -61.4
                                            ],
                                            [
                                                23.6,
                                                -72.9
                                            ],
                                            [
                                                31.3,
                                                -72.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "7",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 58.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5,
                                                4.333333333333333
                                            ],
                                            [
                                                -1.2333333333333343,
                                                3.900000000000001
                                            ],
                                            [
                                                -2.0333333333333337,
                                                3.799999999999997
                                            ],
                                            [
                                                -3.0333333333333314,
                                                4.166666666666667
                                            ],
                                            [
                                                -4.13333333333333,
                                                4.933333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3,
                                                -4.433333333333333
                                            ],
                                            [
                                                1.9666666666666686,
                                                -3.933333333333337
                                            ],
                                            [
                                                1.099999999999999,
                                                -3.866666666666665
                                            ],
                                            [
                                                0.4666666666666662,
                                                -4.066666666666667
                                            ],
                                            [
                                                0,
                                                -4.733333333333333
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.06666666666666761,
                                                -5.266666666666667
                                            ],
                                            [
                                                0.5,
                                                -4.333333333333332
                                            ],
                                            [
                                                1.2333333333333318,
                                                -3.900000000000001
                                            ],
                                            [
                                                2.0333333333333337,
                                                -3.800000000000002
                                            ],
                                            [
                                                3.0333333333333363,
                                                -4.166666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.199999999999998,
                                                5.266666666666666
                                            ],
                                            [
                                                -3,
                                                4.433333333333333
                                            ],
                                            [
                                                -1.966666666666664,
                                                3.9333333333333322
                                            ],
                                            [
                                                -1.1000000000000014,
                                                3.866666666666667
                                            ],
                                            [
                                                -0.46666666666666856,
                                                4.066666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.4,
                                                0
                                            ],
                                            [
                                                19.3,
                                                0
                                            ],
                                            [
                                                19.95,
                                                -14.4
                                            ],
                                            [
                                                22.55,
                                                -26.75
                                            ],
                                            [
                                                27.45,
                                                -38.3
                                            ],
                                            [
                                                35.05,
                                                -50.25
                                            ],
                                            [
                                                45.8,
                                                -63.9
                                            ],
                                            [
                                                2.5,
                                                -63.9
                                            ],
                                            [
                                                2.5,
                                                -72.9
                                            ],
                                            [
                                                56.3,
                                                -72.9
                                            ],
                                            [
                                                56.3,
                                                -63.9
                                            ],
                                            [
                                                45.5,
                                                -49.35
                                            ],
                                            [
                                                38.05,
                                                -36.8
                                            ],
                                            [
                                                33.45,
                                                -25.1
                                            ],
                                            [
                                                31.1,
                                                -13.2
                                            ],
                                            [
                                                30.4,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "p",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 64.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.3333333333333335,
                                                1.8666666666666647
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ],
                                            [
                                                -3.599999999999999,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -1.9666666666666686,
                                                -4.299999999999997
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                2,
                                                -4.4333333333333345
                                            ],
                                            [
                                                3.6666666666666665,
                                                -2.433333333333333
                                            ],
                                            [
                                                4.933333333333337,
                                                0
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.7
                                            ],
                                            [
                                                1.8666666666666671,
                                                3.4
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6000000000000014,
                                                -3.3333333333333335
                                            ],
                                            [
                                                3.3333333333333335,
                                                -1.8666666666666647
                                            ],
                                            [
                                                5,
                                                0
                                            ],
                                            [
                                                3.599999999999999,
                                                2.3333333333333335
                                            ],
                                            [
                                                1.9666666666666686,
                                                4.300000000000002
                                            ],
                                            [
                                                0,
                                                6
                                            ],
                                            [
                                                -2,
                                                4.433333333333333
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.433333333333333
                                            ],
                                            [
                                                -3.999999999999998,
                                                0
                                            ],
                                            [
                                                -3.233333333333332,
                                                -1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                16.7
                                            ],
                                            [
                                                7.1,
                                                16.7
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.5,
                                                -56.3
                                            ],
                                            [
                                                17.2,
                                                -46.7
                                            ],
                                            [
                                                24.6,
                                                -54.5
                                            ],
                                            [
                                                36,
                                                -57.3
                                            ],
                                            [
                                                48.9,
                                                -53.8
                                            ],
                                            [
                                                57.25,
                                                -43.85
                                            ],
                                            [
                                                60.2,
                                                -28.6
                                            ],
                                            [
                                                57.2,
                                                -12.95
                                            ],
                                            [
                                                48.7,
                                                -2.65
                                            ],
                                            [
                                                35.8,
                                                1
                                            ],
                                            [
                                                24.95,
                                                -1.55
                                            ],
                                            [
                                                17.3,
                                                -9.2
                                            ],
                                            [
                                                17.3,
                                                16.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2.633333333333335
                                            ],
                                            [
                                                -2.4666666666666663,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -3.3333333333333357,
                                                0
                                            ],
                                            [
                                                -2.7666666666666657,
                                                3.5666666666666664
                                            ],
                                            [
                                                0,
                                                6.666666666666667
                                            ],
                                            [
                                                2.7666666666666706,
                                                3.4666666666666637
                                            ],
                                            [
                                                5.066666666666667,
                                                0
                                            ],
                                            [
                                                2.5,
                                                -1.400000000000001
                                            ],
                                            [
                                                1.3666666666666647,
                                                -2.566666666666663
                                            ],
                                            [
                                                0,
                                                -3.4666666666666686
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.5333333333333314
                                            ],
                                            [
                                                1.3333333333333333,
                                                2.633333333333333
                                            ],
                                            [
                                                2.4666666666666663,
                                                1.4333333333333336
                                            ],
                                            [
                                                5.13333333333333,
                                                0
                                            ],
                                            [
                                                2.7666666666666706,
                                                -3.5666666666666678
                                            ],
                                            [
                                                0,
                                                -6.333333333333333
                                            ],
                                            [
                                                -2.7666666666666657,
                                                -3.4666666666666686
                                            ],
                                            [
                                                -3.2666666666666657,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                1.400000000000001
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                -31.4
                                            ],
                                            [
                                                17.3,
                                                -25.4
                                            ],
                                            [
                                                19.3,
                                                -16.15
                                            ],
                                            [
                                                25,
                                                -10.05
                                            ],
                                            [
                                                33.7,
                                                -7.9
                                            ],
                                            [
                                                45.55,
                                                -13.25
                                            ],
                                            [
                                                49.7,
                                                -28.6
                                            ],
                                            [
                                                45.55,
                                                -43.3
                                            ],
                                            [
                                                33.8,
                                                -48.5
                                            ],
                                            [
                                                25.15,
                                                -46.4
                                            ],
                                            [
                                                19.35,
                                                -40.45
                                            ],
                                            [
                                                17.3,
                                                -31.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "y",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 51.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2666666666666657,
                                                0.20000000000000048
                                            ],
                                            [
                                                0.8000000000000002,
                                                0.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333334,
                                                -0.13333333333333286
                                            ],
                                            [
                                                -0.7333333333333331,
                                                0
                                            ],
                                            [
                                                -1.4333333333333325,
                                                1.0000000000000007
                                            ],
                                            [
                                                -0.7999999999999995,
                                                2.0666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.733333333333332,
                                                -2.099999999999999
                                            ],
                                            [
                                                -0.8333333333333334,
                                                -2.5666666666666678
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -2.5333333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6000000000000014,
                                                2
                                            ],
                                            [
                                                -0.7000000000000005,
                                                1.9333333333333325
                                            ],
                                            [
                                                -0.8666666666666671,
                                                2.4666666666666663
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6666666666666667,
                                                -1.8333333333333333
                                            ],
                                            [
                                                2.066666666666665,
                                                -0.733333333333332
                                            ],
                                            [
                                                2.5333333333333337,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1,
                                                0
                                            ],
                                            [
                                                -1.2666666666666668,
                                                -0.20000000000000048
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.4666666666666668,
                                                0.20000000000000048
                                            ],
                                            [
                                                0.6333333333333329,
                                                0.13333333333333405
                                            ],
                                            [
                                                2.400000000000001,
                                                0
                                            ],
                                            [
                                                1.4333333333333347,
                                                -1
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.40000000000000097,
                                                1.0666666666666675
                                            ],
                                            [
                                                0.7333333333333343,
                                                2.099999999999999
                                            ],
                                            [
                                                0.8333333333333334,
                                                2.5666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7999999999999995,
                                                -2.6
                                            ],
                                            [
                                                0.5999999999999991,
                                                -2
                                            ],
                                            [
                                                0.7000000000000005,
                                                -1.9333333333333347
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.2000000000000004,
                                                3.266666666666667
                                            ],
                                            [
                                                -1.6666666666666667,
                                                1.8333333333333333
                                            ],
                                            [
                                                -2.0666666666666678,
                                                0.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                11.7,
                                                17.5
                                            ],
                                            [
                                                8.3,
                                                17.2
                                            ],
                                            [
                                                5.2,
                                                16.5
                                            ],
                                            [
                                                5.2,
                                                8.1
                                            ],
                                            [
                                                6,
                                                8.1
                                            ],
                                            [
                                                7.65,
                                                8.6
                                            ],
                                            [
                                                9.7,
                                                8.8
                                            ],
                                            [
                                                15.45,
                                                7.3
                                            ],
                                            [
                                                18.8,
                                                2.7
                                            ],
                                            [
                                                20.7,
                                                -2.1
                                            ],
                                            [
                                                -0.5,
                                                -56.3
                                            ],
                                            [
                                                10.6,
                                                -56.3
                                            ],
                                            [
                                                20,
                                                -30
                                            ],
                                            [
                                                21.7,
                                                -25.25
                                            ],
                                            [
                                                24.05,
                                                -18.25
                                            ],
                                            [
                                                26.3,
                                                -10.6
                                            ],
                                            [
                                                25.7,
                                                -10.6
                                            ],
                                            [
                                                27.8,
                                                -17.5
                                            ],
                                            [
                                                29.75,
                                                -23.4
                                            ],
                                            [
                                                32.1,
                                                -30
                                            ],
                                            [
                                                41.6,
                                                -56.3
                                            ],
                                            [
                                                51.8,
                                                -56.3
                                            ],
                                            [
                                                28.5,
                                                4.9
                                            ],
                                            [
                                                24.2,
                                                12.55
                                            ],
                                            [
                                                18.6,
                                                16.4
                                            ],
                                            [
                                                11.7,
                                                17.5
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "A",
            "fFamily": "BDO Grotesk",
            "size": 15,
            "style": "Regular",
            "w": 73.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7333333333333343,
                                                2
                                            ],
                                            [
                                                0.7999999999999972,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7333333333333343,
                                                -2
                                            ],
                                            [
                                                0.7333333333333343,
                                                -1.9333333333333325
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -2
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.8000000000000019,
                                                2.3333333333333335
                                            ],
                                            [
                                                -0.7333333333333295,
                                                2
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                12.3,
                                                0
                                            ],
                                            [
                                                1.4,
                                                0
                                            ],
                                            [
                                                30.8,
                                                -72.9
                                            ],
                                            [
                                                43.1,
                                                -72.9
                                            ],
                                            [
                                                72.5,
                                                0
                                            ],
                                            [
                                                61.4,
                                                0
                                            ],
                                            [
                                                40.7,
                                                -52.4
                                            ],
                                            [
                                                38.5,
                                                -58.3
                                            ],
                                            [
                                                36.2,
                                                -64.8
                                            ],
                                            [
                                                37.6,
                                                -64.8
                                            ],
                                            [
                                                35.3,
                                                -58.3
                                            ],
                                            [
                                                33.1,
                                                -52.4
                                            ],
                                            [
                                                12.3,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                55.4,
                                                -18.6
                                            ],
                                            [
                                                18.2,
                                                -18.6
                                            ],
                                            [
                                                21.8,
                                                -27.7
                                            ],
                                            [
                                                51.9,
                                                -27.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ],
    "assets": [
        {
            "nm": "User chat",
            "id": "1",
            "fr": 30,
            "layers": [
                {
                    "ty": 5,
                    "nm": "Summarise this account note for the team: [NAME], [EMAIL], [CARD], complained about the transfer delay on 14 Aug. 2",
                    "sr": 1,
                    "st": 25,
                    "op": 18026,
                    "ip": 185,
                    "ln": "147",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                125.916,
                                25.653
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        452.842,
                                        234.056
                                    ],
                                    "t": 184.999
                                },
                                {
                                    "s": [
                                        452.842,
                                        217.354
                                    ],
                                    "t": 187.999
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Bold",
                                        "s": 14,
                                        "t": "Summarise this account note for \u0003the team: [NAME], [EMAIL], \u0003[CARD], complained about the \u0003transfer delay on 14 Aug.",
                                        "fc": [
                                            1,
                                            1,
                                            1
                                        ],
                                        "lh": 20,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 6",
                    "sr": 1,
                    "st": 80,
                    "op": 223,
                    "ip": 189,
                    "ln": "146",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                10.134,
                                -36.273
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        100
                                    ],
                                    "t": 188.999
                                },
                                {
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": 198.999
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                326.823,
                                228.135
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "ef": [
                        {
                            "ty": 5,
                            "nm": "Colorama",
                            "en": 0,
                            "ef": [
                                {
                                    "ty": 6,
                                    "nm": "Input Phase",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Get Phase From",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Add Phase",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Add Phase From",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Add Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 1,
                                    "nm": "Phase Shift",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 188.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    360
                                                ],
                                                "t": 198.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    1440
                                                ],
                                                "t": 209.999
                                            },
                                            {
                                                "s": [
                                                    2160
                                                ],
                                                "t": 220.999
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Output Cycle",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Use Preset Palette",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Output Cycle",
                                    "v": 0
                                },
                                {
                                    "ty": 0,
                                    "nm": "Cycle Repetitions",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Interpolate Palette",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Modify",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Modify",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Modify Alpha",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Change Empty Pixels",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Pixel Selection",
                                    "v": 0
                                },
                                {
                                    "ty": 2,
                                    "nm": "Matching Color",
                                    "v": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Matching Tolerance",
                                    "v": {
                                        "a": 0,
                                        "k": 0.5
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Matching Softness",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Matching Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Masking",
                                    "v": 0
                                },
                                {
                                    "ty": 6,
                                    "nm": "Mask Layer",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Masking Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Composite Over Layer",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Blend With Original",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        }
                    ],
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            60.68,
                                            16.421
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8392,
                                            0.8392,
                                            0.8392
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0.7735,
                                            0.7735
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100.539,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            40.253,
                                            -37.512
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 5",
                    "sr": 1,
                    "st": 80,
                    "op": 223,
                    "ip": 189,
                    "ln": "145",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                8.196,
                                -36.919
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        100
                                    ],
                                    "t": 188.999
                                },
                                {
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": 198.999
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                400.785,
                                207.545
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "ef": [
                        {
                            "ty": 5,
                            "nm": "Colorama",
                            "en": 0,
                            "ef": [
                                {
                                    "ty": 6,
                                    "nm": "Input Phase",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Get Phase From",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Add Phase",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Add Phase From",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Add Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 1,
                                    "nm": "Phase Shift",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 188.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    360
                                                ],
                                                "t": 198.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    1440
                                                ],
                                                "t": 209.999
                                            },
                                            {
                                                "s": [
                                                    2160
                                                ],
                                                "t": 220.999
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Output Cycle",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Use Preset Palette",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Output Cycle",
                                    "v": 0
                                },
                                {
                                    "ty": 0,
                                    "nm": "Cycle Repetitions",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Interpolate Palette",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Modify",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Modify",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Modify Alpha",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Change Empty Pixels",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Pixel Selection",
                                    "v": 0
                                },
                                {
                                    "ty": 2,
                                    "nm": "Matching Color",
                                    "v": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Matching Tolerance",
                                    "v": {
                                        "a": 0,
                                        "k": 0.5
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Matching Softness",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Matching Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Masking",
                                    "v": 0
                                },
                                {
                                    "ty": 6,
                                    "nm": "Mask Layer",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Masking Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Composite Over Layer",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Blend With Original",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        }
                    ],
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            135.68,
                                            16.421
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8392,
                                            0.8392,
                                            0.8392
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0.7735,
                                            0.7735
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100.539,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            76.656,
                                            -37.405
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "User Text Outlines 2",
                    "sr": 1,
                    "st": 100,
                    "op": 18101,
                    "ip": 185,
                    "ln": "144",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                167.5,
                                59
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        474.055,
                                        234.056
                                    ],
                                    "t": 184.999
                                },
                                {
                                    "s": [
                                        474.055,
                                        217.354
                                    ],
                                    "t": 187.999
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.611,
                                                    -0.278
                                                ],
                                                [
                                                    -0.332,
                                                    -0.514
                                                ],
                                                [
                                                    0,
                                                    -0.696
                                                ],
                                                [
                                                    0.225,
                                                    -0.408
                                                ],
                                                [
                                                    0.386,
                                                    -0.258
                                                ],
                                                [
                                                    0.493,
                                                    -0.064
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.397,
                                                    -0.332
                                                ],
                                                [
                                                    -0.054,
                                                    -0.675
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.246,
                                                    0.203
                                                ],
                                                [
                                                    0.578,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.836,
                                                    0
                                                ],
                                                [
                                                    0.622,
                                                    0.279
                                                ],
                                                [
                                                    0.333,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.526
                                                ],
                                                [
                                                    -0.214,
                                                    0.407
                                                ],
                                                [
                                                    -0.376,
                                                    0.257
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.761,
                                                    0
                                                ],
                                                [
                                                    0.396,
                                                    0.322
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.032,
                                                    -0.439
                                                ],
                                                [
                                                    -0.236,
                                                    -0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.607,
                                                    5.709
                                                ],
                                                [
                                                    -4.607,
                                                    -5.709
                                                ],
                                                [
                                                    0.394,
                                                    -5.709
                                                ],
                                                [
                                                    2.565,
                                                    -5.291
                                                ],
                                                [
                                                    3.996,
                                                    -4.101
                                                ],
                                                [
                                                    4.495,
                                                    -2.3
                                                ],
                                                [
                                                    4.157,
                                                    -0.9
                                                ],
                                                [
                                                    3.257,
                                                    0.097
                                                ],
                                                [
                                                    1.954,
                                                    0.579
                                                ],
                                                [
                                                    1.906,
                                                    0.434
                                                ],
                                                [
                                                    3.643,
                                                    0.933
                                                ],
                                                [
                                                    4.318,
                                                    2.428
                                                ],
                                                [
                                                    4.607,
                                                    5.709
                                                ],
                                                [
                                                    2.115,
                                                    5.709
                                                ],
                                                [
                                                    1.906,
                                                    2.814
                                                ],
                                                [
                                                    1.488,
                                                    1.85
                                                ],
                                                [
                                                    0.266,
                                                    1.528
                                                ],
                                                [
                                                    -2.163,
                                                    1.528
                                                ],
                                                [
                                                    -2.163,
                                                    5.709
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.269
                                                ],
                                                [
                                                    0,
                                                    0.503
                                                ],
                                                [
                                                    0.332,
                                                    0.257
                                                ],
                                                [
                                                    0.633,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.589,
                                                    0
                                                ],
                                                [
                                                    0.332,
                                                    -0.278
                                                ],
                                                [
                                                    0,
                                                    -0.515
                                                ],
                                                [
                                                    -0.333,
                                                    -0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.163,
                                                    -0.514
                                                ],
                                                [
                                                    0.121,
                                                    -0.514
                                                ],
                                                [
                                                    1.488,
                                                    -0.917
                                                ],
                                                [
                                                    1.986,
                                                    -2.09
                                                ],
                                                [
                                                    1.488,
                                                    -3.248
                                                ],
                                                [
                                                    0.04,
                                                    -3.65
                                                ],
                                                [
                                                    -2.163,
                                                    -3.65
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.1216,
                                            0.7569,
                                            0.4196
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            317.797,
                                            100.791
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.083
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -16.446
                                                ],
                                                [
                                                    0,
                                                    -16.446
                                                ],
                                                [
                                                    16.446,
                                                    0
                                                ],
                                                [
                                                    16.446,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    16.446
                                                ],
                                                [
                                                    0,
                                                    16.446
                                                ],
                                                [
                                                    -16.446,
                                                    0
                                                ],
                                                [
                                                    -16.446,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.109
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.098,
                                            0.6039,
                                            0.3373
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.7373,
                                            0.9255,
                                            0.8275
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            318,
                                            101
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -16.292,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -16.292
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    16.292
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    16.292,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -16.292,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -16.292
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -114.5,
                                                    -58.5
                                                ],
                                                [
                                                    114.5,
                                                    -58.5
                                                ],
                                                [
                                                    144,
                                                    -29
                                                ],
                                                [
                                                    144,
                                                    58.5
                                                ],
                                                [
                                                    -114.5,
                                                    58.5
                                                ],
                                                [
                                                    -144,
                                                    29
                                                ],
                                                [
                                                    -144,
                                                    -29
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.7373,
                                            0.9255,
                                            0.8275
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.098,
                                            0.6039,
                                            0.3373
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            144.5,
                                            59
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Popup",
            "id": "6",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Summarise this account note for the team rahul.menon@northbank.com, card ending 4417, complained about the transfer delay on 14 Aug. Outlines",
                    "sr": 1,
                    "st": 13,
                    "op": 160,
                    "ip": 109,
                    "ln": "193",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                186.172,
                                24.174
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                389.076,
                                321.744
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "S",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "S",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.663,
                                                    0.555
                                                ],
                                                [
                                                    1.167,
                                                    0
                                                ],
                                                [
                                                    0.537,
                                                    -0.238
                                                ],
                                                [
                                                    0.294,
                                                    -0.42
                                                ],
                                                [
                                                    0,
                                                    -0.56
                                                ],
                                                [
                                                    -0.145,
                                                    -0.317
                                                ],
                                                [
                                                    -0.294,
                                                    -0.229
                                                ],
                                                [
                                                    -0.443,
                                                    -0.168
                                                ],
                                                [
                                                    -0.597,
                                                    -0.131
                                                ],
                                                [
                                                    -0.364,
                                                    -0.117
                                                ],
                                                [
                                                    -0.224,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    0.42,
                                                    -0.261
                                                ],
                                                [
                                                    0.691,
                                                    0
                                                ],
                                                [
                                                    0.453,
                                                    0.392
                                                ],
                                                [
                                                    0.028,
                                                    0.737
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.317,
                                                    -0.504
                                                ],
                                                [
                                                    -0.583,
                                                    -0.28
                                                ],
                                                [
                                                    -0.812,
                                                    0
                                                ],
                                                [
                                                    -0.579,
                                                    0.252
                                                ],
                                                [
                                                    -0.303,
                                                    0.453
                                                ],
                                                [
                                                    0,
                                                    0.607
                                                ],
                                                [
                                                    0.182,
                                                    0.345
                                                ],
                                                [
                                                    0.313,
                                                    0.215
                                                ],
                                                [
                                                    0.392,
                                                    0.131
                                                ],
                                                [
                                                    0.42,
                                                    0.084
                                                ],
                                                [
                                                    0.406,
                                                    0.135
                                                ],
                                                [
                                                    0.215,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0.373
                                                ],
                                                [
                                                    -0.35,
                                                    0.275
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.341,
                                                    -0.154
                                                ],
                                                [
                                                    -0.196,
                                                    -0.294
                                                ],
                                                [
                                                    -0.019,
                                                    -0.429
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.037,
                                                    -0.924
                                                ],
                                                [
                                                    -0.663,
                                                    -0.555
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.537,
                                                    0.238
                                                ],
                                                [
                                                    -0.294,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0.42
                                                ],
                                                [
                                                    0.145,
                                                    0.317
                                                ],
                                                [
                                                    0.294,
                                                    0.229
                                                ],
                                                [
                                                    0.443,
                                                    0.168
                                                ],
                                                [
                                                    0.439,
                                                    0.093
                                                ],
                                                [
                                                    0.364,
                                                    0.117
                                                ],
                                                [
                                                    0.224,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.616
                                                ],
                                                [
                                                    -0.42,
                                                    0.261
                                                ],
                                                [
                                                    -0.765,
                                                    0
                                                ],
                                                [
                                                    -0.453,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.019,
                                                    0.663
                                                ],
                                                [
                                                    0.317,
                                                    0.504
                                                ],
                                                [
                                                    0.583,
                                                    0.28
                                                ],
                                                [
                                                    0.831,
                                                    0
                                                ],
                                                [
                                                    0.579,
                                                    -0.252
                                                ],
                                                [
                                                    0.303,
                                                    -0.453
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    -0.182,
                                                    -0.345
                                                ],
                                                [
                                                    -0.313,
                                                    -0.215
                                                ],
                                                [
                                                    -0.392,
                                                    -0.131
                                                ],
                                                [
                                                    -0.56,
                                                    -0.121
                                                ],
                                                [
                                                    -0.406,
                                                    -0.135
                                                ],
                                                [
                                                    -0.215,
                                                    -0.215
                                                ],
                                                [
                                                    0,
                                                    -0.439
                                                ],
                                                [
                                                    0.35,
                                                    -0.275
                                                ],
                                                [
                                                    0.467,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.154
                                                ],
                                                [
                                                    0.196,
                                                    0.294
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    8.274,
                                                    -7.294
                                                ],
                                                [
                                                    7.224,
                                                    -9.513
                                                ],
                                                [
                                                    4.48,
                                                    -10.346
                                                ],
                                                [
                                                    2.611,
                                                    -9.989
                                                ],
                                                [
                                                    1.365,
                                                    -9.002
                                                ],
                                                [
                                                    0.924,
                                                    -7.532
                                                ],
                                                [
                                                    1.141,
                                                    -6.426
                                                ],
                                                [
                                                    1.799,
                                                    -5.607
                                                ],
                                                [
                                                    2.905,
                                                    -5.012
                                                ],
                                                [
                                                    4.466,
                                                    -4.564
                                                ],
                                                [
                                                    5.67,
                                                    -4.249
                                                ],
                                                [
                                                    6.552,
                                                    -3.745
                                                ],
                                                [
                                                    6.888,
                                                    -2.8
                                                ],
                                                [
                                                    6.258,
                                                    -1.484
                                                ],
                                                [
                                                    4.592,
                                                    -1.092
                                                ],
                                                [
                                                    2.765,
                                                    -1.68
                                                ],
                                                [
                                                    2.044,
                                                    -3.374
                                                ],
                                                [
                                                    0.602,
                                                    -3.206
                                                ],
                                                [
                                                    1.106,
                                                    -1.456
                                                ],
                                                [
                                                    2.457,
                                                    -0.28
                                                ],
                                                [
                                                    4.55,
                                                    0.14
                                                ],
                                                [
                                                    6.664,
                                                    -0.238
                                                ],
                                                [
                                                    7.987,
                                                    -1.295
                                                ],
                                                [
                                                    8.442,
                                                    -2.884
                                                ],
                                                [
                                                    8.169,
                                                    -4.158
                                                ],
                                                [
                                                    7.427,
                                                    -4.998
                                                ],
                                                [
                                                    6.37,
                                                    -5.516
                                                ],
                                                [
                                                    5.152,
                                                    -5.838
                                                ],
                                                [
                                                    3.703,
                                                    -6.223
                                                ],
                                                [
                                                    2.772,
                                                    -6.748
                                                ],
                                                [
                                                    2.45,
                                                    -7.63
                                                ],
                                                [
                                                    2.975,
                                                    -8.701
                                                ],
                                                [
                                                    4.48,
                                                    -9.114
                                                ],
                                                [
                                                    5.691,
                                                    -8.883
                                                ],
                                                [
                                                    6.496,
                                                    -8.211
                                                ],
                                                [
                                                    6.818,
                                                    -7.126
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "u",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.434,
                                                    0.238
                                                ],
                                                [
                                                    -0.243,
                                                    0.411
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.173,
                                                    -0.294
                                                ],
                                                [
                                                    0.313,
                                                    -0.168
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    -0.49
                                                ],
                                                [
                                                    -0.905,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.434,
                                                    -0.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.392
                                                ],
                                                [
                                                    -0.173,
                                                    0.294
                                                ],
                                                [
                                                    -0.313,
                                                    0.168
                                                ],
                                                [
                                                    -0.495,
                                                    0
                                                ],
                                                [
                                                    -0.299,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.476,
                                                    0.49
                                                ],
                                                [
                                                    0.504,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.029,
                                                    -0.217
                                                ],
                                                [
                                                    16.044,
                                                    -1.19
                                                ],
                                                [
                                                    16.114,
                                                    0
                                                ],
                                                [
                                                    17.444,
                                                    0
                                                ],
                                                [
                                                    17.444,
                                                    -7.882
                                                ],
                                                [
                                                    16.002,
                                                    -7.882
                                                ],
                                                [
                                                    16.002,
                                                    -3.122
                                                ],
                                                [
                                                    15.743,
                                                    -2.093
                                                ],
                                                [
                                                    15.015,
                                                    -1.4
                                                ],
                                                [
                                                    13.916,
                                                    -1.148
                                                ],
                                                [
                                                    12.726,
                                                    -1.547
                                                ],
                                                [
                                                    12.278,
                                                    -2.674
                                                ],
                                                [
                                                    12.278,
                                                    -7.882
                                                ],
                                                [
                                                    10.836,
                                                    -7.882
                                                ],
                                                [
                                                    10.836,
                                                    -2.548
                                                ],
                                                [
                                                    11.55,
                                                    -0.595
                                                ],
                                                [
                                                    13.622,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "m",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "m",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.168,
                                                    0.322
                                                ],
                                                [
                                                    -0.299,
                                                    0.187
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.243,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.173,
                                                    0.331
                                                ],
                                                [
                                                    -0.308,
                                                    0.177
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    0.49
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.462,
                                                    -0.275
                                                ],
                                                [
                                                    0.243,
                                                    -0.523
                                                ],
                                                [
                                                    0.42,
                                                    0.271
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.229
                                                ],
                                                [
                                                    0.261,
                                                    -0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    0.168,
                                                    -0.322
                                                ],
                                                [
                                                    0.299,
                                                    -0.187
                                                ],
                                                [
                                                    0.523,
                                                    0
                                                ],
                                                [
                                                    0.243,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    0.173,
                                                    -0.331
                                                ],
                                                [
                                                    0.308,
                                                    -0.177
                                                ],
                                                [
                                                    0.485,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.812
                                                ],
                                                [
                                                    -0.448,
                                                    -0.49
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.462,
                                                    0.275
                                                ],
                                                [
                                                    -0.196,
                                                    -0.532
                                                ],
                                                [
                                                    -0.42,
                                                    -0.271
                                                ],
                                                [
                                                    -0.485,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.672,
                                                    0
                                                ],
                                                [
                                                    21.672,
                                                    -4.592
                                                ],
                                                [
                                                    21.924,
                                                    -5.691
                                                ],
                                                [
                                                    22.624,
                                                    -6.454
                                                ],
                                                [
                                                    23.66,
                                                    -6.734
                                                ],
                                                [
                                                    24.808,
                                                    -6.244
                                                ],
                                                [
                                                    25.172,
                                                    -4.97
                                                ],
                                                [
                                                    25.172,
                                                    0
                                                ],
                                                [
                                                    26.6,
                                                    0
                                                ],
                                                [
                                                    26.6,
                                                    -4.522
                                                ],
                                                [
                                                    26.859,
                                                    -5.705
                                                ],
                                                [
                                                    27.58,
                                                    -6.468
                                                ],
                                                [
                                                    28.63,
                                                    -6.734
                                                ],
                                                [
                                                    29.736,
                                                    -6.307
                                                ],
                                                [
                                                    30.114,
                                                    -5.096
                                                ],
                                                [
                                                    30.114,
                                                    0
                                                ],
                                                [
                                                    31.556,
                                                    0
                                                ],
                                                [
                                                    31.556,
                                                    -5.334
                                                ],
                                                [
                                                    30.884,
                                                    -7.287
                                                ],
                                                [
                                                    28.952,
                                                    -8.022
                                                ],
                                                [
                                                    27.433,
                                                    -7.609
                                                ],
                                                [
                                                    26.376,
                                                    -6.412
                                                ],
                                                [
                                                    25.452,
                                                    -7.616
                                                ],
                                                [
                                                    24.01,
                                                    -8.022
                                                ],
                                                [
                                                    22.652,
                                                    -7.679
                                                ],
                                                [
                                                    21.63,
                                                    -6.622
                                                ],
                                                [
                                                    21.532,
                                                    -7.882
                                                ],
                                                [
                                                    20.23,
                                                    -7.882
                                                ],
                                                [
                                                    20.23,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "m",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "m",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.168,
                                                    0.322
                                                ],
                                                [
                                                    -0.299,
                                                    0.187
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.243,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.173,
                                                    0.331
                                                ],
                                                [
                                                    -0.308,
                                                    0.177
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    0.49
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.462,
                                                    -0.275
                                                ],
                                                [
                                                    0.243,
                                                    -0.523
                                                ],
                                                [
                                                    0.42,
                                                    0.271
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.229
                                                ],
                                                [
                                                    0.261,
                                                    -0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    0.168,
                                                    -0.322
                                                ],
                                                [
                                                    0.299,
                                                    -0.187
                                                ],
                                                [
                                                    0.523,
                                                    0
                                                ],
                                                [
                                                    0.243,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    0.173,
                                                    -0.331
                                                ],
                                                [
                                                    0.308,
                                                    -0.177
                                                ],
                                                [
                                                    0.485,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.812
                                                ],
                                                [
                                                    -0.448,
                                                    -0.49
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.462,
                                                    0.275
                                                ],
                                                [
                                                    -0.196,
                                                    -0.532
                                                ],
                                                [
                                                    -0.42,
                                                    -0.271
                                                ],
                                                [
                                                    -0.485,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.784,
                                                    0
                                                ],
                                                [
                                                    35.784,
                                                    -4.592
                                                ],
                                                [
                                                    36.036,
                                                    -5.691
                                                ],
                                                [
                                                    36.736,
                                                    -6.454
                                                ],
                                                [
                                                    37.772,
                                                    -6.734
                                                ],
                                                [
                                                    38.92,
                                                    -6.244
                                                ],
                                                [
                                                    39.284,
                                                    -4.97
                                                ],
                                                [
                                                    39.284,
                                                    0
                                                ],
                                                [
                                                    40.712,
                                                    0
                                                ],
                                                [
                                                    40.712,
                                                    -4.522
                                                ],
                                                [
                                                    40.971,
                                                    -5.705
                                                ],
                                                [
                                                    41.692,
                                                    -6.468
                                                ],
                                                [
                                                    42.742,
                                                    -6.734
                                                ],
                                                [
                                                    43.848,
                                                    -6.307
                                                ],
                                                [
                                                    44.226,
                                                    -5.096
                                                ],
                                                [
                                                    44.226,
                                                    0
                                                ],
                                                [
                                                    45.668,
                                                    0
                                                ],
                                                [
                                                    45.668,
                                                    -5.334
                                                ],
                                                [
                                                    44.996,
                                                    -7.287
                                                ],
                                                [
                                                    43.064,
                                                    -8.022
                                                ],
                                                [
                                                    41.545,
                                                    -7.609
                                                ],
                                                [
                                                    40.488,
                                                    -6.412
                                                ],
                                                [
                                                    39.564,
                                                    -7.616
                                                ],
                                                [
                                                    38.122,
                                                    -8.022
                                                ],
                                                [
                                                    36.764,
                                                    -7.679
                                                ],
                                                [
                                                    35.742,
                                                    -6.622
                                                ],
                                                [
                                                    35.644,
                                                    -7.882
                                                ],
                                                [
                                                    34.342,
                                                    -7.882
                                                ],
                                                [
                                                    34.342,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.271
                                                ],
                                                [
                                                    -0.196,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    -0.196
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.019
                                                ],
                                                [
                                                    -0.093,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.355
                                                ],
                                                [
                                                    0.453,
                                                    0.173
                                                ],
                                                [
                                                    0.653,
                                                    0
                                                ],
                                                [
                                                    0.602,
                                                    -0.415
                                                ],
                                                [
                                                    0.019,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    0.233
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.327
                                                ],
                                                [
                                                    0.131,
                                                    -0.154
                                                ],
                                                [
                                                    0.42,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.182
                                                ],
                                                [
                                                    0.238,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.453,
                                                    -0.406
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.247,
                                                    0.196
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.532
                                                ],
                                                [
                                                    -0.238,
                                                    -0.355
                                                ],
                                                [
                                                    -0.453,
                                                    -0.173
                                                ],
                                                [
                                                    -0.98,
                                                    0
                                                ],
                                                [
                                                    -0.602,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    -0.485
                                                ],
                                                [
                                                    0.355,
                                                    -0.233
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.252
                                                ],
                                                [
                                                    -0.131,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.084
                                                ],
                                                [
                                                    -0.383,
                                                    0.182
                                                ],
                                                [
                                                    -0.238,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0.653
                                                ],
                                                [
                                                    0.453,
                                                    0.406
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    52.374,
                                                    -0.266
                                                ],
                                                [
                                                    53.438,
                                                    -1.33
                                                ],
                                                [
                                                    53.438,
                                                    -1.078
                                                ],
                                                [
                                                    53.809,
                                                    -0.182
                                                ],
                                                [
                                                    54.782,
                                                    0.112
                                                ],
                                                [
                                                    55.125,
                                                    0.084
                                                ],
                                                [
                                                    55.496,
                                                    0
                                                ],
                                                [
                                                    55.496,
                                                    -1.022
                                                ],
                                                [
                                                    55.412,
                                                    -1.022
                                                ],
                                                [
                                                    55.342,
                                                    -1.001
                                                ],
                                                [
                                                    55.174,
                                                    -0.994
                                                ],
                                                [
                                                    54.838,
                                                    -1.12
                                                ],
                                                [
                                                    54.684,
                                                    -1.666
                                                ],
                                                [
                                                    54.684,
                                                    -5.642
                                                ],
                                                [
                                                    54.327,
                                                    -6.972
                                                ],
                                                [
                                                    53.291,
                                                    -7.763
                                                ],
                                                [
                                                    51.632,
                                                    -8.022
                                                ],
                                                [
                                                    49.259,
                                                    -7.399
                                                ],
                                                [
                                                    48.328,
                                                    -5.614
                                                ],
                                                [
                                                    49.686,
                                                    -5.474
                                                ],
                                                [
                                                    50.204,
                                                    -6.552
                                                ],
                                                [
                                                    51.632,
                                                    -6.902
                                                ],
                                                [
                                                    52.906,
                                                    -6.573
                                                ],
                                                [
                                                    53.256,
                                                    -5.754
                                                ],
                                                [
                                                    53.06,
                                                    -5.145
                                                ],
                                                [
                                                    52.234,
                                                    -4.802
                                                ],
                                                [
                                                    50.582,
                                                    -4.494
                                                ],
                                                [
                                                    49.336,
                                                    -4.095
                                                ],
                                                [
                                                    48.405,
                                                    -3.332
                                                ],
                                                [
                                                    48.048,
                                                    -2.058
                                                ],
                                                [
                                                    48.727,
                                                    -0.469
                                                ],
                                                [
                                                    50.638,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.28,
                                                    0.187
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    -0.191,
                                                    0.233
                                                ],
                                                [
                                                    -0.588,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.056
                                                ],
                                                [
                                                    -0.093,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.238
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.28,
                                                    -0.187
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    0.191,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.075
                                                ],
                                                [
                                                    0.201,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.429
                                                ],
                                                [
                                                    -0.406,
                                                    0.238
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    49.938,
                                                    -1.288
                                                ],
                                                [
                                                    49.518,
                                                    -2.17
                                                ],
                                                [
                                                    49.805,
                                                    -2.926
                                                ],
                                                [
                                                    50.974,
                                                    -3.458
                                                ],
                                                [
                                                    52.136,
                                                    -3.696
                                                ],
                                                [
                                                    52.983,
                                                    -3.892
                                                ],
                                                [
                                                    53.424,
                                                    -4.116
                                                ],
                                                [
                                                    53.27,
                                                    -4.172
                                                ],
                                                [
                                                    53.27,
                                                    -2.366
                                                ],
                                                [
                                                    52.451,
                                                    -1.365
                                                ],
                                                [
                                                    51.002,
                                                    -1.008
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "r",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.327
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ],
                                                [
                                                    -0.098,
                                                    -0.014
                                                ],
                                                [
                                                    -0.075,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0
                                                ],
                                                [
                                                    0.322,
                                                    -0.215
                                                ],
                                                [
                                                    0.205,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    -0.551
                                                ],
                                                [
                                                    0.322,
                                                    -0.327
                                                ],
                                                [
                                                    0.093,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    -0.056
                                                ],
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    58.814,
                                                    0
                                                ],
                                                [
                                                    58.814,
                                                    -4.802
                                                ],
                                                [
                                                    59.367,
                                                    -6.118
                                                ],
                                                [
                                                    60.648,
                                                    -6.608
                                                ],
                                                [
                                                    60.935,
                                                    -6.587
                                                ],
                                                [
                                                    61.194,
                                                    -6.524
                                                ],
                                                [
                                                    61.292,
                                                    -6.524
                                                ],
                                                [
                                                    61.292,
                                                    -7.882
                                                ],
                                                [
                                                    60.648,
                                                    -7.966
                                                ],
                                                [
                                                    59.535,
                                                    -7.644
                                                ],
                                                [
                                                    58.744,
                                                    -6.72
                                                ],
                                                [
                                                    58.66,
                                                    -7.882
                                                ],
                                                [
                                                    57.372,
                                                    -7.882
                                                ],
                                                [
                                                    57.372,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "i",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "i",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    64.526,
                                                    0
                                                ],
                                                [
                                                    64.526,
                                                    -7.882
                                                ],
                                                [
                                                    63.084,
                                                    -7.882
                                                ],
                                                [
                                                    63.084,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "i",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    64.47,
                                                    -9.184
                                                ],
                                                [
                                                    64.47,
                                                    -11.004
                                                ],
                                                [
                                                    63.154,
                                                    -11.004
                                                ],
                                                [
                                                    63.154,
                                                    -9.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "s",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.527,
                                                    0.425
                                                ],
                                                [
                                                    0,
                                                    0.691
                                                ],
                                                [
                                                    0.117,
                                                    0.266
                                                ],
                                                [
                                                    0.219,
                                                    0.177
                                                ],
                                                [
                                                    0.317,
                                                    0.107
                                                ],
                                                [
                                                    0.392,
                                                    0.075
                                                ],
                                                [
                                                    0.327,
                                                    0.103
                                                ],
                                                [
                                                    0.154,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0.271
                                                ],
                                                [
                                                    -0.257,
                                                    0.201
                                                ],
                                                [
                                                    -0.476,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    -0.28
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    0.355
                                                ],
                                                [
                                                    0.457,
                                                    0.177
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.187
                                                ],
                                                [
                                                    0.243,
                                                    -0.336
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    -0.168,
                                                    -0.294
                                                ],
                                                [
                                                    -0.345,
                                                    -0.196
                                                ],
                                                [
                                                    -0.532,
                                                    -0.121
                                                ],
                                                [
                                                    -0.289,
                                                    -0.056
                                                ],
                                                [
                                                    -0.219,
                                                    -0.089
                                                ],
                                                [
                                                    -0.121,
                                                    -0.149
                                                ],
                                                [
                                                    0,
                                                    -0.261
                                                ],
                                                [
                                                    0.313,
                                                    -0.182
                                                ],
                                                [
                                                    0.513,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    0.308
                                                ],
                                                [
                                                    0,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.597,
                                                    -0.457
                                                ],
                                                [
                                                    -0.989,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.527,
                                                    -0.425
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    -0.117,
                                                    -0.266
                                                ],
                                                [
                                                    -0.219,
                                                    -0.177
                                                ],
                                                [
                                                    -0.317,
                                                    -0.107
                                                ],
                                                [
                                                    -0.513,
                                                    -0.103
                                                ],
                                                [
                                                    -0.327,
                                                    -0.103
                                                ],
                                                [
                                                    -0.154,
                                                    -0.163
                                                ],
                                                [
                                                    0,
                                                    -0.317
                                                ],
                                                [
                                                    0.257,
                                                    -0.201
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.541
                                                ],
                                                [
                                                    -0.266,
                                                    -0.355
                                                ],
                                                [
                                                    -0.457,
                                                    -0.177
                                                ],
                                                [
                                                    -0.607,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.187
                                                ],
                                                [
                                                    -0.243,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.168,
                                                    0.294
                                                ],
                                                [
                                                    0.345,
                                                    0.196
                                                ],
                                                [
                                                    0.336,
                                                    0.075
                                                ],
                                                [
                                                    0.289,
                                                    0.056
                                                ],
                                                [
                                                    0.219,
                                                    0.089
                                                ],
                                                [
                                                    0.121,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    -0.313,
                                                    0.182
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    -0.308
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.803
                                                ],
                                                [
                                                    0.597,
                                                    0.457
                                                ],
                                                [
                                                    1.101,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    72.569,
                                                    -0.497
                                                ],
                                                [
                                                    73.36,
                                                    -2.17
                                                ],
                                                [
                                                    73.185,
                                                    -3.157
                                                ],
                                                [
                                                    72.681,
                                                    -3.822
                                                ],
                                                [
                                                    71.876,
                                                    -4.249
                                                ],
                                                [
                                                    70.812,
                                                    -4.522
                                                ],
                                                [
                                                    69.552,
                                                    -4.83
                                                ],
                                                [
                                                    68.831,
                                                    -5.229
                                                ],
                                                [
                                                    68.6,
                                                    -5.88
                                                ],
                                                [
                                                    68.985,
                                                    -6.657
                                                ],
                                                [
                                                    70.084,
                                                    -6.958
                                                ],
                                                [
                                                    71.428,
                                                    -6.538
                                                ],
                                                [
                                                    71.862,
                                                    -5.432
                                                ],
                                                [
                                                    73.248,
                                                    -5.614
                                                ],
                                                [
                                                    72.807,
                                                    -6.958
                                                ],
                                                [
                                                    71.722,
                                                    -7.756
                                                ],
                                                [
                                                    70.126,
                                                    -8.022
                                                ],
                                                [
                                                    68.544,
                                                    -7.742
                                                ],
                                                [
                                                    67.508,
                                                    -6.958
                                                ],
                                                [
                                                    67.144,
                                                    -5.768
                                                ],
                                                [
                                                    67.396,
                                                    -4.725
                                                ],
                                                [
                                                    68.166,
                                                    -3.99
                                                ],
                                                [
                                                    69.482,
                                                    -3.514
                                                ],
                                                [
                                                    70.42,
                                                    -3.318
                                                ],
                                                [
                                                    71.183,
                                                    -3.101
                                                ],
                                                [
                                                    71.694,
                                                    -2.744
                                                ],
                                                [
                                                    71.876,
                                                    -2.128
                                                ],
                                                [
                                                    71.407,
                                                    -1.211
                                                ],
                                                [
                                                    70.168,
                                                    -0.938
                                                ],
                                                [
                                                    68.74,
                                                    -1.4
                                                ],
                                                [
                                                    68.208,
                                                    -2.59
                                                ],
                                                [
                                                    66.808,
                                                    -2.436
                                                ],
                                                [
                                                    67.746,
                                                    -0.546
                                                ],
                                                [
                                                    70.126,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    80.668,
                                                    -0.161
                                                ],
                                                [
                                                    81.816,
                                                    -0.994
                                                ],
                                                [
                                                    82.404,
                                                    -2.24
                                                ],
                                                [
                                                    81.13,
                                                    -2.534
                                                ],
                                                [
                                                    80.472,
                                                    -1.442
                                                ],
                                                [
                                                    79.072,
                                                    -1.05
                                                ],
                                                [
                                                    77.322,
                                                    -1.771
                                                ],
                                                [
                                                    76.706,
                                                    -3.962
                                                ],
                                                [
                                                    77.35,
                                                    -6.202
                                                ],
                                                [
                                                    78.974,
                                                    -6.888
                                                ],
                                                [
                                                    80.633,
                                                    -6.132
                                                ],
                                                [
                                                    80.99,
                                                    -4.158
                                                ],
                                                [
                                                    81.648,
                                                    -4.662
                                                ],
                                                [
                                                    76.538,
                                                    -4.662
                                                ],
                                                [
                                                    76.538,
                                                    -3.584
                                                ],
                                                [
                                                    82.502,
                                                    -3.584
                                                ],
                                                [
                                                    82.18,
                                                    -6.055
                                                ],
                                                [
                                                    80.941,
                                                    -7.532
                                                ],
                                                [
                                                    79.002,
                                                    -8.022
                                                ],
                                                [
                                                    77,
                                                    -7.511
                                                ],
                                                [
                                                    75.733,
                                                    -6.083
                                                ],
                                                [
                                                    75.292,
                                                    -3.934
                                                ],
                                                [
                                                    75.761,
                                                    -1.736
                                                ],
                                                [
                                                    77.077,
                                                    -0.343
                                                ],
                                                [
                                                    79.058,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.177,
                                                    0.019
                                                ],
                                                [
                                                    -0.205,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.009
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.229
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.177,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.019
                                                ],
                                                [
                                                    -0.098,
                                                    0.009
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    0.275,
                                                    0.229
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    91.322,
                                                    0.07
                                                ],
                                                [
                                                    91.896,
                                                    -0.014
                                                ],
                                                [
                                                    91.896,
                                                    -1.162
                                                ],
                                                [
                                                    91.637,
                                                    -1.12
                                                ],
                                                [
                                                    91.28,
                                                    -1.106
                                                ],
                                                [
                                                    90.755,
                                                    -1.246
                                                ],
                                                [
                                                    90.622,
                                                    -1.82
                                                ],
                                                [
                                                    90.622,
                                                    -10.22
                                                ],
                                                [
                                                    89.222,
                                                    -10.08
                                                ],
                                                [
                                                    89.222,
                                                    -1.232
                                                ],
                                                [
                                                    89.635,
                                                    -0.245
                                                ],
                                                [
                                                    90.832,
                                                    0.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    89.922,
                                                    -6.762
                                                ],
                                                [
                                                    89.922,
                                                    -7.882
                                                ],
                                                [
                                                    88.172,
                                                    -7.882
                                                ],
                                                [
                                                    88.172,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    91.896,
                                                    -7.882
                                                ],
                                                [
                                                    89.922,
                                                    -7.882
                                                ],
                                                [
                                                    89.922,
                                                    -6.762
                                                ],
                                                [
                                                    91.896,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "h",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "h",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.415,
                                                    -0.205
                                                ],
                                                [
                                                    0.327,
                                                    -0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ],
                                                [
                                                    -0.415,
                                                    0.205
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    95.452,
                                                    0
                                                ],
                                                [
                                                    95.452,
                                                    -4.704
                                                ],
                                                [
                                                    95.739,
                                                    -5.81
                                                ],
                                                [
                                                    96.516,
                                                    -6.517
                                                ],
                                                [
                                                    97.58,
                                                    -6.762
                                                ],
                                                [
                                                    98.854,
                                                    -6.328
                                                ],
                                                [
                                                    99.274,
                                                    -5.152
                                                ],
                                                [
                                                    99.274,
                                                    0
                                                ],
                                                [
                                                    100.702,
                                                    0
                                                ],
                                                [
                                                    100.702,
                                                    -5.292
                                                ],
                                                [
                                                    99.939,
                                                    -7.371
                                                ],
                                                [
                                                    97.986,
                                                    -8.05
                                                ],
                                                [
                                                    96.565,
                                                    -7.742
                                                ],
                                                [
                                                    95.452,
                                                    -6.776
                                                ],
                                                [
                                                    95.452,
                                                    -11.06
                                                ],
                                                [
                                                    94.01,
                                                    -11.06
                                                ],
                                                [
                                                    94.01,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "i",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "i",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    104.93,
                                                    0
                                                ],
                                                [
                                                    104.93,
                                                    -7.882
                                                ],
                                                [
                                                    103.488,
                                                    -7.882
                                                ],
                                                [
                                                    103.488,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "i",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    104.874,
                                                    -9.184
                                                ],
                                                [
                                                    104.874,
                                                    -11.004
                                                ],
                                                [
                                                    103.558,
                                                    -11.004
                                                ],
                                                [
                                                    103.558,
                                                    -9.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "s",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.527,
                                                    0.425
                                                ],
                                                [
                                                    0,
                                                    0.691
                                                ],
                                                [
                                                    0.117,
                                                    0.266
                                                ],
                                                [
                                                    0.219,
                                                    0.177
                                                ],
                                                [
                                                    0.317,
                                                    0.107
                                                ],
                                                [
                                                    0.392,
                                                    0.075
                                                ],
                                                [
                                                    0.327,
                                                    0.103
                                                ],
                                                [
                                                    0.154,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0.271
                                                ],
                                                [
                                                    -0.257,
                                                    0.201
                                                ],
                                                [
                                                    -0.476,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    -0.28
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    0.355
                                                ],
                                                [
                                                    0.457,
                                                    0.177
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.187
                                                ],
                                                [
                                                    0.243,
                                                    -0.336
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    -0.168,
                                                    -0.294
                                                ],
                                                [
                                                    -0.345,
                                                    -0.196
                                                ],
                                                [
                                                    -0.532,
                                                    -0.121
                                                ],
                                                [
                                                    -0.289,
                                                    -0.056
                                                ],
                                                [
                                                    -0.219,
                                                    -0.089
                                                ],
                                                [
                                                    -0.121,
                                                    -0.149
                                                ],
                                                [
                                                    0,
                                                    -0.261
                                                ],
                                                [
                                                    0.313,
                                                    -0.182
                                                ],
                                                [
                                                    0.513,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    0.308
                                                ],
                                                [
                                                    0,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.597,
                                                    -0.457
                                                ],
                                                [
                                                    -0.989,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.527,
                                                    -0.425
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    -0.117,
                                                    -0.266
                                                ],
                                                [
                                                    -0.219,
                                                    -0.177
                                                ],
                                                [
                                                    -0.317,
                                                    -0.107
                                                ],
                                                [
                                                    -0.513,
                                                    -0.103
                                                ],
                                                [
                                                    -0.327,
                                                    -0.103
                                                ],
                                                [
                                                    -0.154,
                                                    -0.163
                                                ],
                                                [
                                                    0,
                                                    -0.317
                                                ],
                                                [
                                                    0.257,
                                                    -0.201
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.541
                                                ],
                                                [
                                                    -0.266,
                                                    -0.355
                                                ],
                                                [
                                                    -0.457,
                                                    -0.177
                                                ],
                                                [
                                                    -0.607,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.187
                                                ],
                                                [
                                                    -0.243,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.168,
                                                    0.294
                                                ],
                                                [
                                                    0.345,
                                                    0.196
                                                ],
                                                [
                                                    0.336,
                                                    0.075
                                                ],
                                                [
                                                    0.289,
                                                    0.056
                                                ],
                                                [
                                                    0.219,
                                                    0.089
                                                ],
                                                [
                                                    0.121,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    -0.313,
                                                    0.182
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    -0.308
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.803
                                                ],
                                                [
                                                    0.597,
                                                    0.457
                                                ],
                                                [
                                                    1.101,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    112.973,
                                                    -0.497
                                                ],
                                                [
                                                    113.764,
                                                    -2.17
                                                ],
                                                [
                                                    113.589,
                                                    -3.157
                                                ],
                                                [
                                                    113.085,
                                                    -3.822
                                                ],
                                                [
                                                    112.28,
                                                    -4.249
                                                ],
                                                [
                                                    111.216,
                                                    -4.522
                                                ],
                                                [
                                                    109.956,
                                                    -4.83
                                                ],
                                                [
                                                    109.235,
                                                    -5.229
                                                ],
                                                [
                                                    109.004,
                                                    -5.88
                                                ],
                                                [
                                                    109.389,
                                                    -6.657
                                                ],
                                                [
                                                    110.488,
                                                    -6.958
                                                ],
                                                [
                                                    111.832,
                                                    -6.538
                                                ],
                                                [
                                                    112.266,
                                                    -5.432
                                                ],
                                                [
                                                    113.652,
                                                    -5.614
                                                ],
                                                [
                                                    113.211,
                                                    -6.958
                                                ],
                                                [
                                                    112.126,
                                                    -7.756
                                                ],
                                                [
                                                    110.53,
                                                    -8.022
                                                ],
                                                [
                                                    108.948,
                                                    -7.742
                                                ],
                                                [
                                                    107.912,
                                                    -6.958
                                                ],
                                                [
                                                    107.548,
                                                    -5.768
                                                ],
                                                [
                                                    107.8,
                                                    -4.725
                                                ],
                                                [
                                                    108.57,
                                                    -3.99
                                                ],
                                                [
                                                    109.886,
                                                    -3.514
                                                ],
                                                [
                                                    110.824,
                                                    -3.318
                                                ],
                                                [
                                                    111.587,
                                                    -3.101
                                                ],
                                                [
                                                    112.098,
                                                    -2.744
                                                ],
                                                [
                                                    112.28,
                                                    -2.128
                                                ],
                                                [
                                                    111.811,
                                                    -1.211
                                                ],
                                                [
                                                    110.572,
                                                    -0.938
                                                ],
                                                [
                                                    109.144,
                                                    -1.4
                                                ],
                                                [
                                                    108.612,
                                                    -2.59
                                                ],
                                                [
                                                    107.212,
                                                    -2.436
                                                ],
                                                [
                                                    108.15,
                                                    -0.546
                                                ],
                                                [
                                                    110.53,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.271
                                                ],
                                                [
                                                    -0.196,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    -0.196
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.019
                                                ],
                                                [
                                                    -0.093,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.355
                                                ],
                                                [
                                                    0.453,
                                                    0.173
                                                ],
                                                [
                                                    0.653,
                                                    0
                                                ],
                                                [
                                                    0.602,
                                                    -0.415
                                                ],
                                                [
                                                    0.019,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    0.233
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.327
                                                ],
                                                [
                                                    0.131,
                                                    -0.154
                                                ],
                                                [
                                                    0.42,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.182
                                                ],
                                                [
                                                    0.238,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.453,
                                                    -0.406
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.247,
                                                    0.196
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.532
                                                ],
                                                [
                                                    -0.238,
                                                    -0.355
                                                ],
                                                [
                                                    -0.453,
                                                    -0.173
                                                ],
                                                [
                                                    -0.98,
                                                    0
                                                ],
                                                [
                                                    -0.602,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    -0.485
                                                ],
                                                [
                                                    0.355,
                                                    -0.233
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.252
                                                ],
                                                [
                                                    -0.131,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.084
                                                ],
                                                [
                                                    -0.383,
                                                    0.182
                                                ],
                                                [
                                                    -0.238,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0.653
                                                ],
                                                [
                                                    0.453,
                                                    0.406
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    124.194,
                                                    -0.266
                                                ],
                                                [
                                                    125.258,
                                                    -1.33
                                                ],
                                                [
                                                    125.258,
                                                    -1.078
                                                ],
                                                [
                                                    125.629,
                                                    -0.182
                                                ],
                                                [
                                                    126.602,
                                                    0.112
                                                ],
                                                [
                                                    126.945,
                                                    0.084
                                                ],
                                                [
                                                    127.316,
                                                    0
                                                ],
                                                [
                                                    127.316,
                                                    -1.022
                                                ],
                                                [
                                                    127.232,
                                                    -1.022
                                                ],
                                                [
                                                    127.162,
                                                    -1.001
                                                ],
                                                [
                                                    126.994,
                                                    -0.994
                                                ],
                                                [
                                                    126.658,
                                                    -1.12
                                                ],
                                                [
                                                    126.504,
                                                    -1.666
                                                ],
                                                [
                                                    126.504,
                                                    -5.642
                                                ],
                                                [
                                                    126.147,
                                                    -6.972
                                                ],
                                                [
                                                    125.111,
                                                    -7.763
                                                ],
                                                [
                                                    123.452,
                                                    -8.022
                                                ],
                                                [
                                                    121.079,
                                                    -7.399
                                                ],
                                                [
                                                    120.148,
                                                    -5.614
                                                ],
                                                [
                                                    121.506,
                                                    -5.474
                                                ],
                                                [
                                                    122.024,
                                                    -6.552
                                                ],
                                                [
                                                    123.452,
                                                    -6.902
                                                ],
                                                [
                                                    124.726,
                                                    -6.573
                                                ],
                                                [
                                                    125.076,
                                                    -5.754
                                                ],
                                                [
                                                    124.88,
                                                    -5.145
                                                ],
                                                [
                                                    124.054,
                                                    -4.802
                                                ],
                                                [
                                                    122.402,
                                                    -4.494
                                                ],
                                                [
                                                    121.156,
                                                    -4.095
                                                ],
                                                [
                                                    120.225,
                                                    -3.332
                                                ],
                                                [
                                                    119.868,
                                                    -2.058
                                                ],
                                                [
                                                    120.547,
                                                    -0.469
                                                ],
                                                [
                                                    122.458,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.28,
                                                    0.187
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    -0.191,
                                                    0.233
                                                ],
                                                [
                                                    -0.588,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.056
                                                ],
                                                [
                                                    -0.093,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.238
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.28,
                                                    -0.187
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    0.191,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.075
                                                ],
                                                [
                                                    0.201,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.429
                                                ],
                                                [
                                                    -0.406,
                                                    0.238
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    121.758,
                                                    -1.288
                                                ],
                                                [
                                                    121.338,
                                                    -2.17
                                                ],
                                                [
                                                    121.625,
                                                    -2.926
                                                ],
                                                [
                                                    122.794,
                                                    -3.458
                                                ],
                                                [
                                                    123.956,
                                                    -3.696
                                                ],
                                                [
                                                    124.803,
                                                    -3.892
                                                ],
                                                [
                                                    125.244,
                                                    -4.116
                                                ],
                                                [
                                                    125.09,
                                                    -4.172
                                                ],
                                                [
                                                    125.09,
                                                    -2.366
                                                ],
                                                [
                                                    124.271,
                                                    -1.365
                                                ],
                                                [
                                                    122.822,
                                                    -1.008
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "c",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.476,
                                                    0.21
                                                ],
                                                [
                                                    -0.303,
                                                    0.401
                                                ],
                                                [
                                                    -0.075,
                                                    0.569
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.28
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.401,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.877
                                                ],
                                                [
                                                    -0.406,
                                                    0.499
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    -0.271
                                                ],
                                                [
                                                    -0.056,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.499
                                                ],
                                                [
                                                    0.952,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.336
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.476,
                                                    -0.21
                                                ],
                                                [
                                                    0.303,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.056,
                                                    0.513
                                                ],
                                                [
                                                    -0.355,
                                                    0.28
                                                ],
                                                [
                                                    -0.7,
                                                    0
                                                ],
                                                [
                                                    -0.401,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.812
                                                ],
                                                [
                                                    -0.583,
                                                    -0.499
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.336
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    134.134,
                                                    -0.189
                                                ],
                                                [
                                                    135.303,
                                                    -1.106
                                                ],
                                                [
                                                    135.87,
                                                    -2.562
                                                ],
                                                [
                                                    134.47,
                                                    -2.73
                                                ],
                                                [
                                                    133.854,
                                                    -1.54
                                                ],
                                                [
                                                    132.496,
                                                    -1.12
                                                ],
                                                [
                                                    130.844,
                                                    -1.876
                                                ],
                                                [
                                                    130.242,
                                                    -3.948
                                                ],
                                                [
                                                    130.851,
                                                    -6.027
                                                ],
                                                [
                                                    132.496,
                                                    -6.776
                                                ],
                                                [
                                                    133.854,
                                                    -6.37
                                                ],
                                                [
                                                    134.47,
                                                    -5.138
                                                ],
                                                [
                                                    135.87,
                                                    -5.306
                                                ],
                                                [
                                                    134.841,
                                                    -7.273
                                                ],
                                                [
                                                    132.538,
                                                    -8.022
                                                ],
                                                [
                                                    130.557,
                                                    -7.518
                                                ],
                                                [
                                                    129.241,
                                                    -6.097
                                                ],
                                                [
                                                    128.772,
                                                    -3.948
                                                ],
                                                [
                                                    129.234,
                                                    -1.813
                                                ],
                                                [
                                                    130.536,
                                                    -0.385
                                                ],
                                                [
                                                    132.51,
                                                    0.126
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "c",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.476,
                                                    0.21
                                                ],
                                                [
                                                    -0.303,
                                                    0.401
                                                ],
                                                [
                                                    -0.075,
                                                    0.569
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.28
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.401,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.877
                                                ],
                                                [
                                                    -0.406,
                                                    0.499
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    -0.271
                                                ],
                                                [
                                                    -0.056,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.499
                                                ],
                                                [
                                                    0.952,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.336
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.476,
                                                    -0.21
                                                ],
                                                [
                                                    0.303,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.056,
                                                    0.513
                                                ],
                                                [
                                                    -0.355,
                                                    0.28
                                                ],
                                                [
                                                    -0.7,
                                                    0
                                                ],
                                                [
                                                    -0.401,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.812
                                                ],
                                                [
                                                    -0.583,
                                                    -0.499
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.336
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    143.08,
                                                    -0.189
                                                ],
                                                [
                                                    144.249,
                                                    -1.106
                                                ],
                                                [
                                                    144.816,
                                                    -2.562
                                                ],
                                                [
                                                    143.416,
                                                    -2.73
                                                ],
                                                [
                                                    142.8,
                                                    -1.54
                                                ],
                                                [
                                                    141.442,
                                                    -1.12
                                                ],
                                                [
                                                    139.79,
                                                    -1.876
                                                ],
                                                [
                                                    139.188,
                                                    -3.948
                                                ],
                                                [
                                                    139.797,
                                                    -6.027
                                                ],
                                                [
                                                    141.442,
                                                    -6.776
                                                ],
                                                [
                                                    142.8,
                                                    -6.37
                                                ],
                                                [
                                                    143.416,
                                                    -5.138
                                                ],
                                                [
                                                    144.816,
                                                    -5.306
                                                ],
                                                [
                                                    143.787,
                                                    -7.273
                                                ],
                                                [
                                                    141.484,
                                                    -8.022
                                                ],
                                                [
                                                    139.503,
                                                    -7.518
                                                ],
                                                [
                                                    138.187,
                                                    -6.097
                                                ],
                                                [
                                                    137.718,
                                                    -3.948
                                                ],
                                                [
                                                    138.18,
                                                    -1.813
                                                ],
                                                [
                                                    139.482,
                                                    -0.385
                                                ],
                                                [
                                                    141.456,
                                                    0.126
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.56,
                                                    0.336
                                                ],
                                                [
                                                    -0.308,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.341
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    -0.308,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.341
                                                ],
                                                [
                                                    -0.765,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.56,
                                                    -0.336
                                                ],
                                                [
                                                    0.308,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.341
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    152.404,
                                                    -0.364
                                                ],
                                                [
                                                    153.706,
                                                    -1.785
                                                ],
                                                [
                                                    154.168,
                                                    -3.934
                                                ],
                                                [
                                                    153.706,
                                                    -6.083
                                                ],
                                                [
                                                    152.404,
                                                    -7.511
                                                ],
                                                [
                                                    150.43,
                                                    -8.022
                                                ],
                                                [
                                                    148.449,
                                                    -7.511
                                                ],
                                                [
                                                    147.133,
                                                    -6.083
                                                ],
                                                [
                                                    146.664,
                                                    -3.92
                                                ],
                                                [
                                                    147.126,
                                                    -1.792
                                                ],
                                                [
                                                    148.435,
                                                    -0.371
                                                ],
                                                [
                                                    150.43,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.406,
                                                    0.499
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.509
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    0.406,
                                                    -0.504
                                                ],
                                                [
                                                    0.728,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.509
                                                ],
                                                [
                                                    0.719,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    0.495
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.504
                                                ],
                                                [
                                                    -0.728,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    148.715,
                                                    -1.841
                                                ],
                                                [
                                                    148.106,
                                                    -3.934
                                                ],
                                                [
                                                    148.715,
                                                    -6.027
                                                ],
                                                [
                                                    150.43,
                                                    -6.79
                                                ],
                                                [
                                                    152.117,
                                                    -6.048
                                                ],
                                                [
                                                    152.726,
                                                    -3.948
                                                ],
                                                [
                                                    152.117,
                                                    -1.848
                                                ],
                                                [
                                                    150.416,
                                                    -1.092
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "u",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.434,
                                                    0.238
                                                ],
                                                [
                                                    -0.243,
                                                    0.411
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.173,
                                                    -0.294
                                                ],
                                                [
                                                    0.313,
                                                    -0.168
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    -0.49
                                                ],
                                                [
                                                    -0.905,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.434,
                                                    -0.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.392
                                                ],
                                                [
                                                    -0.173,
                                                    0.294
                                                ],
                                                [
                                                    -0.313,
                                                    0.168
                                                ],
                                                [
                                                    -0.495,
                                                    0
                                                ],
                                                [
                                                    -0.299,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.476,
                                                    0.49
                                                ],
                                                [
                                                    0.504,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    160.727,
                                                    -0.217
                                                ],
                                                [
                                                    161.742,
                                                    -1.19
                                                ],
                                                [
                                                    161.812,
                                                    0
                                                ],
                                                [
                                                    163.142,
                                                    0
                                                ],
                                                [
                                                    163.142,
                                                    -7.882
                                                ],
                                                [
                                                    161.7,
                                                    -7.882
                                                ],
                                                [
                                                    161.7,
                                                    -3.122
                                                ],
                                                [
                                                    161.441,
                                                    -2.093
                                                ],
                                                [
                                                    160.713,
                                                    -1.4
                                                ],
                                                [
                                                    159.614,
                                                    -1.148
                                                ],
                                                [
                                                    158.424,
                                                    -1.547
                                                ],
                                                [
                                                    157.976,
                                                    -2.674
                                                ],
                                                [
                                                    157.976,
                                                    -7.882
                                                ],
                                                [
                                                    156.534,
                                                    -7.882
                                                ],
                                                [
                                                    156.534,
                                                    -2.548
                                                ],
                                                [
                                                    157.248,
                                                    -0.595
                                                ],
                                                [
                                                    159.32,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.215
                                                ],
                                                [
                                                    0.336,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    167.37,
                                                    0
                                                ],
                                                [
                                                    167.37,
                                                    -4.676
                                                ],
                                                [
                                                    167.657,
                                                    -5.782
                                                ],
                                                [
                                                    168.434,
                                                    -6.489
                                                ],
                                                [
                                                    169.498,
                                                    -6.734
                                                ],
                                                [
                                                    170.772,
                                                    -6.3
                                                ],
                                                [
                                                    171.192,
                                                    -5.124
                                                ],
                                                [
                                                    171.192,
                                                    0
                                                ],
                                                [
                                                    172.62,
                                                    0
                                                ],
                                                [
                                                    172.62,
                                                    -5.264
                                                ],
                                                [
                                                    171.857,
                                                    -7.343
                                                ],
                                                [
                                                    169.904,
                                                    -8.022
                                                ],
                                                [
                                                    168.462,
                                                    -7.7
                                                ],
                                                [
                                                    167.328,
                                                    -6.692
                                                ],
                                                [
                                                    167.244,
                                                    -7.882
                                                ],
                                                [
                                                    165.928,
                                                    -7.882
                                                ],
                                                [
                                                    165.928,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.177,
                                                    0.019
                                                ],
                                                [
                                                    -0.205,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.009
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.229
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.177,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.019
                                                ],
                                                [
                                                    -0.098,
                                                    0.009
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    0.275,
                                                    0.229
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    177.884,
                                                    0.07
                                                ],
                                                [
                                                    178.458,
                                                    -0.014
                                                ],
                                                [
                                                    178.458,
                                                    -1.162
                                                ],
                                                [
                                                    178.199,
                                                    -1.12
                                                ],
                                                [
                                                    177.842,
                                                    -1.106
                                                ],
                                                [
                                                    177.317,
                                                    -1.246
                                                ],
                                                [
                                                    177.184,
                                                    -1.82
                                                ],
                                                [
                                                    177.184,
                                                    -10.22
                                                ],
                                                [
                                                    175.784,
                                                    -10.08
                                                ],
                                                [
                                                    175.784,
                                                    -1.232
                                                ],
                                                [
                                                    176.197,
                                                    -0.245
                                                ],
                                                [
                                                    177.394,
                                                    0.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    176.484,
                                                    -6.762
                                                ],
                                                [
                                                    176.484,
                                                    -7.882
                                                ],
                                                [
                                                    174.734,
                                                    -7.882
                                                ],
                                                [
                                                    174.734,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    178.458,
                                                    -7.882
                                                ],
                                                [
                                                    176.484,
                                                    -7.882
                                                ],
                                                [
                                                    176.484,
                                                    -6.762
                                                ],
                                                [
                                                    178.458,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.215
                                                ],
                                                [
                                                    0.336,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    186.172,
                                                    0
                                                ],
                                                [
                                                    186.172,
                                                    -4.676
                                                ],
                                                [
                                                    186.459,
                                                    -5.782
                                                ],
                                                [
                                                    187.236,
                                                    -6.489
                                                ],
                                                [
                                                    188.3,
                                                    -6.734
                                                ],
                                                [
                                                    189.574,
                                                    -6.3
                                                ],
                                                [
                                                    189.994,
                                                    -5.124
                                                ],
                                                [
                                                    189.994,
                                                    0
                                                ],
                                                [
                                                    191.422,
                                                    0
                                                ],
                                                [
                                                    191.422,
                                                    -5.264
                                                ],
                                                [
                                                    190.659,
                                                    -7.343
                                                ],
                                                [
                                                    188.706,
                                                    -8.022
                                                ],
                                                [
                                                    187.264,
                                                    -7.7
                                                ],
                                                [
                                                    186.13,
                                                    -6.692
                                                ],
                                                [
                                                    186.046,
                                                    -7.882
                                                ],
                                                [
                                                    184.73,
                                                    -7.882
                                                ],
                                                [
                                                    184.73,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.56,
                                                    0.336
                                                ],
                                                [
                                                    -0.308,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.341
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    -0.308,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.341
                                                ],
                                                [
                                                    -0.765,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.56,
                                                    -0.336
                                                ],
                                                [
                                                    0.308,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.341
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    199.528,
                                                    -0.364
                                                ],
                                                [
                                                    200.83,
                                                    -1.785
                                                ],
                                                [
                                                    201.292,
                                                    -3.934
                                                ],
                                                [
                                                    200.83,
                                                    -6.083
                                                ],
                                                [
                                                    199.528,
                                                    -7.511
                                                ],
                                                [
                                                    197.554,
                                                    -8.022
                                                ],
                                                [
                                                    195.573,
                                                    -7.511
                                                ],
                                                [
                                                    194.257,
                                                    -6.083
                                                ],
                                                [
                                                    193.788,
                                                    -3.92
                                                ],
                                                [
                                                    194.25,
                                                    -1.792
                                                ],
                                                [
                                                    195.559,
                                                    -0.371
                                                ],
                                                [
                                                    197.554,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.406,
                                                    0.499
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.509
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    0.406,
                                                    -0.504
                                                ],
                                                [
                                                    0.728,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.509
                                                ],
                                                [
                                                    0.719,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    0.495
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.504
                                                ],
                                                [
                                                    -0.728,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    195.839,
                                                    -1.841
                                                ],
                                                [
                                                    195.23,
                                                    -3.934
                                                ],
                                                [
                                                    195.839,
                                                    -6.027
                                                ],
                                                [
                                                    197.554,
                                                    -6.79
                                                ],
                                                [
                                                    199.241,
                                                    -6.048
                                                ],
                                                [
                                                    199.85,
                                                    -3.948
                                                ],
                                                [
                                                    199.241,
                                                    -1.848
                                                ],
                                                [
                                                    197.54,
                                                    -1.092
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.177,
                                                    0.019
                                                ],
                                                [
                                                    -0.205,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.009
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.229
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.177,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.019
                                                ],
                                                [
                                                    -0.098,
                                                    0.009
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    0.275,
                                                    0.229
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    206.136,
                                                    0.07
                                                ],
                                                [
                                                    206.71,
                                                    -0.014
                                                ],
                                                [
                                                    206.71,
                                                    -1.162
                                                ],
                                                [
                                                    206.451,
                                                    -1.12
                                                ],
                                                [
                                                    206.094,
                                                    -1.106
                                                ],
                                                [
                                                    205.569,
                                                    -1.246
                                                ],
                                                [
                                                    205.436,
                                                    -1.82
                                                ],
                                                [
                                                    205.436,
                                                    -10.22
                                                ],
                                                [
                                                    204.036,
                                                    -10.08
                                                ],
                                                [
                                                    204.036,
                                                    -1.232
                                                ],
                                                [
                                                    204.449,
                                                    -0.245
                                                ],
                                                [
                                                    205.646,
                                                    0.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    204.736,
                                                    -6.762
                                                ],
                                                [
                                                    204.736,
                                                    -7.882
                                                ],
                                                [
                                                    202.986,
                                                    -7.882
                                                ],
                                                [
                                                    202.986,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    206.71,
                                                    -7.882
                                                ],
                                                [
                                                    204.736,
                                                    -7.882
                                                ],
                                                [
                                                    204.736,
                                                    -6.762
                                                ],
                                                [
                                                    206.71,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    213.78,
                                                    -0.161
                                                ],
                                                [
                                                    214.928,
                                                    -0.994
                                                ],
                                                [
                                                    215.516,
                                                    -2.24
                                                ],
                                                [
                                                    214.242,
                                                    -2.534
                                                ],
                                                [
                                                    213.584,
                                                    -1.442
                                                ],
                                                [
                                                    212.184,
                                                    -1.05
                                                ],
                                                [
                                                    210.434,
                                                    -1.771
                                                ],
                                                [
                                                    209.818,
                                                    -3.962
                                                ],
                                                [
                                                    210.462,
                                                    -6.202
                                                ],
                                                [
                                                    212.086,
                                                    -6.888
                                                ],
                                                [
                                                    213.745,
                                                    -6.132
                                                ],
                                                [
                                                    214.102,
                                                    -4.158
                                                ],
                                                [
                                                    214.76,
                                                    -4.662
                                                ],
                                                [
                                                    209.65,
                                                    -4.662
                                                ],
                                                [
                                                    209.65,
                                                    -3.584
                                                ],
                                                [
                                                    215.614,
                                                    -3.584
                                                ],
                                                [
                                                    215.292,
                                                    -6.055
                                                ],
                                                [
                                                    214.053,
                                                    -7.532
                                                ],
                                                [
                                                    212.114,
                                                    -8.022
                                                ],
                                                [
                                                    210.112,
                                                    -7.511
                                                ],
                                                [
                                                    208.845,
                                                    -6.083
                                                ],
                                                [
                                                    208.404,
                                                    -3.934
                                                ],
                                                [
                                                    208.873,
                                                    -1.736
                                                ],
                                                [
                                                    210.189,
                                                    -0.343
                                                ],
                                                [
                                                    212.17,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "f",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "f",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.177,
                                                    0.154
                                                ],
                                                [
                                                    -0.336,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    -0.014
                                                ],
                                                [
                                                    -0.056,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.14,
                                                    0.014
                                                ],
                                                [
                                                    0.131,
                                                    0
                                                ],
                                                [
                                                    0.378,
                                                    -0.373
                                                ],
                                                [
                                                    0,
                                                    -0.635
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    0.177,
                                                    -0.154
                                                ],
                                                [
                                                    0.103,
                                                    0
                                                ],
                                                [
                                                    0.084,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.093,
                                                    -0.028
                                                ],
                                                [
                                                    -0.14,
                                                    -0.014
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.378,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    223.622,
                                                    0
                                                ],
                                                [
                                                    223.622,
                                                    -8.834
                                                ],
                                                [
                                                    223.888,
                                                    -9.681
                                                ],
                                                [
                                                    224.658,
                                                    -9.912
                                                ],
                                                [
                                                    224.938,
                                                    -9.891
                                                ],
                                                [
                                                    225.148,
                                                    -9.828
                                                ],
                                                [
                                                    225.232,
                                                    -9.828
                                                ],
                                                [
                                                    225.232,
                                                    -11.046
                                                ],
                                                [
                                                    224.882,
                                                    -11.109
                                                ],
                                                [
                                                    224.476,
                                                    -11.13
                                                ],
                                                [
                                                    222.775,
                                                    -10.57
                                                ],
                                                [
                                                    222.208,
                                                    -9.058
                                                ],
                                                [
                                                    222.208,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "f",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    222.922,
                                                    -6.762
                                                ],
                                                [
                                                    222.922,
                                                    -7.882
                                                ],
                                                [
                                                    221.06,
                                                    -7.882
                                                ],
                                                [
                                                    221.06,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "f",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    225.26,
                                                    -6.762
                                                ],
                                                [
                                                    225.26,
                                                    -7.882
                                                ],
                                                [
                                                    222.922,
                                                    -7.882
                                                ],
                                                [
                                                    222.922,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.56,
                                                    0.336
                                                ],
                                                [
                                                    -0.308,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.341
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    -0.308,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.341
                                                ],
                                                [
                                                    -0.765,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.56,
                                                    -0.336
                                                ],
                                                [
                                                    0.308,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.341
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    232.582,
                                                    -0.364
                                                ],
                                                [
                                                    233.884,
                                                    -1.785
                                                ],
                                                [
                                                    234.346,
                                                    -3.934
                                                ],
                                                [
                                                    233.884,
                                                    -6.083
                                                ],
                                                [
                                                    232.582,
                                                    -7.511
                                                ],
                                                [
                                                    230.608,
                                                    -8.022
                                                ],
                                                [
                                                    228.627,
                                                    -7.511
                                                ],
                                                [
                                                    227.311,
                                                    -6.083
                                                ],
                                                [
                                                    226.842,
                                                    -3.92
                                                ],
                                                [
                                                    227.304,
                                                    -1.792
                                                ],
                                                [
                                                    228.613,
                                                    -0.371
                                                ],
                                                [
                                                    230.608,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.406,
                                                    0.499
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.509
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    0.406,
                                                    -0.504
                                                ],
                                                [
                                                    0.728,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.509
                                                ],
                                                [
                                                    0.719,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    0.495
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.504
                                                ],
                                                [
                                                    -0.728,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    228.893,
                                                    -1.841
                                                ],
                                                [
                                                    228.284,
                                                    -3.934
                                                ],
                                                [
                                                    228.893,
                                                    -6.027
                                                ],
                                                [
                                                    230.608,
                                                    -6.79
                                                ],
                                                [
                                                    232.295,
                                                    -6.048
                                                ],
                                                [
                                                    232.904,
                                                    -3.948
                                                ],
                                                [
                                                    232.295,
                                                    -1.848
                                                ],
                                                [
                                                    230.594,
                                                    -1.092
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "r",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.327
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ],
                                                [
                                                    -0.098,
                                                    -0.014
                                                ],
                                                [
                                                    -0.075,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0
                                                ],
                                                [
                                                    0.322,
                                                    -0.215
                                                ],
                                                [
                                                    0.205,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    -0.551
                                                ],
                                                [
                                                    0.322,
                                                    -0.327
                                                ],
                                                [
                                                    0.093,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    -0.056
                                                ],
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    238.154,
                                                    0
                                                ],
                                                [
                                                    238.154,
                                                    -4.802
                                                ],
                                                [
                                                    238.707,
                                                    -6.118
                                                ],
                                                [
                                                    239.988,
                                                    -6.608
                                                ],
                                                [
                                                    240.275,
                                                    -6.587
                                                ],
                                                [
                                                    240.534,
                                                    -6.524
                                                ],
                                                [
                                                    240.632,
                                                    -6.524
                                                ],
                                                [
                                                    240.632,
                                                    -7.882
                                                ],
                                                [
                                                    239.988,
                                                    -7.966
                                                ],
                                                [
                                                    238.875,
                                                    -7.644
                                                ],
                                                [
                                                    238.084,
                                                    -6.72
                                                ],
                                                [
                                                    238,
                                                    -7.882
                                                ],
                                                [
                                                    236.712,
                                                    -7.882
                                                ],
                                                [
                                                    236.712,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.177,
                                                    0.019
                                                ],
                                                [
                                                    -0.205,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.009
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.229
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.177,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.019
                                                ],
                                                [
                                                    -0.098,
                                                    0.009
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    0.275,
                                                    0.229
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    249.06,
                                                    0.07
                                                ],
                                                [
                                                    249.634,
                                                    -0.014
                                                ],
                                                [
                                                    249.634,
                                                    -1.162
                                                ],
                                                [
                                                    249.375,
                                                    -1.12
                                                ],
                                                [
                                                    249.018,
                                                    -1.106
                                                ],
                                                [
                                                    248.493,
                                                    -1.246
                                                ],
                                                [
                                                    248.36,
                                                    -1.82
                                                ],
                                                [
                                                    248.36,
                                                    -10.22
                                                ],
                                                [
                                                    246.96,
                                                    -10.08
                                                ],
                                                [
                                                    246.96,
                                                    -1.232
                                                ],
                                                [
                                                    247.373,
                                                    -0.245
                                                ],
                                                [
                                                    248.57,
                                                    0.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    247.66,
                                                    -6.762
                                                ],
                                                [
                                                    247.66,
                                                    -7.882
                                                ],
                                                [
                                                    245.91,
                                                    -7.882
                                                ],
                                                [
                                                    245.91,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    249.634,
                                                    -7.882
                                                ],
                                                [
                                                    247.66,
                                                    -7.882
                                                ],
                                                [
                                                    247.66,
                                                    -6.762
                                                ],
                                                [
                                                    249.634,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "h",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "h",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.415,
                                                    -0.205
                                                ],
                                                [
                                                    0.327,
                                                    -0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ],
                                                [
                                                    -0.415,
                                                    0.205
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    253.19,
                                                    0
                                                ],
                                                [
                                                    253.19,
                                                    -4.704
                                                ],
                                                [
                                                    253.477,
                                                    -5.81
                                                ],
                                                [
                                                    254.254,
                                                    -6.517
                                                ],
                                                [
                                                    255.318,
                                                    -6.762
                                                ],
                                                [
                                                    256.592,
                                                    -6.328
                                                ],
                                                [
                                                    257.012,
                                                    -5.152
                                                ],
                                                [
                                                    257.012,
                                                    0
                                                ],
                                                [
                                                    258.44,
                                                    0
                                                ],
                                                [
                                                    258.44,
                                                    -5.292
                                                ],
                                                [
                                                    257.677,
                                                    -7.371
                                                ],
                                                [
                                                    255.724,
                                                    -8.05
                                                ],
                                                [
                                                    254.303,
                                                    -7.742
                                                ],
                                                [
                                                    253.19,
                                                    -6.776
                                                ],
                                                [
                                                    253.19,
                                                    -11.06
                                                ],
                                                [
                                                    251.748,
                                                    -11.06
                                                ],
                                                [
                                                    251.748,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    266.182,
                                                    -0.161
                                                ],
                                                [
                                                    267.33,
                                                    -0.994
                                                ],
                                                [
                                                    267.918,
                                                    -2.24
                                                ],
                                                [
                                                    266.644,
                                                    -2.534
                                                ],
                                                [
                                                    265.986,
                                                    -1.442
                                                ],
                                                [
                                                    264.586,
                                                    -1.05
                                                ],
                                                [
                                                    262.836,
                                                    -1.771
                                                ],
                                                [
                                                    262.22,
                                                    -3.962
                                                ],
                                                [
                                                    262.864,
                                                    -6.202
                                                ],
                                                [
                                                    264.488,
                                                    -6.888
                                                ],
                                                [
                                                    266.147,
                                                    -6.132
                                                ],
                                                [
                                                    266.504,
                                                    -4.158
                                                ],
                                                [
                                                    267.162,
                                                    -4.662
                                                ],
                                                [
                                                    262.052,
                                                    -4.662
                                                ],
                                                [
                                                    262.052,
                                                    -3.584
                                                ],
                                                [
                                                    268.016,
                                                    -3.584
                                                ],
                                                [
                                                    267.694,
                                                    -6.055
                                                ],
                                                [
                                                    266.455,
                                                    -7.532
                                                ],
                                                [
                                                    264.516,
                                                    -8.022
                                                ],
                                                [
                                                    262.514,
                                                    -7.511
                                                ],
                                                [
                                                    261.247,
                                                    -6.083
                                                ],
                                                [
                                                    260.806,
                                                    -3.934
                                                ],
                                                [
                                                    261.275,
                                                    -1.736
                                                ],
                                                [
                                                    262.591,
                                                    -0.343
                                                ],
                                                [
                                                    264.572,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.177,
                                                    0.019
                                                ],
                                                [
                                                    -0.205,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.009
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.229
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.177,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.019
                                                ],
                                                [
                                                    -0.098,
                                                    0.009
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    0.275,
                                                    0.229
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    276.836,
                                                    0.07
                                                ],
                                                [
                                                    277.41,
                                                    -0.014
                                                ],
                                                [
                                                    277.41,
                                                    -1.162
                                                ],
                                                [
                                                    277.151,
                                                    -1.12
                                                ],
                                                [
                                                    276.794,
                                                    -1.106
                                                ],
                                                [
                                                    276.269,
                                                    -1.246
                                                ],
                                                [
                                                    276.136,
                                                    -1.82
                                                ],
                                                [
                                                    276.136,
                                                    -10.22
                                                ],
                                                [
                                                    274.736,
                                                    -10.08
                                                ],
                                                [
                                                    274.736,
                                                    -1.232
                                                ],
                                                [
                                                    275.149,
                                                    -0.245
                                                ],
                                                [
                                                    276.346,
                                                    0.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    275.436,
                                                    -6.762
                                                ],
                                                [
                                                    275.436,
                                                    -7.882
                                                ],
                                                [
                                                    273.686,
                                                    -7.882
                                                ],
                                                [
                                                    273.686,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    277.41,
                                                    -7.882
                                                ],
                                                [
                                                    275.436,
                                                    -7.882
                                                ],
                                                [
                                                    275.436,
                                                    -6.762
                                                ],
                                                [
                                                    277.41,
                                                    -6.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    284.48,
                                                    -0.161
                                                ],
                                                [
                                                    285.628,
                                                    -0.994
                                                ],
                                                [
                                                    286.216,
                                                    -2.24
                                                ],
                                                [
                                                    284.942,
                                                    -2.534
                                                ],
                                                [
                                                    284.284,
                                                    -1.442
                                                ],
                                                [
                                                    282.884,
                                                    -1.05
                                                ],
                                                [
                                                    281.134,
                                                    -1.771
                                                ],
                                                [
                                                    280.518,
                                                    -3.962
                                                ],
                                                [
                                                    281.162,
                                                    -6.202
                                                ],
                                                [
                                                    282.786,
                                                    -6.888
                                                ],
                                                [
                                                    284.445,
                                                    -6.132
                                                ],
                                                [
                                                    284.802,
                                                    -4.158
                                                ],
                                                [
                                                    285.46,
                                                    -4.662
                                                ],
                                                [
                                                    280.35,
                                                    -4.662
                                                ],
                                                [
                                                    280.35,
                                                    -3.584
                                                ],
                                                [
                                                    286.314,
                                                    -3.584
                                                ],
                                                [
                                                    285.992,
                                                    -6.055
                                                ],
                                                [
                                                    284.753,
                                                    -7.532
                                                ],
                                                [
                                                    282.814,
                                                    -8.022
                                                ],
                                                [
                                                    280.812,
                                                    -7.511
                                                ],
                                                [
                                                    279.545,
                                                    -6.083
                                                ],
                                                [
                                                    279.104,
                                                    -3.934
                                                ],
                                                [
                                                    279.573,
                                                    -1.736
                                                ],
                                                [
                                                    280.889,
                                                    -0.343
                                                ],
                                                [
                                                    282.87,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.271
                                                ],
                                                [
                                                    -0.196,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    -0.196
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.019
                                                ],
                                                [
                                                    -0.093,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.355
                                                ],
                                                [
                                                    0.453,
                                                    0.173
                                                ],
                                                [
                                                    0.653,
                                                    0
                                                ],
                                                [
                                                    0.602,
                                                    -0.415
                                                ],
                                                [
                                                    0.019,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    0.233
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.327
                                                ],
                                                [
                                                    0.131,
                                                    -0.154
                                                ],
                                                [
                                                    0.42,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.182
                                                ],
                                                [
                                                    0.238,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.453,
                                                    -0.406
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.247,
                                                    0.196
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.532
                                                ],
                                                [
                                                    -0.238,
                                                    -0.355
                                                ],
                                                [
                                                    -0.453,
                                                    -0.173
                                                ],
                                                [
                                                    -0.98,
                                                    0
                                                ],
                                                [
                                                    -0.602,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    -0.485
                                                ],
                                                [
                                                    0.355,
                                                    -0.233
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.252
                                                ],
                                                [
                                                    -0.131,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.084
                                                ],
                                                [
                                                    -0.383,
                                                    0.182
                                                ],
                                                [
                                                    -0.238,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0.653
                                                ],
                                                [
                                                    0.453,
                                                    0.406
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    292.418,
                                                    -0.266
                                                ],
                                                [
                                                    293.482,
                                                    -1.33
                                                ],
                                                [
                                                    293.482,
                                                    -1.078
                                                ],
                                                [
                                                    293.853,
                                                    -0.182
                                                ],
                                                [
                                                    294.826,
                                                    0.112
                                                ],
                                                [
                                                    295.169,
                                                    0.084
                                                ],
                                                [
                                                    295.54,
                                                    0
                                                ],
                                                [
                                                    295.54,
                                                    -1.022
                                                ],
                                                [
                                                    295.456,
                                                    -1.022
                                                ],
                                                [
                                                    295.386,
                                                    -1.001
                                                ],
                                                [
                                                    295.218,
                                                    -0.994
                                                ],
                                                [
                                                    294.882,
                                                    -1.12
                                                ],
                                                [
                                                    294.728,
                                                    -1.666
                                                ],
                                                [
                                                    294.728,
                                                    -5.642
                                                ],
                                                [
                                                    294.371,
                                                    -6.972
                                                ],
                                                [
                                                    293.335,
                                                    -7.763
                                                ],
                                                [
                                                    291.676,
                                                    -8.022
                                                ],
                                                [
                                                    289.303,
                                                    -7.399
                                                ],
                                                [
                                                    288.372,
                                                    -5.614
                                                ],
                                                [
                                                    289.73,
                                                    -5.474
                                                ],
                                                [
                                                    290.248,
                                                    -6.552
                                                ],
                                                [
                                                    291.676,
                                                    -6.902
                                                ],
                                                [
                                                    292.95,
                                                    -6.573
                                                ],
                                                [
                                                    293.3,
                                                    -5.754
                                                ],
                                                [
                                                    293.104,
                                                    -5.145
                                                ],
                                                [
                                                    292.278,
                                                    -4.802
                                                ],
                                                [
                                                    290.626,
                                                    -4.494
                                                ],
                                                [
                                                    289.38,
                                                    -4.095
                                                ],
                                                [
                                                    288.449,
                                                    -3.332
                                                ],
                                                [
                                                    288.092,
                                                    -2.058
                                                ],
                                                [
                                                    288.771,
                                                    -0.469
                                                ],
                                                [
                                                    290.682,
                                                    0.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.28,
                                                    0.187
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    -0.191,
                                                    0.233
                                                ],
                                                [
                                                    -0.588,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.056
                                                ],
                                                [
                                                    -0.093,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.238
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.28,
                                                    -0.187
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    0.191,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.075
                                                ],
                                                [
                                                    0.201,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.429
                                                ],
                                                [
                                                    -0.406,
                                                    0.238
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    289.982,
                                                    -1.288
                                                ],
                                                [
                                                    289.562,
                                                    -2.17
                                                ],
                                                [
                                                    289.849,
                                                    -2.926
                                                ],
                                                [
                                                    291.018,
                                                    -3.458
                                                ],
                                                [
                                                    292.18,
                                                    -3.696
                                                ],
                                                [
                                                    293.027,
                                                    -3.892
                                                ],
                                                [
                                                    293.468,
                                                    -4.116
                                                ],
                                                [
                                                    293.314,
                                                    -4.172
                                                ],
                                                [
                                                    293.314,
                                                    -2.366
                                                ],
                                                [
                                                    292.495,
                                                    -1.365
                                                ],
                                                [
                                                    291.046,
                                                    -1.008
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "m",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "m",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.168,
                                                    0.322
                                                ],
                                                [
                                                    -0.299,
                                                    0.187
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.243,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.173,
                                                    0.331
                                                ],
                                                [
                                                    -0.308,
                                                    0.177
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    0.49
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.462,
                                                    -0.275
                                                ],
                                                [
                                                    0.243,
                                                    -0.523
                                                ],
                                                [
                                                    0.42,
                                                    0.271
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.229
                                                ],
                                                [
                                                    0.261,
                                                    -0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    0.168,
                                                    -0.322
                                                ],
                                                [
                                                    0.299,
                                                    -0.187
                                                ],
                                                [
                                                    0.523,
                                                    0
                                                ],
                                                [
                                                    0.243,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    0.173,
                                                    -0.331
                                                ],
                                                [
                                                    0.308,
                                                    -0.177
                                                ],
                                                [
                                                    0.485,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.812
                                                ],
                                                [
                                                    -0.448,
                                                    -0.49
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.462,
                                                    0.275
                                                ],
                                                [
                                                    -0.196,
                                                    -0.532
                                                ],
                                                [
                                                    -0.42,
                                                    -0.271
                                                ],
                                                [
                                                    -0.485,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    298.858,
                                                    0
                                                ],
                                                [
                                                    298.858,
                                                    -4.592
                                                ],
                                                [
                                                    299.11,
                                                    -5.691
                                                ],
                                                [
                                                    299.81,
                                                    -6.454
                                                ],
                                                [
                                                    300.846,
                                                    -6.734
                                                ],
                                                [
                                                    301.994,
                                                    -6.244
                                                ],
                                                [
                                                    302.358,
                                                    -4.97
                                                ],
                                                [
                                                    302.358,
                                                    0
                                                ],
                                                [
                                                    303.786,
                                                    0
                                                ],
                                                [
                                                    303.786,
                                                    -4.522
                                                ],
                                                [
                                                    304.045,
                                                    -5.705
                                                ],
                                                [
                                                    304.766,
                                                    -6.468
                                                ],
                                                [
                                                    305.816,
                                                    -6.734
                                                ],
                                                [
                                                    306.922,
                                                    -6.307
                                                ],
                                                [
                                                    307.3,
                                                    -5.096
                                                ],
                                                [
                                                    307.3,
                                                    0
                                                ],
                                                [
                                                    308.742,
                                                    0
                                                ],
                                                [
                                                    308.742,
                                                    -5.334
                                                ],
                                                [
                                                    308.07,
                                                    -7.287
                                                ],
                                                [
                                                    306.138,
                                                    -8.022
                                                ],
                                                [
                                                    304.619,
                                                    -7.609
                                                ],
                                                [
                                                    303.562,
                                                    -6.412
                                                ],
                                                [
                                                    302.638,
                                                    -7.616
                                                ],
                                                [
                                                    301.196,
                                                    -8.022
                                                ],
                                                [
                                                    299.838,
                                                    -7.679
                                                ],
                                                [
                                                    298.816,
                                                    -6.622
                                                ],
                                                [
                                                    298.718,
                                                    -7.882
                                                ],
                                                [
                                                    297.416,
                                                    -7.882
                                                ],
                                                [
                                                    297.416,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "r",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.247
                                                ],
                                                [
                                                    -0.485,
                                                    0
                                                ],
                                                [
                                                    -0.112,
                                                    -0.014
                                                ],
                                                [
                                                    -0.065,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0
                                                ],
                                                [
                                                    0.313,
                                                    -0.229
                                                ],
                                                [
                                                    0.224,
                                                    -0.485
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    -0.439
                                                ],
                                                [
                                                    0.313,
                                                    -0.247
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.112,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.187,
                                                    -0.065
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.024,
                                                    37
                                                ],
                                                [
                                                    3.024,
                                                    32.268
                                                ],
                                                [
                                                    3.605,
                                                    31.239
                                                ],
                                                [
                                                    4.802,
                                                    30.868
                                                ],
                                                [
                                                    5.18,
                                                    30.889
                                                ],
                                                [
                                                    5.446,
                                                    30.952
                                                ],
                                                [
                                                    5.53,
                                                    30.952
                                                ],
                                                [
                                                    5.53,
                                                    28.936
                                                ],
                                                [
                                                    4.844,
                                                    28.838
                                                ],
                                                [
                                                    3.731,
                                                    29.181
                                                ],
                                                [
                                                    2.926,
                                                    30.252
                                                ],
                                                [
                                                    2.828,
                                                    28.936
                                                ],
                                                [
                                                    0.84,
                                                    28.936
                                                ],
                                                [
                                                    0.84,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.457,
                                                    0.233
                                                ],
                                                [
                                                    -0.243,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    -0.187
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.028
                                                ],
                                                [
                                                    -0.131,
                                                    0.065
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.056,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.383
                                                ],
                                                [
                                                    0.499,
                                                    0.21
                                                ],
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.644,
                                                    -0.467
                                                ],
                                                [
                                                    -0.009,
                                                    -0.831
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.257,
                                                    0.205
                                                ],
                                                [
                                                    -0.476,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    -0.149
                                                ],
                                                [
                                                    0,
                                                    -0.28
                                                ],
                                                [
                                                    0.117,
                                                    -0.131
                                                ],
                                                [
                                                    0.299,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.369,
                                                    -0.205
                                                ],
                                                [
                                                    0.201,
                                                    -0.336
                                                ],
                                                [
                                                    0,
                                                    -0.476
                                                ],
                                                [
                                                    -0.481,
                                                    -0.42
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.457,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.056,
                                                    0.383
                                                ],
                                                [
                                                    0.289,
                                                    0.187
                                                ],
                                                [
                                                    0.168,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.098,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.541
                                                ],
                                                [
                                                    -0.238,
                                                    -0.383
                                                ],
                                                [
                                                    -0.499,
                                                    -0.21
                                                ],
                                                [
                                                    -1.064,
                                                    0
                                                ],
                                                [
                                                    -0.644,
                                                    0.467
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.257,
                                                    -0.205
                                                ],
                                                [
                                                    0.429,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    -0.117,
                                                    0.131
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.504,
                                                    0.084
                                                ],
                                                [
                                                    -0.369,
                                                    0.205
                                                ],
                                                [
                                                    -0.201,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0.691
                                                ],
                                                [
                                                    0.481,
                                                    0.42
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.284,
                                                    36.79
                                                ],
                                                [
                                                    12.334,
                                                    35.81
                                                ],
                                                [
                                                    12.348,
                                                    35.964
                                                ],
                                                [
                                                    12.866,
                                                    36.818
                                                ],
                                                [
                                                    13.972,
                                                    37.098
                                                ],
                                                [
                                                    14.525,
                                                    37.056
                                                ],
                                                [
                                                    15.022,
                                                    36.916
                                                ],
                                                [
                                                    15.022,
                                                    35.404
                                                ],
                                                [
                                                    14.938,
                                                    35.404
                                                ],
                                                [
                                                    14.84,
                                                    35.425
                                                ],
                                                [
                                                    14.7,
                                                    35.432
                                                ],
                                                [
                                                    14.371,
                                                    35.32
                                                ],
                                                [
                                                    14.224,
                                                    34.858
                                                ],
                                                [
                                                    14.224,
                                                    31.386
                                                ],
                                                [
                                                    13.867,
                                                    30
                                                ],
                                                [
                                                    12.761,
                                                    29.111
                                                ],
                                                [
                                                    10.836,
                                                    28.796
                                                ],
                                                [
                                                    8.274,
                                                    29.496
                                                ],
                                                [
                                                    7.322,
                                                    31.442
                                                ],
                                                [
                                                    9.31,
                                                    31.666
                                                ],
                                                [
                                                    9.695,
                                                    30.714
                                                ],
                                                [
                                                    10.794,
                                                    30.406
                                                ],
                                                [
                                                    11.739,
                                                    30.63
                                                ],
                                                [
                                                    12.04,
                                                    31.274
                                                ],
                                                [
                                                    11.865,
                                                    31.806
                                                ],
                                                [
                                                    11.242,
                                                    32.086
                                                ],
                                                [
                                                    9.492,
                                                    32.38
                                                ],
                                                [
                                                    8.183,
                                                    32.814
                                                ],
                                                [
                                                    7.329,
                                                    33.626
                                                ],
                                                [
                                                    7.028,
                                                    34.844
                                                ],
                                                [
                                                    7.749,
                                                    36.51
                                                ],
                                                [
                                                    9.702,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.205,
                                                    0.159
                                                ],
                                                [
                                                    0,
                                                    0.299
                                                ],
                                                [
                                                    -0.145,
                                                    0.177
                                                ],
                                                [
                                                    -0.373,
                                                    0.065
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.047
                                                ],
                                                [
                                                    -0.112,
                                                    0.065
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.303,
                                                    -0.215
                                                ],
                                                [
                                                    0.467,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.205,
                                                    -0.159
                                                ],
                                                [
                                                    0,
                                                    -0.215
                                                ],
                                                [
                                                    0.145,
                                                    -0.177
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.047
                                                ],
                                                [
                                                    0.154,
                                                    -0.047
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.383
                                                ],
                                                [
                                                    -0.303,
                                                    0.215
                                                ],
                                                [
                                                    -0.355,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.534,
                                                    35.334
                                                ],
                                                [
                                                    9.226,
                                                    34.648
                                                ],
                                                [
                                                    9.443,
                                                    34.06
                                                ],
                                                [
                                                    10.22,
                                                    33.696
                                                ],
                                                [
                                                    11.27,
                                                    33.5
                                                ],
                                                [
                                                    11.837,
                                                    33.36
                                                ],
                                                [
                                                    12.236,
                                                    33.192
                                                ],
                                                [
                                                    12.096,
                                                    33.122
                                                ],
                                                [
                                                    12.096,
                                                    34.354
                                                ],
                                                [
                                                    11.529,
                                                    35.25
                                                ],
                                                [
                                                    10.374,
                                                    35.572
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "h",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "h",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.233
                                                ],
                                                [
                                                    -0.233,
                                                    0.121
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.229,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.49,
                                                    0.467
                                                ],
                                                [
                                                    0.831,
                                                    0
                                                ],
                                                [
                                                    0.378,
                                                    -0.173
                                                ],
                                                [
                                                    0.299,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.019,
                                                    -0.317
                                                ],
                                                [
                                                    0.145,
                                                    -0.233
                                                ],
                                                [
                                                    0.233,
                                                    -0.121
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.229,
                                                    0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    -0.49,
                                                    -0.467
                                                ],
                                                [
                                                    -0.513,
                                                    0
                                                ],
                                                [
                                                    -0.378,
                                                    0.173
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.984,
                                                    37
                                                ],
                                                [
                                                    18.984,
                                                    32.226
                                                ],
                                                [
                                                    19.229,
                                                    31.4
                                                ],
                                                [
                                                    19.796,
                                                    30.868
                                                ],
                                                [
                                                    20.566,
                                                    30.686
                                                ],
                                                [
                                                    21.539,
                                                    31.001
                                                ],
                                                [
                                                    21.882,
                                                    31.904
                                                ],
                                                [
                                                    21.882,
                                                    37
                                                ],
                                                [
                                                    24.052,
                                                    37
                                                ],
                                                [
                                                    24.052,
                                                    31.554
                                                ],
                                                [
                                                    23.317,
                                                    29.496
                                                ],
                                                [
                                                    21.336,
                                                    28.796
                                                ],
                                                [
                                                    19.999,
                                                    29.055
                                                ],
                                                [
                                                    18.984,
                                                    29.902
                                                ],
                                                [
                                                    18.984,
                                                    25.94
                                                ],
                                                [
                                                    16.8,
                                                    25.94
                                                ],
                                                [
                                                    16.8,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "u",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.397,
                                                    0.201
                                                ],
                                                [
                                                    -0.271,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.14,
                                                    -0.229
                                                ],
                                                [
                                                    0.229,
                                                    -0.126
                                                ],
                                                [
                                                    0.299,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.499,
                                                    -0.495
                                                ],
                                                [
                                                    -0.868,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.397,
                                                    -0.201
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.019,
                                                    0.299
                                                ],
                                                [
                                                    -0.14,
                                                    0.229
                                                ],
                                                [
                                                    -0.229,
                                                    0.126
                                                ],
                                                [
                                                    -0.411,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    -0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.905
                                                ],
                                                [
                                                    0.499,
                                                    0.495
                                                ],
                                                [
                                                    0.485,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    30.653,
                                                    36.839
                                                ],
                                                [
                                                    31.654,
                                                    35.908
                                                ],
                                                [
                                                    31.738,
                                                    37
                                                ],
                                                [
                                                    33.74,
                                                    37
                                                ],
                                                [
                                                    33.74,
                                                    28.936
                                                ],
                                                [
                                                    31.57,
                                                    28.936
                                                ],
                                                [
                                                    31.57,
                                                    33.738
                                                ],
                                                [
                                                    31.332,
                                                    34.529
                                                ],
                                                [
                                                    30.779,
                                                    35.061
                                                ],
                                                [
                                                    29.988,
                                                    35.25
                                                ],
                                                [
                                                    29.036,
                                                    34.907
                                                ],
                                                [
                                                    28.7,
                                                    33.892
                                                ],
                                                [
                                                    28.7,
                                                    28.936
                                                ],
                                                [
                                                    26.53,
                                                    28.936
                                                ],
                                                [
                                                    26.53,
                                                    34.298
                                                ],
                                                [
                                                    27.279,
                                                    36.398
                                                ],
                                                [
                                                    29.33,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "l",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "l",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    38.416,
                                                    37
                                                ],
                                                [
                                                    38.416,
                                                    25.94
                                                ],
                                                [
                                                    36.232,
                                                    25.94
                                                ],
                                                [
                                                    36.232,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": ".",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": ".",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    42.84,
                                                    37
                                                ],
                                                [
                                                    42.84,
                                                    34.914
                                                ],
                                                [
                                                    40.796,
                                                    34.914
                                                ],
                                                [
                                                    40.796,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "m",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "m",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.121,
                                                    0.238
                                                ],
                                                [
                                                    -0.224,
                                                    0.135
                                                ],
                                                [
                                                    -0.308,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.131,
                                                    0.238
                                                ],
                                                [
                                                    -0.224,
                                                    0.121
                                                ],
                                                [
                                                    -0.299,
                                                    0
                                                ],
                                                [
                                                    -0.196,
                                                    -0.247
                                                ],
                                                [
                                                    0,
                                                    -0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.471,
                                                    0.504
                                                ],
                                                [
                                                    0.877,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    -0.261
                                                ],
                                                [
                                                    0.233,
                                                    -0.467
                                                ],
                                                [
                                                    0.429,
                                                    0.247
                                                ],
                                                [
                                                    0.532,
                                                    0
                                                ],
                                                [
                                                    0.392,
                                                    -0.201
                                                ],
                                                [
                                                    0.28,
                                                    -0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.317
                                                ],
                                                [
                                                    0.121,
                                                    -0.238
                                                ],
                                                [
                                                    0.224,
                                                    -0.135
                                                ],
                                                [
                                                    0.439,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.364
                                                ],
                                                [
                                                    0.131,
                                                    -0.238
                                                ],
                                                [
                                                    0.224,
                                                    -0.121
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.196,
                                                    0.247
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.471,
                                                    -0.504
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.439,
                                                    0.261
                                                ],
                                                [
                                                    -0.224,
                                                    -0.495
                                                ],
                                                [
                                                    -0.429,
                                                    -0.247
                                                ],
                                                [
                                                    -0.439,
                                                    0
                                                ],
                                                [
                                                    -0.392,
                                                    0.201
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    47.39,
                                                    37
                                                ],
                                                [
                                                    47.39,
                                                    32.296
                                                ],
                                                [
                                                    47.572,
                                                    31.463
                                                ],
                                                [
                                                    48.09,
                                                    30.903
                                                ],
                                                [
                                                    48.888,
                                                    30.7
                                                ],
                                                [
                                                    49.833,
                                                    31.099
                                                ],
                                                [
                                                    50.12,
                                                    32.142
                                                ],
                                                [
                                                    50.12,
                                                    37
                                                ],
                                                [
                                                    52.29,
                                                    37
                                                ],
                                                [
                                                    52.29,
                                                    32.324
                                                ],
                                                [
                                                    52.486,
                                                    31.421
                                                ],
                                                [
                                                    53.018,
                                                    30.882
                                                ],
                                                [
                                                    53.802,
                                                    30.7
                                                ],
                                                [
                                                    54.726,
                                                    31.071
                                                ],
                                                [
                                                    55.02,
                                                    32.1
                                                ],
                                                [
                                                    55.02,
                                                    37
                                                ],
                                                [
                                                    57.204,
                                                    37
                                                ],
                                                [
                                                    57.204,
                                                    31.54
                                                ],
                                                [
                                                    56.497,
                                                    29.552
                                                ],
                                                [
                                                    54.474,
                                                    28.796
                                                ],
                                                [
                                                    52.99,
                                                    29.188
                                                ],
                                                [
                                                    51.982,
                                                    30.28
                                                ],
                                                [
                                                    51.002,
                                                    29.167
                                                ],
                                                [
                                                    49.56,
                                                    28.796
                                                ],
                                                [
                                                    48.314,
                                                    29.097
                                                ],
                                                [
                                                    47.306,
                                                    30.056
                                                ],
                                                [
                                                    47.152,
                                                    28.936
                                                ],
                                                [
                                                    45.206,
                                                    28.936
                                                ],
                                                [
                                                    45.206,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.201
                                                ],
                                                [
                                                    -0.336,
                                                    0.355
                                                ],
                                                [
                                                    -0.112,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.313,
                                                    -0.21
                                                ],
                                                [
                                                    0.476,
                                                    0
                                                ],
                                                [
                                                    0.345,
                                                    0.397
                                                ],
                                                [
                                                    0,
                                                    0.905
                                                ],
                                                [
                                                    -0.322,
                                                    0.415
                                                ],
                                                [
                                                    -0.579,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.415
                                                ],
                                                [
                                                    0.121,
                                                    -0.728
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0.709
                                                ],
                                                [
                                                    0.597,
                                                    0.373
                                                ],
                                                [
                                                    0.831,
                                                    0
                                                ],
                                                [
                                                    0.597,
                                                    -0.35
                                                ],
                                                [
                                                    0.331,
                                                    -0.625
                                                ],
                                                [
                                                    0,
                                                    -0.849
                                                ],
                                                [
                                                    -0.35,
                                                    -0.616
                                                ],
                                                [
                                                    -0.611,
                                                    -0.327
                                                ],
                                                [
                                                    -0.793,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.201
                                                ],
                                                [
                                                    0.336,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.373
                                                ],
                                                [
                                                    -0.313,
                                                    0.21
                                                ],
                                                [
                                                    -0.616,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.397
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    0.322,
                                                    -0.415
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.093,
                                                    -1.027
                                                ],
                                                [
                                                    -0.289,
                                                    -0.709
                                                ],
                                                [
                                                    -0.597,
                                                    -0.373
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ],
                                                [
                                                    -0.597,
                                                    0.35
                                                ],
                                                [
                                                    -0.331,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0.877
                                                ],
                                                [
                                                    0.35,
                                                    0.616
                                                ],
                                                [
                                                    0.611,
                                                    0.327
                                                ],
                                                [
                                                    0.635,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    65.114,
                                                    36.839
                                                ],
                                                [
                                                    66.388,
                                                    36.006
                                                ],
                                                [
                                                    67.06,
                                                    34.76
                                                ],
                                                [
                                                    65.184,
                                                    34.284
                                                ],
                                                [
                                                    64.603,
                                                    35.159
                                                ],
                                                [
                                                    63.42,
                                                    35.474
                                                ],
                                                [
                                                    61.978,
                                                    34.879
                                                ],
                                                [
                                                    61.46,
                                                    32.926
                                                ],
                                                [
                                                    61.943,
                                                    31.057
                                                ],
                                                [
                                                    63.294,
                                                    30.434
                                                ],
                                                [
                                                    64.61,
                                                    31.057
                                                ],
                                                [
                                                    64.848,
                                                    32.772
                                                ],
                                                [
                                                    65.506,
                                                    32.156
                                                ],
                                                [
                                                    61.068,
                                                    32.156
                                                ],
                                                [
                                                    61.068,
                                                    33.584
                                                ],
                                                [
                                                    67.102,
                                                    33.584
                                                ],
                                                [
                                                    66.808,
                                                    30.98
                                                ],
                                                [
                                                    65.478,
                                                    29.356
                                                ],
                                                [
                                                    63.336,
                                                    28.796
                                                ],
                                                [
                                                    61.208,
                                                    29.321
                                                ],
                                                [
                                                    59.815,
                                                    30.784
                                                ],
                                                [
                                                    59.318,
                                                    32.996
                                                ],
                                                [
                                                    59.843,
                                                    35.236
                                                ],
                                                [
                                                    61.285,
                                                    36.65
                                                ],
                                                [
                                                    63.392,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.233
                                                ],
                                                [
                                                    -0.233,
                                                    0.121
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.229,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.49,
                                                    0.471
                                                ],
                                                [
                                                    0.831,
                                                    0
                                                ],
                                                [
                                                    0.392,
                                                    -0.196
                                                ],
                                                [
                                                    0.308,
                                                    -0.429
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.019,
                                                    -0.317
                                                ],
                                                [
                                                    0.145,
                                                    -0.233
                                                ],
                                                [
                                                    0.233,
                                                    -0.121
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.229,
                                                    0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    -0.49,
                                                    -0.471
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.392,
                                                    0.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    71.372,
                                                    37
                                                ],
                                                [
                                                    71.372,
                                                    32.24
                                                ],
                                                [
                                                    71.617,
                                                    31.414
                                                ],
                                                [
                                                    72.184,
                                                    30.882
                                                ],
                                                [
                                                    72.954,
                                                    30.7
                                                ],
                                                [
                                                    73.927,
                                                    31.015
                                                ],
                                                [
                                                    74.27,
                                                    31.918
                                                ],
                                                [
                                                    74.27,
                                                    37
                                                ],
                                                [
                                                    76.44,
                                                    37
                                                ],
                                                [
                                                    76.44,
                                                    31.568
                                                ],
                                                [
                                                    75.705,
                                                    29.503
                                                ],
                                                [
                                                    73.724,
                                                    28.796
                                                ],
                                                [
                                                    72.324,
                                                    29.09
                                                ],
                                                [
                                                    71.274,
                                                    30.028
                                                ],
                                                [
                                                    71.19,
                                                    28.936
                                                ],
                                                [
                                                    69.188,
                                                    28.936
                                                ],
                                                [
                                                    69.188,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.602,
                                                    0.345
                                                ],
                                                [
                                                    -0.331,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0.331,
                                                    0.621
                                                ],
                                                [
                                                    0.602,
                                                    0.35
                                                ],
                                                [
                                                    0.812,
                                                    0
                                                ],
                                                [
                                                    0.607,
                                                    -0.35
                                                ],
                                                [
                                                    0.336,
                                                    -0.625
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ],
                                                [
                                                    -0.331,
                                                    -0.621
                                                ],
                                                [
                                                    -0.607,
                                                    -0.35
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.602,
                                                    -0.345
                                                ],
                                                [
                                                    0.331,
                                                    -0.625
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ],
                                                [
                                                    -0.331,
                                                    -0.621
                                                ],
                                                [
                                                    -0.602,
                                                    -0.35
                                                ],
                                                [
                                                    -0.812,
                                                    0
                                                ],
                                                [
                                                    -0.607,
                                                    0.35
                                                ],
                                                [
                                                    -0.336,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0.831
                                                ],
                                                [
                                                    0.331,
                                                    0.621
                                                ],
                                                [
                                                    0.607,
                                                    0.35
                                                ],
                                                [
                                                    0.812,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    84.721,
                                                    36.622
                                                ],
                                                [
                                                    86.121,
                                                    35.166
                                                ],
                                                [
                                                    86.618,
                                                    32.968
                                                ],
                                                [
                                                    86.121,
                                                    30.777
                                                ],
                                                [
                                                    84.721,
                                                    29.321
                                                ],
                                                [
                                                    82.6,
                                                    28.796
                                                ],
                                                [
                                                    80.472,
                                                    29.321
                                                ],
                                                [
                                                    79.058,
                                                    30.784
                                                ],
                                                [
                                                    78.554,
                                                    32.982
                                                ],
                                                [
                                                    79.051,
                                                    35.159
                                                ],
                                                [
                                                    80.458,
                                                    36.615
                                                ],
                                                [
                                                    82.6,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.331,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0.765
                                                ],
                                                [
                                                    -0.331,
                                                    0.425
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.415
                                                ],
                                                [
                                                    0,
                                                    -0.775
                                                ],
                                                [
                                                    0.331,
                                                    -0.42
                                                ],
                                                [
                                                    0.588,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.331,
                                                    -0.415
                                                ],
                                                [
                                                    0,
                                                    -0.765
                                                ],
                                                [
                                                    0.331,
                                                    -0.425
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0.765
                                                ],
                                                [
                                                    -0.331,
                                                    0.42
                                                ],
                                                [
                                                    -0.588,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    81.207,
                                                    34.753
                                                ],
                                                [
                                                    80.71,
                                                    32.982
                                                ],
                                                [
                                                    81.207,
                                                    31.197
                                                ],
                                                [
                                                    82.6,
                                                    30.56
                                                ],
                                                [
                                                    83.965,
                                                    31.183
                                                ],
                                                [
                                                    84.462,
                                                    32.968
                                                ],
                                                [
                                                    83.965,
                                                    34.746
                                                ],
                                                [
                                                    82.586,
                                                    35.376
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.233
                                                ],
                                                [
                                                    -0.233,
                                                    0.121
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.229,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.49,
                                                    0.471
                                                ],
                                                [
                                                    0.831,
                                                    0
                                                ],
                                                [
                                                    0.392,
                                                    -0.196
                                                ],
                                                [
                                                    0.308,
                                                    -0.429
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.019,
                                                    -0.317
                                                ],
                                                [
                                                    0.145,
                                                    -0.233
                                                ],
                                                [
                                                    0.233,
                                                    -0.121
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.229,
                                                    0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    -0.49,
                                                    -0.471
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.392,
                                                    0.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    90.916,
                                                    37
                                                ],
                                                [
                                                    90.916,
                                                    32.24
                                                ],
                                                [
                                                    91.161,
                                                    31.414
                                                ],
                                                [
                                                    91.728,
                                                    30.882
                                                ],
                                                [
                                                    92.498,
                                                    30.7
                                                ],
                                                [
                                                    93.471,
                                                    31.015
                                                ],
                                                [
                                                    93.814,
                                                    31.918
                                                ],
                                                [
                                                    93.814,
                                                    37
                                                ],
                                                [
                                                    95.984,
                                                    37
                                                ],
                                                [
                                                    95.984,
                                                    31.568
                                                ],
                                                [
                                                    95.249,
                                                    29.503
                                                ],
                                                [
                                                    93.268,
                                                    28.796
                                                ],
                                                [
                                                    91.868,
                                                    29.09
                                                ],
                                                [
                                                    90.818,
                                                    30.028
                                                ],
                                                [
                                                    90.734,
                                                    28.936
                                                ],
                                                [
                                                    88.732,
                                                    28.936
                                                ],
                                                [
                                                    88.732,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "@",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "@",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.401,
                                                    0.154
                                                ],
                                                [
                                                    -0.317,
                                                    0.331
                                                ],
                                                [
                                                    -0.182,
                                                    0.523
                                                ],
                                                [
                                                    0,
                                                    0.728
                                                ],
                                                [
                                                    0.299,
                                                    0.672
                                                ],
                                                [
                                                    0.541,
                                                    0.485
                                                ],
                                                [
                                                    0.737,
                                                    0.266
                                                ],
                                                [
                                                    0.877,
                                                    0
                                                ],
                                                [
                                                    0.803,
                                                    -0.331
                                                ],
                                                [
                                                    0.597,
                                                    -0.597
                                                ],
                                                [
                                                    0.336,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    -0.961
                                                ],
                                                [
                                                    -0.303,
                                                    -0.77
                                                ],
                                                [
                                                    -0.546,
                                                    -0.56
                                                ],
                                                [
                                                    -0.747,
                                                    -0.299
                                                ],
                                                [
                                                    -0.887,
                                                    0
                                                ],
                                                [
                                                    -0.695,
                                                    0.266
                                                ],
                                                [
                                                    -0.485,
                                                    0.383
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.625,
                                                    -0.233
                                                ],
                                                [
                                                    0.775,
                                                    0
                                                ],
                                                [
                                                    0.779,
                                                    0.443
                                                ],
                                                [
                                                    0.453,
                                                    0.812
                                                ],
                                                [
                                                    0,
                                                    1.101
                                                ],
                                                [
                                                    -0.285,
                                                    0.7
                                                ],
                                                [
                                                    -0.504,
                                                    0.532
                                                ],
                                                [
                                                    -0.672,
                                                    0.289
                                                ],
                                                [
                                                    -0.775,
                                                    0
                                                ],
                                                [
                                                    -0.611,
                                                    -0.233
                                                ],
                                                [
                                                    -0.448,
                                                    -0.425
                                                ],
                                                [
                                                    -0.243,
                                                    -0.569
                                                ],
                                                [
                                                    0,
                                                    -0.672
                                                ],
                                                [
                                                    0.103,
                                                    -0.383
                                                ],
                                                [
                                                    0.182,
                                                    -0.247
                                                ],
                                                [
                                                    0.219,
                                                    -0.117
                                                ],
                                                [
                                                    0.233,
                                                    0
                                                ],
                                                [
                                                    0.131,
                                                    0.219
                                                ],
                                                [
                                                    -0.084,
                                                    0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    0.205
                                                ],
                                                [
                                                    0.457,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.21
                                                ],
                                                [
                                                    0.275,
                                                    -0.364
                                                ],
                                                [
                                                    0.149,
                                                    -0.462
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    -0.373,
                                                    -0.462
                                                ],
                                                [
                                                    -0.681,
                                                    0
                                                ],
                                                [
                                                    -0.35,
                                                    0.252
                                                ],
                                                [
                                                    -0.215,
                                                    0.411
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.229
                                                ],
                                                [
                                                    -0.495,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.401,
                                                    -0.154
                                                ],
                                                [
                                                    0.317,
                                                    -0.331
                                                ],
                                                [
                                                    0.182,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    -0.812
                                                ],
                                                [
                                                    -0.299,
                                                    -0.672
                                                ],
                                                [
                                                    -0.541,
                                                    -0.485
                                                ],
                                                [
                                                    -0.737,
                                                    -0.266
                                                ],
                                                [
                                                    -0.924,
                                                    0
                                                ],
                                                [
                                                    -0.803,
                                                    0.331
                                                ],
                                                [
                                                    -0.597,
                                                    0.597
                                                ],
                                                [
                                                    -0.336,
                                                    0.812
                                                ],
                                                [
                                                    0,
                                                    0.933
                                                ],
                                                [
                                                    0.303,
                                                    0.77
                                                ],
                                                [
                                                    0.546,
                                                    0.56
                                                ],
                                                [
                                                    0.747,
                                                    0.299
                                                ],
                                                [
                                                    0.943,
                                                    0
                                                ],
                                                [
                                                    0.695,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    0.327
                                                ],
                                                [
                                                    -0.625,
                                                    0.233
                                                ],
                                                [
                                                    -0.999,
                                                    0
                                                ],
                                                [
                                                    -0.779,
                                                    -0.443
                                                ],
                                                [
                                                    -0.453,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    0.285,
                                                    -0.7
                                                ],
                                                [
                                                    0.504,
                                                    -0.532
                                                ],
                                                [
                                                    0.672,
                                                    -0.289
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.611,
                                                    0.233
                                                ],
                                                [
                                                    0.448,
                                                    0.425
                                                ],
                                                [
                                                    0.243,
                                                    0.569
                                                ],
                                                [
                                                    0,
                                                    0.532
                                                ],
                                                [
                                                    -0.103,
                                                    0.383
                                                ],
                                                [
                                                    -0.182,
                                                    0.247
                                                ],
                                                [
                                                    -0.219,
                                                    0.117
                                                ],
                                                [
                                                    -0.336,
                                                    0
                                                ],
                                                [
                                                    -0.131,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.093,
                                                    -0.271
                                                ],
                                                [
                                                    -0.266,
                                                    -0.205
                                                ],
                                                [
                                                    -0.485,
                                                    0
                                                ],
                                                [
                                                    -0.383,
                                                    0.21
                                                ],
                                                [
                                                    -0.275,
                                                    0.364
                                                ],
                                                [
                                                    -0.149,
                                                    0.462
                                                ],
                                                [
                                                    0.009,
                                                    0.747
                                                ],
                                                [
                                                    0.373,
                                                    0.462
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.35,
                                                    -0.252
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    0.476
                                                ],
                                                [
                                                    0.359,
                                                    0.229
                                                ],
                                                [
                                                    0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    108.71,
                                                    36.013
                                                ],
                                                [
                                                    109.788,
                                                    35.285
                                                ],
                                                [
                                                    110.537,
                                                    34.004
                                                ],
                                                [
                                                    110.81,
                                                    32.128
                                                ],
                                                [
                                                    110.362,
                                                    29.902
                                                ],
                                                [
                                                    109.102,
                                                    28.166
                                                ],
                                                [
                                                    107.184,
                                                    27.039
                                                ],
                                                [
                                                    104.762,
                                                    26.64
                                                ],
                                                [
                                                    102.172,
                                                    27.137
                                                ],
                                                [
                                                    100.072,
                                                    28.53
                                                ],
                                                [
                                                    98.672,
                                                    30.644
                                                ],
                                                [
                                                    98.168,
                                                    33.304
                                                ],
                                                [
                                                    98.623,
                                                    35.859
                                                ],
                                                [
                                                    99.897,
                                                    37.854
                                                ],
                                                [
                                                    101.836,
                                                    39.142
                                                ],
                                                [
                                                    104.286,
                                                    39.59
                                                ],
                                                [
                                                    106.743,
                                                    39.191
                                                ],
                                                [
                                                    108.514,
                                                    38.218
                                                ],
                                                [
                                                    108.038,
                                                    37.532
                                                ],
                                                [
                                                    106.484,
                                                    38.372
                                                ],
                                                [
                                                    104.384,
                                                    38.722
                                                ],
                                                [
                                                    101.717,
                                                    38.057
                                                ],
                                                [
                                                    99.869,
                                                    36.174
                                                ],
                                                [
                                                    99.19,
                                                    33.304
                                                ],
                                                [
                                                    99.617,
                                                    31.022
                                                ],
                                                [
                                                    100.8,
                                                    29.174
                                                ],
                                                [
                                                    102.564,
                                                    27.942
                                                ],
                                                [
                                                    104.734,
                                                    27.508
                                                ],
                                                [
                                                    106.771,
                                                    27.858
                                                ],
                                                [
                                                    108.36,
                                                    28.845
                                                ],
                                                [
                                                    109.396,
                                                    30.336
                                                ],
                                                [
                                                    109.76,
                                                    32.198
                                                ],
                                                [
                                                    109.606,
                                                    33.57
                                                ],
                                                [
                                                    109.179,
                                                    34.515
                                                ],
                                                [
                                                    108.577,
                                                    35.061
                                                ],
                                                [
                                                    107.898,
                                                    35.236
                                                ],
                                                [
                                                    107.198,
                                                    34.907
                                                ],
                                                [
                                                    107.128,
                                                    33.99
                                                ],
                                                [
                                                    107.954,
                                                    30.07
                                                ],
                                                [
                                                    106.134,
                                                    30.07
                                                ],
                                                [
                                                    105.98,
                                                    30.868
                                                ],
                                                [
                                                    105.938,
                                                    30.868
                                                ],
                                                [
                                                    105.399,
                                                    30.154
                                                ],
                                                [
                                                    104.314,
                                                    29.846
                                                ],
                                                [
                                                    103.012,
                                                    30.161
                                                ],
                                                [
                                                    102.025,
                                                    31.022
                                                ],
                                                [
                                                    101.388,
                                                    32.261
                                                ],
                                                [
                                                    101.164,
                                                    33.71
                                                ],
                                                [
                                                    101.738,
                                                    35.523
                                                ],
                                                [
                                                    103.32,
                                                    36.216
                                                ],
                                                [
                                                    104.657,
                                                    35.838
                                                ],
                                                [
                                                    105.504,
                                                    34.844
                                                ],
                                                [
                                                    105.546,
                                                    34.844
                                                ],
                                                [
                                                    106.183,
                                                    35.901
                                                ],
                                                [
                                                    107.464,
                                                    36.244
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "@",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.154,
                                                    0.224
                                                ],
                                                [
                                                    0,
                                                    0.392
                                                ],
                                                [
                                                    -0.065,
                                                    0.303
                                                ],
                                                [
                                                    -0.135,
                                                    0.261
                                                ],
                                                [
                                                    -0.21,
                                                    0.163
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.149,
                                                    -0.149
                                                ],
                                                [
                                                    -0.047,
                                                    -0.243
                                                ],
                                                [
                                                    0.056,
                                                    -0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.275,
                                                    -0.308
                                                ],
                                                [
                                                    0.345,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.154,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.28
                                                ],
                                                [
                                                    0.065,
                                                    -0.303
                                                ],
                                                [
                                                    0.135,
                                                    -0.261
                                                ],
                                                [
                                                    0.21,
                                                    -0.163
                                                ],
                                                [
                                                    0.252,
                                                    0
                                                ],
                                                [
                                                    0.149,
                                                    0.149
                                                ],
                                                [
                                                    0.047,
                                                    0.243
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    0.513
                                                ],
                                                [
                                                    -0.275,
                                                    0.308
                                                ],
                                                [
                                                    -0.308,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    103.285,
                                                    34.62
                                                ],
                                                [
                                                    103.054,
                                                    33.696
                                                ],
                                                [
                                                    103.152,
                                                    32.821
                                                ],
                                                [
                                                    103.453,
                                                    31.974
                                                ],
                                                [
                                                    103.971,
                                                    31.337
                                                ],
                                                [
                                                    104.706,
                                                    31.092
                                                ],
                                                [
                                                    105.308,
                                                    31.316
                                                ],
                                                [
                                                    105.602,
                                                    31.904
                                                ],
                                                [
                                                    105.588,
                                                    32.716
                                                ],
                                                [
                                                    105.476,
                                                    33.262
                                                ],
                                                [
                                                    104.909,
                                                    34.494
                                                ],
                                                [
                                                    103.978,
                                                    34.956
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.233
                                                ],
                                                [
                                                    -0.233,
                                                    0.121
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.229,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.49,
                                                    0.471
                                                ],
                                                [
                                                    0.831,
                                                    0
                                                ],
                                                [
                                                    0.392,
                                                    -0.196
                                                ],
                                                [
                                                    0.308,
                                                    -0.429
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.019,
                                                    -0.317
                                                ],
                                                [
                                                    0.145,
                                                    -0.233
                                                ],
                                                [
                                                    0.233,
                                                    -0.121
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.229,
                                                    0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    -0.49,
                                                    -0.471
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.392,
                                                    0.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    115.178,
                                                    37
                                                ],
                                                [
                                                    115.178,
                                                    32.24
                                                ],
                                                [
                                                    115.423,
                                                    31.414
                                                ],
                                                [
                                                    115.99,
                                                    30.882
                                                ],
                                                [
                                                    116.76,
                                                    30.7
                                                ],
                                                [
                                                    117.733,
                                                    31.015
                                                ],
                                                [
                                                    118.076,
                                                    31.918
                                                ],
                                                [
                                                    118.076,
                                                    37
                                                ],
                                                [
                                                    120.246,
                                                    37
                                                ],
                                                [
                                                    120.246,
                                                    31.568
                                                ],
                                                [
                                                    119.511,
                                                    29.503
                                                ],
                                                [
                                                    117.53,
                                                    28.796
                                                ],
                                                [
                                                    116.13,
                                                    29.09
                                                ],
                                                [
                                                    115.08,
                                                    30.028
                                                ],
                                                [
                                                    114.996,
                                                    28.936
                                                ],
                                                [
                                                    112.994,
                                                    28.936
                                                ],
                                                [
                                                    112.994,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.602,
                                                    0.345
                                                ],
                                                [
                                                    -0.331,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0.331,
                                                    0.621
                                                ],
                                                [
                                                    0.602,
                                                    0.35
                                                ],
                                                [
                                                    0.812,
                                                    0
                                                ],
                                                [
                                                    0.607,
                                                    -0.35
                                                ],
                                                [
                                                    0.336,
                                                    -0.625
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ],
                                                [
                                                    -0.331,
                                                    -0.621
                                                ],
                                                [
                                                    -0.607,
                                                    -0.35
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.602,
                                                    -0.345
                                                ],
                                                [
                                                    0.331,
                                                    -0.625
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ],
                                                [
                                                    -0.331,
                                                    -0.621
                                                ],
                                                [
                                                    -0.602,
                                                    -0.35
                                                ],
                                                [
                                                    -0.812,
                                                    0
                                                ],
                                                [
                                                    -0.607,
                                                    0.35
                                                ],
                                                [
                                                    -0.336,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0.831
                                                ],
                                                [
                                                    0.331,
                                                    0.621
                                                ],
                                                [
                                                    0.607,
                                                    0.35
                                                ],
                                                [
                                                    0.812,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    128.527,
                                                    36.622
                                                ],
                                                [
                                                    129.927,
                                                    35.166
                                                ],
                                                [
                                                    130.424,
                                                    32.968
                                                ],
                                                [
                                                    129.927,
                                                    30.777
                                                ],
                                                [
                                                    128.527,
                                                    29.321
                                                ],
                                                [
                                                    126.406,
                                                    28.796
                                                ],
                                                [
                                                    124.278,
                                                    29.321
                                                ],
                                                [
                                                    122.864,
                                                    30.784
                                                ],
                                                [
                                                    122.36,
                                                    32.982
                                                ],
                                                [
                                                    122.857,
                                                    35.159
                                                ],
                                                [
                                                    124.264,
                                                    36.615
                                                ],
                                                [
                                                    126.406,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.331,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0.765
                                                ],
                                                [
                                                    -0.331,
                                                    0.425
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.415
                                                ],
                                                [
                                                    0,
                                                    -0.775
                                                ],
                                                [
                                                    0.331,
                                                    -0.42
                                                ],
                                                [
                                                    0.588,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.331,
                                                    -0.415
                                                ],
                                                [
                                                    0,
                                                    -0.765
                                                ],
                                                [
                                                    0.331,
                                                    -0.425
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0.765
                                                ],
                                                [
                                                    -0.331,
                                                    0.42
                                                ],
                                                [
                                                    -0.588,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    125.013,
                                                    34.753
                                                ],
                                                [
                                                    124.516,
                                                    32.982
                                                ],
                                                [
                                                    125.013,
                                                    31.197
                                                ],
                                                [
                                                    126.406,
                                                    30.56
                                                ],
                                                [
                                                    127.771,
                                                    31.183
                                                ],
                                                [
                                                    128.268,
                                                    32.968
                                                ],
                                                [
                                                    127.771,
                                                    34.746
                                                ],
                                                [
                                                    126.392,
                                                    35.376
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "r",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.247
                                                ],
                                                [
                                                    -0.485,
                                                    0
                                                ],
                                                [
                                                    -0.112,
                                                    -0.014
                                                ],
                                                [
                                                    -0.065,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0
                                                ],
                                                [
                                                    0.313,
                                                    -0.229
                                                ],
                                                [
                                                    0.224,
                                                    -0.485
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    -0.439
                                                ],
                                                [
                                                    0.313,
                                                    -0.247
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.112,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.187,
                                                    -0.065
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    134.722,
                                                    37
                                                ],
                                                [
                                                    134.722,
                                                    32.268
                                                ],
                                                [
                                                    135.303,
                                                    31.239
                                                ],
                                                [
                                                    136.5,
                                                    30.868
                                                ],
                                                [
                                                    136.878,
                                                    30.889
                                                ],
                                                [
                                                    137.144,
                                                    30.952
                                                ],
                                                [
                                                    137.228,
                                                    30.952
                                                ],
                                                [
                                                    137.228,
                                                    28.936
                                                ],
                                                [
                                                    136.542,
                                                    28.838
                                                ],
                                                [
                                                    135.429,
                                                    29.181
                                                ],
                                                [
                                                    134.624,
                                                    30.252
                                                ],
                                                [
                                                    134.526,
                                                    28.936
                                                ],
                                                [
                                                    132.538,
                                                    28.936
                                                ],
                                                [
                                                    132.538,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.28,
                                                    0.047
                                                ],
                                                [
                                                    -0.196,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.121,
                                                    -0.033
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.107
                                                ],
                                                [
                                                    0,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    -0.313
                                                ],
                                                [
                                                    -0.663,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.28,
                                                    -0.047
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.028
                                                ],
                                                [
                                                    -0.121,
                                                    0.033
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    -0.107
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.607
                                                ],
                                                [
                                                    0.313,
                                                    0.313
                                                ],
                                                [
                                                    0.261,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    142.352,
                                                    37.056
                                                ],
                                                [
                                                    143.066,
                                                    36.874
                                                ],
                                                [
                                                    143.066,
                                                    35.18
                                                ],
                                                [
                                                    142.772,
                                                    35.271
                                                ],
                                                [
                                                    142.366,
                                                    35.32
                                                ],
                                                [
                                                    141.862,
                                                    35.159
                                                ],
                                                [
                                                    141.75,
                                                    34.55
                                                ],
                                                [
                                                    141.75,
                                                    26.71
                                                ],
                                                [
                                                    139.608,
                                                    26.85
                                                ],
                                                [
                                                    139.608,
                                                    35.278
                                                ],
                                                [
                                                    140.077,
                                                    36.657
                                                ],
                                                [
                                                    141.54,
                                                    37.126
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    140.686,
                                                    30.42
                                                ],
                                                [
                                                    140.686,
                                                    29.02
                                                ],
                                                [
                                                    138.572,
                                                    28.936
                                                ],
                                                [
                                                    138.572,
                                                    30.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    143.08,
                                                    28.936
                                                ],
                                                [
                                                    140.686,
                                                    29.02
                                                ],
                                                [
                                                    140.686,
                                                    30.42
                                                ],
                                                [
                                                    143.08,
                                                    30.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "h",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "h",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.233
                                                ],
                                                [
                                                    -0.233,
                                                    0.121
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.229,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.49,
                                                    0.467
                                                ],
                                                [
                                                    0.831,
                                                    0
                                                ],
                                                [
                                                    0.378,
                                                    -0.173
                                                ],
                                                [
                                                    0.299,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.019,
                                                    -0.317
                                                ],
                                                [
                                                    0.145,
                                                    -0.233
                                                ],
                                                [
                                                    0.233,
                                                    -0.121
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.229,
                                                    0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    -0.49,
                                                    -0.467
                                                ],
                                                [
                                                    -0.513,
                                                    0
                                                ],
                                                [
                                                    -0.378,
                                                    0.173
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    147.364,
                                                    37
                                                ],
                                                [
                                                    147.364,
                                                    32.226
                                                ],
                                                [
                                                    147.609,
                                                    31.4
                                                ],
                                                [
                                                    148.176,
                                                    30.868
                                                ],
                                                [
                                                    148.946,
                                                    30.686
                                                ],
                                                [
                                                    149.919,
                                                    31.001
                                                ],
                                                [
                                                    150.262,
                                                    31.904
                                                ],
                                                [
                                                    150.262,
                                                    37
                                                ],
                                                [
                                                    152.432,
                                                    37
                                                ],
                                                [
                                                    152.432,
                                                    31.554
                                                ],
                                                [
                                                    151.697,
                                                    29.496
                                                ],
                                                [
                                                    149.716,
                                                    28.796
                                                ],
                                                [
                                                    148.379,
                                                    29.055
                                                ],
                                                [
                                                    147.364,
                                                    29.902
                                                ],
                                                [
                                                    147.364,
                                                    25.94
                                                ],
                                                [
                                                    145.18,
                                                    25.94
                                                ],
                                                [
                                                    145.18,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "b",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "b",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    -0.229
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.509,
                                                    0.336
                                                ],
                                                [
                                                    -0.28,
                                                    0.621
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0.285,
                                                    0.63
                                                ],
                                                [
                                                    0.518,
                                                    0.345
                                                ],
                                                [
                                                    0.709,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.201
                                                ],
                                                [
                                                    0.243,
                                                    -0.42
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.42
                                                ],
                                                [
                                                    0.448,
                                                    0.229
                                                ],
                                                [
                                                    0.7,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    -0.336
                                                ],
                                                [
                                                    0.28,
                                                    -0.621
                                                ],
                                                [
                                                    0,
                                                    -0.859
                                                ],
                                                [
                                                    -0.285,
                                                    -0.63
                                                ],
                                                [
                                                    -0.518,
                                                    -0.345
                                                ],
                                                [
                                                    -0.513,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    0.201
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    156.912,
                                                    37
                                                ],
                                                [
                                                    157.038,
                                                    35.824
                                                ],
                                                [
                                                    158.018,
                                                    36.797
                                                ],
                                                [
                                                    159.502,
                                                    37.14
                                                ],
                                                [
                                                    161.315,
                                                    36.636
                                                ],
                                                [
                                                    162.498,
                                                    35.201
                                                ],
                                                [
                                                    162.918,
                                                    33.01
                                                ],
                                                [
                                                    162.491,
                                                    30.777
                                                ],
                                                [
                                                    161.287,
                                                    29.314
                                                ],
                                                [
                                                    159.446,
                                                    28.796
                                                ],
                                                [
                                                    158.067,
                                                    29.097
                                                ],
                                                [
                                                    157.094,
                                                    30.028
                                                ],
                                                [
                                                    157.094,
                                                    25.94
                                                ],
                                                [
                                                    154.91,
                                                    25.94
                                                ],
                                                [
                                                    154.91,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "b",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.322
                                                ],
                                                [
                                                    -0.271,
                                                    0.168
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    -0.415
                                                ],
                                                [
                                                    0,
                                                    -0.784
                                                ],
                                                [
                                                    0.313,
                                                    -0.411
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0.163
                                                ],
                                                [
                                                    0.145,
                                                    0.313
                                                ],
                                                [
                                                    0,
                                                    0.439
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    0.14,
                                                    -0.322
                                                ],
                                                [
                                                    0.271,
                                                    -0.168
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.313,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0.756
                                                ],
                                                [
                                                    -0.313,
                                                    0.411
                                                ],
                                                [
                                                    -0.373,
                                                    0
                                                ],
                                                [
                                                    -0.271,
                                                    -0.163
                                                ],
                                                [
                                                    -0.145,
                                                    -0.313
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    157.094,
                                                    32.73
                                                ],
                                                [
                                                    157.304,
                                                    31.561
                                                ],
                                                [
                                                    157.92,
                                                    30.826
                                                ],
                                                [
                                                    158.9,
                                                    30.574
                                                ],
                                                [
                                                    160.237,
                                                    31.197
                                                ],
                                                [
                                                    160.706,
                                                    32.996
                                                ],
                                                [
                                                    160.237,
                                                    34.746
                                                ],
                                                [
                                                    158.9,
                                                    35.362
                                                ],
                                                [
                                                    157.934,
                                                    35.117
                                                ],
                                                [
                                                    157.311,
                                                    34.403
                                                ],
                                                [
                                                    157.094,
                                                    33.276
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.457,
                                                    0.233
                                                ],
                                                [
                                                    -0.243,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    -0.187
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.028
                                                ],
                                                [
                                                    -0.131,
                                                    0.065
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.056,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.383
                                                ],
                                                [
                                                    0.499,
                                                    0.21
                                                ],
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.644,
                                                    -0.467
                                                ],
                                                [
                                                    -0.009,
                                                    -0.831
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.257,
                                                    0.205
                                                ],
                                                [
                                                    -0.476,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    -0.149
                                                ],
                                                [
                                                    0,
                                                    -0.28
                                                ],
                                                [
                                                    0.117,
                                                    -0.131
                                                ],
                                                [
                                                    0.299,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.369,
                                                    -0.205
                                                ],
                                                [
                                                    0.201,
                                                    -0.336
                                                ],
                                                [
                                                    0,
                                                    -0.476
                                                ],
                                                [
                                                    -0.481,
                                                    -0.42
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.457,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.056,
                                                    0.383
                                                ],
                                                [
                                                    0.289,
                                                    0.187
                                                ],
                                                [
                                                    0.168,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.098,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.541
                                                ],
                                                [
                                                    -0.238,
                                                    -0.383
                                                ],
                                                [
                                                    -0.499,
                                                    -0.21
                                                ],
                                                [
                                                    -1.064,
                                                    0
                                                ],
                                                [
                                                    -0.644,
                                                    0.467
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.257,
                                                    -0.205
                                                ],
                                                [
                                                    0.429,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    -0.117,
                                                    0.131
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.504,
                                                    0.084
                                                ],
                                                [
                                                    -0.369,
                                                    0.205
                                                ],
                                                [
                                                    -0.201,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0.691
                                                ],
                                                [
                                                    0.481,
                                                    0.42
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    168.924,
                                                    36.79
                                                ],
                                                [
                                                    169.974,
                                                    35.81
                                                ],
                                                [
                                                    169.988,
                                                    35.964
                                                ],
                                                [
                                                    170.506,
                                                    36.818
                                                ],
                                                [
                                                    171.612,
                                                    37.098
                                                ],
                                                [
                                                    172.165,
                                                    37.056
                                                ],
                                                [
                                                    172.662,
                                                    36.916
                                                ],
                                                [
                                                    172.662,
                                                    35.404
                                                ],
                                                [
                                                    172.578,
                                                    35.404
                                                ],
                                                [
                                                    172.48,
                                                    35.425
                                                ],
                                                [
                                                    172.34,
                                                    35.432
                                                ],
                                                [
                                                    172.011,
                                                    35.32
                                                ],
                                                [
                                                    171.864,
                                                    34.858
                                                ],
                                                [
                                                    171.864,
                                                    31.386
                                                ],
                                                [
                                                    171.507,
                                                    30
                                                ],
                                                [
                                                    170.401,
                                                    29.111
                                                ],
                                                [
                                                    168.476,
                                                    28.796
                                                ],
                                                [
                                                    165.914,
                                                    29.496
                                                ],
                                                [
                                                    164.962,
                                                    31.442
                                                ],
                                                [
                                                    166.95,
                                                    31.666
                                                ],
                                                [
                                                    167.335,
                                                    30.714
                                                ],
                                                [
                                                    168.434,
                                                    30.406
                                                ],
                                                [
                                                    169.379,
                                                    30.63
                                                ],
                                                [
                                                    169.68,
                                                    31.274
                                                ],
                                                [
                                                    169.505,
                                                    31.806
                                                ],
                                                [
                                                    168.882,
                                                    32.086
                                                ],
                                                [
                                                    167.132,
                                                    32.38
                                                ],
                                                [
                                                    165.823,
                                                    32.814
                                                ],
                                                [
                                                    164.969,
                                                    33.626
                                                ],
                                                [
                                                    164.668,
                                                    34.844
                                                ],
                                                [
                                                    165.389,
                                                    36.51
                                                ],
                                                [
                                                    167.342,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.205,
                                                    0.159
                                                ],
                                                [
                                                    0,
                                                    0.299
                                                ],
                                                [
                                                    -0.145,
                                                    0.177
                                                ],
                                                [
                                                    -0.373,
                                                    0.065
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.047
                                                ],
                                                [
                                                    -0.112,
                                                    0.065
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.303,
                                                    -0.215
                                                ],
                                                [
                                                    0.467,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.205,
                                                    -0.159
                                                ],
                                                [
                                                    0,
                                                    -0.215
                                                ],
                                                [
                                                    0.145,
                                                    -0.177
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.047
                                                ],
                                                [
                                                    0.154,
                                                    -0.047
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.383
                                                ],
                                                [
                                                    -0.303,
                                                    0.215
                                                ],
                                                [
                                                    -0.355,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    167.174,
                                                    35.334
                                                ],
                                                [
                                                    166.866,
                                                    34.648
                                                ],
                                                [
                                                    167.083,
                                                    34.06
                                                ],
                                                [
                                                    167.86,
                                                    33.696
                                                ],
                                                [
                                                    168.91,
                                                    33.5
                                                ],
                                                [
                                                    169.477,
                                                    33.36
                                                ],
                                                [
                                                    169.876,
                                                    33.192
                                                ],
                                                [
                                                    169.736,
                                                    33.122
                                                ],
                                                [
                                                    169.736,
                                                    34.354
                                                ],
                                                [
                                                    169.169,
                                                    35.25
                                                ],
                                                [
                                                    168.014,
                                                    35.572
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.233
                                                ],
                                                [
                                                    -0.233,
                                                    0.121
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.229,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.49,
                                                    0.471
                                                ],
                                                [
                                                    0.831,
                                                    0
                                                ],
                                                [
                                                    0.392,
                                                    -0.196
                                                ],
                                                [
                                                    0.308,
                                                    -0.429
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.019,
                                                    -0.317
                                                ],
                                                [
                                                    0.145,
                                                    -0.233
                                                ],
                                                [
                                                    0.233,
                                                    -0.121
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.229,
                                                    0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    -0.49,
                                                    -0.471
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.392,
                                                    0.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    176.624,
                                                    37
                                                ],
                                                [
                                                    176.624,
                                                    32.24
                                                ],
                                                [
                                                    176.869,
                                                    31.414
                                                ],
                                                [
                                                    177.436,
                                                    30.882
                                                ],
                                                [
                                                    178.206,
                                                    30.7
                                                ],
                                                [
                                                    179.179,
                                                    31.015
                                                ],
                                                [
                                                    179.522,
                                                    31.918
                                                ],
                                                [
                                                    179.522,
                                                    37
                                                ],
                                                [
                                                    181.692,
                                                    37
                                                ],
                                                [
                                                    181.692,
                                                    31.568
                                                ],
                                                [
                                                    180.957,
                                                    29.503
                                                ],
                                                [
                                                    178.976,
                                                    28.796
                                                ],
                                                [
                                                    177.576,
                                                    29.09
                                                ],
                                                [
                                                    176.526,
                                                    30.028
                                                ],
                                                [
                                                    176.442,
                                                    28.936
                                                ],
                                                [
                                                    174.44,
                                                    28.936
                                                ],
                                                [
                                                    174.44,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "k",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "k",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    192.178,
                                                    37
                                                ],
                                                [
                                                    188.692,
                                                    31.652
                                                ],
                                                [
                                                    188.692,
                                                    32.072
                                                ],
                                                [
                                                    191.954,
                                                    28.936
                                                ],
                                                [
                                                    189.238,
                                                    28.936
                                                ],
                                                [
                                                    186.2,
                                                    32.072
                                                ],
                                                [
                                                    186.2,
                                                    34.48
                                                ],
                                                [
                                                    187.348,
                                                    33.36
                                                ],
                                                [
                                                    189.588,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "k",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    186.354,
                                                    37
                                                ],
                                                [
                                                    186.354,
                                                    25.94
                                                ],
                                                [
                                                    184.17,
                                                    25.94
                                                ],
                                                [
                                                    184.17,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": ".",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": ".",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    195.706,
                                                    37
                                                ],
                                                [
                                                    195.706,
                                                    34.914
                                                ],
                                                [
                                                    193.662,
                                                    34.914
                                                ],
                                                [
                                                    193.662,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "c",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.541,
                                                    0.243
                                                ],
                                                [
                                                    -0.322,
                                                    0.448
                                                ],
                                                [
                                                    -0.056,
                                                    0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.294,
                                                    -0.261
                                                ],
                                                [
                                                    0.485,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0.756
                                                ],
                                                [
                                                    -0.331,
                                                    0.415
                                                ],
                                                [
                                                    -0.569,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    -0.219
                                                ],
                                                [
                                                    -0.047,
                                                    -0.467
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.635,
                                                    0.523
                                                ],
                                                [
                                                    1.064,
                                                    0
                                                ],
                                                [
                                                    0.607,
                                                    -0.35
                                                ],
                                                [
                                                    0.336,
                                                    -0.621
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ],
                                                [
                                                    -0.331,
                                                    -0.625
                                                ],
                                                [
                                                    -0.607,
                                                    -0.35
                                                ],
                                                [
                                                    -0.812,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.541,
                                                    -0.243
                                                ],
                                                [
                                                    0.322,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    0.467
                                                ],
                                                [
                                                    -0.294,
                                                    0.261
                                                ],
                                                [
                                                    -0.569,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.42
                                                ],
                                                [
                                                    0,
                                                    -0.765
                                                ],
                                                [
                                                    0.331,
                                                    -0.415
                                                ],
                                                [
                                                    0.457,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.093,
                                                    -0.859
                                                ],
                                                [
                                                    -0.635,
                                                    -0.523
                                                ],
                                                [
                                                    -0.812,
                                                    0
                                                ],
                                                [
                                                    -0.607,
                                                    0.35
                                                ],
                                                [
                                                    -0.336,
                                                    0.621
                                                ],
                                                [
                                                    0,
                                                    0.831
                                                ],
                                                [
                                                    0.331,
                                                    0.625
                                                ],
                                                [
                                                    0.607,
                                                    0.35
                                                ],
                                                [
                                                    0.691,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    203.588,
                                                    36.776
                                                ],
                                                [
                                                    204.883,
                                                    35.74
                                                ],
                                                [
                                                    205.45,
                                                    34.172
                                                ],
                                                [
                                                    203.378,
                                                    33.878
                                                ],
                                                [
                                                    202.895,
                                                    34.97
                                                ],
                                                [
                                                    201.726,
                                                    35.362
                                                ],
                                                [
                                                    200.375,
                                                    34.732
                                                ],
                                                [
                                                    199.878,
                                                    32.968
                                                ],
                                                [
                                                    200.375,
                                                    31.197
                                                ],
                                                [
                                                    201.726,
                                                    30.574
                                                ],
                                                [
                                                    202.846,
                                                    30.903
                                                ],
                                                [
                                                    203.35,
                                                    31.932
                                                ],
                                                [
                                                    205.394,
                                                    31.652
                                                ],
                                                [
                                                    204.302,
                                                    29.58
                                                ],
                                                [
                                                    201.754,
                                                    28.796
                                                ],
                                                [
                                                    199.626,
                                                    29.321
                                                ],
                                                [
                                                    198.212,
                                                    30.777
                                                ],
                                                [
                                                    197.708,
                                                    32.968
                                                ],
                                                [
                                                    198.205,
                                                    35.152
                                                ],
                                                [
                                                    199.612,
                                                    36.615
                                                ],
                                                [
                                                    201.74,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.602,
                                                    0.345
                                                ],
                                                [
                                                    -0.331,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0.331,
                                                    0.621
                                                ],
                                                [
                                                    0.602,
                                                    0.35
                                                ],
                                                [
                                                    0.812,
                                                    0
                                                ],
                                                [
                                                    0.607,
                                                    -0.35
                                                ],
                                                [
                                                    0.336,
                                                    -0.625
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ],
                                                [
                                                    -0.331,
                                                    -0.621
                                                ],
                                                [
                                                    -0.607,
                                                    -0.35
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.602,
                                                    -0.345
                                                ],
                                                [
                                                    0.331,
                                                    -0.625
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ],
                                                [
                                                    -0.331,
                                                    -0.621
                                                ],
                                                [
                                                    -0.602,
                                                    -0.35
                                                ],
                                                [
                                                    -0.812,
                                                    0
                                                ],
                                                [
                                                    -0.607,
                                                    0.35
                                                ],
                                                [
                                                    -0.336,
                                                    0.625
                                                ],
                                                [
                                                    0,
                                                    0.831
                                                ],
                                                [
                                                    0.331,
                                                    0.621
                                                ],
                                                [
                                                    0.607,
                                                    0.35
                                                ],
                                                [
                                                    0.812,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    213.297,
                                                    36.622
                                                ],
                                                [
                                                    214.697,
                                                    35.166
                                                ],
                                                [
                                                    215.194,
                                                    32.968
                                                ],
                                                [
                                                    214.697,
                                                    30.777
                                                ],
                                                [
                                                    213.297,
                                                    29.321
                                                ],
                                                [
                                                    211.176,
                                                    28.796
                                                ],
                                                [
                                                    209.048,
                                                    29.321
                                                ],
                                                [
                                                    207.634,
                                                    30.784
                                                ],
                                                [
                                                    207.13,
                                                    32.982
                                                ],
                                                [
                                                    207.627,
                                                    35.159
                                                ],
                                                [
                                                    209.034,
                                                    36.615
                                                ],
                                                [
                                                    211.176,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.331,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0.765
                                                ],
                                                [
                                                    -0.331,
                                                    0.425
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.415
                                                ],
                                                [
                                                    0,
                                                    -0.775
                                                ],
                                                [
                                                    0.331,
                                                    -0.42
                                                ],
                                                [
                                                    0.588,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.331,
                                                    -0.415
                                                ],
                                                [
                                                    0,
                                                    -0.765
                                                ],
                                                [
                                                    0.331,
                                                    -0.425
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0.765
                                                ],
                                                [
                                                    -0.331,
                                                    0.42
                                                ],
                                                [
                                                    -0.588,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    209.783,
                                                    34.753
                                                ],
                                                [
                                                    209.286,
                                                    32.982
                                                ],
                                                [
                                                    209.783,
                                                    31.197
                                                ],
                                                [
                                                    211.176,
                                                    30.56
                                                ],
                                                [
                                                    212.541,
                                                    31.183
                                                ],
                                                [
                                                    213.038,
                                                    32.968
                                                ],
                                                [
                                                    212.541,
                                                    34.746
                                                ],
                                                [
                                                    211.162,
                                                    35.376
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "m",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "m",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.121,
                                                    0.238
                                                ],
                                                [
                                                    -0.224,
                                                    0.135
                                                ],
                                                [
                                                    -0.308,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.131,
                                                    0.238
                                                ],
                                                [
                                                    -0.224,
                                                    0.121
                                                ],
                                                [
                                                    -0.299,
                                                    0
                                                ],
                                                [
                                                    -0.196,
                                                    -0.247
                                                ],
                                                [
                                                    0,
                                                    -0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.471,
                                                    0.504
                                                ],
                                                [
                                                    0.877,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    -0.261
                                                ],
                                                [
                                                    0.233,
                                                    -0.467
                                                ],
                                                [
                                                    0.429,
                                                    0.247
                                                ],
                                                [
                                                    0.532,
                                                    0
                                                ],
                                                [
                                                    0.392,
                                                    -0.201
                                                ],
                                                [
                                                    0.28,
                                                    -0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.317
                                                ],
                                                [
                                                    0.121,
                                                    -0.238
                                                ],
                                                [
                                                    0.224,
                                                    -0.135
                                                ],
                                                [
                                                    0.439,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.364
                                                ],
                                                [
                                                    0.131,
                                                    -0.238
                                                ],
                                                [
                                                    0.224,
                                                    -0.121
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.196,
                                                    0.247
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.471,
                                                    -0.504
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.439,
                                                    0.261
                                                ],
                                                [
                                                    -0.224,
                                                    -0.495
                                                ],
                                                [
                                                    -0.429,
                                                    -0.247
                                                ],
                                                [
                                                    -0.439,
                                                    0
                                                ],
                                                [
                                                    -0.392,
                                                    0.201
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    219.492,
                                                    37
                                                ],
                                                [
                                                    219.492,
                                                    32.296
                                                ],
                                                [
                                                    219.674,
                                                    31.463
                                                ],
                                                [
                                                    220.192,
                                                    30.903
                                                ],
                                                [
                                                    220.99,
                                                    30.7
                                                ],
                                                [
                                                    221.935,
                                                    31.099
                                                ],
                                                [
                                                    222.222,
                                                    32.142
                                                ],
                                                [
                                                    222.222,
                                                    37
                                                ],
                                                [
                                                    224.392,
                                                    37
                                                ],
                                                [
                                                    224.392,
                                                    32.324
                                                ],
                                                [
                                                    224.588,
                                                    31.421
                                                ],
                                                [
                                                    225.12,
                                                    30.882
                                                ],
                                                [
                                                    225.904,
                                                    30.7
                                                ],
                                                [
                                                    226.828,
                                                    31.071
                                                ],
                                                [
                                                    227.122,
                                                    32.1
                                                ],
                                                [
                                                    227.122,
                                                    37
                                                ],
                                                [
                                                    229.306,
                                                    37
                                                ],
                                                [
                                                    229.306,
                                                    31.54
                                                ],
                                                [
                                                    228.599,
                                                    29.552
                                                ],
                                                [
                                                    226.576,
                                                    28.796
                                                ],
                                                [
                                                    225.092,
                                                    29.188
                                                ],
                                                [
                                                    224.084,
                                                    30.28
                                                ],
                                                [
                                                    223.104,
                                                    29.167
                                                ],
                                                [
                                                    221.662,
                                                    28.796
                                                ],
                                                [
                                                    220.416,
                                                    29.097
                                                ],
                                                [
                                                    219.408,
                                                    30.056
                                                ],
                                                [
                                                    219.254,
                                                    28.936
                                                ],
                                                [
                                                    217.308,
                                                    28.936
                                                ],
                                                [
                                                    217.308,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": ",",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": ",",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.299,
                                                    0.261
                                                ],
                                                [
                                                    0,
                                                    0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    -0.121
                                                ],
                                                [
                                                    0.299,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    -0.261
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.233
                                                ],
                                                [
                                                    -0.103,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    232.008,
                                                    39.254
                                                ],
                                                [
                                                    233.268,
                                                    38.862
                                                ],
                                                [
                                                    233.716,
                                                    37.686
                                                ],
                                                [
                                                    233.716,
                                                    34.914
                                                ],
                                                [
                                                    231.672,
                                                    34.914
                                                ],
                                                [
                                                    231.672,
                                                    37
                                                ],
                                                [
                                                    232.652,
                                                    37
                                                ],
                                                [
                                                    232.652,
                                                    37.476
                                                ],
                                                [
                                                    232.498,
                                                    38.008
                                                ],
                                                [
                                                    231.896,
                                                    38.19
                                                ],
                                                [
                                                    231.56,
                                                    38.19
                                                ],
                                                [
                                                    231.56,
                                                    39.254
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "c",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.476,
                                                    0.21
                                                ],
                                                [
                                                    -0.303,
                                                    0.401
                                                ],
                                                [
                                                    -0.075,
                                                    0.569
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.28
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.401,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.877
                                                ],
                                                [
                                                    -0.406,
                                                    0.499
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    -0.271
                                                ],
                                                [
                                                    -0.056,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.499
                                                ],
                                                [
                                                    0.952,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.336
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.476,
                                                    -0.21
                                                ],
                                                [
                                                    0.303,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.056,
                                                    0.513
                                                ],
                                                [
                                                    -0.355,
                                                    0.28
                                                ],
                                                [
                                                    -0.7,
                                                    0
                                                ],
                                                [
                                                    -0.401,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.812
                                                ],
                                                [
                                                    -0.583,
                                                    -0.499
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.336
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    245.336,
                                                    36.811
                                                ],
                                                [
                                                    246.505,
                                                    35.894
                                                ],
                                                [
                                                    247.072,
                                                    34.438
                                                ],
                                                [
                                                    245.672,
                                                    34.27
                                                ],
                                                [
                                                    245.056,
                                                    35.46
                                                ],
                                                [
                                                    243.698,
                                                    35.88
                                                ],
                                                [
                                                    242.046,
                                                    35.124
                                                ],
                                                [
                                                    241.444,
                                                    33.052
                                                ],
                                                [
                                                    242.053,
                                                    30.973
                                                ],
                                                [
                                                    243.698,
                                                    30.224
                                                ],
                                                [
                                                    245.056,
                                                    30.63
                                                ],
                                                [
                                                    245.672,
                                                    31.862
                                                ],
                                                [
                                                    247.072,
                                                    31.694
                                                ],
                                                [
                                                    246.043,
                                                    29.727
                                                ],
                                                [
                                                    243.74,
                                                    28.978
                                                ],
                                                [
                                                    241.759,
                                                    29.482
                                                ],
                                                [
                                                    240.443,
                                                    30.903
                                                ],
                                                [
                                                    239.974,
                                                    33.052
                                                ],
                                                [
                                                    240.436,
                                                    35.187
                                                ],
                                                [
                                                    241.738,
                                                    36.615
                                                ],
                                                [
                                                    243.712,
                                                    37.126
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.271
                                                ],
                                                [
                                                    -0.196,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    -0.196
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.019
                                                ],
                                                [
                                                    -0.093,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.355
                                                ],
                                                [
                                                    0.453,
                                                    0.173
                                                ],
                                                [
                                                    0.653,
                                                    0
                                                ],
                                                [
                                                    0.602,
                                                    -0.415
                                                ],
                                                [
                                                    0.019,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    0.233
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.327
                                                ],
                                                [
                                                    0.131,
                                                    -0.154
                                                ],
                                                [
                                                    0.42,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.182
                                                ],
                                                [
                                                    0.238,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.453,
                                                    -0.406
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.247,
                                                    0.196
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.532
                                                ],
                                                [
                                                    -0.238,
                                                    -0.355
                                                ],
                                                [
                                                    -0.453,
                                                    -0.173
                                                ],
                                                [
                                                    -0.98,
                                                    0
                                                ],
                                                [
                                                    -0.602,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    -0.485
                                                ],
                                                [
                                                    0.355,
                                                    -0.233
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.252
                                                ],
                                                [
                                                    -0.131,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.084
                                                ],
                                                [
                                                    -0.383,
                                                    0.182
                                                ],
                                                [
                                                    -0.238,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0.653
                                                ],
                                                [
                                                    0.453,
                                                    0.406
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    253.26,
                                                    36.734
                                                ],
                                                [
                                                    254.324,
                                                    35.67
                                                ],
                                                [
                                                    254.324,
                                                    35.922
                                                ],
                                                [
                                                    254.695,
                                                    36.818
                                                ],
                                                [
                                                    255.668,
                                                    37.112
                                                ],
                                                [
                                                    256.011,
                                                    37.084
                                                ],
                                                [
                                                    256.382,
                                                    37
                                                ],
                                                [
                                                    256.382,
                                                    35.978
                                                ],
                                                [
                                                    256.298,
                                                    35.978
                                                ],
                                                [
                                                    256.228,
                                                    35.999
                                                ],
                                                [
                                                    256.06,
                                                    36.006
                                                ],
                                                [
                                                    255.724,
                                                    35.88
                                                ],
                                                [
                                                    255.57,
                                                    35.334
                                                ],
                                                [
                                                    255.57,
                                                    31.358
                                                ],
                                                [
                                                    255.213,
                                                    30.028
                                                ],
                                                [
                                                    254.177,
                                                    29.237
                                                ],
                                                [
                                                    252.518,
                                                    28.978
                                                ],
                                                [
                                                    250.145,
                                                    29.601
                                                ],
                                                [
                                                    249.214,
                                                    31.386
                                                ],
                                                [
                                                    250.572,
                                                    31.526
                                                ],
                                                [
                                                    251.09,
                                                    30.448
                                                ],
                                                [
                                                    252.518,
                                                    30.098
                                                ],
                                                [
                                                    253.792,
                                                    30.427
                                                ],
                                                [
                                                    254.142,
                                                    31.246
                                                ],
                                                [
                                                    253.946,
                                                    31.855
                                                ],
                                                [
                                                    253.12,
                                                    32.198
                                                ],
                                                [
                                                    251.468,
                                                    32.506
                                                ],
                                                [
                                                    250.222,
                                                    32.905
                                                ],
                                                [
                                                    249.291,
                                                    33.668
                                                ],
                                                [
                                                    248.934,
                                                    34.942
                                                ],
                                                [
                                                    249.613,
                                                    36.531
                                                ],
                                                [
                                                    251.524,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.28,
                                                    0.187
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    -0.191,
                                                    0.233
                                                ],
                                                [
                                                    -0.588,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.056
                                                ],
                                                [
                                                    -0.093,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.238
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.28,
                                                    -0.187
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    0.191,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.075
                                                ],
                                                [
                                                    0.201,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.429
                                                ],
                                                [
                                                    -0.406,
                                                    0.238
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    250.824,
                                                    35.712
                                                ],
                                                [
                                                    250.404,
                                                    34.83
                                                ],
                                                [
                                                    250.691,
                                                    34.074
                                                ],
                                                [
                                                    251.86,
                                                    33.542
                                                ],
                                                [
                                                    253.022,
                                                    33.304
                                                ],
                                                [
                                                    253.869,
                                                    33.108
                                                ],
                                                [
                                                    254.31,
                                                    32.884
                                                ],
                                                [
                                                    254.156,
                                                    32.828
                                                ],
                                                [
                                                    254.156,
                                                    34.634
                                                ],
                                                [
                                                    253.337,
                                                    35.635
                                                ],
                                                [
                                                    251.888,
                                                    35.992
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "r",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.327
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ],
                                                [
                                                    -0.098,
                                                    -0.014
                                                ],
                                                [
                                                    -0.075,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0
                                                ],
                                                [
                                                    0.322,
                                                    -0.215
                                                ],
                                                [
                                                    0.205,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    -0.551
                                                ],
                                                [
                                                    0.322,
                                                    -0.327
                                                ],
                                                [
                                                    0.093,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    -0.056
                                                ],
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    259.7,
                                                    37
                                                ],
                                                [
                                                    259.7,
                                                    32.198
                                                ],
                                                [
                                                    260.253,
                                                    30.882
                                                ],
                                                [
                                                    261.534,
                                                    30.392
                                                ],
                                                [
                                                    261.821,
                                                    30.413
                                                ],
                                                [
                                                    262.08,
                                                    30.476
                                                ],
                                                [
                                                    262.178,
                                                    30.476
                                                ],
                                                [
                                                    262.178,
                                                    29.118
                                                ],
                                                [
                                                    261.534,
                                                    29.034
                                                ],
                                                [
                                                    260.421,
                                                    29.356
                                                ],
                                                [
                                                    259.63,
                                                    30.28
                                                ],
                                                [
                                                    259.546,
                                                    29.118
                                                ],
                                                [
                                                    258.258,
                                                    29.118
                                                ],
                                                [
                                                    258.258,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "d",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "d",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.271,
                                                    -0.602
                                                ],
                                                [
                                                    -0.509,
                                                    -0.331
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.462,
                                                    0.266
                                                ],
                                                [
                                                    -0.224,
                                                    0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    0.243
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    -0.336
                                                ],
                                                [
                                                    0.28,
                                                    -0.621
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.271,
                                                    0.602
                                                ],
                                                [
                                                    0.509,
                                                    0.331
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.462,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.457
                                                ],
                                                [
                                                    -0.439,
                                                    -0.243
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.336
                                                ],
                                                [
                                                    -0.28,
                                                    0.621
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    263.956,
                                                    35.243
                                                ],
                                                [
                                                    265.125,
                                                    36.643
                                                ],
                                                [
                                                    266.924,
                                                    37.14
                                                ],
                                                [
                                                    268.527,
                                                    36.741
                                                ],
                                                [
                                                    269.556,
                                                    35.656
                                                ],
                                                [
                                                    269.654,
                                                    37
                                                ],
                                                [
                                                    270.984,
                                                    37
                                                ],
                                                [
                                                    270.984,
                                                    25.94
                                                ],
                                                [
                                                    269.556,
                                                    25.94
                                                ],
                                                [
                                                    269.556,
                                                    30.392
                                                ],
                                                [
                                                    268.52,
                                                    29.342
                                                ],
                                                [
                                                    266.966,
                                                    28.978
                                                ],
                                                [
                                                    265.16,
                                                    29.482
                                                ],
                                                [
                                                    263.97,
                                                    30.917
                                                ],
                                                [
                                                    263.55,
                                                    33.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "d",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.387,
                                                    0.504
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.201
                                                ],
                                                [
                                                    -0.187,
                                                    -0.369
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    -0.359
                                                ],
                                                [
                                                    0.35,
                                                    -0.201
                                                ],
                                                [
                                                    0.467,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.387,
                                                    -0.504
                                                ],
                                                [
                                                    0.476,
                                                    0
                                                ],
                                                [
                                                    0.345,
                                                    0.201
                                                ],
                                                [
                                                    0.187,
                                                    0.369
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.476
                                                ],
                                                [
                                                    -0.191,
                                                    0.359
                                                ],
                                                [
                                                    -0.35,
                                                    0.201
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.383,
                                                    -0.485
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    265.601,
                                                    30.966
                                                ],
                                                [
                                                    267.246,
                                                    30.21
                                                ],
                                                [
                                                    268.478,
                                                    30.511
                                                ],
                                                [
                                                    269.276,
                                                    31.365
                                                ],
                                                [
                                                    269.556,
                                                    32.674
                                                ],
                                                [
                                                    269.556,
                                                    33.514
                                                ],
                                                [
                                                    269.269,
                                                    34.767
                                                ],
                                                [
                                                    268.457,
                                                    35.607
                                                ],
                                                [
                                                    267.232,
                                                    35.908
                                                ],
                                                [
                                                    265.594,
                                                    35.18
                                                ],
                                                [
                                                    265.02,
                                                    33.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    282.912,
                                                    36.839
                                                ],
                                                [
                                                    284.06,
                                                    36.006
                                                ],
                                                [
                                                    284.648,
                                                    34.76
                                                ],
                                                [
                                                    283.374,
                                                    34.466
                                                ],
                                                [
                                                    282.716,
                                                    35.558
                                                ],
                                                [
                                                    281.316,
                                                    35.95
                                                ],
                                                [
                                                    279.566,
                                                    35.229
                                                ],
                                                [
                                                    278.95,
                                                    33.038
                                                ],
                                                [
                                                    279.594,
                                                    30.798
                                                ],
                                                [
                                                    281.218,
                                                    30.112
                                                ],
                                                [
                                                    282.877,
                                                    30.868
                                                ],
                                                [
                                                    283.234,
                                                    32.842
                                                ],
                                                [
                                                    283.892,
                                                    32.338
                                                ],
                                                [
                                                    278.782,
                                                    32.338
                                                ],
                                                [
                                                    278.782,
                                                    33.416
                                                ],
                                                [
                                                    284.746,
                                                    33.416
                                                ],
                                                [
                                                    284.424,
                                                    30.945
                                                ],
                                                [
                                                    283.185,
                                                    29.468
                                                ],
                                                [
                                                    281.246,
                                                    28.978
                                                ],
                                                [
                                                    279.244,
                                                    29.489
                                                ],
                                                [
                                                    277.977,
                                                    30.917
                                                ],
                                                [
                                                    277.536,
                                                    33.066
                                                ],
                                                [
                                                    278.005,
                                                    35.264
                                                ],
                                                [
                                                    279.321,
                                                    36.657
                                                ],
                                                [
                                                    281.302,
                                                    37.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.215
                                                ],
                                                [
                                                    0.336,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    288.372,
                                                    37
                                                ],
                                                [
                                                    288.372,
                                                    32.324
                                                ],
                                                [
                                                    288.659,
                                                    31.218
                                                ],
                                                [
                                                    289.436,
                                                    30.511
                                                ],
                                                [
                                                    290.5,
                                                    30.266
                                                ],
                                                [
                                                    291.774,
                                                    30.7
                                                ],
                                                [
                                                    292.194,
                                                    31.876
                                                ],
                                                [
                                                    292.194,
                                                    37
                                                ],
                                                [
                                                    293.622,
                                                    37
                                                ],
                                                [
                                                    293.622,
                                                    31.736
                                                ],
                                                [
                                                    292.859,
                                                    29.657
                                                ],
                                                [
                                                    290.906,
                                                    28.978
                                                ],
                                                [
                                                    289.464,
                                                    29.3
                                                ],
                                                [
                                                    288.33,
                                                    30.308
                                                ],
                                                [
                                                    288.246,
                                                    29.118
                                                ],
                                                [
                                                    286.93,
                                                    29.118
                                                ],
                                                [
                                                    286.93,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "d",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "d",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.271,
                                                    -0.602
                                                ],
                                                [
                                                    -0.509,
                                                    -0.331
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.462,
                                                    0.266
                                                ],
                                                [
                                                    -0.224,
                                                    0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    0.243
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    -0.336
                                                ],
                                                [
                                                    0.28,
                                                    -0.621
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.271,
                                                    0.602
                                                ],
                                                [
                                                    0.509,
                                                    0.331
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.462,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.457
                                                ],
                                                [
                                                    -0.439,
                                                    -0.243
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.336
                                                ],
                                                [
                                                    -0.28,
                                                    0.621
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    296.394,
                                                    35.243
                                                ],
                                                [
                                                    297.563,
                                                    36.643
                                                ],
                                                [
                                                    299.362,
                                                    37.14
                                                ],
                                                [
                                                    300.965,
                                                    36.741
                                                ],
                                                [
                                                    301.994,
                                                    35.656
                                                ],
                                                [
                                                    302.092,
                                                    37
                                                ],
                                                [
                                                    303.422,
                                                    37
                                                ],
                                                [
                                                    303.422,
                                                    25.94
                                                ],
                                                [
                                                    301.994,
                                                    25.94
                                                ],
                                                [
                                                    301.994,
                                                    30.392
                                                ],
                                                [
                                                    300.958,
                                                    29.342
                                                ],
                                                [
                                                    299.404,
                                                    28.978
                                                ],
                                                [
                                                    297.598,
                                                    29.482
                                                ],
                                                [
                                                    296.408,
                                                    30.917
                                                ],
                                                [
                                                    295.988,
                                                    33.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "d",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.387,
                                                    0.504
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.201
                                                ],
                                                [
                                                    -0.187,
                                                    -0.369
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    -0.359
                                                ],
                                                [
                                                    0.35,
                                                    -0.201
                                                ],
                                                [
                                                    0.467,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.387,
                                                    -0.504
                                                ],
                                                [
                                                    0.476,
                                                    0
                                                ],
                                                [
                                                    0.345,
                                                    0.201
                                                ],
                                                [
                                                    0.187,
                                                    0.369
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.476
                                                ],
                                                [
                                                    -0.191,
                                                    0.359
                                                ],
                                                [
                                                    -0.35,
                                                    0.201
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.383,
                                                    -0.485
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    298.039,
                                                    30.966
                                                ],
                                                [
                                                    299.684,
                                                    30.21
                                                ],
                                                [
                                                    300.916,
                                                    30.511
                                                ],
                                                [
                                                    301.714,
                                                    31.365
                                                ],
                                                [
                                                    301.994,
                                                    32.674
                                                ],
                                                [
                                                    301.994,
                                                    33.514
                                                ],
                                                [
                                                    301.707,
                                                    34.767
                                                ],
                                                [
                                                    300.895,
                                                    35.607
                                                ],
                                                [
                                                    299.67,
                                                    35.908
                                                ],
                                                [
                                                    298.032,
                                                    35.18
                                                ],
                                                [
                                                    297.458,
                                                    33.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "i",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "i",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    307.678,
                                                    37
                                                ],
                                                [
                                                    307.678,
                                                    29.118
                                                ],
                                                [
                                                    306.236,
                                                    29.118
                                                ],
                                                [
                                                    306.236,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "i",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    307.622,
                                                    27.816
                                                ],
                                                [
                                                    307.622,
                                                    25.996
                                                ],
                                                [
                                                    306.306,
                                                    25.996
                                                ],
                                                [
                                                    306.306,
                                                    27.816
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.215
                                                ],
                                                [
                                                    0.336,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    311.906,
                                                    37
                                                ],
                                                [
                                                    311.906,
                                                    32.324
                                                ],
                                                [
                                                    312.193,
                                                    31.218
                                                ],
                                                [
                                                    312.97,
                                                    30.511
                                                ],
                                                [
                                                    314.034,
                                                    30.266
                                                ],
                                                [
                                                    315.308,
                                                    30.7
                                                ],
                                                [
                                                    315.728,
                                                    31.876
                                                ],
                                                [
                                                    315.728,
                                                    37
                                                ],
                                                [
                                                    317.156,
                                                    37
                                                ],
                                                [
                                                    317.156,
                                                    31.736
                                                ],
                                                [
                                                    316.393,
                                                    29.657
                                                ],
                                                [
                                                    314.44,
                                                    28.978
                                                ],
                                                [
                                                    312.998,
                                                    29.3
                                                ],
                                                [
                                                    311.864,
                                                    30.308
                                                ],
                                                [
                                                    311.78,
                                                    29.118
                                                ],
                                                [
                                                    310.464,
                                                    29.118
                                                ],
                                                [
                                                    310.464,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "g",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "g",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.537,
                                                    0.257
                                                ],
                                                [
                                                    -0.261,
                                                    0.462
                                                ],
                                                [
                                                    0,
                                                    0.607
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.453,
                                                    0.257
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.313
                                                ],
                                                [
                                                    0.257,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    -0.709
                                                ],
                                                [
                                                    -0.261,
                                                    -0.537
                                                ],
                                                [
                                                    -0.49,
                                                    -0.299
                                                ],
                                                [
                                                    -0.663,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.191
                                                ],
                                                [
                                                    -0.243,
                                                    0.429
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.392,
                                                    -0.303
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.089
                                                ],
                                                [
                                                    0.173,
                                                    0.205
                                                ],
                                                [
                                                    0.037,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.546,
                                                    -0.401
                                                ],
                                                [
                                                    -0.924,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.537,
                                                    -0.257
                                                ],
                                                [
                                                    0.261,
                                                    -0.462
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    -0.448
                                                ],
                                                [
                                                    -0.453,
                                                    -0.257
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.313
                                                ],
                                                [
                                                    -0.257,
                                                    0.551
                                                ],
                                                [
                                                    0,
                                                    0.719
                                                ],
                                                [
                                                    0.261,
                                                    0.537
                                                ],
                                                [
                                                    0.49,
                                                    0.299
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.191
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.691
                                                ],
                                                [
                                                    -0.392,
                                                    0.303
                                                ],
                                                [
                                                    -0.327,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.089
                                                ],
                                                [
                                                    -0.173,
                                                    -0.205
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.653
                                                ],
                                                [
                                                    0.546,
                                                    0.401
                                                ],
                                                [
                                                    0.821,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    325.059,
                                                    39.079
                                                ],
                                                [
                                                    326.256,
                                                    38.001
                                                ],
                                                [
                                                    326.648,
                                                    36.398
                                                ],
                                                [
                                                    326.648,
                                                    29.118
                                                ],
                                                [
                                                    325.318,
                                                    29.118
                                                ],
                                                [
                                                    325.234,
                                                    30.42
                                                ],
                                                [
                                                    324.247,
                                                    29.363
                                                ],
                                                [
                                                    322.7,
                                                    28.978
                                                ],
                                                [
                                                    321.006,
                                                    29.447
                                                ],
                                                [
                                                    319.907,
                                                    30.742
                                                ],
                                                [
                                                    319.522,
                                                    32.632
                                                ],
                                                [
                                                    319.914,
                                                    34.515
                                                ],
                                                [
                                                    321.041,
                                                    35.768
                                                ],
                                                [
                                                    322.77,
                                                    36.216
                                                ],
                                                [
                                                    324.24,
                                                    35.929
                                                ],
                                                [
                                                    325.234,
                                                    34.998
                                                ],
                                                [
                                                    325.234,
                                                    36.426
                                                ],
                                                [
                                                    324.646,
                                                    37.917
                                                ],
                                                [
                                                    323.092,
                                                    38.372
                                                ],
                                                [
                                                    322.182,
                                                    38.239
                                                ],
                                                [
                                                    321.503,
                                                    37.798
                                                ],
                                                [
                                                    321.188,
                                                    36.972
                                                ],
                                                [
                                                    319.886,
                                                    37.28
                                                ],
                                                [
                                                    320.817,
                                                    38.862
                                                ],
                                                [
                                                    323.022,
                                                    39.464
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "g",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.355,
                                                    0.471
                                                ],
                                                [
                                                    0,
                                                    0.737
                                                ],
                                                [
                                                    -0.355,
                                                    0.453
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.327,
                                                    -0.191
                                                ],
                                                [
                                                    -0.187,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.182,
                                                    -0.341
                                                ],
                                                [
                                                    0.322,
                                                    -0.201
                                                ],
                                                [
                                                    0.429,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.355,
                                                    -0.471
                                                ],
                                                [
                                                    0,
                                                    -0.747
                                                ],
                                                [
                                                    0.355,
                                                    -0.453
                                                ],
                                                [
                                                    0.439,
                                                    0
                                                ],
                                                [
                                                    0.327,
                                                    0.191
                                                ],
                                                [
                                                    0.187,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    -0.182,
                                                    0.341
                                                ],
                                                [
                                                    -0.322,
                                                    0.201
                                                ],
                                                [
                                                    -0.681,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    321.524,
                                                    34.459
                                                ],
                                                [
                                                    320.992,
                                                    32.646
                                                ],
                                                [
                                                    321.524,
                                                    30.847
                                                ],
                                                [
                                                    323.036,
                                                    30.168
                                                ],
                                                [
                                                    324.184,
                                                    30.455
                                                ],
                                                [
                                                    324.954,
                                                    31.232
                                                ],
                                                [
                                                    325.234,
                                                    32.366
                                                ],
                                                [
                                                    325.234,
                                                    32.898
                                                ],
                                                [
                                                    324.961,
                                                    34.053
                                                ],
                                                [
                                                    324.205,
                                                    34.865
                                                ],
                                                [
                                                    323.078,
                                                    35.166
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    340.27,
                                                    37
                                                ],
                                                [
                                                    340.27,
                                                    35.012
                                                ],
                                                [
                                                    341.838,
                                                    35.012
                                                ],
                                                [
                                                    341.838,
                                                    33.262
                                                ],
                                                [
                                                    340.27,
                                                    33.262
                                                ],
                                                [
                                                    340.27,
                                                    26.794
                                                ],
                                                [
                                                    338.184,
                                                    26.794
                                                ],
                                                [
                                                    333.13,
                                                    33.388
                                                ],
                                                [
                                                    333.13,
                                                    35.012
                                                ],
                                                [
                                                    338.1,
                                                    35.012
                                                ],
                                                [
                                                    338.1,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    338.1,
                                                    29.622
                                                ],
                                                [
                                                    338.1,
                                                    33.262
                                                ],
                                                [
                                                    335.356,
                                                    33.262
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    350.588,
                                                    37
                                                ],
                                                [
                                                    350.588,
                                                    35.012
                                                ],
                                                [
                                                    352.156,
                                                    35.012
                                                ],
                                                [
                                                    352.156,
                                                    33.262
                                                ],
                                                [
                                                    350.588,
                                                    33.262
                                                ],
                                                [
                                                    350.588,
                                                    26.794
                                                ],
                                                [
                                                    348.502,
                                                    26.794
                                                ],
                                                [
                                                    343.448,
                                                    33.388
                                                ],
                                                [
                                                    343.448,
                                                    35.012
                                                ],
                                                [
                                                    348.418,
                                                    35.012
                                                ],
                                                [
                                                    348.418,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    348.418,
                                                    29.622
                                                ],
                                                [
                                                    348.418,
                                                    33.262
                                                ],
                                                [
                                                    345.674,
                                                    33.262
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.401,
                                                    -0.378
                                                ],
                                                [
                                                    0.765,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.121,
                                                    0.653
                                                ],
                                                [
                                                    -0.401,
                                                    0.378
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    358.092,
                                                    37
                                                ],
                                                [
                                                    358.092,
                                                    26.794
                                                ],
                                                [
                                                    356.496,
                                                    26.794
                                                ],
                                                [
                                                    355.712,
                                                    28.341
                                                ],
                                                [
                                                    353.962,
                                                    28.908
                                                ],
                                                [
                                                    353.696,
                                                    28.908
                                                ],
                                                [
                                                    353.696,
                                                    30.434
                                                ],
                                                [
                                                    355.922,
                                                    30.434
                                                ],
                                                [
                                                    355.922,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.07,
                                                    0.555
                                                ],
                                                [
                                                    -0.149,
                                                    0.509
                                                ],
                                                [
                                                    -0.257,
                                                    0.499
                                                ],
                                                [
                                                    -0.378,
                                                    0.555
                                                ],
                                                [
                                                    -0.532,
                                                    0.663
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.527
                                                ],
                                                [
                                                    0.261,
                                                    -0.499
                                                ],
                                                [
                                                    0.163,
                                                    -0.513
                                                ],
                                                [
                                                    0.075,
                                                    -0.583
                                                ],
                                                [
                                                    -0.009,
                                                    -0.691
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.009,
                                                    -0.681
                                                ],
                                                [
                                                    0.07,
                                                    -0.555
                                                ],
                                                [
                                                    0.149,
                                                    -0.509
                                                ],
                                                [
                                                    0.257,
                                                    -0.499
                                                ],
                                                [
                                                    0.378,
                                                    -0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.597
                                                ],
                                                [
                                                    -0.383,
                                                    0.527
                                                ],
                                                [
                                                    -0.261,
                                                    0.499
                                                ],
                                                [
                                                    -0.163,
                                                    0.513
                                                ],
                                                [
                                                    -0.075,
                                                    0.583
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    364.924,
                                                    37
                                                ],
                                                [
                                                    365.043,
                                                    35.145
                                                ],
                                                [
                                                    365.372,
                                                    33.549
                                                ],
                                                [
                                                    365.981,
                                                    32.037
                                                ],
                                                [
                                                    366.933,
                                                    30.455
                                                ],
                                                [
                                                    368.298,
                                                    28.628
                                                ],
                                                [
                                                    368.298,
                                                    26.794
                                                ],
                                                [
                                                    360.612,
                                                    26.794
                                                ],
                                                [
                                                    360.612,
                                                    28.698
                                                ],
                                                [
                                                    366.114,
                                                    28.698
                                                ],
                                                [
                                                    364.77,
                                                    30.385
                                                ],
                                                [
                                                    363.804,
                                                    31.925
                                                ],
                                                [
                                                    363.167,
                                                    33.444
                                                ],
                                                [
                                                    362.81,
                                                    35.089
                                                ],
                                                [
                                                    362.712,
                                                    37
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": ",",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": ",",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.243,
                                                    0.205
                                                ],
                                                [
                                                    0,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.084,
                                                    -0.117
                                                ],
                                                [
                                                    0.243,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.392,
                                                    0
                                                ],
                                                [
                                                    0.243,
                                                    -0.205
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.177
                                                ],
                                                [
                                                    -0.084,
                                                    0.117
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    370.454,
                                                    38.932
                                                ],
                                                [
                                                    371.406,
                                                    38.624
                                                ],
                                                [
                                                    371.77,
                                                    37.658
                                                ],
                                                [
                                                    371.77,
                                                    35.404
                                                ],
                                                [
                                                    370.3,
                                                    35.404
                                                ],
                                                [
                                                    370.3,
                                                    37
                                                ],
                                                [
                                                    371.028,
                                                    37
                                                ],
                                                [
                                                    371.028,
                                                    37.532
                                                ],
                                                [
                                                    370.902,
                                                    37.973
                                                ],
                                                [
                                                    370.412,
                                                    38.148
                                                ],
                                                [
                                                    370.174,
                                                    38.148
                                                ],
                                                [
                                                    370.174,
                                                    38.932
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "c",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "c",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.476,
                                                    0.21
                                                ],
                                                [
                                                    -0.303,
                                                    0.401
                                                ],
                                                [
                                                    -0.075,
                                                    0.569
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.28
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.401,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.877
                                                ],
                                                [
                                                    -0.406,
                                                    0.499
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    -0.271
                                                ],
                                                [
                                                    -0.056,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.499
                                                ],
                                                [
                                                    0.952,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.336
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.476,
                                                    -0.21
                                                ],
                                                [
                                                    0.303,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.056,
                                                    0.513
                                                ],
                                                [
                                                    -0.355,
                                                    0.28
                                                ],
                                                [
                                                    -0.7,
                                                    0
                                                ],
                                                [
                                                    -0.401,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.812
                                                ],
                                                [
                                                    -0.583,
                                                    -0.499
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.336
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.936,
                                                    56.811
                                                ],
                                                [
                                                    7.105,
                                                    55.894
                                                ],
                                                [
                                                    7.672,
                                                    54.438
                                                ],
                                                [
                                                    6.272,
                                                    54.27
                                                ],
                                                [
                                                    5.656,
                                                    55.46
                                                ],
                                                [
                                                    4.298,
                                                    55.88
                                                ],
                                                [
                                                    2.646,
                                                    55.124
                                                ],
                                                [
                                                    2.044,
                                                    53.052
                                                ],
                                                [
                                                    2.653,
                                                    50.973
                                                ],
                                                [
                                                    4.298,
                                                    50.224
                                                ],
                                                [
                                                    5.656,
                                                    50.63
                                                ],
                                                [
                                                    6.272,
                                                    51.862
                                                ],
                                                [
                                                    7.672,
                                                    51.694
                                                ],
                                                [
                                                    6.643,
                                                    49.727
                                                ],
                                                [
                                                    4.34,
                                                    48.978
                                                ],
                                                [
                                                    2.359,
                                                    49.482
                                                ],
                                                [
                                                    1.043,
                                                    50.903
                                                ],
                                                [
                                                    0.574,
                                                    53.052
                                                ],
                                                [
                                                    1.036,
                                                    55.187
                                                ],
                                                [
                                                    2.338,
                                                    56.615
                                                ],
                                                [
                                                    4.312,
                                                    57.126
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.56,
                                                    0.336
                                                ],
                                                [
                                                    -0.308,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.341
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    -0.308,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.341
                                                ],
                                                [
                                                    -0.765,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.56,
                                                    -0.336
                                                ],
                                                [
                                                    0.308,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.341
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.26,
                                                    56.636
                                                ],
                                                [
                                                    16.562,
                                                    55.215
                                                ],
                                                [
                                                    17.024,
                                                    53.066
                                                ],
                                                [
                                                    16.562,
                                                    50.917
                                                ],
                                                [
                                                    15.26,
                                                    49.489
                                                ],
                                                [
                                                    13.286,
                                                    48.978
                                                ],
                                                [
                                                    11.305,
                                                    49.489
                                                ],
                                                [
                                                    9.989,
                                                    50.917
                                                ],
                                                [
                                                    9.52,
                                                    53.08
                                                ],
                                                [
                                                    9.982,
                                                    55.208
                                                ],
                                                [
                                                    11.291,
                                                    56.629
                                                ],
                                                [
                                                    13.286,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.406,
                                                    0.499
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.509
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    0.406,
                                                    -0.504
                                                ],
                                                [
                                                    0.728,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.509
                                                ],
                                                [
                                                    0.719,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    0.495
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.504
                                                ],
                                                [
                                                    -0.728,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.571,
                                                    55.159
                                                ],
                                                [
                                                    10.962,
                                                    53.066
                                                ],
                                                [
                                                    11.571,
                                                    50.973
                                                ],
                                                [
                                                    13.286,
                                                    50.21
                                                ],
                                                [
                                                    14.973,
                                                    50.952
                                                ],
                                                [
                                                    15.582,
                                                    53.052
                                                ],
                                                [
                                                    14.973,
                                                    55.152
                                                ],
                                                [
                                                    13.272,
                                                    55.908
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "m",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "m",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.168,
                                                    0.322
                                                ],
                                                [
                                                    -0.299,
                                                    0.187
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.243,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.173,
                                                    0.331
                                                ],
                                                [
                                                    -0.308,
                                                    0.177
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    0.49
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.462,
                                                    -0.275
                                                ],
                                                [
                                                    0.243,
                                                    -0.523
                                                ],
                                                [
                                                    0.42,
                                                    0.271
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.229
                                                ],
                                                [
                                                    0.261,
                                                    -0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    0.168,
                                                    -0.322
                                                ],
                                                [
                                                    0.299,
                                                    -0.187
                                                ],
                                                [
                                                    0.523,
                                                    0
                                                ],
                                                [
                                                    0.243,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    0.173,
                                                    -0.331
                                                ],
                                                [
                                                    0.308,
                                                    -0.177
                                                ],
                                                [
                                                    0.485,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.812
                                                ],
                                                [
                                                    -0.448,
                                                    -0.49
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.462,
                                                    0.275
                                                ],
                                                [
                                                    -0.196,
                                                    -0.532
                                                ],
                                                [
                                                    -0.42,
                                                    -0.271
                                                ],
                                                [
                                                    -0.485,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.832,
                                                    57
                                                ],
                                                [
                                                    20.832,
                                                    52.408
                                                ],
                                                [
                                                    21.084,
                                                    51.309
                                                ],
                                                [
                                                    21.784,
                                                    50.546
                                                ],
                                                [
                                                    22.82,
                                                    50.266
                                                ],
                                                [
                                                    23.968,
                                                    50.756
                                                ],
                                                [
                                                    24.332,
                                                    52.03
                                                ],
                                                [
                                                    24.332,
                                                    57
                                                ],
                                                [
                                                    25.76,
                                                    57
                                                ],
                                                [
                                                    25.76,
                                                    52.478
                                                ],
                                                [
                                                    26.019,
                                                    51.295
                                                ],
                                                [
                                                    26.74,
                                                    50.532
                                                ],
                                                [
                                                    27.79,
                                                    50.266
                                                ],
                                                [
                                                    28.896,
                                                    50.693
                                                ],
                                                [
                                                    29.274,
                                                    51.904
                                                ],
                                                [
                                                    29.274,
                                                    57
                                                ],
                                                [
                                                    30.716,
                                                    57
                                                ],
                                                [
                                                    30.716,
                                                    51.666
                                                ],
                                                [
                                                    30.044,
                                                    49.713
                                                ],
                                                [
                                                    28.112,
                                                    48.978
                                                ],
                                                [
                                                    26.593,
                                                    49.391
                                                ],
                                                [
                                                    25.536,
                                                    50.588
                                                ],
                                                [
                                                    24.612,
                                                    49.384
                                                ],
                                                [
                                                    23.17,
                                                    48.978
                                                ],
                                                [
                                                    21.812,
                                                    49.321
                                                ],
                                                [
                                                    20.79,
                                                    50.378
                                                ],
                                                [
                                                    20.692,
                                                    49.118
                                                ],
                                                [
                                                    19.39,
                                                    49.118
                                                ],
                                                [
                                                    19.39,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "p",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "p",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.453,
                                                    -0.238
                                                ],
                                                [
                                                    -0.56,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.341
                                                ],
                                                [
                                                    -0.28,
                                                    0.621
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0.275,
                                                    0.602
                                                ],
                                                [
                                                    0.504,
                                                    0.327
                                                ],
                                                [
                                                    0.7,
                                                    0
                                                ],
                                                [
                                                    0.467,
                                                    -0.261
                                                ],
                                                [
                                                    0.224,
                                                    -0.467
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.261,
                                                    0.476
                                                ],
                                                [
                                                    0.453,
                                                    0.238
                                                ],
                                                [
                                                    0.691,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    -0.341
                                                ],
                                                [
                                                    0.28,
                                                    -0.621
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.275,
                                                    -0.602
                                                ],
                                                [
                                                    -0.504,
                                                    -0.327
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.467,
                                                    0.261
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    34.93,
                                                    59.338
                                                ],
                                                [
                                                    34.93,
                                                    55.712
                                                ],
                                                [
                                                    36.001,
                                                    56.783
                                                ],
                                                [
                                                    37.52,
                                                    57.14
                                                ],
                                                [
                                                    39.326,
                                                    56.629
                                                ],
                                                [
                                                    40.516,
                                                    55.187
                                                ],
                                                [
                                                    40.936,
                                                    52.996
                                                ],
                                                [
                                                    40.523,
                                                    50.861
                                                ],
                                                [
                                                    39.354,
                                                    49.468
                                                ],
                                                [
                                                    37.548,
                                                    48.978
                                                ],
                                                [
                                                    35.952,
                                                    49.37
                                                ],
                                                [
                                                    34.916,
                                                    50.462
                                                ],
                                                [
                                                    34.818,
                                                    49.118
                                                ],
                                                [
                                                    33.502,
                                                    49.118
                                                ],
                                                [
                                                    33.502,
                                                    59.338
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "p",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.359
                                                ],
                                                [
                                                    -0.35,
                                                    0.196
                                                ],
                                                [
                                                    -0.457,
                                                    0
                                                ],
                                                [
                                                    -0.387,
                                                    -0.485
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.387,
                                                    -0.499
                                                ],
                                                [
                                                    0.719,
                                                    0
                                                ],
                                                [
                                                    0.345,
                                                    0.201
                                                ],
                                                [
                                                    0.187,
                                                    0.369
                                                ],
                                                [
                                                    0,
                                                    0.495
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.485
                                                ],
                                                [
                                                    0.191,
                                                    -0.359
                                                ],
                                                [
                                                    0.35,
                                                    -0.196
                                                ],
                                                [
                                                    0.709,
                                                    0
                                                ],
                                                [
                                                    0.387,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0.933
                                                ],
                                                [
                                                    -0.387,
                                                    0.499
                                                ],
                                                [
                                                    -0.467,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.201
                                                ],
                                                [
                                                    -0.187,
                                                    -0.369
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    34.93,
                                                    52.604
                                                ],
                                                [
                                                    35.217,
                                                    51.337
                                                ],
                                                [
                                                    36.029,
                                                    50.504
                                                ],
                                                [
                                                    37.24,
                                                    50.21
                                                ],
                                                [
                                                    38.885,
                                                    50.938
                                                ],
                                                [
                                                    39.466,
                                                    52.996
                                                ],
                                                [
                                                    38.885,
                                                    55.145
                                                ],
                                                [
                                                    37.226,
                                                    55.894
                                                ],
                                                [
                                                    36.008,
                                                    55.593
                                                ],
                                                [
                                                    35.21,
                                                    54.739
                                                ],
                                                [
                                                    34.93,
                                                    53.444
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "l",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "l",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.73,
                                                    57
                                                ],
                                                [
                                                    44.73,
                                                    45.94
                                                ],
                                                [
                                                    43.302,
                                                    45.94
                                                ],
                                                [
                                                    43.302,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.271
                                                ],
                                                [
                                                    -0.196,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    -0.196
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.019
                                                ],
                                                [
                                                    -0.093,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.355
                                                ],
                                                [
                                                    0.453,
                                                    0.173
                                                ],
                                                [
                                                    0.653,
                                                    0
                                                ],
                                                [
                                                    0.602,
                                                    -0.415
                                                ],
                                                [
                                                    0.019,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    0.233
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.327
                                                ],
                                                [
                                                    0.131,
                                                    -0.154
                                                ],
                                                [
                                                    0.42,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.182
                                                ],
                                                [
                                                    0.238,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.453,
                                                    -0.406
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.247,
                                                    0.196
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.532
                                                ],
                                                [
                                                    -0.238,
                                                    -0.355
                                                ],
                                                [
                                                    -0.453,
                                                    -0.173
                                                ],
                                                [
                                                    -0.98,
                                                    0
                                                ],
                                                [
                                                    -0.602,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    -0.485
                                                ],
                                                [
                                                    0.355,
                                                    -0.233
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.252
                                                ],
                                                [
                                                    -0.131,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.084
                                                ],
                                                [
                                                    -0.383,
                                                    0.182
                                                ],
                                                [
                                                    -0.238,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0.653
                                                ],
                                                [
                                                    0.453,
                                                    0.406
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    51.464,
                                                    56.734
                                                ],
                                                [
                                                    52.528,
                                                    55.67
                                                ],
                                                [
                                                    52.528,
                                                    55.922
                                                ],
                                                [
                                                    52.899,
                                                    56.818
                                                ],
                                                [
                                                    53.872,
                                                    57.112
                                                ],
                                                [
                                                    54.215,
                                                    57.084
                                                ],
                                                [
                                                    54.586,
                                                    57
                                                ],
                                                [
                                                    54.586,
                                                    55.978
                                                ],
                                                [
                                                    54.502,
                                                    55.978
                                                ],
                                                [
                                                    54.432,
                                                    55.999
                                                ],
                                                [
                                                    54.264,
                                                    56.006
                                                ],
                                                [
                                                    53.928,
                                                    55.88
                                                ],
                                                [
                                                    53.774,
                                                    55.334
                                                ],
                                                [
                                                    53.774,
                                                    51.358
                                                ],
                                                [
                                                    53.417,
                                                    50.028
                                                ],
                                                [
                                                    52.381,
                                                    49.237
                                                ],
                                                [
                                                    50.722,
                                                    48.978
                                                ],
                                                [
                                                    48.349,
                                                    49.601
                                                ],
                                                [
                                                    47.418,
                                                    51.386
                                                ],
                                                [
                                                    48.776,
                                                    51.526
                                                ],
                                                [
                                                    49.294,
                                                    50.448
                                                ],
                                                [
                                                    50.722,
                                                    50.098
                                                ],
                                                [
                                                    51.996,
                                                    50.427
                                                ],
                                                [
                                                    52.346,
                                                    51.246
                                                ],
                                                [
                                                    52.15,
                                                    51.855
                                                ],
                                                [
                                                    51.324,
                                                    52.198
                                                ],
                                                [
                                                    49.672,
                                                    52.506
                                                ],
                                                [
                                                    48.426,
                                                    52.905
                                                ],
                                                [
                                                    47.495,
                                                    53.668
                                                ],
                                                [
                                                    47.138,
                                                    54.942
                                                ],
                                                [
                                                    47.817,
                                                    56.531
                                                ],
                                                [
                                                    49.728,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.28,
                                                    0.187
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    -0.191,
                                                    0.233
                                                ],
                                                [
                                                    -0.588,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.056
                                                ],
                                                [
                                                    -0.093,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.238
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.28,
                                                    -0.187
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    0.191,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.075
                                                ],
                                                [
                                                    0.201,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.429
                                                ],
                                                [
                                                    -0.406,
                                                    0.238
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    49.028,
                                                    55.712
                                                ],
                                                [
                                                    48.608,
                                                    54.83
                                                ],
                                                [
                                                    48.895,
                                                    54.074
                                                ],
                                                [
                                                    50.064,
                                                    53.542
                                                ],
                                                [
                                                    51.226,
                                                    53.304
                                                ],
                                                [
                                                    52.073,
                                                    53.108
                                                ],
                                                [
                                                    52.514,
                                                    52.884
                                                ],
                                                [
                                                    52.36,
                                                    52.828
                                                ],
                                                [
                                                    52.36,
                                                    54.634
                                                ],
                                                [
                                                    51.541,
                                                    55.635
                                                ],
                                                [
                                                    50.092,
                                                    55.992
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "i",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "i",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    57.904,
                                                    57
                                                ],
                                                [
                                                    57.904,
                                                    49.118
                                                ],
                                                [
                                                    56.462,
                                                    49.118
                                                ],
                                                [
                                                    56.462,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "i",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    57.848,
                                                    47.816
                                                ],
                                                [
                                                    57.848,
                                                    45.996
                                                ],
                                                [
                                                    56.532,
                                                    45.996
                                                ],
                                                [
                                                    56.532,
                                                    47.816
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.215
                                                ],
                                                [
                                                    0.336,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    62.132,
                                                    57
                                                ],
                                                [
                                                    62.132,
                                                    52.324
                                                ],
                                                [
                                                    62.419,
                                                    51.218
                                                ],
                                                [
                                                    63.196,
                                                    50.511
                                                ],
                                                [
                                                    64.26,
                                                    50.266
                                                ],
                                                [
                                                    65.534,
                                                    50.7
                                                ],
                                                [
                                                    65.954,
                                                    51.876
                                                ],
                                                [
                                                    65.954,
                                                    57
                                                ],
                                                [
                                                    67.382,
                                                    57
                                                ],
                                                [
                                                    67.382,
                                                    51.736
                                                ],
                                                [
                                                    66.619,
                                                    49.657
                                                ],
                                                [
                                                    64.666,
                                                    48.978
                                                ],
                                                [
                                                    63.224,
                                                    49.3
                                                ],
                                                [
                                                    62.09,
                                                    50.308
                                                ],
                                                [
                                                    62.006,
                                                    49.118
                                                ],
                                                [
                                                    60.69,
                                                    49.118
                                                ],
                                                [
                                                    60.69,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    75.124,
                                                    56.839
                                                ],
                                                [
                                                    76.272,
                                                    56.006
                                                ],
                                                [
                                                    76.86,
                                                    54.76
                                                ],
                                                [
                                                    75.586,
                                                    54.466
                                                ],
                                                [
                                                    74.928,
                                                    55.558
                                                ],
                                                [
                                                    73.528,
                                                    55.95
                                                ],
                                                [
                                                    71.778,
                                                    55.229
                                                ],
                                                [
                                                    71.162,
                                                    53.038
                                                ],
                                                [
                                                    71.806,
                                                    50.798
                                                ],
                                                [
                                                    73.43,
                                                    50.112
                                                ],
                                                [
                                                    75.089,
                                                    50.868
                                                ],
                                                [
                                                    75.446,
                                                    52.842
                                                ],
                                                [
                                                    76.104,
                                                    52.338
                                                ],
                                                [
                                                    70.994,
                                                    52.338
                                                ],
                                                [
                                                    70.994,
                                                    53.416
                                                ],
                                                [
                                                    76.958,
                                                    53.416
                                                ],
                                                [
                                                    76.636,
                                                    50.945
                                                ],
                                                [
                                                    75.397,
                                                    49.468
                                                ],
                                                [
                                                    73.458,
                                                    48.978
                                                ],
                                                [
                                                    71.456,
                                                    49.489
                                                ],
                                                [
                                                    70.189,
                                                    50.917
                                                ],
                                                [
                                                    69.748,
                                                    53.066
                                                ],
                                                [
                                                    70.217,
                                                    55.264
                                                ],
                                                [
                                                    71.533,
                                                    56.657
                                                ],
                                                [
                                                    73.514,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "d",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "d",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.271,
                                                    -0.602
                                                ],
                                                [
                                                    -0.509,
                                                    -0.331
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.462,
                                                    0.266
                                                ],
                                                [
                                                    -0.224,
                                                    0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    0.243
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    -0.336
                                                ],
                                                [
                                                    0.28,
                                                    -0.621
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.271,
                                                    0.602
                                                ],
                                                [
                                                    0.509,
                                                    0.331
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.462,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.457
                                                ],
                                                [
                                                    -0.439,
                                                    -0.243
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.336
                                                ],
                                                [
                                                    -0.28,
                                                    0.621
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    79.128,
                                                    55.243
                                                ],
                                                [
                                                    80.297,
                                                    56.643
                                                ],
                                                [
                                                    82.096,
                                                    57.14
                                                ],
                                                [
                                                    83.699,
                                                    56.741
                                                ],
                                                [
                                                    84.728,
                                                    55.656
                                                ],
                                                [
                                                    84.826,
                                                    57
                                                ],
                                                [
                                                    86.156,
                                                    57
                                                ],
                                                [
                                                    86.156,
                                                    45.94
                                                ],
                                                [
                                                    84.728,
                                                    45.94
                                                ],
                                                [
                                                    84.728,
                                                    50.392
                                                ],
                                                [
                                                    83.692,
                                                    49.342
                                                ],
                                                [
                                                    82.138,
                                                    48.978
                                                ],
                                                [
                                                    80.332,
                                                    49.482
                                                ],
                                                [
                                                    79.142,
                                                    50.917
                                                ],
                                                [
                                                    78.722,
                                                    53.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "d",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.387,
                                                    0.504
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.201
                                                ],
                                                [
                                                    -0.187,
                                                    -0.369
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    -0.359
                                                ],
                                                [
                                                    0.35,
                                                    -0.201
                                                ],
                                                [
                                                    0.467,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.387,
                                                    -0.504
                                                ],
                                                [
                                                    0.476,
                                                    0
                                                ],
                                                [
                                                    0.345,
                                                    0.201
                                                ],
                                                [
                                                    0.187,
                                                    0.369
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.476
                                                ],
                                                [
                                                    -0.191,
                                                    0.359
                                                ],
                                                [
                                                    -0.35,
                                                    0.201
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.383,
                                                    -0.485
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    80.773,
                                                    50.966
                                                ],
                                                [
                                                    82.418,
                                                    50.21
                                                ],
                                                [
                                                    83.65,
                                                    50.511
                                                ],
                                                [
                                                    84.448,
                                                    51.365
                                                ],
                                                [
                                                    84.728,
                                                    52.674
                                                ],
                                                [
                                                    84.728,
                                                    53.514
                                                ],
                                                [
                                                    84.441,
                                                    54.767
                                                ],
                                                [
                                                    83.629,
                                                    55.607
                                                ],
                                                [
                                                    82.404,
                                                    55.908
                                                ],
                                                [
                                                    80.766,
                                                    55.18
                                                ],
                                                [
                                                    80.192,
                                                    53.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.271
                                                ],
                                                [
                                                    -0.196,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    -0.196
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.019
                                                ],
                                                [
                                                    -0.093,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.355
                                                ],
                                                [
                                                    0.453,
                                                    0.173
                                                ],
                                                [
                                                    0.653,
                                                    0
                                                ],
                                                [
                                                    0.602,
                                                    -0.415
                                                ],
                                                [
                                                    0.019,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    0.233
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.327
                                                ],
                                                [
                                                    0.131,
                                                    -0.154
                                                ],
                                                [
                                                    0.42,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.182
                                                ],
                                                [
                                                    0.238,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.453,
                                                    -0.406
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.247,
                                                    0.196
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.532
                                                ],
                                                [
                                                    -0.238,
                                                    -0.355
                                                ],
                                                [
                                                    -0.453,
                                                    -0.173
                                                ],
                                                [
                                                    -0.98,
                                                    0
                                                ],
                                                [
                                                    -0.602,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    -0.485
                                                ],
                                                [
                                                    0.355,
                                                    -0.233
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.252
                                                ],
                                                [
                                                    -0.131,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.084
                                                ],
                                                [
                                                    -0.383,
                                                    0.182
                                                ],
                                                [
                                                    -0.238,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0.653
                                                ],
                                                [
                                                    0.453,
                                                    0.406
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    97.048,
                                                    56.734
                                                ],
                                                [
                                                    98.112,
                                                    55.67
                                                ],
                                                [
                                                    98.112,
                                                    55.922
                                                ],
                                                [
                                                    98.483,
                                                    56.818
                                                ],
                                                [
                                                    99.456,
                                                    57.112
                                                ],
                                                [
                                                    99.799,
                                                    57.084
                                                ],
                                                [
                                                    100.17,
                                                    57
                                                ],
                                                [
                                                    100.17,
                                                    55.978
                                                ],
                                                [
                                                    100.086,
                                                    55.978
                                                ],
                                                [
                                                    100.016,
                                                    55.999
                                                ],
                                                [
                                                    99.848,
                                                    56.006
                                                ],
                                                [
                                                    99.512,
                                                    55.88
                                                ],
                                                [
                                                    99.358,
                                                    55.334
                                                ],
                                                [
                                                    99.358,
                                                    51.358
                                                ],
                                                [
                                                    99.001,
                                                    50.028
                                                ],
                                                [
                                                    97.965,
                                                    49.237
                                                ],
                                                [
                                                    96.306,
                                                    48.978
                                                ],
                                                [
                                                    93.933,
                                                    49.601
                                                ],
                                                [
                                                    93.002,
                                                    51.386
                                                ],
                                                [
                                                    94.36,
                                                    51.526
                                                ],
                                                [
                                                    94.878,
                                                    50.448
                                                ],
                                                [
                                                    96.306,
                                                    50.098
                                                ],
                                                [
                                                    97.58,
                                                    50.427
                                                ],
                                                [
                                                    97.93,
                                                    51.246
                                                ],
                                                [
                                                    97.734,
                                                    51.855
                                                ],
                                                [
                                                    96.908,
                                                    52.198
                                                ],
                                                [
                                                    95.256,
                                                    52.506
                                                ],
                                                [
                                                    94.01,
                                                    52.905
                                                ],
                                                [
                                                    93.079,
                                                    53.668
                                                ],
                                                [
                                                    92.722,
                                                    54.942
                                                ],
                                                [
                                                    93.401,
                                                    56.531
                                                ],
                                                [
                                                    95.312,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.28,
                                                    0.187
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    -0.191,
                                                    0.233
                                                ],
                                                [
                                                    -0.588,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.056
                                                ],
                                                [
                                                    -0.093,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.238
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.28,
                                                    -0.187
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    0.191,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.075
                                                ],
                                                [
                                                    0.201,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.429
                                                ],
                                                [
                                                    -0.406,
                                                    0.238
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    94.612,
                                                    55.712
                                                ],
                                                [
                                                    94.192,
                                                    54.83
                                                ],
                                                [
                                                    94.479,
                                                    54.074
                                                ],
                                                [
                                                    95.648,
                                                    53.542
                                                ],
                                                [
                                                    96.81,
                                                    53.304
                                                ],
                                                [
                                                    97.657,
                                                    53.108
                                                ],
                                                [
                                                    98.098,
                                                    52.884
                                                ],
                                                [
                                                    97.944,
                                                    52.828
                                                ],
                                                [
                                                    97.944,
                                                    54.634
                                                ],
                                                [
                                                    97.125,
                                                    55.635
                                                ],
                                                [
                                                    95.676,
                                                    55.992
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "b",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "b",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.467,
                                                    -0.266
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.504,
                                                    0.331
                                                ],
                                                [
                                                    -0.275,
                                                    0.602
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.28,
                                                    0.621
                                                ],
                                                [
                                                    0.513,
                                                    0.336
                                                ],
                                                [
                                                    0.691,
                                                    0
                                                ],
                                                [
                                                    0.443,
                                                    -0.233
                                                ],
                                                [
                                                    0.271,
                                                    -0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    0.457
                                                ],
                                                [
                                                    0.467,
                                                    0.266
                                                ],
                                                [
                                                    0.7,
                                                    0
                                                ],
                                                [
                                                    0.504,
                                                    -0.331
                                                ],
                                                [
                                                    0.275,
                                                    -0.602
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ],
                                                [
                                                    -0.28,
                                                    -0.621
                                                ],
                                                [
                                                    -0.513,
                                                    -0.336
                                                ],
                                                [
                                                    -0.569,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    103.362,
                                                    57
                                                ],
                                                [
                                                    103.46,
                                                    55.656
                                                ],
                                                [
                                                    104.496,
                                                    56.741
                                                ],
                                                [
                                                    106.092,
                                                    57.14
                                                ],
                                                [
                                                    107.898,
                                                    56.643
                                                ],
                                                [
                                                    109.067,
                                                    55.243
                                                ],
                                                [
                                                    109.48,
                                                    53.108
                                                ],
                                                [
                                                    109.06,
                                                    50.917
                                                ],
                                                [
                                                    107.87,
                                                    49.482
                                                ],
                                                [
                                                    106.064,
                                                    48.978
                                                ],
                                                [
                                                    104.545,
                                                    49.328
                                                ],
                                                [
                                                    103.474,
                                                    50.392
                                                ],
                                                [
                                                    103.474,
                                                    45.94
                                                ],
                                                [
                                                    102.046,
                                                    45.94
                                                ],
                                                [
                                                    102.046,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "b",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.187,
                                                    0.369
                                                ],
                                                [
                                                    -0.345,
                                                    0.201
                                                ],
                                                [
                                                    -0.467,
                                                    0
                                                ],
                                                [
                                                    -0.387,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ],
                                                [
                                                    0.387,
                                                    -0.49
                                                ],
                                                [
                                                    0.709,
                                                    0
                                                ],
                                                [
                                                    0.345,
                                                    0.191
                                                ],
                                                [
                                                    0.196,
                                                    0.35
                                                ],
                                                [
                                                    0,
                                                    0.457
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0.187,
                                                    -0.369
                                                ],
                                                [
                                                    0.345,
                                                    -0.201
                                                ],
                                                [
                                                    0.719,
                                                    0
                                                ],
                                                [
                                                    0.387,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.887
                                                ],
                                                [
                                                    -0.387,
                                                    0.49
                                                ],
                                                [
                                                    -0.457,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.191
                                                ],
                                                [
                                                    -0.196,
                                                    -0.35
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    103.474,
                                                    52.674
                                                ],
                                                [
                                                    103.754,
                                                    51.365
                                                ],
                                                [
                                                    104.552,
                                                    50.511
                                                ],
                                                [
                                                    105.77,
                                                    50.21
                                                ],
                                                [
                                                    107.429,
                                                    50.966
                                                ],
                                                [
                                                    108.01,
                                                    53.108
                                                ],
                                                [
                                                    107.429,
                                                    55.173
                                                ],
                                                [
                                                    105.784,
                                                    55.908
                                                ],
                                                [
                                                    104.58,
                                                    55.621
                                                ],
                                                [
                                                    103.768,
                                                    54.809
                                                ],
                                                [
                                                    103.474,
                                                    53.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.56,
                                                    0.336
                                                ],
                                                [
                                                    -0.308,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.341
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    -0.308,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.341
                                                ],
                                                [
                                                    -0.765,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.56,
                                                    -0.336
                                                ],
                                                [
                                                    0.308,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.341
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    117.166,
                                                    56.636
                                                ],
                                                [
                                                    118.468,
                                                    55.215
                                                ],
                                                [
                                                    118.93,
                                                    53.066
                                                ],
                                                [
                                                    118.468,
                                                    50.917
                                                ],
                                                [
                                                    117.166,
                                                    49.489
                                                ],
                                                [
                                                    115.192,
                                                    48.978
                                                ],
                                                [
                                                    113.211,
                                                    49.489
                                                ],
                                                [
                                                    111.895,
                                                    50.917
                                                ],
                                                [
                                                    111.426,
                                                    53.08
                                                ],
                                                [
                                                    111.888,
                                                    55.208
                                                ],
                                                [
                                                    113.197,
                                                    56.629
                                                ],
                                                [
                                                    115.192,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.406,
                                                    0.499
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.509
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    0.406,
                                                    -0.504
                                                ],
                                                [
                                                    0.728,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.509
                                                ],
                                                [
                                                    0.719,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    0.495
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.504
                                                ],
                                                [
                                                    -0.728,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    113.477,
                                                    55.159
                                                ],
                                                [
                                                    112.868,
                                                    53.066
                                                ],
                                                [
                                                    113.477,
                                                    50.973
                                                ],
                                                [
                                                    115.192,
                                                    50.21
                                                ],
                                                [
                                                    116.879,
                                                    50.952
                                                ],
                                                [
                                                    117.488,
                                                    53.052
                                                ],
                                                [
                                                    116.879,
                                                    55.152
                                                ],
                                                [
                                                    115.178,
                                                    55.908
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "u",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.434,
                                                    0.238
                                                ],
                                                [
                                                    -0.243,
                                                    0.411
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.173,
                                                    -0.294
                                                ],
                                                [
                                                    0.313,
                                                    -0.168
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    -0.49
                                                ],
                                                [
                                                    -0.905,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.434,
                                                    -0.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.392
                                                ],
                                                [
                                                    -0.173,
                                                    0.294
                                                ],
                                                [
                                                    -0.313,
                                                    0.168
                                                ],
                                                [
                                                    -0.495,
                                                    0
                                                ],
                                                [
                                                    -0.299,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.476,
                                                    0.49
                                                ],
                                                [
                                                    0.504,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    125.489,
                                                    56.783
                                                ],
                                                [
                                                    126.504,
                                                    55.81
                                                ],
                                                [
                                                    126.574,
                                                    57
                                                ],
                                                [
                                                    127.904,
                                                    57
                                                ],
                                                [
                                                    127.904,
                                                    49.118
                                                ],
                                                [
                                                    126.462,
                                                    49.118
                                                ],
                                                [
                                                    126.462,
                                                    53.878
                                                ],
                                                [
                                                    126.203,
                                                    54.907
                                                ],
                                                [
                                                    125.475,
                                                    55.6
                                                ],
                                                [
                                                    124.376,
                                                    55.852
                                                ],
                                                [
                                                    123.186,
                                                    55.453
                                                ],
                                                [
                                                    122.738,
                                                    54.326
                                                ],
                                                [
                                                    122.738,
                                                    49.118
                                                ],
                                                [
                                                    121.296,
                                                    49.118
                                                ],
                                                [
                                                    121.296,
                                                    54.452
                                                ],
                                                [
                                                    122.01,
                                                    56.405
                                                ],
                                                [
                                                    124.082,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.177,
                                                    0.019
                                                ],
                                                [
                                                    -0.205,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.009
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.229
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.177,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.019
                                                ],
                                                [
                                                    -0.098,
                                                    0.009
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    0.275,
                                                    0.229
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    133.168,
                                                    57.07
                                                ],
                                                [
                                                    133.742,
                                                    56.986
                                                ],
                                                [
                                                    133.742,
                                                    55.838
                                                ],
                                                [
                                                    133.483,
                                                    55.88
                                                ],
                                                [
                                                    133.126,
                                                    55.894
                                                ],
                                                [
                                                    132.601,
                                                    55.754
                                                ],
                                                [
                                                    132.468,
                                                    55.18
                                                ],
                                                [
                                                    132.468,
                                                    46.78
                                                ],
                                                [
                                                    131.068,
                                                    46.92
                                                ],
                                                [
                                                    131.068,
                                                    55.768
                                                ],
                                                [
                                                    131.481,
                                                    56.755
                                                ],
                                                [
                                                    132.678,
                                                    57.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    131.768,
                                                    50.238
                                                ],
                                                [
                                                    131.768,
                                                    49.118
                                                ],
                                                [
                                                    130.018,
                                                    49.118
                                                ],
                                                [
                                                    130.018,
                                                    50.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    133.742,
                                                    49.118
                                                ],
                                                [
                                                    131.768,
                                                    49.118
                                                ],
                                                [
                                                    131.768,
                                                    50.238
                                                ],
                                                [
                                                    133.742,
                                                    50.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.177,
                                                    0.019
                                                ],
                                                [
                                                    -0.205,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.009
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.229
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.177,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.019
                                                ],
                                                [
                                                    -0.098,
                                                    0.009
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    0.275,
                                                    0.229
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    142.492,
                                                    57.07
                                                ],
                                                [
                                                    143.066,
                                                    56.986
                                                ],
                                                [
                                                    143.066,
                                                    55.838
                                                ],
                                                [
                                                    142.807,
                                                    55.88
                                                ],
                                                [
                                                    142.45,
                                                    55.894
                                                ],
                                                [
                                                    141.925,
                                                    55.754
                                                ],
                                                [
                                                    141.792,
                                                    55.18
                                                ],
                                                [
                                                    141.792,
                                                    46.78
                                                ],
                                                [
                                                    140.392,
                                                    46.92
                                                ],
                                                [
                                                    140.392,
                                                    55.768
                                                ],
                                                [
                                                    140.805,
                                                    56.755
                                                ],
                                                [
                                                    142.002,
                                                    57.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    141.092,
                                                    50.238
                                                ],
                                                [
                                                    141.092,
                                                    49.118
                                                ],
                                                [
                                                    139.342,
                                                    49.118
                                                ],
                                                [
                                                    139.342,
                                                    50.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    143.066,
                                                    49.118
                                                ],
                                                [
                                                    141.092,
                                                    49.118
                                                ],
                                                [
                                                    141.092,
                                                    50.238
                                                ],
                                                [
                                                    143.066,
                                                    50.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "h",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "h",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.415,
                                                    -0.205
                                                ],
                                                [
                                                    0.327,
                                                    -0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ],
                                                [
                                                    -0.415,
                                                    0.205
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    146.622,
                                                    57
                                                ],
                                                [
                                                    146.622,
                                                    52.296
                                                ],
                                                [
                                                    146.909,
                                                    51.19
                                                ],
                                                [
                                                    147.686,
                                                    50.483
                                                ],
                                                [
                                                    148.75,
                                                    50.238
                                                ],
                                                [
                                                    150.024,
                                                    50.672
                                                ],
                                                [
                                                    150.444,
                                                    51.848
                                                ],
                                                [
                                                    150.444,
                                                    57
                                                ],
                                                [
                                                    151.872,
                                                    57
                                                ],
                                                [
                                                    151.872,
                                                    51.708
                                                ],
                                                [
                                                    151.109,
                                                    49.629
                                                ],
                                                [
                                                    149.156,
                                                    48.95
                                                ],
                                                [
                                                    147.735,
                                                    49.258
                                                ],
                                                [
                                                    146.622,
                                                    50.224
                                                ],
                                                [
                                                    146.622,
                                                    45.94
                                                ],
                                                [
                                                    145.18,
                                                    45.94
                                                ],
                                                [
                                                    145.18,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    159.614,
                                                    56.839
                                                ],
                                                [
                                                    160.762,
                                                    56.006
                                                ],
                                                [
                                                    161.35,
                                                    54.76
                                                ],
                                                [
                                                    160.076,
                                                    54.466
                                                ],
                                                [
                                                    159.418,
                                                    55.558
                                                ],
                                                [
                                                    158.018,
                                                    55.95
                                                ],
                                                [
                                                    156.268,
                                                    55.229
                                                ],
                                                [
                                                    155.652,
                                                    53.038
                                                ],
                                                [
                                                    156.296,
                                                    50.798
                                                ],
                                                [
                                                    157.92,
                                                    50.112
                                                ],
                                                [
                                                    159.579,
                                                    50.868
                                                ],
                                                [
                                                    159.936,
                                                    52.842
                                                ],
                                                [
                                                    160.594,
                                                    52.338
                                                ],
                                                [
                                                    155.484,
                                                    52.338
                                                ],
                                                [
                                                    155.484,
                                                    53.416
                                                ],
                                                [
                                                    161.448,
                                                    53.416
                                                ],
                                                [
                                                    161.126,
                                                    50.945
                                                ],
                                                [
                                                    159.887,
                                                    49.468
                                                ],
                                                [
                                                    157.948,
                                                    48.978
                                                ],
                                                [
                                                    155.946,
                                                    49.489
                                                ],
                                                [
                                                    154.679,
                                                    50.917
                                                ],
                                                [
                                                    154.238,
                                                    53.066
                                                ],
                                                [
                                                    154.707,
                                                    55.264
                                                ],
                                                [
                                                    156.023,
                                                    56.657
                                                ],
                                                [
                                                    158.004,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "t",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.177,
                                                    0.019
                                                ],
                                                [
                                                    -0.205,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.009
                                                ],
                                                [
                                                    0.14,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.229
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.177,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.019
                                                ],
                                                [
                                                    -0.098,
                                                    0.009
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    0.275,
                                                    0.229
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    170.268,
                                                    57.07
                                                ],
                                                [
                                                    170.842,
                                                    56.986
                                                ],
                                                [
                                                    170.842,
                                                    55.838
                                                ],
                                                [
                                                    170.583,
                                                    55.88
                                                ],
                                                [
                                                    170.226,
                                                    55.894
                                                ],
                                                [
                                                    169.701,
                                                    55.754
                                                ],
                                                [
                                                    169.568,
                                                    55.18
                                                ],
                                                [
                                                    169.568,
                                                    46.78
                                                ],
                                                [
                                                    168.168,
                                                    46.92
                                                ],
                                                [
                                                    168.168,
                                                    55.768
                                                ],
                                                [
                                                    168.581,
                                                    56.755
                                                ],
                                                [
                                                    169.778,
                                                    57.098
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    168.868,
                                                    50.238
                                                ],
                                                [
                                                    168.868,
                                                    49.118
                                                ],
                                                [
                                                    167.118,
                                                    49.118
                                                ],
                                                [
                                                    167.118,
                                                    50.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "t",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    170.842,
                                                    49.118
                                                ],
                                                [
                                                    168.868,
                                                    49.118
                                                ],
                                                [
                                                    168.868,
                                                    50.238
                                                ],
                                                [
                                                    170.842,
                                                    50.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "r",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.327
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ],
                                                [
                                                    -0.098,
                                                    -0.014
                                                ],
                                                [
                                                    -0.075,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0
                                                ],
                                                [
                                                    0.322,
                                                    -0.215
                                                ],
                                                [
                                                    0.205,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    -0.551
                                                ],
                                                [
                                                    0.322,
                                                    -0.327
                                                ],
                                                [
                                                    0.093,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    -0.056
                                                ],
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    174.398,
                                                    57
                                                ],
                                                [
                                                    174.398,
                                                    52.198
                                                ],
                                                [
                                                    174.951,
                                                    50.882
                                                ],
                                                [
                                                    176.232,
                                                    50.392
                                                ],
                                                [
                                                    176.519,
                                                    50.413
                                                ],
                                                [
                                                    176.778,
                                                    50.476
                                                ],
                                                [
                                                    176.876,
                                                    50.476
                                                ],
                                                [
                                                    176.876,
                                                    49.118
                                                ],
                                                [
                                                    176.232,
                                                    49.034
                                                ],
                                                [
                                                    175.119,
                                                    49.356
                                                ],
                                                [
                                                    174.328,
                                                    50.28
                                                ],
                                                [
                                                    174.244,
                                                    49.118
                                                ],
                                                [
                                                    172.956,
                                                    49.118
                                                ],
                                                [
                                                    172.956,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.271
                                                ],
                                                [
                                                    -0.196,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    -0.196
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.019
                                                ],
                                                [
                                                    -0.093,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.355
                                                ],
                                                [
                                                    0.453,
                                                    0.173
                                                ],
                                                [
                                                    0.653,
                                                    0
                                                ],
                                                [
                                                    0.602,
                                                    -0.415
                                                ],
                                                [
                                                    0.019,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    0.233
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.327
                                                ],
                                                [
                                                    0.131,
                                                    -0.154
                                                ],
                                                [
                                                    0.42,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.182
                                                ],
                                                [
                                                    0.238,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.453,
                                                    -0.406
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.247,
                                                    0.196
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.532
                                                ],
                                                [
                                                    -0.238,
                                                    -0.355
                                                ],
                                                [
                                                    -0.453,
                                                    -0.173
                                                ],
                                                [
                                                    -0.98,
                                                    0
                                                ],
                                                [
                                                    -0.602,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    -0.485
                                                ],
                                                [
                                                    0.355,
                                                    -0.233
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.252
                                                ],
                                                [
                                                    -0.131,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.084
                                                ],
                                                [
                                                    -0.383,
                                                    0.182
                                                ],
                                                [
                                                    -0.238,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0.653
                                                ],
                                                [
                                                    0.453,
                                                    0.406
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    182.588,
                                                    56.734
                                                ],
                                                [
                                                    183.652,
                                                    55.67
                                                ],
                                                [
                                                    183.652,
                                                    55.922
                                                ],
                                                [
                                                    184.023,
                                                    56.818
                                                ],
                                                [
                                                    184.996,
                                                    57.112
                                                ],
                                                [
                                                    185.339,
                                                    57.084
                                                ],
                                                [
                                                    185.71,
                                                    57
                                                ],
                                                [
                                                    185.71,
                                                    55.978
                                                ],
                                                [
                                                    185.626,
                                                    55.978
                                                ],
                                                [
                                                    185.556,
                                                    55.999
                                                ],
                                                [
                                                    185.388,
                                                    56.006
                                                ],
                                                [
                                                    185.052,
                                                    55.88
                                                ],
                                                [
                                                    184.898,
                                                    55.334
                                                ],
                                                [
                                                    184.898,
                                                    51.358
                                                ],
                                                [
                                                    184.541,
                                                    50.028
                                                ],
                                                [
                                                    183.505,
                                                    49.237
                                                ],
                                                [
                                                    181.846,
                                                    48.978
                                                ],
                                                [
                                                    179.473,
                                                    49.601
                                                ],
                                                [
                                                    178.542,
                                                    51.386
                                                ],
                                                [
                                                    179.9,
                                                    51.526
                                                ],
                                                [
                                                    180.418,
                                                    50.448
                                                ],
                                                [
                                                    181.846,
                                                    50.098
                                                ],
                                                [
                                                    183.12,
                                                    50.427
                                                ],
                                                [
                                                    183.47,
                                                    51.246
                                                ],
                                                [
                                                    183.274,
                                                    51.855
                                                ],
                                                [
                                                    182.448,
                                                    52.198
                                                ],
                                                [
                                                    180.796,
                                                    52.506
                                                ],
                                                [
                                                    179.55,
                                                    52.905
                                                ],
                                                [
                                                    178.619,
                                                    53.668
                                                ],
                                                [
                                                    178.262,
                                                    54.942
                                                ],
                                                [
                                                    178.941,
                                                    56.531
                                                ],
                                                [
                                                    180.852,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.28,
                                                    0.187
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    -0.191,
                                                    0.233
                                                ],
                                                [
                                                    -0.588,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.056
                                                ],
                                                [
                                                    -0.093,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.238
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.28,
                                                    -0.187
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    0.191,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.075
                                                ],
                                                [
                                                    0.201,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.429
                                                ],
                                                [
                                                    -0.406,
                                                    0.238
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    180.152,
                                                    55.712
                                                ],
                                                [
                                                    179.732,
                                                    54.83
                                                ],
                                                [
                                                    180.019,
                                                    54.074
                                                ],
                                                [
                                                    181.188,
                                                    53.542
                                                ],
                                                [
                                                    182.35,
                                                    53.304
                                                ],
                                                [
                                                    183.197,
                                                    53.108
                                                ],
                                                [
                                                    183.638,
                                                    52.884
                                                ],
                                                [
                                                    183.484,
                                                    52.828
                                                ],
                                                [
                                                    183.484,
                                                    54.634
                                                ],
                                                [
                                                    182.665,
                                                    55.635
                                                ],
                                                [
                                                    181.216,
                                                    55.992
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.215
                                                ],
                                                [
                                                    0.336,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    189.028,
                                                    57
                                                ],
                                                [
                                                    189.028,
                                                    52.324
                                                ],
                                                [
                                                    189.315,
                                                    51.218
                                                ],
                                                [
                                                    190.092,
                                                    50.511
                                                ],
                                                [
                                                    191.156,
                                                    50.266
                                                ],
                                                [
                                                    192.43,
                                                    50.7
                                                ],
                                                [
                                                    192.85,
                                                    51.876
                                                ],
                                                [
                                                    192.85,
                                                    57
                                                ],
                                                [
                                                    194.278,
                                                    57
                                                ],
                                                [
                                                    194.278,
                                                    51.736
                                                ],
                                                [
                                                    193.515,
                                                    49.657
                                                ],
                                                [
                                                    191.562,
                                                    48.978
                                                ],
                                                [
                                                    190.12,
                                                    49.3
                                                ],
                                                [
                                                    188.986,
                                                    50.308
                                                ],
                                                [
                                                    188.902,
                                                    49.118
                                                ],
                                                [
                                                    187.586,
                                                    49.118
                                                ],
                                                [
                                                    187.586,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "s",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "s",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.527,
                                                    0.425
                                                ],
                                                [
                                                    0,
                                                    0.691
                                                ],
                                                [
                                                    0.117,
                                                    0.266
                                                ],
                                                [
                                                    0.219,
                                                    0.177
                                                ],
                                                [
                                                    0.317,
                                                    0.107
                                                ],
                                                [
                                                    0.392,
                                                    0.075
                                                ],
                                                [
                                                    0.327,
                                                    0.103
                                                ],
                                                [
                                                    0.154,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0.271
                                                ],
                                                [
                                                    -0.257,
                                                    0.201
                                                ],
                                                [
                                                    -0.476,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    -0.28
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    0.355
                                                ],
                                                [
                                                    0.457,
                                                    0.177
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.187
                                                ],
                                                [
                                                    0.243,
                                                    -0.336
                                                ],
                                                [
                                                    0,
                                                    -0.457
                                                ],
                                                [
                                                    -0.168,
                                                    -0.294
                                                ],
                                                [
                                                    -0.345,
                                                    -0.196
                                                ],
                                                [
                                                    -0.532,
                                                    -0.121
                                                ],
                                                [
                                                    -0.289,
                                                    -0.056
                                                ],
                                                [
                                                    -0.219,
                                                    -0.089
                                                ],
                                                [
                                                    -0.121,
                                                    -0.149
                                                ],
                                                [
                                                    0,
                                                    -0.261
                                                ],
                                                [
                                                    0.313,
                                                    -0.182
                                                ],
                                                [
                                                    0.513,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    0.308
                                                ],
                                                [
                                                    0,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.597,
                                                    -0.457
                                                ],
                                                [
                                                    -0.989,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.527,
                                                    -0.425
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    -0.117,
                                                    -0.266
                                                ],
                                                [
                                                    -0.219,
                                                    -0.177
                                                ],
                                                [
                                                    -0.317,
                                                    -0.107
                                                ],
                                                [
                                                    -0.513,
                                                    -0.103
                                                ],
                                                [
                                                    -0.327,
                                                    -0.103
                                                ],
                                                [
                                                    -0.154,
                                                    -0.163
                                                ],
                                                [
                                                    0,
                                                    -0.317
                                                ],
                                                [
                                                    0.257,
                                                    -0.201
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.541
                                                ],
                                                [
                                                    -0.266,
                                                    -0.355
                                                ],
                                                [
                                                    -0.457,
                                                    -0.177
                                                ],
                                                [
                                                    -0.607,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.187
                                                ],
                                                [
                                                    -0.243,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.168,
                                                    0.294
                                                ],
                                                [
                                                    0.345,
                                                    0.196
                                                ],
                                                [
                                                    0.336,
                                                    0.075
                                                ],
                                                [
                                                    0.289,
                                                    0.056
                                                ],
                                                [
                                                    0.219,
                                                    0.089
                                                ],
                                                [
                                                    0.121,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.429
                                                ],
                                                [
                                                    -0.313,
                                                    0.182
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    -0.308
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.803
                                                ],
                                                [
                                                    0.597,
                                                    0.457
                                                ],
                                                [
                                                    1.101,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    202.321,
                                                    56.503
                                                ],
                                                [
                                                    203.112,
                                                    54.83
                                                ],
                                                [
                                                    202.937,
                                                    53.843
                                                ],
                                                [
                                                    202.433,
                                                    53.178
                                                ],
                                                [
                                                    201.628,
                                                    52.751
                                                ],
                                                [
                                                    200.564,
                                                    52.478
                                                ],
                                                [
                                                    199.304,
                                                    52.17
                                                ],
                                                [
                                                    198.583,
                                                    51.771
                                                ],
                                                [
                                                    198.352,
                                                    51.12
                                                ],
                                                [
                                                    198.737,
                                                    50.343
                                                ],
                                                [
                                                    199.836,
                                                    50.042
                                                ],
                                                [
                                                    201.18,
                                                    50.462
                                                ],
                                                [
                                                    201.614,
                                                    51.568
                                                ],
                                                [
                                                    203,
                                                    51.386
                                                ],
                                                [
                                                    202.559,
                                                    50.042
                                                ],
                                                [
                                                    201.474,
                                                    49.244
                                                ],
                                                [
                                                    199.878,
                                                    48.978
                                                ],
                                                [
                                                    198.296,
                                                    49.258
                                                ],
                                                [
                                                    197.26,
                                                    50.042
                                                ],
                                                [
                                                    196.896,
                                                    51.232
                                                ],
                                                [
                                                    197.148,
                                                    52.275
                                                ],
                                                [
                                                    197.918,
                                                    53.01
                                                ],
                                                [
                                                    199.234,
                                                    53.486
                                                ],
                                                [
                                                    200.172,
                                                    53.682
                                                ],
                                                [
                                                    200.935,
                                                    53.899
                                                ],
                                                [
                                                    201.446,
                                                    54.256
                                                ],
                                                [
                                                    201.628,
                                                    54.872
                                                ],
                                                [
                                                    201.159,
                                                    55.789
                                                ],
                                                [
                                                    199.92,
                                                    56.062
                                                ],
                                                [
                                                    198.492,
                                                    55.6
                                                ],
                                                [
                                                    197.96,
                                                    54.41
                                                ],
                                                [
                                                    196.56,
                                                    54.564
                                                ],
                                                [
                                                    197.498,
                                                    56.454
                                                ],
                                                [
                                                    199.878,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "f",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "f",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.177,
                                                    0.154
                                                ],
                                                [
                                                    -0.336,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    -0.014
                                                ],
                                                [
                                                    -0.056,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.14,
                                                    0.014
                                                ],
                                                [
                                                    0.131,
                                                    0
                                                ],
                                                [
                                                    0.378,
                                                    -0.373
                                                ],
                                                [
                                                    0,
                                                    -0.635
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    0.177,
                                                    -0.154
                                                ],
                                                [
                                                    0.103,
                                                    0
                                                ],
                                                [
                                                    0.084,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.093,
                                                    -0.028
                                                ],
                                                [
                                                    -0.14,
                                                    -0.014
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.378,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    207.13,
                                                    57
                                                ],
                                                [
                                                    207.13,
                                                    48.166
                                                ],
                                                [
                                                    207.396,
                                                    47.319
                                                ],
                                                [
                                                    208.166,
                                                    47.088
                                                ],
                                                [
                                                    208.446,
                                                    47.109
                                                ],
                                                [
                                                    208.656,
                                                    47.172
                                                ],
                                                [
                                                    208.74,
                                                    47.172
                                                ],
                                                [
                                                    208.74,
                                                    45.954
                                                ],
                                                [
                                                    208.39,
                                                    45.891
                                                ],
                                                [
                                                    207.984,
                                                    45.87
                                                ],
                                                [
                                                    206.283,
                                                    46.43
                                                ],
                                                [
                                                    205.716,
                                                    47.942
                                                ],
                                                [
                                                    205.716,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "f",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    206.43,
                                                    50.238
                                                ],
                                                [
                                                    206.43,
                                                    49.118
                                                ],
                                                [
                                                    204.568,
                                                    49.118
                                                ],
                                                [
                                                    204.568,
                                                    50.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "f",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    208.768,
                                                    50.238
                                                ],
                                                [
                                                    208.768,
                                                    49.118
                                                ],
                                                [
                                                    206.43,
                                                    49.118
                                                ],
                                                [
                                                    206.43,
                                                    50.238
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    215.726,
                                                    56.839
                                                ],
                                                [
                                                    216.874,
                                                    56.006
                                                ],
                                                [
                                                    217.462,
                                                    54.76
                                                ],
                                                [
                                                    216.188,
                                                    54.466
                                                ],
                                                [
                                                    215.53,
                                                    55.558
                                                ],
                                                [
                                                    214.13,
                                                    55.95
                                                ],
                                                [
                                                    212.38,
                                                    55.229
                                                ],
                                                [
                                                    211.764,
                                                    53.038
                                                ],
                                                [
                                                    212.408,
                                                    50.798
                                                ],
                                                [
                                                    214.032,
                                                    50.112
                                                ],
                                                [
                                                    215.691,
                                                    50.868
                                                ],
                                                [
                                                    216.048,
                                                    52.842
                                                ],
                                                [
                                                    216.706,
                                                    52.338
                                                ],
                                                [
                                                    211.596,
                                                    52.338
                                                ],
                                                [
                                                    211.596,
                                                    53.416
                                                ],
                                                [
                                                    217.56,
                                                    53.416
                                                ],
                                                [
                                                    217.238,
                                                    50.945
                                                ],
                                                [
                                                    215.999,
                                                    49.468
                                                ],
                                                [
                                                    214.06,
                                                    48.978
                                                ],
                                                [
                                                    212.058,
                                                    49.489
                                                ],
                                                [
                                                    210.791,
                                                    50.917
                                                ],
                                                [
                                                    210.35,
                                                    53.066
                                                ],
                                                [
                                                    210.819,
                                                    55.264
                                                ],
                                                [
                                                    212.135,
                                                    56.657
                                                ],
                                                [
                                                    214.116,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "r",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "r",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.327
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ],
                                                [
                                                    -0.098,
                                                    -0.014
                                                ],
                                                [
                                                    -0.075,
                                                    -0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    0
                                                ],
                                                [
                                                    0.322,
                                                    -0.215
                                                ],
                                                [
                                                    0.205,
                                                    -0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    -0.551
                                                ],
                                                [
                                                    0.322,
                                                    -0.327
                                                ],
                                                [
                                                    0.093,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    0.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    -0.056
                                                ],
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.322,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    221.186,
                                                    57
                                                ],
                                                [
                                                    221.186,
                                                    52.198
                                                ],
                                                [
                                                    221.739,
                                                    50.882
                                                ],
                                                [
                                                    223.02,
                                                    50.392
                                                ],
                                                [
                                                    223.307,
                                                    50.413
                                                ],
                                                [
                                                    223.566,
                                                    50.476
                                                ],
                                                [
                                                    223.664,
                                                    50.476
                                                ],
                                                [
                                                    223.664,
                                                    49.118
                                                ],
                                                [
                                                    223.02,
                                                    49.034
                                                ],
                                                [
                                                    221.907,
                                                    49.356
                                                ],
                                                [
                                                    221.116,
                                                    50.28
                                                ],
                                                [
                                                    221.032,
                                                    49.118
                                                ],
                                                [
                                                    219.744,
                                                    49.118
                                                ],
                                                [
                                                    219.744,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "d",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "d",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.271,
                                                    -0.602
                                                ],
                                                [
                                                    -0.509,
                                                    -0.331
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.462,
                                                    0.266
                                                ],
                                                [
                                                    -0.224,
                                                    0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    0.243
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    -0.336
                                                ],
                                                [
                                                    0.28,
                                                    -0.621
                                                ],
                                                [
                                                    0,
                                                    -0.84
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.271,
                                                    0.602
                                                ],
                                                [
                                                    0.509,
                                                    0.331
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.462,
                                                    -0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.457
                                                ],
                                                [
                                                    -0.439,
                                                    -0.243
                                                ],
                                                [
                                                    -0.691,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.336
                                                ],
                                                [
                                                    -0.28,
                                                    0.621
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    229.6,
                                                    55.243
                                                ],
                                                [
                                                    230.769,
                                                    56.643
                                                ],
                                                [
                                                    232.568,
                                                    57.14
                                                ],
                                                [
                                                    234.171,
                                                    56.741
                                                ],
                                                [
                                                    235.2,
                                                    55.656
                                                ],
                                                [
                                                    235.298,
                                                    57
                                                ],
                                                [
                                                    236.628,
                                                    57
                                                ],
                                                [
                                                    236.628,
                                                    45.94
                                                ],
                                                [
                                                    235.2,
                                                    45.94
                                                ],
                                                [
                                                    235.2,
                                                    50.392
                                                ],
                                                [
                                                    234.164,
                                                    49.342
                                                ],
                                                [
                                                    232.61,
                                                    48.978
                                                ],
                                                [
                                                    230.804,
                                                    49.482
                                                ],
                                                [
                                                    229.614,
                                                    50.917
                                                ],
                                                [
                                                    229.194,
                                                    53.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "d",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.387,
                                                    0.504
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.345,
                                                    -0.201
                                                ],
                                                [
                                                    -0.187,
                                                    -0.369
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    -0.359
                                                ],
                                                [
                                                    0.35,
                                                    -0.201
                                                ],
                                                [
                                                    0.467,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    0.485
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.387,
                                                    -0.504
                                                ],
                                                [
                                                    0.476,
                                                    0
                                                ],
                                                [
                                                    0.345,
                                                    0.201
                                                ],
                                                [
                                                    0.187,
                                                    0.369
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.476
                                                ],
                                                [
                                                    -0.191,
                                                    0.359
                                                ],
                                                [
                                                    -0.35,
                                                    0.201
                                                ],
                                                [
                                                    -0.709,
                                                    0
                                                ],
                                                [
                                                    -0.383,
                                                    -0.485
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    231.245,
                                                    50.966
                                                ],
                                                [
                                                    232.89,
                                                    50.21
                                                ],
                                                [
                                                    234.122,
                                                    50.511
                                                ],
                                                [
                                                    234.92,
                                                    51.365
                                                ],
                                                [
                                                    235.2,
                                                    52.674
                                                ],
                                                [
                                                    235.2,
                                                    53.514
                                                ],
                                                [
                                                    234.913,
                                                    54.767
                                                ],
                                                [
                                                    234.101,
                                                    55.607
                                                ],
                                                [
                                                    232.876,
                                                    55.908
                                                ],
                                                [
                                                    231.238,
                                                    55.18
                                                ],
                                                [
                                                    230.664,
                                                    53.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "e",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "e",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.467,
                                                    0.201
                                                ],
                                                [
                                                    -0.299,
                                                    0.355
                                                ],
                                                [
                                                    -0.093,
                                                    0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.355,
                                                    -0.261
                                                ],
                                                [
                                                    0.579,
                                                    0
                                                ],
                                                [
                                                    0.411,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.98
                                                ],
                                                [
                                                    -0.429,
                                                    0.457
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.359,
                                                    -0.504
                                                ],
                                                [
                                                    0.121,
                                                    -0.812
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.658
                                                ],
                                                [
                                                    0.546,
                                                    0.327
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    -0.341
                                                ],
                                                [
                                                    0.294,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.313,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.322
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.467,
                                                    -0.201
                                                ],
                                                [
                                                    0.299,
                                                    -0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.467
                                                ],
                                                [
                                                    -0.355,
                                                    0.261
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.411,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -1.036
                                                ],
                                                [
                                                    0.429,
                                                    -0.457
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.359,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.989
                                                ],
                                                [
                                                    -0.28,
                                                    -0.658
                                                ],
                                                [
                                                    -0.546,
                                                    -0.327
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    0.341
                                                ],
                                                [
                                                    -0.294,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.859
                                                ],
                                                [
                                                    0.313,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.322
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    244.398,
                                                    56.839
                                                ],
                                                [
                                                    245.546,
                                                    56.006
                                                ],
                                                [
                                                    246.134,
                                                    54.76
                                                ],
                                                [
                                                    244.86,
                                                    54.466
                                                ],
                                                [
                                                    244.202,
                                                    55.558
                                                ],
                                                [
                                                    242.802,
                                                    55.95
                                                ],
                                                [
                                                    241.052,
                                                    55.229
                                                ],
                                                [
                                                    240.436,
                                                    53.038
                                                ],
                                                [
                                                    241.08,
                                                    50.798
                                                ],
                                                [
                                                    242.704,
                                                    50.112
                                                ],
                                                [
                                                    244.363,
                                                    50.868
                                                ],
                                                [
                                                    244.72,
                                                    52.842
                                                ],
                                                [
                                                    245.378,
                                                    52.338
                                                ],
                                                [
                                                    240.268,
                                                    52.338
                                                ],
                                                [
                                                    240.268,
                                                    53.416
                                                ],
                                                [
                                                    246.232,
                                                    53.416
                                                ],
                                                [
                                                    245.91,
                                                    50.945
                                                ],
                                                [
                                                    244.671,
                                                    49.468
                                                ],
                                                [
                                                    242.732,
                                                    48.978
                                                ],
                                                [
                                                    240.73,
                                                    49.489
                                                ],
                                                [
                                                    239.463,
                                                    50.917
                                                ],
                                                [
                                                    239.022,
                                                    53.066
                                                ],
                                                [
                                                    239.491,
                                                    55.264
                                                ],
                                                [
                                                    240.807,
                                                    56.657
                                                ],
                                                [
                                                    242.788,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "l",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "l",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    249.844,
                                                    57
                                                ],
                                                [
                                                    249.844,
                                                    45.94
                                                ],
                                                [
                                                    248.416,
                                                    45.94
                                                ],
                                                [
                                                    248.416,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "a",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0.271
                                                ],
                                                [
                                                    -0.196,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.247,
                                                    -0.196
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    0.019
                                                ],
                                                [
                                                    -0.093,
                                                    0.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    -0.005
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.238,
                                                    0.355
                                                ],
                                                [
                                                    0.453,
                                                    0.173
                                                ],
                                                [
                                                    0.653,
                                                    0
                                                ],
                                                [
                                                    0.602,
                                                    -0.415
                                                ],
                                                [
                                                    0.019,
                                                    -0.775
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.355,
                                                    0.233
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.219
                                                ],
                                                [
                                                    0,
                                                    -0.327
                                                ],
                                                [
                                                    0.131,
                                                    -0.154
                                                ],
                                                [
                                                    0.42,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.383,
                                                    -0.182
                                                ],
                                                [
                                                    0.238,
                                                    -0.327
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.453,
                                                    -0.406
                                                ],
                                                [
                                                    -0.821,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.513,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.247,
                                                    0.196
                                                ],
                                                [
                                                    0.075,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    0.009
                                                ],
                                                [
                                                    -0.037,
                                                    0.005
                                                ],
                                                [
                                                    -0.121,
                                                    0
                                                ],
                                                [
                                                    -0.103,
                                                    -0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.532
                                                ],
                                                [
                                                    -0.238,
                                                    -0.355
                                                ],
                                                [
                                                    -0.453,
                                                    -0.173
                                                ],
                                                [
                                                    -0.98,
                                                    0
                                                ],
                                                [
                                                    -0.602,
                                                    0.415
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.009,
                                                    -0.485
                                                ],
                                                [
                                                    0.355,
                                                    -0.233
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0.219
                                                ],
                                                [
                                                    0,
                                                    0.252
                                                ],
                                                [
                                                    -0.131,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.084
                                                ],
                                                [
                                                    -0.383,
                                                    0.182
                                                ],
                                                [
                                                    -0.238,
                                                    0.327
                                                ],
                                                [
                                                    0,
                                                    0.653
                                                ],
                                                [
                                                    0.453,
                                                    0.406
                                                ],
                                                [
                                                    0.644,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    256.578,
                                                    56.734
                                                ],
                                                [
                                                    257.642,
                                                    55.67
                                                ],
                                                [
                                                    257.642,
                                                    55.922
                                                ],
                                                [
                                                    258.013,
                                                    56.818
                                                ],
                                                [
                                                    258.986,
                                                    57.112
                                                ],
                                                [
                                                    259.329,
                                                    57.084
                                                ],
                                                [
                                                    259.7,
                                                    57
                                                ],
                                                [
                                                    259.7,
                                                    55.978
                                                ],
                                                [
                                                    259.616,
                                                    55.978
                                                ],
                                                [
                                                    259.546,
                                                    55.999
                                                ],
                                                [
                                                    259.378,
                                                    56.006
                                                ],
                                                [
                                                    259.042,
                                                    55.88
                                                ],
                                                [
                                                    258.888,
                                                    55.334
                                                ],
                                                [
                                                    258.888,
                                                    51.358
                                                ],
                                                [
                                                    258.531,
                                                    50.028
                                                ],
                                                [
                                                    257.495,
                                                    49.237
                                                ],
                                                [
                                                    255.836,
                                                    48.978
                                                ],
                                                [
                                                    253.463,
                                                    49.601
                                                ],
                                                [
                                                    252.532,
                                                    51.386
                                                ],
                                                [
                                                    253.89,
                                                    51.526
                                                ],
                                                [
                                                    254.408,
                                                    50.448
                                                ],
                                                [
                                                    255.836,
                                                    50.098
                                                ],
                                                [
                                                    257.11,
                                                    50.427
                                                ],
                                                [
                                                    257.46,
                                                    51.246
                                                ],
                                                [
                                                    257.264,
                                                    51.855
                                                ],
                                                [
                                                    256.438,
                                                    52.198
                                                ],
                                                [
                                                    254.786,
                                                    52.506
                                                ],
                                                [
                                                    253.54,
                                                    52.905
                                                ],
                                                [
                                                    252.609,
                                                    53.668
                                                ],
                                                [
                                                    252.252,
                                                    54.942
                                                ],
                                                [
                                                    252.931,
                                                    56.531
                                                ],
                                                [
                                                    254.842,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "a",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.28,
                                                    0.187
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    -0.191,
                                                    0.233
                                                ],
                                                [
                                                    -0.588,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.201,
                                                    0.056
                                                ],
                                                [
                                                    -0.093,
                                                    0.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.238
                                                ],
                                                [
                                                    0.56,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.28,
                                                    -0.187
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    0.191,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.075
                                                ],
                                                [
                                                    0.201,
                                                    -0.056
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.429
                                                ],
                                                [
                                                    -0.406,
                                                    0.238
                                                ],
                                                [
                                                    -0.429,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    254.142,
                                                    55.712
                                                ],
                                                [
                                                    253.722,
                                                    54.83
                                                ],
                                                [
                                                    254.009,
                                                    54.074
                                                ],
                                                [
                                                    255.178,
                                                    53.542
                                                ],
                                                [
                                                    256.34,
                                                    53.304
                                                ],
                                                [
                                                    257.187,
                                                    53.108
                                                ],
                                                [
                                                    257.628,
                                                    52.884
                                                ],
                                                [
                                                    257.474,
                                                    52.828
                                                ],
                                                [
                                                    257.474,
                                                    54.634
                                                ],
                                                [
                                                    256.655,
                                                    55.635
                                                ],
                                                [
                                                    255.206,
                                                    55.992
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "y",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "y",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.289,
                                                    0.103
                                                ],
                                                [
                                                    -0.233,
                                                    0.257
                                                ],
                                                [
                                                    -0.168,
                                                    0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.098,
                                                    -0.271
                                                ],
                                                [
                                                    0.084,
                                                    -0.28
                                                ],
                                                [
                                                    0.112,
                                                    -0.364
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.117,
                                                    0.359
                                                ],
                                                [
                                                    0.103,
                                                    0.294
                                                ],
                                                [
                                                    0.056,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    -0.14
                                                ],
                                                [
                                                    0.336,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.019
                                                ],
                                                [
                                                    0.065,
                                                    0.028
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.177,
                                                    -0.028
                                                ],
                                                [
                                                    -0.14,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.289,
                                                    -0.103
                                                ],
                                                [
                                                    0.233,
                                                    -0.257
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.121,
                                                    0.345
                                                ],
                                                [
                                                    -0.098,
                                                    0.271
                                                ],
                                                [
                                                    -0.084,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.093,
                                                    -0.355
                                                ],
                                                [
                                                    -0.117,
                                                    -0.359
                                                ],
                                                [
                                                    -0.103,
                                                    -0.294
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.112,
                                                    0.289
                                                ],
                                                [
                                                    -0.201,
                                                    0.14
                                                ],
                                                [
                                                    -0.103,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    -0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.112,
                                                    0.037
                                                ],
                                                [
                                                    0.177,
                                                    0.028
                                                ],
                                                [
                                                    0.355,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    263.186,
                                                    59.296
                                                ],
                                                [
                                                    263.97,
                                                    58.757
                                                ],
                                                [
                                                    264.572,
                                                    57.686
                                                ],
                                                [
                                                    267.834,
                                                    49.118
                                                ],
                                                [
                                                    266.406,
                                                    49.118
                                                ],
                                                [
                                                    265.076,
                                                    52.8
                                                ],
                                                [
                                                    264.747,
                                                    53.724
                                                ],
                                                [
                                                    264.474,
                                                    54.55
                                                ],
                                                [
                                                    264.18,
                                                    55.516
                                                ],
                                                [
                                                    264.264,
                                                    55.516
                                                ],
                                                [
                                                    263.949,
                                                    54.445
                                                ],
                                                [
                                                    263.62,
                                                    53.465
                                                ],
                                                [
                                                    263.382,
                                                    52.8
                                                ],
                                                [
                                                    262.066,
                                                    49.118
                                                ],
                                                [
                                                    260.512,
                                                    49.118
                                                ],
                                                [
                                                    263.48,
                                                    56.706
                                                ],
                                                [
                                                    263.214,
                                                    57.378
                                                ],
                                                [
                                                    262.745,
                                                    58.022
                                                ],
                                                [
                                                    261.94,
                                                    58.232
                                                ],
                                                [
                                                    261.653,
                                                    58.204
                                                ],
                                                [
                                                    261.422,
                                                    58.134
                                                ],
                                                [
                                                    261.31,
                                                    58.134
                                                ],
                                                [
                                                    261.31,
                                                    59.31
                                                ],
                                                [
                                                    261.744,
                                                    59.408
                                                ],
                                                [
                                                    262.22,
                                                    59.45
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "o",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.56,
                                                    0.336
                                                ],
                                                [
                                                    -0.308,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.308,
                                                    0.611
                                                ],
                                                [
                                                    0.56,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.341
                                                ],
                                                [
                                                    0.313,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    -0.308,
                                                    -0.607
                                                ],
                                                [
                                                    -0.565,
                                                    -0.341
                                                ],
                                                [
                                                    -0.765,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.56,
                                                    -0.336
                                                ],
                                                [
                                                    0.308,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.308,
                                                    -0.611
                                                ],
                                                [
                                                    -0.56,
                                                    -0.341
                                                ],
                                                [
                                                    -0.756,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    0.341
                                                ],
                                                [
                                                    -0.313,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    0.308,
                                                    0.607
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    279.034,
                                                    56.636
                                                ],
                                                [
                                                    280.336,
                                                    55.215
                                                ],
                                                [
                                                    280.798,
                                                    53.066
                                                ],
                                                [
                                                    280.336,
                                                    50.917
                                                ],
                                                [
                                                    279.034,
                                                    49.489
                                                ],
                                                [
                                                    277.06,
                                                    48.978
                                                ],
                                                [
                                                    275.079,
                                                    49.489
                                                ],
                                                [
                                                    273.763,
                                                    50.917
                                                ],
                                                [
                                                    273.294,
                                                    53.08
                                                ],
                                                [
                                                    273.756,
                                                    55.208
                                                ],
                                                [
                                                    275.065,
                                                    56.629
                                                ],
                                                [
                                                    277.06,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "o",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.406,
                                                    0.499
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.509
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    -0.905
                                                ],
                                                [
                                                    0.406,
                                                    -0.504
                                                ],
                                                [
                                                    0.728,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.406,
                                                    -0.499
                                                ],
                                                [
                                                    0,
                                                    -0.887
                                                ],
                                                [
                                                    0.406,
                                                    -0.509
                                                ],
                                                [
                                                    0.719,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    0.495
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.406,
                                                    0.504
                                                ],
                                                [
                                                    -0.728,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    275.345,
                                                    55.159
                                                ],
                                                [
                                                    274.736,
                                                    53.066
                                                ],
                                                [
                                                    275.345,
                                                    50.973
                                                ],
                                                [
                                                    277.06,
                                                    50.21
                                                ],
                                                [
                                                    278.747,
                                                    50.952
                                                ],
                                                [
                                                    279.356,
                                                    53.052
                                                ],
                                                [
                                                    278.747,
                                                    55.152
                                                ],
                                                [
                                                    277.046,
                                                    55.908
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "n",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "n",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.308
                                                ],
                                                [
                                                    -0.327,
                                                    0.163
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.289
                                                ],
                                                [
                                                    0,
                                                    -0.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.509,
                                                    0.453
                                                ],
                                                [
                                                    0.793,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.215
                                                ],
                                                [
                                                    0.336,
                                                    -0.457
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.429
                                                ],
                                                [
                                                    0.191,
                                                    -0.308
                                                ],
                                                [
                                                    0.327,
                                                    -0.163
                                                ],
                                                [
                                                    0.569,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.289
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.933
                                                ],
                                                [
                                                    -0.509,
                                                    -0.453
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    284.606,
                                                    57
                                                ],
                                                [
                                                    284.606,
                                                    52.324
                                                ],
                                                [
                                                    284.893,
                                                    51.218
                                                ],
                                                [
                                                    285.67,
                                                    50.511
                                                ],
                                                [
                                                    286.734,
                                                    50.266
                                                ],
                                                [
                                                    288.008,
                                                    50.7
                                                ],
                                                [
                                                    288.428,
                                                    51.876
                                                ],
                                                [
                                                    288.428,
                                                    57
                                                ],
                                                [
                                                    289.856,
                                                    57
                                                ],
                                                [
                                                    289.856,
                                                    51.736
                                                ],
                                                [
                                                    289.093,
                                                    49.657
                                                ],
                                                [
                                                    287.14,
                                                    48.978
                                                ],
                                                [
                                                    285.698,
                                                    49.3
                                                ],
                                                [
                                                    284.564,
                                                    50.308
                                                ],
                                                [
                                                    284.48,
                                                    49.118
                                                ],
                                                [
                                                    283.164,
                                                    49.118
                                                ],
                                                [
                                                    283.164,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.401,
                                                    -0.378
                                                ],
                                                [
                                                    0.765,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.121,
                                                    0.653
                                                ],
                                                [
                                                    -0.401,
                                                    0.378
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    300.678,
                                                    57
                                                ],
                                                [
                                                    300.678,
                                                    46.794
                                                ],
                                                [
                                                    299.082,
                                                    46.794
                                                ],
                                                [
                                                    298.298,
                                                    48.341
                                                ],
                                                [
                                                    296.548,
                                                    48.908
                                                ],
                                                [
                                                    296.282,
                                                    48.908
                                                ],
                                                [
                                                    296.282,
                                                    50.434
                                                ],
                                                [
                                                    298.508,
                                                    50.434
                                                ],
                                                [
                                                    298.508,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    310.464,
                                                    57
                                                ],
                                                [
                                                    310.464,
                                                    55.012
                                                ],
                                                [
                                                    312.032,
                                                    55.012
                                                ],
                                                [
                                                    312.032,
                                                    53.262
                                                ],
                                                [
                                                    310.464,
                                                    53.262
                                                ],
                                                [
                                                    310.464,
                                                    46.794
                                                ],
                                                [
                                                    308.378,
                                                    46.794
                                                ],
                                                [
                                                    303.324,
                                                    53.388
                                                ],
                                                [
                                                    303.324,
                                                    55.012
                                                ],
                                                [
                                                    308.294,
                                                    55.012
                                                ],
                                                [
                                                    308.294,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    308.294,
                                                    49.622
                                                ],
                                                [
                                                    308.294,
                                                    53.262
                                                ],
                                                [
                                                    305.55,
                                                    53.262
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "A",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "A",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.089,
                                                    0.261
                                                ],
                                                [
                                                    -0.093,
                                                    0.355
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    -0.261
                                                ],
                                                [
                                                    -0.084,
                                                    -0.243
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.093,
                                                    -0.243
                                                ],
                                                [
                                                    0.089,
                                                    -0.261
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.103,
                                                    0.355
                                                ],
                                                [
                                                    0.084,
                                                    0.261
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    319.172,
                                                    57
                                                ],
                                                [
                                                    321.622,
                                                    50.336
                                                ],
                                                [
                                                    321.895,
                                                    49.58
                                                ],
                                                [
                                                    322.168,
                                                    48.656
                                                ],
                                                [
                                                    322,
                                                    48.656
                                                ],
                                                [
                                                    322.28,
                                                    49.58
                                                ],
                                                [
                                                    322.532,
                                                    50.336
                                                ],
                                                [
                                                    324.954,
                                                    57
                                                ],
                                                [
                                                    327.306,
                                                    57
                                                ],
                                                [
                                                    323.358,
                                                    46.794
                                                ],
                                                [
                                                    320.838,
                                                    46.794
                                                ],
                                                [
                                                    316.89,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "A",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    324.394,
                                                    54.886
                                                ],
                                                [
                                                    323.722,
                                                    53.066
                                                ],
                                                [
                                                    320.418,
                                                    53.066
                                                ],
                                                [
                                                    319.746,
                                                    54.886
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "u",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "u",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.397,
                                                    0.201
                                                ],
                                                [
                                                    -0.271,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.14,
                                                    -0.229
                                                ],
                                                [
                                                    0.229,
                                                    -0.126
                                                ],
                                                [
                                                    0.299,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.499,
                                                    -0.495
                                                ],
                                                [
                                                    -0.868,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.397,
                                                    -0.201
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.019,
                                                    0.299
                                                ],
                                                [
                                                    -0.14,
                                                    0.229
                                                ],
                                                [
                                                    -0.229,
                                                    0.126
                                                ],
                                                [
                                                    -0.411,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    -0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.905
                                                ],
                                                [
                                                    0.499,
                                                    0.495
                                                ],
                                                [
                                                    0.485,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    333.207,
                                                    56.839
                                                ],
                                                [
                                                    334.208,
                                                    55.908
                                                ],
                                                [
                                                    334.292,
                                                    57
                                                ],
                                                [
                                                    336.294,
                                                    57
                                                ],
                                                [
                                                    336.294,
                                                    48.936
                                                ],
                                                [
                                                    334.124,
                                                    48.936
                                                ],
                                                [
                                                    334.124,
                                                    53.738
                                                ],
                                                [
                                                    333.886,
                                                    54.529
                                                ],
                                                [
                                                    333.333,
                                                    55.061
                                                ],
                                                [
                                                    332.542,
                                                    55.25
                                                ],
                                                [
                                                    331.59,
                                                    54.907
                                                ],
                                                [
                                                    331.254,
                                                    53.892
                                                ],
                                                [
                                                    331.254,
                                                    48.936
                                                ],
                                                [
                                                    329.084,
                                                    48.936
                                                ],
                                                [
                                                    329.084,
                                                    54.298
                                                ],
                                                [
                                                    329.833,
                                                    56.398
                                                ],
                                                [
                                                    331.884,
                                                    57.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "g",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "g",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.583,
                                                    0.261
                                                ],
                                                [
                                                    -0.275,
                                                    0.467
                                                ],
                                                [
                                                    0,
                                                    0.607
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.429,
                                                    0.219
                                                ],
                                                [
                                                    0.523,
                                                    0
                                                ],
                                                [
                                                    0.481,
                                                    -0.313
                                                ],
                                                [
                                                    0.266,
                                                    -0.56
                                                ],
                                                [
                                                    0,
                                                    -0.756
                                                ],
                                                [
                                                    -0.271,
                                                    -0.56
                                                ],
                                                [
                                                    -0.495,
                                                    -0.308
                                                ],
                                                [
                                                    -0.663,
                                                    0
                                                ],
                                                [
                                                    -0.392,
                                                    0.182
                                                ],
                                                [
                                                    -0.215,
                                                    0.383
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.294,
                                                    -0.238
                                                ],
                                                [
                                                    0.523,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    0.065
                                                ],
                                                [
                                                    0.126,
                                                    0.163
                                                ],
                                                [
                                                    0.028,
                                                    0.28
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.588,
                                                    -0.415
                                                ],
                                                [
                                                    -0.999,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.583,
                                                    -0.261
                                                ],
                                                [
                                                    0.275,
                                                    -0.467
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.196,
                                                    -0.401
                                                ],
                                                [
                                                    -0.429,
                                                    -0.219
                                                ],
                                                [
                                                    -0.653,
                                                    0
                                                ],
                                                [
                                                    -0.481,
                                                    0.313
                                                ],
                                                [
                                                    -0.266,
                                                    0.56
                                                ],
                                                [
                                                    0,
                                                    0.756
                                                ],
                                                [
                                                    0.271,
                                                    0.56
                                                ],
                                                [
                                                    0.495,
                                                    0.308
                                                ],
                                                [
                                                    0.495,
                                                    0
                                                ],
                                                [
                                                    0.392,
                                                    -0.182
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.513
                                                ],
                                                [
                                                    -0.294,
                                                    0.238
                                                ],
                                                [
                                                    -0.261,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    -0.065
                                                ],
                                                [
                                                    -0.126,
                                                    -0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.084,
                                                    0.672
                                                ],
                                                [
                                                    0.588,
                                                    0.415
                                                ],
                                                [
                                                    0.933,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    344.421,
                                                    59.086
                                                ],
                                                [
                                                    345.709,
                                                    57.994
                                                ],
                                                [
                                                    346.122,
                                                    56.384
                                                ],
                                                [
                                                    346.122,
                                                    48.936
                                                ],
                                                [
                                                    344.106,
                                                    48.936
                                                ],
                                                [
                                                    344.008,
                                                    50.07
                                                ],
                                                [
                                                    343.07,
                                                    49.139
                                                ],
                                                [
                                                    341.642,
                                                    48.81
                                                ],
                                                [
                                                    339.941,
                                                    49.279
                                                ],
                                                [
                                                    338.821,
                                                    50.588
                                                ],
                                                [
                                                    338.422,
                                                    52.562
                                                ],
                                                [
                                                    338.828,
                                                    54.536
                                                ],
                                                [
                                                    339.976,
                                                    55.838
                                                ],
                                                [
                                                    341.712,
                                                    56.3
                                                ],
                                                [
                                                    343.042,
                                                    56.027
                                                ],
                                                [
                                                    343.952,
                                                    55.18
                                                ],
                                                [
                                                    343.952,
                                                    56.482
                                                ],
                                                [
                                                    343.511,
                                                    57.609
                                                ],
                                                [
                                                    342.286,
                                                    57.966
                                                ],
                                                [
                                                    341.579,
                                                    57.868
                                                ],
                                                [
                                                    341.075,
                                                    57.525
                                                ],
                                                [
                                                    340.844,
                                                    56.86
                                                ],
                                                [
                                                    338.758,
                                                    57.224
                                                ],
                                                [
                                                    339.766,
                                                    58.855
                                                ],
                                                [
                                                    342.146,
                                                    59.478
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "g",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.285,
                                                    0.378
                                                ],
                                                [
                                                    0,
                                                    0.644
                                                ],
                                                [
                                                    -0.285,
                                                    0.369
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.149
                                                ],
                                                [
                                                    -0.135,
                                                    -0.285
                                                ],
                                                [
                                                    0,
                                                    -0.392
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.135,
                                                    -0.289
                                                ],
                                                [
                                                    0.247,
                                                    -0.159
                                                ],
                                                [
                                                    0.345,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.285,
                                                    -0.378
                                                ],
                                                [
                                                    0,
                                                    -0.653
                                                ],
                                                [
                                                    0.285,
                                                    -0.369
                                                ],
                                                [
                                                    0.345,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    0.149
                                                ],
                                                [
                                                    0.135,
                                                    0.285
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.383
                                                ],
                                                [
                                                    -0.135,
                                                    0.289
                                                ],
                                                [
                                                    -0.247,
                                                    0.159
                                                ],
                                                [
                                                    -0.532,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    341.061,
                                                    54.109
                                                ],
                                                [
                                                    340.634,
                                                    52.576
                                                ],
                                                [
                                                    341.061,
                                                    51.043
                                                ],
                                                [
                                                    342.272,
                                                    50.49
                                                ],
                                                [
                                                    343.168,
                                                    50.714
                                                ],
                                                [
                                                    343.749,
                                                    51.365
                                                ],
                                                [
                                                    343.952,
                                                    52.38
                                                ],
                                                [
                                                    343.952,
                                                    52.758
                                                ],
                                                [
                                                    343.749,
                                                    53.766
                                                ],
                                                [
                                                    343.175,
                                                    54.438
                                                ],
                                                [
                                                    342.286,
                                                    54.676
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": ".",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": ".",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    350.504,
                                                    57
                                                ],
                                                [
                                                    350.504,
                                                    54.914
                                                ],
                                                [
                                                    348.46,
                                                    54.914
                                                ],
                                                [
                                                    348.46,
                                                    57
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 4",
                    "sr": 1,
                    "st": 5,
                    "op": 160,
                    "ip": 114,
                    "ln": "111",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                10.612,
                                -36.767
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        100
                                    ],
                                    "t": 113.999
                                },
                                {
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": 123.999
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                532.612,
                                329.233
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "ef": [
                        {
                            "ty": 5,
                            "nm": "Colorama",
                            "en": 0,
                            "ef": [
                                {
                                    "ty": 6,
                                    "nm": "Input Phase",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Get Phase From",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Add Phase",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Add Phase From",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Add Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 1,
                                    "nm": "Phase Shift",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 113.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    360
                                                ],
                                                "t": 123.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    1440
                                                ],
                                                "t": 134.999
                                            },
                                            {
                                                "s": [
                                                    2160
                                                ],
                                                "t": 145.999
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Output Cycle",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Use Preset Palette",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Output Cycle",
                                    "v": 0
                                },
                                {
                                    "ty": 0,
                                    "nm": "Cycle Repetitions",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Interpolate Palette",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Modify",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Modify",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Modify Alpha",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Change Empty Pixels",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Pixel Selection",
                                    "v": 0
                                },
                                {
                                    "ty": 2,
                                    "nm": "Matching Color",
                                    "v": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Matching Tolerance",
                                    "v": {
                                        "a": 0,
                                        "k": 0.5
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Matching Softness",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Matching Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Masking",
                                    "v": 0
                                },
                                {
                                    "ty": 6,
                                    "nm": "Mask Layer",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Masking Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Composite Over Layer",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Blend With Original",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        }
                    ],
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            43.68,
                                            17.421
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8392,
                                            0.8392,
                                            0.8392
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.7294,
                                            0.4824,
                                            0.5059
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100.539,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            32.538,
                                            -37.059
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 19",
                    "sr": 1,
                    "st": 5,
                    "op": 160,
                    "ip": 114,
                    "ln": "208",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -180.571,
                                -35.559
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0,
                                        100
                                    ],
                                    "t": 113.999
                                },
                                {
                                    "s": [
                                        100,
                                        100
                                    ],
                                    "t": 130.999
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                201.429,
                                330.441
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "ef": [
                        {
                            "ty": 5,
                            "nm": "Colorama",
                            "en": 0,
                            "ef": [
                                {
                                    "ty": 6,
                                    "nm": "Input Phase",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Get Phase From",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Add Phase",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Add Phase From",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Add Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 1,
                                    "nm": "Phase Shift",
                                    "v": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 113.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    360
                                                ],
                                                "t": 123.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    1440
                                                ],
                                                "t": 134.999
                                            },
                                            {
                                                "s": [
                                                    2160
                                                ],
                                                "t": 145.999
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Output Cycle",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Use Preset Palette",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Output Cycle",
                                    "v": 0
                                },
                                {
                                    "ty": 0,
                                    "nm": "Cycle Repetitions",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Interpolate Palette",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Modify",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Modify",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Modify Alpha",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Change Empty Pixels",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Pixel Selection",
                                    "v": 0
                                },
                                {
                                    "ty": 2,
                                    "nm": "Matching Color",
                                    "v": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Matching Tolerance",
                                    "v": {
                                        "a": 0,
                                        "k": 0.5
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Matching Softness",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Matching Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 6,
                                    "nm": "Masking",
                                    "v": 0
                                },
                                {
                                    "ty": 6,
                                    "nm": "Mask Layer",
                                    "v": 0
                                },
                                {
                                    "ty": 7,
                                    "nm": "Masking Mode",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 7,
                                    "nm": "Composite Over Layer",
                                    "v": {
                                        "a": 0,
                                        "k": 1
                                    }
                                },
                                {
                                    "ty": 0,
                                    "nm": "Blend With Original",
                                    "v": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            ]
                        }
                    ],
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            236.68,
                                            20.421
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.7294,
                                            0.4824,
                                            0.5059
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.7294,
                                            0.4824,
                                            0.5059
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            -118.437,
                                            -0.762
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100.539,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -181.508,
                                            -36.321
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 109,
                    "op": 160,
                    "ip": 109,
                    "ln": "108",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                3.877,
                                -30.675
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                385.877,
                                335.325
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            407.655,
                                            112.213
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8392,
                                            0.8392,
                                            0.8392
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9373,
                                            0.9373,
                                            0.9373
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            5.877,
                                            -43.675
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Text field",
            "id": "7",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Mouse Outlines",
                    "sr": 1,
                    "st": 33,
                    "op": 141,
                    "ip": 106,
                    "ln": "305",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                27,
                                27
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        85,
                                        85
                                    ],
                                    "t": 120.999
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        75,
                                        75
                                    ],
                                    "t": 127.999
                                },
                                {
                                    "s": [
                                        85,
                                        85
                                    ],
                                    "t": 135.999
                                }
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        626.468,
                                        542.677
                                    ],
                                    "t": 105.999
                                },
                                {
                                    "s": [
                                        612.863,
                                        520.909
                                    ],
                                    "t": 112.999
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 14
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.042,
                                                    0.22
                                                ],
                                                [
                                                    -0.158,
                                                    0.158
                                                ],
                                                [
                                                    -0.219,
                                                    0.041
                                                ],
                                                [
                                                    -0.205,
                                                    -0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.125,
                                                    -0.2
                                                ],
                                                [
                                                    0.015,
                                                    -0.236
                                                ],
                                                [
                                                    0.15,
                                                    -0.182
                                                ],
                                                [
                                                    0.229,
                                                    -0.06
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.569,
                                                    -0.568
                                                ],
                                                [
                                                    0.202,
                                                    -0.778
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.182,
                                                    -0.151
                                                ],
                                                [
                                                    0.236,
                                                    -0.016
                                                ],
                                                [
                                                    0.201,
                                                    0.125
                                                ],
                                                [
                                                    0.089,
                                                    0.218
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.089,
                                                    -0.205
                                                ],
                                                [
                                                    0.041,
                                                    -0.219
                                                ],
                                                [
                                                    0.158,
                                                    -0.158
                                                ],
                                                [
                                                    0.22,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.218,
                                                    0.089
                                                ],
                                                [
                                                    0.125,
                                                    0.201
                                                ],
                                                [
                                                    -0.016,
                                                    0.236
                                                ],
                                                [
                                                    -0.151,
                                                    0.182
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.779,
                                                    0.2
                                                ],
                                                [
                                                    -0.569,
                                                    0.567
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.06,
                                                    0.229
                                                ],
                                                [
                                                    -0.182,
                                                    0.15
                                                ],
                                                [
                                                    -0.236,
                                                    0.015
                                                ],
                                                [
                                                    -0.2,
                                                    -0.125
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -19.032,
                                                    -17.567
                                                ],
                                                [
                                                    -19.104,
                                                    -18.219
                                                ],
                                                [
                                                    -18.798,
                                                    -18.798
                                                ],
                                                [
                                                    -18.219,
                                                    -19.104
                                                ],
                                                [
                                                    -17.567,
                                                    -19.032
                                                ],
                                                [
                                                    18.433,
                                                    -4.407
                                                ],
                                                [
                                                    18.962,
                                                    -3.962
                                                ],
                                                [
                                                    19.131,
                                                    -3.291
                                                ],
                                                [
                                                    18.875,
                                                    -2.648
                                                ],
                                                [
                                                    18.291,
                                                    -2.276
                                                ],
                                                [
                                                    4.512,
                                                    1.279
                                                ],
                                                [
                                                    2.454,
                                                    2.452
                                                ],
                                                [
                                                    1.276,
                                                    4.507
                                                ],
                                                [
                                                    -2.276,
                                                    18.291
                                                ],
                                                [
                                                    -2.648,
                                                    18.875
                                                ],
                                                [
                                                    -3.291,
                                                    19.131
                                                ],
                                                [
                                                    -3.962,
                                                    18.962
                                                ],
                                                [
                                                    -4.407,
                                                    18.433
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.115,
                                            28.115
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Button Outlines",
                    "sr": 1,
                    "st": 2,
                    "op": 18003,
                    "ip": 166,
                    "ln": "103",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                28.5,
                                28.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                85,
                                85
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                593.538,
                                489.114
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.5,
                                                    29
                                                ],
                                                [
                                                    41.5,
                                                    29
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.124,
                                                    -0.018
                                                ],
                                                [
                                                    0.092,
                                                    -0.084
                                                ],
                                                [
                                                    0.028,
                                                    -0.122
                                                ],
                                                [
                                                    -0.045,
                                                    -0.117
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.563
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.121
                                                ],
                                                [
                                                    -0.092,
                                                    -0.084
                                                ],
                                                [
                                                    -0.124,
                                                    -0.018
                                                ],
                                                [
                                                    -0.112,
                                                    0.055
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    0.1
                                                ],
                                                [
                                                    0,
                                                    0.119
                                                ],
                                                [
                                                    0.063,
                                                    0.1
                                                ],
                                                [
                                                    0.107,
                                                    0.051
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.112,
                                                    -0.055
                                                ],
                                                [
                                                    -0.123,
                                                    0.018
                                                ],
                                                [
                                                    -0.092,
                                                    0.085
                                                ],
                                                [
                                                    -0.029,
                                                    0.122
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    0.563
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.045,
                                                    0.116
                                                ],
                                                [
                                                    0.029,
                                                    0.122
                                                ],
                                                [
                                                    0.092,
                                                    0.085
                                                ],
                                                [
                                                    0.123,
                                                    0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.05
                                                ],
                                                [
                                                    0.063,
                                                    -0.1
                                                ],
                                                [
                                                    0,
                                                    -0.118
                                                ],
                                                [
                                                    -0.064,
                                                    -0.1
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -10.975,
                                                    -11.19
                                                ],
                                                [
                                                    -11.338,
                                                    -11.246
                                                ],
                                                [
                                                    -11.669,
                                                    -11.089
                                                ],
                                                [
                                                    -11.854,
                                                    -10.772
                                                ],
                                                [
                                                    -11.829,
                                                    -10.406
                                                ],
                                                [
                                                    -8.275,
                                                    -0.872
                                                ],
                                                [
                                                    -8.275,
                                                    0.873
                                                ],
                                                [
                                                    -11.827,
                                                    10.407
                                                ],
                                                [
                                                    -11.853,
                                                    10.772
                                                ],
                                                [
                                                    -11.668,
                                                    11.088
                                                ],
                                                [
                                                    -11.337,
                                                    11.246
                                                ],
                                                [
                                                    -10.975,
                                                    11.19
                                                ],
                                                [
                                                    11.525,
                                                    0.565
                                                ],
                                                [
                                                    11.786,
                                                    0.335
                                                ],
                                                [
                                                    11.883,
                                                    0
                                                ],
                                                [
                                                    11.786,
                                                    -0.334
                                                ],
                                                [
                                                    11.525,
                                                    -0.565
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            29.618,
                                            28.999
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -15.74
                                                ],
                                                [
                                                    15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    15.74
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    15.74
                                                ],
                                                [
                                                    -15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -15.74
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -28.5
                                                ],
                                                [
                                                    28.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    28.5
                                                ],
                                                [
                                                    -28.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4431,
                                            0.2824,
                                            0.8314
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.5,
                                            28.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 3",
                    "sr": 1,
                    "st": 24,
                    "op": 188,
                    "ip": 133,
                    "ln": "99",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                212.087,
                                124.589
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                594.087,
                                490.589
                            ]
                        },
                        "r": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": 132.999
                                },
                                {
                                    "s": [
                                        207.82
                                    ],
                                    "t": 224.998
                                }
                            ]
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Ellipse 1",
                            "it": [
                                {
                                    "ty": "el",
                                    "nm": "Ellipse Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            30.939,
                                            30.939
                                        ]
                                    }
                                },
                                {
                                    "ty": "tm",
                                    "nm": "Trim Paths 1",
                                    "e": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 134.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 171.999
                                            }
                                        ]
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 151.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 186.999
                                            }
                                        ]
                                    },
                                    "m": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 2",
                                    "lc": 2,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 3
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            212.087,
                                            124.589
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Button Outlines 2",
                    "sr": 1,
                    "st": 24,
                    "op": 18025,
                    "ip": 133,
                    "ln": "98",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                28.5,
                                28.5
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        85,
                                        85
                                    ],
                                    "t": 111.999
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        75,
                                        75
                                    ],
                                    "t": 118.999
                                },
                                {
                                    "s": [
                                        85,
                                        85
                                    ],
                                    "t": 126.999
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                594.336,
                                489.014
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -15.74
                                                ],
                                                [
                                                    15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    15.74
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    15.74
                                                ],
                                                [
                                                    -15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -15.74
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -28.5
                                                ],
                                                [
                                                    28.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    28.5
                                                ],
                                                [
                                                    -28.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4431,
                                            0.2824,
                                            0.8314
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.5,
                                            28.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                },
                {
                    "ty": 4,
                    "nm": "Button Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 134,
                    "ip": 0,
                    "ln": "39",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                28.5,
                                28.5
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        85,
                                        85
                                    ],
                                    "t": 119.999
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        75,
                                        75
                                    ],
                                    "t": 126.999
                                },
                                {
                                    "s": [
                                        85,
                                        85
                                    ],
                                    "t": 134.999
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                594.336,
                                489.014
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.5,
                                                    29
                                                ],
                                                [
                                                    41.5,
                                                    29
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.124,
                                                    -0.018
                                                ],
                                                [
                                                    0.092,
                                                    -0.084
                                                ],
                                                [
                                                    0.028,
                                                    -0.122
                                                ],
                                                [
                                                    -0.045,
                                                    -0.117
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.563
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.121
                                                ],
                                                [
                                                    -0.092,
                                                    -0.084
                                                ],
                                                [
                                                    -0.124,
                                                    -0.018
                                                ],
                                                [
                                                    -0.112,
                                                    0.055
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    0.1
                                                ],
                                                [
                                                    0,
                                                    0.119
                                                ],
                                                [
                                                    0.063,
                                                    0.1
                                                ],
                                                [
                                                    0.107,
                                                    0.051
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.112,
                                                    -0.055
                                                ],
                                                [
                                                    -0.123,
                                                    0.018
                                                ],
                                                [
                                                    -0.092,
                                                    0.085
                                                ],
                                                [
                                                    -0.029,
                                                    0.122
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    0.563
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.045,
                                                    0.116
                                                ],
                                                [
                                                    0.029,
                                                    0.122
                                                ],
                                                [
                                                    0.092,
                                                    0.085
                                                ],
                                                [
                                                    0.123,
                                                    0.018
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.05
                                                ],
                                                [
                                                    0.063,
                                                    -0.1
                                                ],
                                                [
                                                    0,
                                                    -0.118
                                                ],
                                                [
                                                    -0.064,
                                                    -0.1
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -10.975,
                                                    -11.19
                                                ],
                                                [
                                                    -11.338,
                                                    -11.246
                                                ],
                                                [
                                                    -11.669,
                                                    -11.089
                                                ],
                                                [
                                                    -11.854,
                                                    -10.772
                                                ],
                                                [
                                                    -11.829,
                                                    -10.406
                                                ],
                                                [
                                                    -8.275,
                                                    -0.872
                                                ],
                                                [
                                                    -8.275,
                                                    0.873
                                                ],
                                                [
                                                    -11.827,
                                                    10.407
                                                ],
                                                [
                                                    -11.853,
                                                    10.772
                                                ],
                                                [
                                                    -11.668,
                                                    11.088
                                                ],
                                                [
                                                    -11.337,
                                                    11.246
                                                ],
                                                [
                                                    -10.975,
                                                    11.19
                                                ],
                                                [
                                                    11.525,
                                                    0.565
                                                ],
                                                [
                                                    11.786,
                                                    0.335
                                                ],
                                                [
                                                    11.883,
                                                    0
                                                ],
                                                [
                                                    11.786,
                                                    -0.334
                                                ],
                                                [
                                                    11.525,
                                                    -0.565
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 2
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            29.618,
                                            28.999
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -15.74
                                                ],
                                                [
                                                    15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    15.74
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    15.74
                                                ],
                                                [
                                                    -15.74,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -15.74
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -28.5
                                                ],
                                                [
                                                    28.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    28.5
                                                ],
                                                [
                                                    -28.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4431,
                                            0.2824,
                                            0.8314
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.5,
                                            28.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 5
                },
                {
                    "ty": 5,
                    "nm": "Summarise this account note for the team rahul.menon@northbank.com, card ending 4417, complained about the transfer delay on 14 Aug.",
                    "sr": 1,
                    "st": 0,
                    "op": 133,
                    "ip": 0,
                    "ln": "38",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                225.403,
                                20.239
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        366.766,
                                        515.731
                                    ],
                                    "t": 32
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        366.766,
                                        499.618
                                    ],
                                    "t": 33
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        366.766,
                                        499.618
                                    ],
                                    "t": 69.999
                                },
                                {
                                    "s": [
                                        366.766,
                                        489.618
                                    ],
                                    "t": 70.999
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [
                            {
                                "s": {
                                    "t": 0,
                                    "xe": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ne": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "b": 1,
                                    "rn": 0,
                                    "sh": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "r": 1,
                                    "sm": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 0
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 108.999
                                            }
                                        ]
                                    },
                                    "e": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                "a": {
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "rx": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ry": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sw": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fh": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fs": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "fb": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "t": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            }
                        ],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 15,
                                        "t": "Summarise this account note for the team\u0003\rrahul.menon@northbank.com, card ending 4417, \u0003complained about the transfer delay on 14 Aug.",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 6
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "37",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0.74,
                                107.799
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382.74,
                                487.799
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.333,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 1,
                                                    "y": 1
                                                },
                                                "s": [
                                                    516.412,
                                                    66.982
                                                ],
                                                "t": 33
                                            },
                                            {
                                                "o": {
                                                    "x": 0.333,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 1,
                                                    "y": 1
                                                },
                                                "s": [
                                                    516.412,
                                                    92.982
                                                ],
                                                "t": 40
                                            },
                                            {
                                                "o": {
                                                    "x": 0.333,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 1,
                                                    "y": 1
                                                },
                                                "s": [
                                                    516.412,
                                                    97.982
                                                ],
                                                "t": 72.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.333,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 1,
                                                    "y": 1
                                                },
                                                "s": [
                                                    516.412,
                                                    100.821
                                                ],
                                                "t": 73.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.333,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 1
                                                },
                                                "s": [
                                                    516.412,
                                                    112.821
                                                ],
                                                "t": 74.999
                                            },
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 1
                                                },
                                                "s": [
                                                    516.412,
                                                    112.821
                                                ],
                                                "t": 129.999
                                            },
                                            {
                                                "s": [
                                                    516.412,
                                                    72.821
                                                ],
                                                "t": 132.999
                                            }
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            1.488,
                                            -49.765
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            2.621,
                                            58.57
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 7
                }
            ]
        },
        {
            "nm": "Window",
            "id": "10",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "SVG 1.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "64",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                95.076
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 556,
                    "h": 63,
                    "refId": "11",
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "63",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                384,
                                374
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            555.946,
                                            495.29
                                        ]
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -1.76,
                                            -61.141
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                }
            ]
        },
        {
            "nm": "SVG 1.svg",
            "id": "11",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "SVG 1.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "25",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.584,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.664
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.311,
                                                    0.672
                                                ],
                                                [
                                                    -0.576,
                                                    0.36
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.36
                                                ],
                                                [
                                                    -0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.583,
                                                    -0.36
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.36
                                                ],
                                                [
                                                    -0.311,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.584,
                                                    -0.36
                                                ],
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.312,
                                                    0.664
                                                ],
                                                [
                                                    -0.577,
                                                    0.36
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    4.452
                                                ],
                                                [
                                                    -15.294,
                                                    3.912
                                                ],
                                                [
                                                    -16.626,
                                                    2.376
                                                ],
                                                [
                                                    -17.094,
                                                    0.012
                                                ],
                                                [
                                                    -16.626,
                                                    -2.364
                                                ],
                                                [
                                                    -15.294,
                                                    -3.912
                                                ],
                                                [
                                                    -13.242,
                                                    -4.452
                                                ],
                                                [
                                                    -11.201,
                                                    -3.912
                                                ],
                                                [
                                                    -9.858,
                                                    -2.364
                                                ],
                                                [
                                                    -9.39,
                                                    0.012
                                                ],
                                                [
                                                    -9.858,
                                                    2.376
                                                ],
                                                [
                                                    -11.201,
                                                    3.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.264
                                                ],
                                                [
                                                    -0.216,
                                                    0.512
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.52
                                                ],
                                                [
                                                    0.416,
                                                    0.272
                                                ],
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ],
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.272
                                                ],
                                                [
                                                    -0.216,
                                                    0.52
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.512
                                                ],
                                                [
                                                    0.416,
                                                    0.264
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    3.468
                                                ],
                                                [
                                                    -11.718,
                                                    3.072
                                                ],
                                                [
                                                    -10.77,
                                                    1.896
                                                ],
                                                [
                                                    -10.446,
                                                    0.012
                                                ],
                                                [
                                                    -10.77,
                                                    -1.872
                                                ],
                                                [
                                                    -11.718,
                                                    -3.06
                                                ],
                                                [
                                                    -13.242,
                                                    -3.468
                                                ],
                                                [
                                                    -14.766,
                                                    -3.06
                                                ],
                                                [
                                                    -15.714,
                                                    -1.872
                                                ],
                                                [
                                                    -16.038,
                                                    0.012
                                                ],
                                                [
                                                    -15.714,
                                                    1.896
                                                ],
                                                [
                                                    -14.766,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.113,
                                                    -2.1
                                                ],
                                                [
                                                    -7.065,
                                                    -0.468
                                                ],
                                                [
                                                    -7.197,
                                                    -0.6
                                                ],
                                                [
                                                    -6.477,
                                                    -1.824
                                                ],
                                                [
                                                    -5.121,
                                                    -2.244
                                                ],
                                                [
                                                    -3.525,
                                                    -1.572
                                                ],
                                                [
                                                    -2.973,
                                                    0.168
                                                ],
                                                [
                                                    -2.973,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    0.456
                                                ],
                                                [
                                                    -4.101,
                                                    -0.54
                                                ],
                                                [
                                                    -4.545,
                                                    -1.152
                                                ],
                                                [
                                                    -5.325,
                                                    -1.368
                                                ],
                                                [
                                                    -6.573,
                                                    -0.888
                                                ],
                                                [
                                                    -7.029,
                                                    0.456
                                                ],
                                                [
                                                    -7.029,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.064
                                                ],
                                                [
                                                    -0.136,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.232,
                                                    0.224
                                                ],
                                                [
                                                    0,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    0.072,
                                                    0.064
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    -0.232
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.161,
                                                    -4.26
                                                ],
                                                [
                                                    -0.161,
                                                    2.988
                                                ],
                                                [
                                                    -0.065,
                                                    3.288
                                                ],
                                                [
                                                    0.247,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    4.26
                                                ],
                                                [
                                                    0.103,
                                                    4.26
                                                ],
                                                [
                                                    -0.809,
                                                    3.924
                                                ],
                                                [
                                                    -1.145,
                                                    3.036
                                                ],
                                                [
                                                    -1.145,
                                                    -4.26
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.178,
                                                    -2.1
                                                ],
                                                [
                                                    3.178,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.202,
                                                    -4.236
                                                ],
                                                [
                                                    3.202,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -4.236
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.527,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.942,
                                                    -2.1
                                                ],
                                                [
                                                    5.99,
                                                    -0.468
                                                ],
                                                [
                                                    5.858,
                                                    -0.6
                                                ],
                                                [
                                                    6.578,
                                                    -1.824
                                                ],
                                                [
                                                    7.933,
                                                    -2.244
                                                ],
                                                [
                                                    9.529,
                                                    -1.572
                                                ],
                                                [
                                                    10.081,
                                                    0.168
                                                ],
                                                [
                                                    10.081,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    0.456
                                                ],
                                                [
                                                    8.953,
                                                    -0.54
                                                ],
                                                [
                                                    8.509,
                                                    -1.152
                                                ],
                                                [
                                                    7.729,
                                                    -1.368
                                                ],
                                                [
                                                    6.482,
                                                    -0.888
                                                ],
                                                [
                                                    6.026,
                                                    0.456
                                                ],
                                                [
                                                    6.026,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.672
                                                ],
                                                [
                                                    -0.24,
                                                    0.496
                                                ],
                                                [
                                                    -0.431,
                                                    0.272
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.4,
                                                    -0.224
                                                ],
                                                [
                                                    -0.248,
                                                    -0.48
                                                ],
                                                [
                                                    -0.032,
                                                    -0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -0.368
                                                ],
                                                [
                                                    -0.544,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.192
                                                ],
                                                [
                                                    -0.144,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.352
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.44,
                                                    0.272
                                                ],
                                                [
                                                    0.24,
                                                    0.496
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.672
                                                ],
                                                [
                                                    0.24,
                                                    -0.504
                                                ],
                                                [
                                                    0.44,
                                                    -0.272
                                                ],
                                                [
                                                    0.496,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    0.224
                                                ],
                                                [
                                                    0.256,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    0.656
                                                ],
                                                [
                                                    0.328,
                                                    0.36
                                                ],
                                                [
                                                    0.353,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.184,
                                                    0.592
                                                ],
                                                [
                                                    -0.488,
                                                    0.352
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.431,
                                                    -0.272
                                                ],
                                                [
                                                    -0.24,
                                                    -0.504
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.417,
                                                    1.08
                                                ],
                                                [
                                                    11.777,
                                                    -0.672
                                                ],
                                                [
                                                    12.785,
                                                    -1.836
                                                ],
                                                [
                                                    14.321,
                                                    -2.244
                                                ],
                                                [
                                                    15.665,
                                                    -1.908
                                                ],
                                                [
                                                    16.649,
                                                    -0.852
                                                ],
                                                [
                                                    17.081,
                                                    0.948
                                                ],
                                                [
                                                    17.093,
                                                    1.392
                                                ],
                                                [
                                                    12.461,
                                                    1.392
                                                ],
                                                [
                                                    13.013,
                                                    2.928
                                                ],
                                                [
                                                    14.321,
                                                    3.468
                                                ],
                                                [
                                                    15.281,
                                                    3.18
                                                ],
                                                [
                                                    15.929,
                                                    2.388
                                                ],
                                                [
                                                    16.985,
                                                    2.46
                                                ],
                                                [
                                                    15.977,
                                                    3.876
                                                ],
                                                [
                                                    14.321,
                                                    4.404
                                                ],
                                                [
                                                    12.785,
                                                    3.996
                                                ],
                                                [
                                                    11.777,
                                                    2.844
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    0.288
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.32
                                                ],
                                                [
                                                    0.088,
                                                    -0.584
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.088,
                                                    -0.632
                                                ],
                                                [
                                                    -0.304,
                                                    -0.296
                                                ],
                                                [
                                                    -0.512,
                                                    0
                                                ],
                                                [
                                                    -0.312,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.013,
                                                    0.516
                                                ],
                                                [
                                                    15.425,
                                                    -0.864
                                                ],
                                                [
                                                    14.321,
                                                    -1.308
                                                ],
                                                [
                                                    13.085,
                                                    -0.828
                                                ],
                                                [
                                                    12.485,
                                                    0.516
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9333,
                                            0.9255,
                                            0.9255
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            92.682,
                                            43.24
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ],
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ],
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -4.5
                                                ],
                                                [
                                                    4.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.5
                                                ],
                                                [
                                                    -4.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.1216,
                                            0.7569,
                                            0.4196
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            62.5,
                                            43.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.642,
                                                    5.656
                                                ],
                                                [
                                                    -41.546,
                                                    -5.704
                                                ],
                                                [
                                                    -39.002,
                                                    -5.704
                                                ],
                                                [
                                                    -34.906,
                                                    5.656
                                                ],
                                                [
                                                    -37.082,
                                                    5.656
                                                ],
                                                [
                                                    -38.026,
                                                    2.968
                                                ],
                                                [
                                                    -42.522,
                                                    2.968
                                                ],
                                                [
                                                    -43.466,
                                                    5.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -41.914,
                                                    1.192
                                                ],
                                                [
                                                    -38.634,
                                                    1.192
                                                ],
                                                [
                                                    -40.266,
                                                    -3.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -33.712,
                                                    5.656
                                                ],
                                                [
                                                    -33.712,
                                                    -5.704
                                                ],
                                                [
                                                    -31.632,
                                                    -5.704
                                                ],
                                                [
                                                    -31.632,
                                                    5.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.267,
                                                    5.656
                                                ],
                                                [
                                                    -22.171,
                                                    -5.704
                                                ],
                                                [
                                                    -19.627,
                                                    -5.704
                                                ],
                                                [
                                                    -15.531,
                                                    5.656
                                                ],
                                                [
                                                    -17.707,
                                                    5.656
                                                ],
                                                [
                                                    -18.651,
                                                    2.968
                                                ],
                                                [
                                                    -23.146,
                                                    2.968
                                                ],
                                                [
                                                    -24.09,
                                                    5.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -22.539,
                                                    1.192
                                                ],
                                                [
                                                    -19.259,
                                                    1.192
                                                ],
                                                [
                                                    -20.891,
                                                    -3.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.099,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.245
                                                ],
                                                [
                                                    0.299,
                                                    0.437
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    -0.245
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.096,
                                                    0.128
                                                ],
                                                [
                                                    0.267,
                                                    0.096
                                                ],
                                                [
                                                    0.502,
                                                    0.096
                                                ],
                                                [
                                                    0.491,
                                                    0.213
                                                ],
                                                [
                                                    0.203,
                                                    0.331
                                                ],
                                                [
                                                    0,
                                                    0.491
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -1.184,
                                                    0
                                                ],
                                                [
                                                    -0.522,
                                                    -0.267
                                                ],
                                                [
                                                    -0.266,
                                                    -0.437
                                                ],
                                                [
                                                    -0.042,
                                                    -0.533
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.118,
                                                    0.213
                                                ],
                                                [
                                                    0.235,
                                                    0.117
                                                ],
                                                [
                                                    0.384,
                                                    0
                                                ],
                                                [
                                                    0.256,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.32
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.245,
                                                    -0.096
                                                ],
                                                [
                                                    -0.426,
                                                    -0.075
                                                ],
                                                [
                                                    -0.512,
                                                    -0.224
                                                ],
                                                [
                                                    -0.213,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0.662,
                                                    -0.448
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.245
                                                ],
                                                [
                                                    -0.298,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.448
                                                ],
                                                [
                                                    0.288,
                                                    0.245
                                                ],
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.256,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.192
                                                ],
                                                [
                                                    -0.085,
                                                    -0.128
                                                ],
                                                [
                                                    -0.256,
                                                    -0.096
                                                ],
                                                [
                                                    -0.864,
                                                    -0.149
                                                ],
                                                [
                                                    -0.49,
                                                    -0.224
                                                ],
                                                [
                                                    -0.192,
                                                    -0.331
                                                ],
                                                [
                                                    0,
                                                    -0.8
                                                ],
                                                [
                                                    0.619,
                                                    -0.501
                                                ],
                                                [
                                                    0.822,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.256
                                                ],
                                                [
                                                    0.278,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.01,
                                                    -0.267
                                                ],
                                                [
                                                    -0.117,
                                                    -0.213
                                                ],
                                                [
                                                    -0.234,
                                                    -0.128
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.107,
                                                    0.149
                                                ],
                                                [
                                                    0.246,
                                                    0.085
                                                ],
                                                [
                                                    0.875,
                                                    0.128
                                                ],
                                                [
                                                    0.512,
                                                    0.224
                                                ],
                                                [
                                                    0.224,
                                                    0.331
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    -0.65,
                                                    0.437
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.01,
                                                    5.848
                                                ],
                                                [
                                                    -13.17,
                                                    5.48
                                                ],
                                                [
                                                    -14.466,
                                                    4.456
                                                ],
                                                [
                                                    -14.978,
                                                    2.968
                                                ],
                                                [
                                                    -12.882,
                                                    2.872
                                                ],
                                                [
                                                    -12.338,
                                                    3.912
                                                ],
                                                [
                                                    -10.994,
                                                    4.28
                                                ],
                                                [
                                                    -9.906,
                                                    4.056
                                                ],
                                                [
                                                    -9.522,
                                                    3.32
                                                ],
                                                [
                                                    -9.666,
                                                    2.84
                                                ],
                                                [
                                                    -10.194,
                                                    2.504
                                                ],
                                                [
                                                    -11.33,
                                                    2.216
                                                ],
                                                [
                                                    -13.362,
                                                    1.672
                                                ],
                                                [
                                                    -14.402,
                                                    0.84
                                                ],
                                                [
                                                    -14.69,
                                                    -0.392
                                                ],
                                                [
                                                    -13.778,
                                                    -2.328
                                                ],
                                                [
                                                    -11.074,
                                                    -3.08
                                                ],
                                                [
                                                    -9.058,
                                                    -2.68
                                                ],
                                                [
                                                    -7.858,
                                                    -1.64
                                                ],
                                                [
                                                    -7.378,
                                                    -0.2
                                                ],
                                                [
                                                    -9.458,
                                                    -0.104
                                                ],
                                                [
                                                    -9.65,
                                                    -0.824
                                                ],
                                                [
                                                    -10.178,
                                                    -1.32
                                                ],
                                                [
                                                    -11.106,
                                                    -1.512
                                                ],
                                                [
                                                    -12.21,
                                                    -1.224
                                                ],
                                                [
                                                    -12.578,
                                                    -0.456
                                                ],
                                                [
                                                    -12.434,
                                                    0.104
                                                ],
                                                [
                                                    -11.906,
                                                    0.472
                                                ],
                                                [
                                                    -10.898,
                                                    0.712
                                                ],
                                                [
                                                    -8.818,
                                                    1.24
                                                ],
                                                [
                                                    -7.73,
                                                    2.088
                                                ],
                                                [
                                                    -7.394,
                                                    3.288
                                                ],
                                                [
                                                    -8.386,
                                                    5.192
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.099,
                                                    0
                                                ],
                                                [
                                                    0.575,
                                                    0.245
                                                ],
                                                [
                                                    0.298,
                                                    0.437
                                                ],
                                                [
                                                    0.042,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.287,
                                                    -0.245
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.097,
                                                    0.128
                                                ],
                                                [
                                                    0.267,
                                                    0.096
                                                ],
                                                [
                                                    0.502,
                                                    0.096
                                                ],
                                                [
                                                    0.49,
                                                    0.213
                                                ],
                                                [
                                                    0.202,
                                                    0.331
                                                ],
                                                [
                                                    0,
                                                    0.491
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -1.184,
                                                    0
                                                ],
                                                [
                                                    -0.522,
                                                    -0.267
                                                ],
                                                [
                                                    -0.266,
                                                    -0.437
                                                ],
                                                [
                                                    -0.042,
                                                    -0.533
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.118,
                                                    0.213
                                                ],
                                                [
                                                    0.235,
                                                    0.117
                                                ],
                                                [
                                                    0.384,
                                                    0
                                                ],
                                                [
                                                    0.256,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.32
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.245,
                                                    -0.096
                                                ],
                                                [
                                                    -0.426,
                                                    -0.075
                                                ],
                                                [
                                                    -0.512,
                                                    -0.224
                                                ],
                                                [
                                                    -0.213,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0.662,
                                                    -0.448
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.566,
                                                    -0.245
                                                ],
                                                [
                                                    -0.299,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.074,
                                                    0.448
                                                ],
                                                [
                                                    0.288,
                                                    0.245
                                                ],
                                                [
                                                    0.481,
                                                    0
                                                ],
                                                [
                                                    0.256,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.192
                                                ],
                                                [
                                                    -0.084,
                                                    -0.128
                                                ],
                                                [
                                                    -0.256,
                                                    -0.096
                                                ],
                                                [
                                                    -0.864,
                                                    -0.149
                                                ],
                                                [
                                                    -0.491,
                                                    -0.224
                                                ],
                                                [
                                                    -0.192,
                                                    -0.331
                                                ],
                                                [
                                                    0,
                                                    -0.8
                                                ],
                                                [
                                                    0.618,
                                                    -0.501
                                                ],
                                                [
                                                    0.822,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.256
                                                ],
                                                [
                                                    0.278,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.01,
                                                    -0.267
                                                ],
                                                [
                                                    -0.117,
                                                    -0.213
                                                ],
                                                [
                                                    -0.234,
                                                    -0.128
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.107,
                                                    0.149
                                                ],
                                                [
                                                    0.246,
                                                    0.085
                                                ],
                                                [
                                                    0.875,
                                                    0.128
                                                ],
                                                [
                                                    0.513,
                                                    0.224
                                                ],
                                                [
                                                    0.224,
                                                    0.331
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    -0.65,
                                                    0.437
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.323,
                                                    5.848
                                                ],
                                                [
                                                    -4.482,
                                                    5.48
                                                ],
                                                [
                                                    -5.778,
                                                    4.456
                                                ],
                                                [
                                                    -6.29,
                                                    2.968
                                                ],
                                                [
                                                    -4.194,
                                                    2.872
                                                ],
                                                [
                                                    -3.651,
                                                    3.912
                                                ],
                                                [
                                                    -2.307,
                                                    4.28
                                                ],
                                                [
                                                    -1.219,
                                                    4.056
                                                ],
                                                [
                                                    -0.835,
                                                    3.32
                                                ],
                                                [
                                                    -0.979,
                                                    2.84
                                                ],
                                                [
                                                    -1.507,
                                                    2.504
                                                ],
                                                [
                                                    -2.643,
                                                    2.216
                                                ],
                                                [
                                                    -4.674,
                                                    1.672
                                                ],
                                                [
                                                    -5.714,
                                                    0.84
                                                ],
                                                [
                                                    -6.002,
                                                    -0.392
                                                ],
                                                [
                                                    -5.09,
                                                    -2.328
                                                ],
                                                [
                                                    -2.387,
                                                    -3.08
                                                ],
                                                [
                                                    -0.371,
                                                    -2.68
                                                ],
                                                [
                                                    0.829,
                                                    -1.64
                                                ],
                                                [
                                                    1.309,
                                                    -0.2
                                                ],
                                                [
                                                    -0.771,
                                                    -0.104
                                                ],
                                                [
                                                    -0.963,
                                                    -0.824
                                                ],
                                                [
                                                    -1.491,
                                                    -1.32
                                                ],
                                                [
                                                    -2.419,
                                                    -1.512
                                                ],
                                                [
                                                    -3.523,
                                                    -1.224
                                                ],
                                                [
                                                    -3.891,
                                                    -0.456
                                                ],
                                                [
                                                    -3.747,
                                                    0.104
                                                ],
                                                [
                                                    -3.219,
                                                    0.472
                                                ],
                                                [
                                                    -2.211,
                                                    0.712
                                                ],
                                                [
                                                    -0.131,
                                                    1.24
                                                ],
                                                [
                                                    0.957,
                                                    2.088
                                                ],
                                                [
                                                    1.293,
                                                    3.288
                                                ],
                                                [
                                                    0.301,
                                                    5.192
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.893,
                                                    5.656
                                                ],
                                                [
                                                    2.893,
                                                    -2.888
                                                ],
                                                [
                                                    4.941,
                                                    -2.888
                                                ],
                                                [
                                                    4.941,
                                                    5.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.861,
                                                    -4.024
                                                ],
                                                [
                                                    2.861,
                                                    -5.848
                                                ],
                                                [
                                                    4.989,
                                                    -5.848
                                                ],
                                                [
                                                    4.989,
                                                    -4.024
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.099,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.245
                                                ],
                                                [
                                                    0.299,
                                                    0.437
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    -0.245
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.096,
                                                    0.128
                                                ],
                                                [
                                                    0.267,
                                                    0.096
                                                ],
                                                [
                                                    0.502,
                                                    0.096
                                                ],
                                                [
                                                    0.491,
                                                    0.213
                                                ],
                                                [
                                                    0.203,
                                                    0.331
                                                ],
                                                [
                                                    0,
                                                    0.491
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -1.184,
                                                    0
                                                ],
                                                [
                                                    -0.522,
                                                    -0.267
                                                ],
                                                [
                                                    -0.266,
                                                    -0.437
                                                ],
                                                [
                                                    -0.042,
                                                    -0.533
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.118,
                                                    0.213
                                                ],
                                                [
                                                    0.235,
                                                    0.117
                                                ],
                                                [
                                                    0.384,
                                                    0
                                                ],
                                                [
                                                    0.257,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.32
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.245,
                                                    -0.096
                                                ],
                                                [
                                                    -0.427,
                                                    -0.075
                                                ],
                                                [
                                                    -0.512,
                                                    -0.224
                                                ],
                                                [
                                                    -0.213,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0.662,
                                                    -0.448
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.245
                                                ],
                                                [
                                                    -0.298,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.448
                                                ],
                                                [
                                                    0.288,
                                                    0.245
                                                ],
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.256,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.192
                                                ],
                                                [
                                                    -0.085,
                                                    -0.128
                                                ],
                                                [
                                                    -0.256,
                                                    -0.096
                                                ],
                                                [
                                                    -0.864,
                                                    -0.149
                                                ],
                                                [
                                                    -0.49,
                                                    -0.224
                                                ],
                                                [
                                                    -0.192,
                                                    -0.331
                                                ],
                                                [
                                                    0,
                                                    -0.8
                                                ],
                                                [
                                                    0.619,
                                                    -0.501
                                                ],
                                                [
                                                    0.822,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.256
                                                ],
                                                [
                                                    0.278,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.01,
                                                    -0.267
                                                ],
                                                [
                                                    -0.117,
                                                    -0.213
                                                ],
                                                [
                                                    -0.233,
                                                    -0.128
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.107,
                                                    0.149
                                                ],
                                                [
                                                    0.246,
                                                    0.085
                                                ],
                                                [
                                                    0.875,
                                                    0.128
                                                ],
                                                [
                                                    0.512,
                                                    0.224
                                                ],
                                                [
                                                    0.224,
                                                    0.331
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    -0.65,
                                                    0.437
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    10.505,
                                                    5.848
                                                ],
                                                [
                                                    8.345,
                                                    5.48
                                                ],
                                                [
                                                    7.049,
                                                    4.456
                                                ],
                                                [
                                                    6.537,
                                                    2.968
                                                ],
                                                [
                                                    8.633,
                                                    2.872
                                                ],
                                                [
                                                    9.177,
                                                    3.912
                                                ],
                                                [
                                                    10.521,
                                                    4.28
                                                ],
                                                [
                                                    11.609,
                                                    4.056
                                                ],
                                                [
                                                    11.993,
                                                    3.32
                                                ],
                                                [
                                                    11.849,
                                                    2.84
                                                ],
                                                [
                                                    11.321,
                                                    2.504
                                                ],
                                                [
                                                    10.185,
                                                    2.216
                                                ],
                                                [
                                                    8.153,
                                                    1.672
                                                ],
                                                [
                                                    7.113,
                                                    0.84
                                                ],
                                                [
                                                    6.826,
                                                    -0.392
                                                ],
                                                [
                                                    7.737,
                                                    -2.328
                                                ],
                                                [
                                                    10.441,
                                                    -3.08
                                                ],
                                                [
                                                    12.457,
                                                    -2.68
                                                ],
                                                [
                                                    13.657,
                                                    -1.64
                                                ],
                                                [
                                                    14.137,
                                                    -0.2
                                                ],
                                                [
                                                    12.057,
                                                    -0.104
                                                ],
                                                [
                                                    11.865,
                                                    -0.824
                                                ],
                                                [
                                                    11.337,
                                                    -1.32
                                                ],
                                                [
                                                    10.409,
                                                    -1.512
                                                ],
                                                [
                                                    9.305,
                                                    -1.224
                                                ],
                                                [
                                                    8.937,
                                                    -0.456
                                                ],
                                                [
                                                    9.081,
                                                    0.104
                                                ],
                                                [
                                                    9.609,
                                                    0.472
                                                ],
                                                [
                                                    10.618,
                                                    0.712
                                                ],
                                                [
                                                    12.697,
                                                    1.24
                                                ],
                                                [
                                                    13.785,
                                                    2.088
                                                ],
                                                [
                                                    14.121,
                                                    3.288
                                                ],
                                                [
                                                    13.129,
                                                    5.192
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0.843
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.16
                                                ],
                                                [
                                                    -0.363,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.853,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.171,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.848,
                                                    5.656
                                                ],
                                                [
                                                    16.96,
                                                    5.064
                                                ],
                                                [
                                                    16.368,
                                                    3.208
                                                ],
                                                [
                                                    16.368,
                                                    -4.888
                                                ],
                                                [
                                                    18.416,
                                                    -4.888
                                                ],
                                                [
                                                    18.416,
                                                    3.016
                                                ],
                                                [
                                                    18.672,
                                                    3.848
                                                ],
                                                [
                                                    19.472,
                                                    4.072
                                                ],
                                                [
                                                    20.672,
                                                    4.072
                                                ],
                                                [
                                                    20.672,
                                                    5.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.024,
                                                    -1.304
                                                ],
                                                [
                                                    15.024,
                                                    -2.888
                                                ],
                                                [
                                                    20.672,
                                                    -2.888
                                                ],
                                                [
                                                    20.672,
                                                    -1.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.533,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    -0.459,
                                                    0.416
                                                ],
                                                [
                                                    -0.939,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.277,
                                                    0.299
                                                ],
                                                [
                                                    0.545,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.235
                                                ],
                                                [
                                                    0.107,
                                                    -0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.661,
                                                    0.48
                                                ],
                                                [
                                                    -1.056,
                                                    0
                                                ],
                                                [
                                                    -0.619,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.141
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    -0.085
                                                ],
                                                [
                                                    -0.159,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.149,
                                                    -0.011
                                                ],
                                                [
                                                    0.149,
                                                    0
                                                ],
                                                [
                                                    0.278,
                                                    0.107
                                                ],
                                                [
                                                    0.149,
                                                    0.277
                                                ],
                                                [
                                                    0,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    -0.299
                                                ],
                                                [
                                                    0.427,
                                                    -0.16
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.896,
                                                    0
                                                ],
                                                [
                                                    -0.544,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    0.459,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.608
                                                ],
                                                [
                                                    -0.277,
                                                    -0.309
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.276,
                                                    0.224
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.171,
                                                    -0.907
                                                ],
                                                [
                                                    0.661,
                                                    -0.491
                                                ],
                                                [
                                                    1.216,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.086,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    0.021
                                                ],
                                                [
                                                    -0.14,
                                                    0.011
                                                ],
                                                [
                                                    -0.351,
                                                    0
                                                ],
                                                [
                                                    -0.276,
                                                    -0.117
                                                ],
                                                [
                                                    -0.149,
                                                    -0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    0.373
                                                ],
                                                [
                                                    -0.277,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    24.607,
                                                    5.848
                                                ],
                                                [
                                                    22.447,
                                                    5.24
                                                ],
                                                [
                                                    21.632,
                                                    3.512
                                                ],
                                                [
                                                    22.319,
                                                    1.784
                                                ],
                                                [
                                                    24.415,
                                                    0.888
                                                ],
                                                [
                                                    27.247,
                                                    0.328
                                                ],
                                                [
                                                    26.831,
                                                    -1.032
                                                ],
                                                [
                                                    25.599,
                                                    -1.496
                                                ],
                                                [
                                                    24.431,
                                                    -1.144
                                                ],
                                                [
                                                    23.855,
                                                    -0.168
                                                ],
                                                [
                                                    21.775,
                                                    -0.264
                                                ],
                                                [
                                                    23.023,
                                                    -2.344
                                                ],
                                                [
                                                    25.599,
                                                    -3.08
                                                ],
                                                [
                                                    28.351,
                                                    -2.152
                                                ],
                                                [
                                                    29.295,
                                                    0.472
                                                ],
                                                [
                                                    29.295,
                                                    3.576
                                                ],
                                                [
                                                    29.407,
                                                    4.04
                                                ],
                                                [
                                                    29.775,
                                                    4.168
                                                ],
                                                [
                                                    30.047,
                                                    4.168
                                                ],
                                                [
                                                    30.047,
                                                    5.656
                                                ],
                                                [
                                                    29.728,
                                                    5.704
                                                ],
                                                [
                                                    29.295,
                                                    5.72
                                                ],
                                                [
                                                    28.351,
                                                    5.56
                                                ],
                                                [
                                                    27.711,
                                                    4.968
                                                ],
                                                [
                                                    27.487,
                                                    3.8
                                                ],
                                                [
                                                    27.663,
                                                    3.928
                                                ],
                                                [
                                                    27.103,
                                                    4.936
                                                ],
                                                [
                                                    26.047,
                                                    5.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.405,
                                                    0
                                                ],
                                                [
                                                    -0.33,
                                                    0.181
                                                ],
                                                [
                                                    -0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.203,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.299
                                                ],
                                                [
                                                    -0.213,
                                                    -0.181
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.459,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    -0.181
                                                ],
                                                [
                                                    0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.459,
                                                    0.096
                                                ],
                                                [
                                                    -0.192,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.224,
                                                    0.181
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.023,
                                                    4.36
                                                ],
                                                [
                                                    26.207,
                                                    4.088
                                                ],
                                                [
                                                    26.976,
                                                    3.336
                                                ],
                                                [
                                                    27.247,
                                                    2.2
                                                ],
                                                [
                                                    27.247,
                                                    1.72
                                                ],
                                                [
                                                    25.039,
                                                    2.168
                                                ],
                                                [
                                                    24.047,
                                                    2.6
                                                ],
                                                [
                                                    23.759,
                                                    3.32
                                                ],
                                                [
                                                    24.079,
                                                    4.088
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.267,
                                                    0.363
                                                ],
                                                [
                                                    -0.383,
                                                    0.171
                                                ],
                                                [
                                                    -0.459,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.277
                                                ],
                                                [
                                                    -0.224,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.64
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.095,
                                                    0.331
                                                ],
                                                [
                                                    0.225,
                                                    0.171
                                                ],
                                                [
                                                    0.363,
                                                    0
                                                ],
                                                [
                                                    0.332,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    -0.597
                                                ],
                                                [
                                                    0.267,
                                                    -0.363
                                                ],
                                                [
                                                    0.384,
                                                    -0.171
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    0.277
                                                ],
                                                [
                                                    0.224,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.48
                                                ],
                                                [
                                                    -0.097,
                                                    -0.331
                                                ],
                                                [
                                                    -0.213,
                                                    -0.181
                                                ],
                                                [
                                                    -0.543,
                                                    0
                                                ],
                                                [
                                                    -0.319,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.377,
                                                    5.656
                                                ],
                                                [
                                                    31.377,
                                                    -2.888
                                                ],
                                                [
                                                    33.233,
                                                    -2.888
                                                ],
                                                [
                                                    33.313,
                                                    -0.488
                                                ],
                                                [
                                                    33.073,
                                                    -0.584
                                                ],
                                                [
                                                    33.601,
                                                    -2.024
                                                ],
                                                [
                                                    34.577,
                                                    -2.824
                                                ],
                                                [
                                                    35.841,
                                                    -3.08
                                                ],
                                                [
                                                    37.425,
                                                    -2.664
                                                ],
                                                [
                                                    38.418,
                                                    -1.512
                                                ],
                                                [
                                                    38.754,
                                                    0.168
                                                ],
                                                [
                                                    38.754,
                                                    5.656
                                                ],
                                                [
                                                    36.705,
                                                    5.656
                                                ],
                                                [
                                                    36.705,
                                                    0.824
                                                ],
                                                [
                                                    36.562,
                                                    -0.392
                                                ],
                                                [
                                                    36.081,
                                                    -1.144
                                                ],
                                                [
                                                    35.217,
                                                    -1.416
                                                ],
                                                [
                                                    33.905,
                                                    -0.84
                                                ],
                                                [
                                                    33.425,
                                                    0.824
                                                ],
                                                [
                                                    33.425,
                                                    5.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0.843
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.172,
                                                    -0.16
                                                ],
                                                [
                                                    -0.363,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.854,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.17,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    43.817,
                                                    5.656
                                                ],
                                                [
                                                    41.929,
                                                    5.064
                                                ],
                                                [
                                                    41.338,
                                                    3.208
                                                ],
                                                [
                                                    41.338,
                                                    -4.888
                                                ],
                                                [
                                                    43.385,
                                                    -4.888
                                                ],
                                                [
                                                    43.385,
                                                    3.016
                                                ],
                                                [
                                                    43.642,
                                                    3.848
                                                ],
                                                [
                                                    44.441,
                                                    4.072
                                                ],
                                                [
                                                    45.642,
                                                    4.072
                                                ],
                                                [
                                                    45.642,
                                                    5.656
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    39.993,
                                                    -1.304
                                                ],
                                                [
                                                    39.993,
                                                    -2.888
                                                ],
                                                [
                                                    45.642,
                                                    -2.888
                                                ],
                                                [
                                                    45.642,
                                                    -1.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9216,
                                            0.9216,
                                            0.9216
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            103.946,
                                            22.844
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.359
                                                ],
                                                [
                                                    0.322,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0.269,
                                                    -0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.064,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.307
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.08,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.089
                                                ],
                                                [
                                                    0.029,
                                                    -0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.125,
                                                    -0.359
                                                ],
                                                [
                                                    -0.322,
                                                    -0.202
                                                ],
                                                [
                                                    -0.378,
                                                    0.042
                                                ],
                                                [
                                                    -0.269,
                                                    0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.065,
                                                    0.326
                                                ],
                                                [
                                                    0.127,
                                                    0.306
                                                ],
                                                [
                                                    0.275,
                                                    0.184
                                                ],
                                                [
                                                    0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.089
                                                ],
                                                [
                                                    -0.03,
                                                    0.085
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.126,
                                                    -0.359
                                                ],
                                                [
                                                    -0.124,
                                                    -0.359
                                                ],
                                                [
                                                    -0.321,
                                                    -0.203
                                                ],
                                                [
                                                    -0.377,
                                                    0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.234
                                                ],
                                                [
                                                    -0.065,
                                                    0.325
                                                ],
                                                [
                                                    0.126,
                                                    0.306
                                                ],
                                                [
                                                    0.276,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0
                                                ],
                                                [
                                                    0.079,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.127,
                                                    0.359
                                                ],
                                                [
                                                    0.125,
                                                    0.36
                                                ],
                                                [
                                                    0.321,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.234,
                                                    -0.235
                                                ],
                                                [
                                                    0.064,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.306
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    0
                                                ],
                                                [
                                                    -0.079,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.375,
                                                    -8.941
                                                ],
                                                [
                                                    4.377,
                                                    -10.049
                                                ],
                                                [
                                                    3.688,
                                                    -10.917
                                                ],
                                                [
                                                    2.608,
                                                    -11.165
                                                ],
                                                [
                                                    1.609,
                                                    -10.686
                                                ],
                                                [
                                                    -8.449,
                                                    -0.627
                                                ],
                                                [
                                                    -8.908,
                                                    0.231
                                                ],
                                                [
                                                    -8.813,
                                                    1.2
                                                ],
                                                [
                                                    -8.196,
                                                    1.952
                                                ],
                                                [
                                                    -7.265,
                                                    2.235
                                                ],
                                                [
                                                    -2.792,
                                                    2.235
                                                ],
                                                [
                                                    -2.535,
                                                    2.298
                                                ],
                                                [
                                                    -2.336,
                                                    2.471
                                                ],
                                                [
                                                    -2.239,
                                                    2.717
                                                ],
                                                [
                                                    -2.265,
                                                    2.98
                                                ],
                                                [
                                                    -4.374,
                                                    8.941
                                                ],
                                                [
                                                    -4.377,
                                                    10.049
                                                ],
                                                [
                                                    -3.687,
                                                    10.917
                                                ],
                                                [
                                                    -2.607,
                                                    11.165
                                                ],
                                                [
                                                    -1.608,
                                                    10.685
                                                ],
                                                [
                                                    8.451,
                                                    0.626
                                                ],
                                                [
                                                    8.909,
                                                    -0.233
                                                ],
                                                [
                                                    8.813,
                                                    -1.201
                                                ],
                                                [
                                                    8.196,
                                                    -1.953
                                                ],
                                                [
                                                    7.265,
                                                    -2.235
                                                ],
                                                [
                                                    2.798,
                                                    -2.235
                                                ],
                                                [
                                                    2.54,
                                                    -2.298
                                                ],
                                                [
                                                    2.341,
                                                    -2.471
                                                ],
                                                [
                                                    2.243,
                                                    -2.718
                                                ],
                                                [
                                                    2.27,
                                                    -2.981
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "gf",
                                    "nm": "Gradient Fill 1",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            13.412
                                        ]
                                    },
                                    "g": {
                                        "p": 3,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                0.51372552,
                                                0.36078432,
                                                0.96078438,
                                                0.5,
                                                0.2941176635,
                                                0.6588235649999999,
                                                0.729411815,
                                                1,
                                                0.074509807,
                                                0.95686281,
                                                0.49803925
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            -13.412
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            33.999,
                                            31.998
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.5255,
                                            0.3804,
                                            0.9529
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            34,
                                            32
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.624,
                                                    3.625
                                                ],
                                                [
                                                    -3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.624,
                                                    3.625
                                                ],
                                                [
                                                    3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.813
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            524.5,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.674,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.674,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.083
                                                ],
                                                [
                                                    -12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.083
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.6863,
                                            0.5843,
                                            0.9961
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            524.5,
                                            31.501
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -278,
                                                    -7.5
                                                ],
                                                [
                                                    -254,
                                                    -31.5
                                                ],
                                                [
                                                    254,
                                                    -31.5
                                                ],
                                                [
                                                    278,
                                                    -7.5
                                                ],
                                                [
                                                    278,
                                                    31.5
                                                ],
                                                [
                                                    -278,
                                                    31.5
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            278,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        }
    ]
};

//# sourceMappingURL=enterprise-ai-security-and-governance.de598ada.js.map
